/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(18);


/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.4.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2019-05-01T21:04Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.4.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code, options ) {
			DOMEval( code, { nonce: options && options.nonce } );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.4
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2019-04-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) &&
	
					// Support: IE 8 only
					// Exclude object elements
					(nodeType !== 1 || context.nodeName.toLowerCase() !== "object") ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 && rdescend.test( selector ) ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem.namespaceURI,
			docElem = (elem.ownerDocument || elem).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( typeof elem.contentDocument !== "undefined" ) {
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
							return result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									} );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		// Support: IE 9-11 only
		// Also use offsetWidth/offsetHeight for when box sizing is unreliable
		// We use getClientRects() to check for hidden/disconnected.
		// In those cases, the computed value can be trusted to be border-box
		if ( ( !support.boxSizingReliable() && isBorderBox ||
			val === "auto" ||
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
						jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = Date.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url, options ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

	module.exports = [{"id":367,"date":"2017-05-19T10:47:33","date_gmt":"2017-05-19T08:47:33","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367"},"modified":"2023-10-02T12:27:36","modified_gmt":"2023-10-02T10:27:36","slug":"moduli-di-servizio-e-cappelliere","status":"publish","type":"product_categories","link":"https://wp.primaautomotive.it/product_categories/moduli-di-servizio-e-cappelliere/","title":{"rendered":"Moduli di servizio"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"07","category_id":"moduli_di_servizio","category_name_it":"Moduli di servizio","category_name_en":"Service sets","catalogo_pdf_completo":false,"documento_normative_it":false,"documento_normative_en":false,"category_name_ru":"КОМФОРТ БЛОК","category_name_ru_latin":"KOMFORT BLOK","category_description_it":"<p>Un viaggio è un insieme di sensazioni e di piccoli bisogni che vanno gestiti: serve la giusta temperatura e c’è chi vuole leggere con una musica leggera in sottofondo, magari mentre ricarica il proprio cellulare.</p>\n<div class=\"view-more\">Prima Industries aiuta i costrutturi automotive a gestire queste esigenze, lavorando gomito a gomito già con i progettisti per creare un oggetto che soddisfi tutti i requisiti funzionali del veicolo ma che incarni anche il feeling estetico del costruttore<br />\ndal momento che, soprattutto all’interno dei mezzi turistici, la cura dei dettagli deve trasmettere un’idea di confort ed esclusività.<br />\nPrima Industries produce al suo interno plance e multiset di vario tipo utilizzando a piene mani la tecnologia led che consente “effetti scenici” inimmaginabili fino a pochi anni fa e che apre nuove possibilità per ridefinire i termini del confort a bordo di un veicolo adibito al trasporto passeggeri sulle lunghe distanze.</div>\n","category_description_en":"<p>A trip is a combination of sensations and small needs that must be managed: you need the right temperature and there are those who want to read with light music in the background, perhaps while charging their mobile phone.</p>\n<div class=\"view-more\">Prima Industries helps automotive manufacturers to manage these needs, working side by side with the designers to create an object that meets all the functional<br />\nrequirements of the vehicle, but which also embodies the manufacturer&#8217;s aesthetic feeling since, especially inside tourist vehicles, attention to detail must convey an idea of comfort and exclusivity. Prima Industries produces various types of internal dashboards and multisets using LED technology abundantly, which allows &#8220;scenic effects&#8221; unimaginable until a few years ago and which opens up new possibilities to redefine the terms of comfort on board of a vehicle used for long-distance passenger transport.</div>\n","category_description_ru":"","cataloghi_collegati_alla_categoria":[{"nome_catalogo_it":"Catalogo completo","nome_catalogo_en":"Complete catalogue","catalogo_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/18F_moduli_di_servizio.pdf"}]},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/product_categories/367"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/product_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/product_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=367"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":24,"date":"2017-04-11T12:06:55","date_gmt":"2017-04-11T10:06:55","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24"},"modified":"2023-09-29T10:28:49","modified_gmt":"2023-09-29T08:28:49","slug":"maniglie","status":"publish","type":"product_categories","link":"https://wp.primaautomotive.it/product_categories/maniglie/","title":{"rendered":"Maniglie"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"category_id":"maniglie","category_name_it":"Maniglie","category_name_en":"Handles","index_order":"01","catalogo_pdf_completo":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/A_Manig_Esecutivo_CS6_Rev9-2.pdf","documento_normative_it":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/A_informativa-it.pdf","documento_normative_en":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/A_informativa-en.pdf","category_name_ru":"РУЧКИ И ПОРУЧНИ","category_description_it":"<p>Le maniglie esterne sono l’accessorio di carrozzeria più importante perché possono comprendere le serrature, il catarifrangente, si devono poter integrare eventualmente in un sistema pneumatico e comunque devono garantire la loro prestazione in tutte le condizioni ambientali, senza trafilamenti o problemi funzionali a bassissime temperature.</p>\n<div class=\"view-more\">Le maniglie esterne utilizzate sono poi diverse a seconda che occorra equipaggiare la porta autista, il bagagliaio o altri portelli d’accesso. Prima Industries fornisce una risposta a tutte queste esigenze, lasciando al cliente &#8220;soltanto&#8221; il compito di lavorare sul proprio design di carrozzeria per la quale le soluzioni Prima sono in grado di coprire le esigenze di tutte le tipologie di bus esistenti, utilizzando diversi approcci estetici.</div>\n","category_description_en":"<p>The exterior handles are the most important bodywork accessory because they can include the lock and the reflector and they must be able to be integrated into a pneumatic system if necessary. In any case, they must guarantee their performance in all environmental conditions, without water leaks or functional problems at very low temperatures.</p>\n<div class=\"view-more\">Then, the exterior handles are different depending on whether it is necessary to fit out the driver&#8217;s door, the boot, or other access doors. Prima Industries provides an answer to all these needs, leaving the customer &#8220;just&#8221; the task of working on their own bodywork design for which Prima solutions are able to cover the needs of all types of existing buses, using different aesthetic approaches.</div>\n","category_description_ru":"<p>Широкий ассортимент ручек, полностью спроектированных и изготовленных в Италии, подходящих для широкого круга транспортных средств и приложений, включая автобусы и микроавтобусы, микроавтобусы, городские автобусы, специальные транспортные средства и транспортные средства для отдыха, такие как лодки, фургоны или караваны.</p>\n<p>Все корпуса изготовлены из высококачественных полимеров, включая полиамид 6, полибутилентерефталат и ацетальную смолу, что обеспечивает снижение веса и длительную защиту от атмосферных воздействий благодаря анти-УФ-обработке, обеспечивающей защиту от элементов. Использование нержавеющей стали для всех компонентов и механики обеспечивает надежное использование на протяжении всей жизни.</p>\n<div class=\"view-more\">В зависимости от моделей, ручки доступны для ручной, электрической или электропневматической установки и могут подходить для дверей водителя, пассажирских дверей, багажных дверей, интерьеров, запасных дверей и всех видов транспортных и промышленных транспортных средств.Полный каталог аксессуаров, замков и замков, а также запатентованная система JOK (всего один ключ), которая позволяет нашим ручкам использовать только один ключ на всех дверях, предлагает идеальное решение для всех типов производителей автомобилей.<br />\nВсе ручки и аксессуары полностью соответствуют наиболее распространенным нормам в автомобильной промышленности, в том числе: ПРАВИЛА 107/06, 70/156 / EEC, 97/27 / EC и 2001/85 / EC. UN ECE R118.2 и FMVSS302, DIRECTIVE 2000/53 / EC (и поправки: 2008/33 / EC DIRECTIVE 2002/95 / EC DIRECTIVE 1907/2006 / EC &#8211; (REACH) DIRECTIVE 2005/20 / CE. ПРАВИЛА R10. GADSL , ПАУ И МИНЕРАЛЫ КОНФЛИКТА</div>\n","category_name_ru_latin":"RUČKI I PORUČNI","cataloghi_collegati_alla_categoria":[{"nome_catalogo_it":"Catalogo maniglie","nome_catalogo_en":"Handles catalog","catalogo_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/prima-autmotive-18A.pdf"}]},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/product_categories/24"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/product_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/product_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=24"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":23,"date":"2017-04-11T12:06:27","date_gmt":"2017-04-11T10:06:27","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23"},"modified":"2024-01-30T15:47:38","modified_gmt":"2024-01-30T14:47:38","slug":"sistemi-e-componenti-di-chiusura","status":"publish","type":"product_categories","link":"https://wp.primaautomotive.it/product_categories/sistemi-e-componenti-di-chiusura/","title":{"rendered":"Sistemi e componenti per portelloni bus"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"category_id":"sistemi_e_componenti_per_portelloni_bus","category_name_it":"Sistemi e componenti per portelloni bus","category_name_en":"Bus doors systems and components","index_order":"02","catalogo_pdf_completo":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/18B-Rev0-2.pdf","documento_normative_it":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/B_informativa-it.pdf","documento_normative_en":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/B_informativa-en.pdf","category_name_ru":"БЛОКИРУЮЩИЕ УСТРОЙСТВА","category_name_ru_latin":"BLOKIRUJuŜIE USTROJSTVA","category_description_it":"<p>Per chiudere e movimentare i diversi portelloni presenti negli autobus, si utilizzano molti dispositivi che, tutti insieme, possono essere azionati meccanicamente, pneumaticamente o elettricamente. La Maniglia esterna è la parte più visibile di un sistema complesso che deve alleggerire il compito dell’autista ma che vede la sicurezza come prima specifica costruttiva e progettuale.</p>\n<div class=\"view-more\">La gamma delle soluzioni che Prima Industries propone per la movimentazione dei portelloni è molto articolata e cerca anche di comprendere le esperienze e le soluzioni prima adottate in alcuni distretti produttivi e poi condivise ad un livello più ampio. E’ chiaro che sono soprattutto i Coaches ad offrire un ampio spazio per i bagagli ed è questo il target principale delle soluzioni contenute in questa categoria.</div>\n","category_description_en":"<p>To close and move the various hatches in the bus, many devices are used which, all together, can be operated mechanically, pneumatically or electrically. The external handle is the most visible part of a complex system that should ease the driver&#8217;s task but sees safety as the first construction and design specification.</p>\n<div class=\"view-more\">The range of solutions that Prima Industries proposes for hatchtes motion is very diverse and also seeks to encompass the experiences and solutions first adopted in certain production districts and then shared at a broader level. Of course, mainly Coaches offer ample space for luggage and this is the main target of the solutions contained in this category.</div>\n","category_description_ru":"","cataloghi_collegati_alla_categoria":[{"nome_catalogo_it":"Sacarica il catalogo conpleto","nome_catalogo_en":"Download full catalogue","catalogo_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/18B-Rev0.pdf"}]},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/product_categories/23"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/product_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/product_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=23"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":22,"date":"2017-04-11T12:05:54","date_gmt":"2017-04-11T10:05:54","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22"},"modified":"2023-09-29T12:34:39","modified_gmt":"2023-09-29T10:34:39","slug":"sistemi-di-diffusione-aria","status":"publish","type":"product_categories","link":"https://wp.primaautomotive.it/product_categories/sistemi-di-diffusione-aria/","title":{"rendered":"Sistemi di diffusione aria / HVAC"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"category_id":"sistemi_di_diffusione_aria_HVAC","category_name_it":"Sistemi di diffusione aria / HVAC","category_name_en":"Air diffusers components / HVAC","index_order":"03","catalogo_pdf_completo":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/Prima-catalogo-completo-18C.pdf","documento_normative_it":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/C_Informativa_it.pdf","documento_normative_en":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/C_informativa_en.pdf","category_name_ru":"ВЕНТИЛЯЦИОННАЯ СИСТЕМА / HVAC","category_description_it":"<p>La giusta temperatura definisce il comfort di un viaggiatore che ama farsi coccolare, soprattutto durante i lunghi viaggi, ma la temperatura sbagliata può affaticare quelli per i quali la cabina di un mezzo è il proprio luogo di lavoro. Per questa ragione, un moderno sistema di aereazione è ciò che contraddistingue i veicoli moderni da quelli del passato dove si poteva soltanto decidere se aprire o chiudere il finestrino.</p>\n<div class=\"view-more\">Oggi Prima Industries collabora con tutti i principali attori del mondo HVAC, fornendo bocchette, defroster e service set con caratteristiche diverse e integrandosi con l’estetica interna della cabina di un bus, di un trattore, nonché di una macchina per movimento terra o di una spazzatrice stradale.<br />\nUna bocchetta svolge un lavoro apparentemente semplice, ma le applicazioni sono molto varie e serve grande flessibilità (colore, forma, fissaggio, possibilità di parzializzazione) e questo è il valore aggiunto che Prima Industries garantisce per far sì che, fresca o calda, l’aria arrivi sempre dove serve!</div>\n","category_description_en":"<p>The right temperature defines the comfort for a traveler who loves to be pampered, especially during long journeys, but the wrong one can accentuate the fatigue of<br />\nthose for whom the cabin of a vehicle is their workplace. For this reason, a modern ventilation system is what distinguishes new vehicles from those of the past where you could only decide whether to open or close the window.</p>\n<div class=\"view-more\">Today Prima Industries cooperates with all the main players in the HVAC world, supplying vents, defrosters and service sets with distinct characteristics and integrating with the internal aesthetics of the cabin of a bus, a tractor, as well as an earthmoving machine or a road sweeper.</div>\n","category_description_ru":"<p>Широкий ассортимент вентиляционных отверстий, спроектированных и изготовленных в Италии, подходящих для широкого спектра транспортных средств и приложений, включая автобусы и микроавтобусы, микроавтобусы, городские автобусы, автомобили, минивэны, специальные транспортные средства и транспортные средства для отдыха, такие как лодки, фургоны или караваны.</p>\n<p>Наши воздушные жалюзийныe воздушныe клапаны изготовлены из высококачественных полимеров, включая полиамид 6, полибутилентерефталат и ацетальную смолу, что обеспечивает снижение веса и длительную защиту от атмосферных воздействий благодаря анти-УФ-обработке, обеспечивающей защиту от элементов.</p>\n<div class=\"view-more\">Все вентиляционные отверстия доступны в округлой, квадратной и прямоугольной формах, как в фиксированном, так и в регулируемом режиме. В зависимости от моделей наши вентиляционные отверстия могут быть установлены на все виды транспортных средств, включая приборные панели и мультисети для систем кондиционирования и отопления.Наши вентиляционные системы, доступные как в качестве запасной части, так и установленные на наших мультисетях и багажных стойках, могут предложить удобное решение для всех типов производителей автомобилей.Все вентиляционные отверстия и аксессуары полностью соответствуют наиболее распространенным нормам в автомобильной промышленности, в том числе: ПРАВИЛА 107/06, 70/156 / EEC, 97/27 / EC и 2001/85 / EC. UN ECE R118.2 и FMVSS302, DIRECTIVE 2000/53 / EC (и поправки: 2008/33 / EC DIRECTIVE 2002/95 / EC DIRECTIVE 1907/2006 / EC &#8211; (REACH) DIRECTIVE 2005/20 / CE. ПРАВИЛА R10. GADSL , ПАУ И МИНЕРАЛЫ КОНФЛИКТА.</div>\n","category_name_ru_latin":"VENTILJaCIONNAJa SISTEMA / HVAC","cataloghi_collegati_alla_categoria":[{"nome_catalogo_it":"Diffusori aria / HVAC","nome_catalogo_en":"Air diffuser / HVAC","catalogo_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/Prima-catalogo-completo-18C.pdf"}]},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/product_categories/22"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/product_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/product_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=22"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":21,"date":"2017-04-11T12:05:15","date_gmt":"2017-04-11T10:05:15","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21"},"modified":"2023-09-29T12:34:16","modified_gmt":"2023-09-29T10:34:16","slug":"sistemi-e-componenti-di-illuminazione","status":"publish","type":"product_categories","link":"https://wp.primaautomotive.it/product_categories/sistemi-e-componenti-di-illuminazione/","title":{"rendered":"Sistemi e componenti di illuminazione"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"category_id":"illuminazione","category_name_it":"Illuminazione","category_name_en":"Interior lights","index_order":"04","catalogo_pdf_completo":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/prima_automotive_18D.pdf","documento_normative_it":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/D_informativa-it-en-1.pdf","documento_normative_en":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/D_informativa-it-en-1.pdf","category_name_ru":"ОСВЕЩЕНИЕ","category_name_ru_latin":"OSVEЩENIE","category_description_it":"<p>Durante il viaggio lo spazio e il tempo si rincorrono e si mescolano, evocando ricordi. Il sedile definisce lo spazio a noi riservato ma la luce è intimità, è il calore di un buon libro ed è per noi la nostra barriera verso ciò che ci circonda. La luce giusta delinea lo spazio individuale ma deve essere “discreta”, non deve disturbare chi vuole rimanere nel suo cono di riservatezza, assopendosi mentre si macinano km.</p>\n<div class=\"read-more\">Prima Industries non produce “luci decorative o luci generiche” ma cerca d’inserire luci da interno nello spazio del viaggiatore dove il confort regna sovrano e con pochi semplici gesti si devono poter attivare i servizi riservati al passeggero. Mettiamo le nostre soluzioni luce a disposizione dei designers sempre attivi nel progettare una sempre migliore esperienza di viaggio per i passeggeri.</div>\n","category_description_en":"<p>During the journey, space and time chase each other and mingle, evoking memories. The seat defines the space reserved for us, but light is intimacy, it is the warmth of a good book, and it is our barrier to our surroundings. The right light delineates individual space, but it must be &#8220;unobtrusive,&#8221; not disturbing those who want to remain in their cone of privacy, dozing off while grinding out miles.</p>\n<div class=\"view-more\">Prima Industries does not produce decorative or generic lights, but seeks to insert interior lights into the traveler&#8217;s space where comfort reigns supreme and with a few simple gestures one should be able to activate the services reserved for the passenger. We make our light solutions available to designers who are always active in creating an ever better travel experience for passengers.</div>\n","category_description_ru":"","cataloghi_collegati_alla_categoria":[{"nome_catalogo_it":"Catalogo illuminazione","nome_catalogo_en":"Interiors lights catalog","catalogo_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/prima_automotive_18D.pdf"}]},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/product_categories/21"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/product_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/product_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=21"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":20,"date":"2017-04-11T12:04:39","date_gmt":"2017-04-11T10:04:39","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20"},"modified":"2023-10-05T10:00:53","modified_gmt":"2023-10-05T08:00:53","slug":"morsetterie-e-pulsantiere","status":"publish","type":"product_categories","link":"https://wp.primaautomotive.it/product_categories/morsetterie-e-pulsantiere/","title":{"rendered":"Accessori x Interni Bus"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"category_id":"accessori_per_interni_bus","category_name_it":"Accessori x Interni Bus","category_name_en":"Bus interior accessories","index_order":"05","catalogo_pdf_completo":false,"documento_normative_it":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/F_informativa-it-en.pdf","documento_normative_en":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/F_informativa-it-en.pdf","category_name_ru":"ПОРУЧНИ / КРОНШТЕЙНЫ КНОПОЧНЫЕ ПАНЕЛИ","category_name_ru_latin":"PORUČNI / KRONŠTEJNY KNOPOČNYE PANELI","category_description_it":"<p>È difficile dare personalità ad un bus urbano che, per definizione, deve contenere un allestimento essenziale, che non rubi spazio ai passeggeri in costante movimento. Prima Industries riesce a farlo grazie ad una gamma di accessori molto vasta ed in grado di rispondere alle esigenze diversificate dei numerosi mercati in cui opera.</p>\n<div class=\"view-more\">Per esempio, Prima Industries offre un’ampia scelta di pulsantiere per richiesta fermata con diverse caratteristiche sia ergonomiche che estetiche, per le quali è stata sviluppata l’estetica in chiave ergonomica contestualmente ad un’analisi tecnica per rispondere positivamente sia ai diversi requisiti normativi che alle specifiche dei costruttori di autoveicoli che sono sempre più stringenti sui temi della sicurezza dei passeggeri in generale e in particolare di quelli con disabilità.</div>\n","category_description_en":"<p>It’s difficult to give a personality to an Urban bus which, by definition, must contain an essential set-up that does not take away space from passengers in constant<br />\nmovement. Prima Industries is able to do this thanks to a very wide range of accessories capable of responding to the diversified needs of the numerous markets in which it operates.</p>\n<div class=\"view-more\">For example, Prima Industries offers a wide choice of stop request push-buttons with different ergonomic and aesthetic features, for which the aesthetics has been developed ergonomically together with a technical analysis to respond positively to both the different regulatory requirements and to the specifications of Bus manufacturers, who are increasingly stringent on the issues of passenger safety in general and of those with disabilities in particular.</div>\n","category_description_ru":"","cataloghi_collegati_alla_categoria":[{"nome_catalogo_it":"Catalogo accessori","nome_catalogo_en":"Accessories catalog","catalogo_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/18E_accessori_Rev0-1.pdf"}]},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/product_categories/20"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/product_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/product_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=20"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}}]

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = [{"id":1732,"date":"2023-09-29T15:11:40","date_gmt":"2023-09-29T13:11:40","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=sub_categories&#038;p=1732"},"modified":"2023-09-29T15:11:40","modified_gmt":"2023-09-29T13:11:40","slug":"prese-usb","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/prese-usb/","title":{"rendered":"Prese USB"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"12","sub_category_id":"prese_usb","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Prese USB","sub_category_name_en":"USB sockets","sub_category_name_ru":"USB sockets","sub_category_name_ru_latin":"","sub_category_description_it":"","sub_category_description_en":"","sub_category_description_ru":"","nascondi_in_home_page":true},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/1732"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1732"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1561,"date":"2023-09-27T12:53:08","date_gmt":"2023-09-27T10:53:08","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=sub_categories&#038;p=1561"},"modified":"2023-09-27T12:53:08","modified_gmt":"2023-09-27T10:53:08","slug":"pannelli-richiesta-fermata","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/pannelli-richiesta-fermata/","title":{"rendered":"Pannelli richiesta fermata"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"pannelli_richiesta_fermata","sub_category_id":"pannello_richiesta_fermata","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Pannelli richiesta fermata","sub_category_name_en":"Stop request panels","sub_category_name_ru":"Stop request panels","sub_category_name_ru_latin":"Stop request panels","sub_category_description_it":"","sub_category_description_en":"","sub_category_description_ru":"","nascondi_in_home_page":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/1561"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1561"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1442,"date":"2022-08-01T10:47:19","date_gmt":"2022-08-01T08:47:19","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=sub_categories&#038;p=1442"},"modified":"2022-11-17T17:57:02","modified_gmt":"2022-11-17T16:57:02","slug":"posacenere","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/posacenere/","title":{"rendered":"Posacenere"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"06_02_01","sub_category_id":"posacenere","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Posacenere","sub_category_name_en":"Ashtray","sub_category_name_ru":"Пепельница","sub_category_name_ru_latin":"","sub_category_description_it":"","sub_category_description_en":"","sub_category_description_ru":"","nascondi_in_home_page":true},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/1442"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1442"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1168,"date":"2021-07-16T11:58:09","date_gmt":"2021-07-16T09:58:09","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=sub_categories&#038;p=1168"},"modified":"2022-02-24T10:37:40","modified_gmt":"2022-02-24T09:37:40","slug":"valvola-di-sovrapressione","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/valvola-di-sovrapressione/","title":{"rendered":"Valvola di sovrapressione"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"06_10","sub_category_id":"valvola di sovrapressione","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Valvola di sovrapressione","sub_category_name_en":"Overpressure valve","sub_category_name_ru":"клапан избыточного давления","sub_category_name_ru_latin":"","sub_category_description_it":"","sub_category_description_en":"","sub_category_description_ru":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/1168"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1168"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":935,"date":"2019-09-28T12:23:17","date_gmt":"2019-09-28T10:23:17","guid":{"rendered":"https://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=935"},"modified":"2022-02-24T10:38:03","modified_gmt":"2022-02-24T09:38:03","slug":"rubinetti-taps","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/rubinetti-taps/","title":{"rendered":"Rubinetti"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"06_10","sub_category_id":"rubinetti","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Rubinetti","sub_category_name_en":"Taps","sub_category_description_it":"","sub_category_description_en":"","sub_category_name_ru":"КРАН ДЛЯ ЦИКЛА ОХЛАЖДЕНИЯ","sub_category_name_ru_latin":"Kran dlja cikla ohlaždenija","sub_category_description_ru":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/935"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=935"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":468,"date":"2017-09-27T15:41:24","date_gmt":"2017-09-27T13:41:24","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=468"},"modified":"2022-11-17T17:52:19","modified_gmt":"2022-11-17T16:52:19","slug":"sistemi-elettrici","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/sistemi-elettrici/","title":{"rendered":"Sistemi elettrici"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"08_04","sub_category_id":"sistemi_elettrici","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Sistemi elettrici","sub_category_name_en":"Electric systems","sub_category_description_it":"","sub_category_description_en":"","sub_category_name_ru":"ЭЛЕКТРИЧЕСКИЕ СИСТЕМЫ","sub_category_description_ru":"","sub_category_name_ru_latin":"ЭLEKTRIČESKIE SISTEMЫ","nascondi_in_home_page":true},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/468"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=468"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":384,"date":"2017-05-19T11:13:16","date_gmt":"2017-05-19T09:13:16","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=384"},"modified":"2022-11-17T18:00:49","modified_gmt":"2022-11-17T17:00:49","slug":"interruttori-e-pulsanti","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/interruttori-e-pulsanti/","title":{"rendered":"Interruttori e pulsanti"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"06_06","sub_category_id":"interruttori_e_pulsanti","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Interruttori e pulsanti","sub_category_name_en":"Switches and push buttons","sub_category_description_it":"","sub_category_description_en":"","sub_category_name_ru":"ПЕРЕКЛЮЧАТЕЛИ И КНОПКИ","sub_category_description_ru":"","sub_category_name_ru_latin":"PEREKLЮČATELI I KNOPKI","nascondi_in_home_page":true},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/384"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=384"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":383,"date":"2017-05-19T11:11:57","date_gmt":"2017-05-19T09:11:57","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=383"},"modified":"2022-11-17T18:00:32","modified_gmt":"2022-11-17T17:00:32","slug":"pomelli-per-vetri-scorrevoli","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/pomelli-per-vetri-scorrevoli/","title":{"rendered":"Pomelli per vetri scorrevoli"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"06_05","sub_category_id":"pomelli_per_vetri_scorrevoli","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Pomelli per vetri scorrevoli","sub_category_name_en":"Knobs for sliding windows","sub_category_description_it":"","sub_category_description_en":"","sub_category_name_ru":"РУЧКИ ДЛЯ РАЗДВИЖНЫХ СТЕКОЛ","sub_category_description_ru":"","sub_category_name_ru_latin":"RUČKI DLЯ RAZDVIŽNЫH STEKOL","nascondi_in_home_page":true},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/383"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=383"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":382,"date":"2017-05-19T11:10:55","date_gmt":"2017-05-19T09:10:55","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=382"},"modified":"2022-10-20T13:37:27","modified_gmt":"2022-10-20T11:37:27","slug":"gancio-appendiabiti","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/gancio-appendiabiti/","title":{"rendered":"Gancio appendiabiti"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"06_04","sub_category_id":"gancio_appendiabiti","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Gancio appendiabiti","sub_category_name_en":"Hanger","sub_category_description_it":"","sub_category_description_en":"","sub_category_name_ru":"КРЮЧОК / ВЕШАЛКА ДЛЯ ОДЕЖДЫ","sub_category_description_ru":"","sub_category_name_ru_latin":"KRJuČOK / VEŠALKA DLJa ODEŽDY"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/382"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=382"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":381,"date":"2017-05-19T11:10:17","date_gmt":"2017-05-19T09:10:17","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=381"},"modified":"2022-11-17T18:00:06","modified_gmt":"2022-11-17T17:00:06","slug":"portalattine-e-sportello-di-protezione","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/portalattine-e-sportello-di-protezione/","title":{"rendered":"Portalattine e sportello di protezione"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"06_03","sub_category_id":"portalattine_e_sportello_di_protezione","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Portalattine e sportello di protezione","sub_category_name_en":"Glass holder and door lock guard","sub_category_description_it":"","sub_category_description_en":"","sub_category_name_ru":"ПОДСТАКАННИК /ДЕРЖАТЕЛЬ ДЛЯ БУТЫЛКИ И БЛОКИРУЮЩИЕ УСТРОЙСТВА","sub_category_description_ru":"","sub_category_name_ru_latin":"PODSTAKANNIK /DERŽATELʹ DLJa BUTYLKI I BLOKIRUJuŜIE USTROJSTVA","nascondi_in_home_page":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/381"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=381"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":379,"date":"2017-05-19T11:08:45","date_gmt":"2017-05-19T09:08:45","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=379"},"modified":"2022-10-20T13:35:24","modified_gmt":"2022-10-20T11:35:24","slug":"posaceneri","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/posaceneri/","title":{"rendered":"Portaoggetti"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"06_02","sub_category_id":"portaoggetti","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Portaoggetti","sub_category_name_en":"Storage compartment","sub_category_description_it":"","sub_category_description_en":"","sub_category_name_ru":"Отсек для хранения","sub_category_description_ru":"","sub_category_name_ru_latin":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/379"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=379"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":378,"date":"2017-05-19T11:08:07","date_gmt":"2017-05-19T09:08:07","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=378"},"modified":"2022-10-20T13:35:08","modified_gmt":"2022-10-20T11:35:08","slug":"martello-emergenza-frangivetro","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/martello-emergenza-frangivetro/","title":{"rendered":"Martello emergenza frangivetro"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"06_01","sub_category_id":"martello_emergenza_frangivetro","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Martello emergenza frangivetro","sub_category_name_en":"Emergency breaker arm","sub_category_description_it":"","sub_category_description_en":"","sub_category_name_ru":"МОЛОТОК ДЛЯ РАЗБИВАНИЯ ОКОН","sub_category_description_ru":"","sub_category_name_ru_latin":"MOLOTOK DLJa RAZBIVANIJa OKON"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/378"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=378"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":377,"date":"2017-05-19T11:06:19","date_gmt":"2017-05-19T09:06:19","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=377"},"modified":"2022-11-17T17:55:59","modified_gmt":"2022-11-17T16:55:59","slug":"tasto-non-rialzato","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/tasto-non-rialzato/","title":{"rendered":"Tasto non rialzato"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"05_06","sub_category_id":"tasto_non_rialzato","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Tasto non rialzato","sub_category_name_en":"Flat button","sub_category_description_it":"","sub_category_description_en":"","sub_category_name_ru":"КНОПКА БЕЗ ВОЗВЫШЕНИЯ","sub_category_description_ru":"","sub_category_name_ru_latin":"KNOPKA BEZ VOZVЫŠENIЯ","nascondi_in_home_page":true},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/377"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=377"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":376,"date":"2017-05-19T11:05:31","date_gmt":"2017-05-19T09:05:31","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=376"},"modified":"2022-11-17T17:55:55","modified_gmt":"2022-11-17T16:55:55","slug":"tasto-rialzato","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/tasto-rialzato/","title":{"rendered":"Tasto rialzato"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"05_05","sub_category_id":"tasto_rialzato","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Tasto rialzato","sub_category_name_en":"Raised button","sub_category_description_it":"","sub_category_description_en":"","sub_category_name_ru":"КНОПКА С ВОЗВЫШЕНИЕМ","sub_category_description_ru":"","sub_category_name_ru_latin":"KNOPKA S VOZVЫŠENIEM","nascondi_in_home_page":true},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/376"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=376"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":375,"date":"2017-05-19T11:04:46","date_gmt":"2017-05-19T09:04:46","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=375"},"modified":"2022-11-17T17:54:02","modified_gmt":"2022-11-17T16:54:02","slug":"wireless-ad-ultrasuoni","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/wireless-ad-ultrasuoni/","title":{"rendered":"Wireless ad ultrasuoni"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"05_04","sub_category_id":"wireless_ad_ultrasuoni","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Wireless ad ultrasuoni","sub_category_name_en":"Wireless bell pushes","sub_category_description_it":"","sub_category_description_en":"","sub_category_name_ru":"УЛЬТРАЗВУКОВАЯ БЕСПРОВОДНАЯ СВЯЗЬ","sub_category_description_ru":"","sub_category_name_ru_latin":"ULЬTRAZVUKOVAЯ BESPROVODNAЯ SVЯZЬ","nascondi_in_home_page":true},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/375"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=375"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":373,"date":"2017-05-19T11:01:40","date_gmt":"2017-05-19T09:01:40","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=373"},"modified":"2020-02-14T16:46:34","modified_gmt":"2020-02-14T15:46:34","slug":"tubo-rivestito","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/tubo-rivestito/","title":{"rendered":"Tubo rivestito"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"05_02","sub_category_id":"tubo_rivestito","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Tubo rivestito","sub_category_name_en":"Covered tube","sub_category_description_it":"","sub_category_description_en":"","sub_category_name_ru":"ТРУБА С ОБОЛОЧКОЙ","sub_category_description_ru":"","sub_category_name_ru_latin":"TRUBA S OBOLOČKOЙ"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/373"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=373"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":372,"date":"2017-05-19T10:59:37","date_gmt":"2017-05-19T08:59:37","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=372"},"modified":"2020-03-05T16:30:06","modified_gmt":"2020-03-05T15:30:06","slug":"reglette-e-strisce-luce-led","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/reglette-e-strisce-luce-led/","title":{"rendered":"Reglette e strisce luce LED"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"04_03","sub_category_id":"reglette_e_strisce_luce_led","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Reglette e strisce luce LED","sub_category_name_en":"Lighting assembly and LED strips","sub_category_description_it":"","sub_category_description_en":"","sub_category_name_ru":"СВЕТОДИОДНАЯ ЛЕНТА","sub_category_description_ru":"","sub_category_name_ru_latin":"SVETODIODNAJa LENTA"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/372"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=372"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":369,"date":"2017-05-19T10:53:12","date_gmt":"2017-05-19T08:53:12","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=369"},"modified":"2020-02-14T16:47:02","modified_gmt":"2020-02-14T15:47:02","slug":"dispositivi-di-bloccaggio","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/dispositivi-di-bloccaggio/","title":{"rendered":"Dispositivi di bloccaggio"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"02_04","sub_category_id":"dispositivi_di_bloccaggio","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Dispositivi di bloccaggio","sub_category_name_en":"Locking devices","sub_category_description_it":"","sub_category_description_en":"","sub_category_name_ru":"ЗАПОРНЫЕ УСТРОЙСТВА","sub_category_description_ru":"","sub_category_name_ru_latin":"ZAPORNЫE USTROЙSTVA"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/369"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=369"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":344,"date":"2017-05-11T12:53:56","date_gmt":"2017-05-11T10:53:56","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=344"},"modified":"2022-10-20T14:07:47","modified_gmt":"2022-10-20T12:07:47","slug":"sistemi-di-apertura-portelloni-pneumatici","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/sistemi-di-apertura-portelloni-pneumatici/","title":{"rendered":"Sistemi di apertura portelloni pneumatici"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"sistemi_di_apertura_portelloni_pneumatici","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Sistemi di apertura portelloni pneumatici","sub_category_name_en":"Pneumatic doors opening system","sub_category_description_it":"","sub_category_description_en":"","index_order":"08_03","sub_category_name_ru":"ПНЕВМАТИЧЕСКИЕ СИСТЕМЫ ОТКРЫВАНИЯ ДВЕРЕЙ","sub_category_description_ru":"","sub_category_name_ru_latin":"PNEVMATIČESKIE SISTEMЫ OTKRЫVANIЯ DVEREЙ"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/344"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=344"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":343,"date":"2017-05-11T12:50:13","date_gmt":"2017-05-11T10:50:13","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=343"},"modified":"2022-10-20T14:07:56","modified_gmt":"2022-10-20T12:07:56","slug":"sistemi-di-apertura-portelloni-manuali","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/sistemi-di-apertura-portelloni-manuali/","title":{"rendered":"Sistemi di apertura portelloni manuali"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"sistemi_di_apertura_portelloni_manuali","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Sistemi di apertura portelloni manuali","sub_category_name_en":"Manuals door opening system","sub_category_description_it":"","sub_category_description_en":"","index_order":"08_01","sub_category_name_ru":"СИСТЕМЫ ДЛЯ ОТКРЫТИЯ ДВЕРЕЙ В РУЧНУЮ","sub_category_description_ru":"","sub_category_name_ru_latin":"SISTEMY DLJa OTKRYTIJa DVEREJ V RUČNUJu"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/343"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=343"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":53,"date":"2017-04-11T12:49:19","date_gmt":"2017-04-11T10:49:19","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=53"},"modified":"2022-10-20T12:16:04","modified_gmt":"2022-10-20T10:16:04","slug":"cappelliere-per-bus-urbani-e-interurbani","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/cappelliere-per-bus-urbani-e-interurbani/","title":{"rendered":"Cappelliere per bus urbani-interurbani"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"cappelliere_per_bus_urbani_e_interurbani","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Cappelliere per bus urbani-interurbani","sub_category_name_en":"Luggage racks for city-intercity bus","sub_category_description_it":"","sub_category_description_en":"","index_order":"09_02","sub_category_name_ru":"БАГАЖНЫЕ ПОЛКИ ДЛЯ ГОРОДСКИХ И МЕЖДУГОРОДНЫХ АВТОБУСОВ","sub_category_description_ru":"","sub_category_name_ru_latin":"BAGAŽNYE POLKI DLJa GORODSKIH I MEŽDUGORODNYH AVTOBUSOV"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/53"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=53"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":52,"date":"2017-04-11T12:48:35","date_gmt":"2017-04-11T10:48:35","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=52"},"modified":"2022-10-20T12:16:36","modified_gmt":"2022-10-20T10:16:36","slug":"cappelliere-per-bus-turistici","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/cappelliere-per-bus-turistici/","title":{"rendered":"Cappelliere per bus turistici"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"cappelliere_per_bus_turistici","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Cappelliere per bus turistici","sub_category_name_en":"Luggage racks for coach","sub_category_description_it":"BAGAŽNYE POLKI DLJa TURISTIČESKIH AVTOBUSOV","sub_category_description_en":"","index_order":"09_01","sub_category_name_ru":"БАГАЖНЫЕ ПОЛКИ ДЛЯ ТУРИСТИЧЕСКИХ АВТОБУСОВ","sub_category_description_ru":"","sub_category_name_ru_latin":"POLKI DLЯ TURISTIČESKIH AVTOBUSOV"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/52"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=52"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":51,"date":"2017-04-11T12:47:58","date_gmt":"2017-04-11T10:47:58","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=51"},"modified":"2020-02-14T16:48:45","modified_gmt":"2020-02-14T15:48:45","slug":"multiset","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/multiset/","title":{"rendered":"Multiset"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"multiset","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Multiset","sub_category_name_en":"Multiset","sub_category_description_it":"","sub_category_description_en":"","index_order":"07_01","sub_category_name_ru":"МУЛЬТИКОМПЛЕКТ","sub_category_description_ru":"","sub_category_name_ru_latin":"MULЬTIKOMPLEKT"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/51"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=51"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":49,"date":"2017-04-11T12:46:21","date_gmt":"2017-04-11T10:46:21","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=49"},"modified":"2020-02-14T16:49:30","modified_gmt":"2020-02-14T15:49:30","slug":"maniglie-di-presa","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/maniglie-di-presa/","title":{"rendered":"Maniglia di presa per urbani"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"maniglia_di_presa_per_urbani","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Maniglia di presa per urbani","sub_category_name_en":"Citybus catching handles","sub_category_description_it":"","sub_category_description_en":"","index_order":"05_03","sub_category_name_ru":"РУКОЯТКИ ДЛЯ ГОРОДСКОГО ТРАНСПОРТА","sub_category_description_ru":"","sub_category_name_ru_latin":"RUKOЯTKI DLЯ GORODSKOGO TRANSPORTA"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/49"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=49"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":47,"date":"2017-04-11T12:45:07","date_gmt":"2017-04-11T10:45:07","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=47"},"modified":"2020-02-14T16:52:03","modified_gmt":"2020-02-14T15:52:03","slug":"morsetteria-per-urbani","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/morsetteria-per-urbani/","title":{"rendered":"Morsetti in plastica per urbani"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"morsetti_in_plastica_per_urbani","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Morsetti in plastica per urbani","sub_category_name_en":"Citybus plastic support","sub_category_description_it":"","sub_category_description_en":"","index_order":"05_01","sub_category_name_ru":"ПЛАСТИКОВЫЕ ЗАЖИМЫ ДЛЯ ГОРОДСКОГО ТРАНСПОРТА","sub_category_description_ru":"","sub_category_name_ru_latin":"PLASTIKOVЫE ZAŽIMЫ DLЯ GORODSKOGO TRANSPORTA"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/47"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=47"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":46,"date":"2017-04-11T12:44:33","date_gmt":"2017-04-11T10:44:33","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=46"},"modified":"2020-02-14T16:52:34","modified_gmt":"2020-02-14T15:52:34","slug":"plafoniere","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/plafoniere/","title":{"rendered":"Plafoniere"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"plafoniere","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Plafoniere","sub_category_name_en":"Central Lighting Boards","sub_category_description_it":"","sub_category_description_en":"","index_order":"04_04","sub_category_name_ru":"ПЛАФОНЫ","sub_category_description_ru":"","sub_category_name_ru_latin":"PLAFONЫ"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/46"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=46"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":45,"date":"2017-04-11T12:43:58","date_gmt":"2017-04-11T10:43:58","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=45"},"modified":"2020-03-05T16:28:43","modified_gmt":"2020-03-05T15:28:43","slug":"diffusori-luce-tondi","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/diffusori-luce-tondi/","title":{"rendered":"Diffusori luce tondi"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"diffusori_luce_tondi","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Diffusori luce tondi","sub_category_name_en":"Round light diffusers","sub_category_description_it":"","sub_category_description_en":"","index_order":"04_01","sub_category_name_ru":"КРУГЛЫЕ ЛАМПЫ ДЛЯ ОСВЕЩЕНИЯ САЛОНА","sub_category_description_ru":"","sub_category_name_ru_latin":"KRUGLYE LAMPY DLJa OSVEŜENIJa SALONA"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/45"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=45"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":44,"date":"2017-04-11T12:42:52","date_gmt":"2017-04-11T10:42:52","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=44"},"modified":"2020-03-05T16:29:22","modified_gmt":"2020-03-05T15:29:22","slug":"diffusori-luce-rettangolari","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/diffusori-luce-rettangolari/","title":{"rendered":"Diffusori luce rettangolari"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"diffusori_luce_rettangolari","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Diffusori luce rettangolari","sub_category_name_en":"Rectangular light diffusers","sub_category_description_it":"","sub_category_description_en":"","index_order":"04_02","sub_category_name_ru":"ПЛАФОН СВЕТОДИОДНЫЙ ДЛЯ ОСВЕЩЕНИЯ САЛОНА ","sub_category_description_ru":"","sub_category_name_ru_latin":"PLAFON SVETODIODNYJ DLJa OSVEŜENIJa SALONA "},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/44"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=44"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":43,"date":"2017-04-11T12:27:13","date_gmt":"2017-04-11T10:27:13","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=43"},"modified":"2020-03-05T16:39:03","modified_gmt":"2020-03-05T15:39:03","slug":"riduzioni-e-raccordi","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/riduzioni-e-raccordi/","title":{"rendered":"Riduzioni raccordi e tubi"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"riduzioni_raccordi_e_tubi","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Riduzioni raccordi e tubi","sub_category_name_en":"Reductions connectors and hoses","sub_category_description_it":"","sub_category_description_en":"","index_order":"03_04","sub_category_name_ru":"РЕДУКТОРЫ, СОЕДИНЕНИЕ И ШЛАНГИ","sub_category_description_ru":"","sub_category_name_ru_latin":"REDUKTORY, SOEDINENIE I ŠLANGI"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/43"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=43"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":42,"date":"2017-04-11T12:26:39","date_gmt":"2017-04-11T10:26:39","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=42"},"modified":"2020-02-14T16:53:44","modified_gmt":"2020-02-14T15:53:44","slug":"diffusori-aria-fissi-a-griglie-di-areazione","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/diffusori-aria-fissi-a-griglie-di-areazione/","title":{"rendered":"Diffusori aria fissi e griglie di areazione"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"diffusori_aria_fissi_e_griglie_di_areazione","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Diffusori aria fissi e griglie di areazione","sub_category_name_en":"Not adjustable air diffuser and grids","sub_category_description_it":"","sub_category_description_en":"","index_order":"03_03","sub_category_name_ru":"СТАЦИОНАРНЫЕ ДИФФУЗОРЫ ВОЗДУХА И ВЕНТИЛЯЦИОННЫЕ РЕШЕТКИ","sub_category_description_ru":"","sub_category_name_ru_latin":"STACIONARNЫE DIFFUZORЫ VOZDUHA I VENTILЯCIONNЫE REŠETKI"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/42"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=42"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":41,"date":"2017-04-11T12:25:52","date_gmt":"2017-04-11T10:25:52","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41"},"modified":"2020-02-14T16:54:00","modified_gmt":"2020-02-14T15:54:00","slug":"diffusori-aria-tondi-orientabili","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/diffusori-aria-tondi-orientabili/","title":{"rendered":"Diffusori aria tondi orientabili"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"diffusori_aria_tondi_orientabili","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Diffusori aria tondi orientabili","sub_category_name_en":"Round adjustable air diffuser","sub_category_description_it":"","sub_category_description_en":"","index_order":"03_02","sub_category_name_ru":"РЕГУЛИРУЕМЫЕ КРУГЛЫЕ ДИФФУЗОРЫ ВОЗДУХА ","sub_category_description_ru":"","sub_category_name_ru_latin":"REGULIRUEMЫE KRUGLЫE DIFFUZORЫ VOZDUHA"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/41"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=41"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":40,"date":"2017-04-11T12:25:08","date_gmt":"2017-04-11T10:25:08","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=40"},"modified":"2020-02-14T16:54:23","modified_gmt":"2020-02-14T15:54:23","slug":"diffusori-aria-rettangolari-orientabili","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/diffusori-aria-rettangolari-orientabili/","title":{"rendered":"Diffusori aria rettangolari orientabili"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"diffusori_aria_rettangolari_orientabili","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Diffusori aria rettangolari orientabili","sub_category_name_en":"Rectangular adjustable air diffuser","sub_category_description_it":"","sub_category_description_en":"","index_order":"03_01","sub_category_name_ru":"РЕГУЛИРУЕМЫЕ ПРЯМОУГОЛЬНЫЕ ДИФФУЗОРЫ ВОЗДУХА","sub_category_description_ru":"","sub_category_name_ru_latin":"REGULIRUEMЫE PRЯMOUGOLЬNЫE DIFFUZORЫ VOZDUHA"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/40"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=40"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":39,"date":"2017-04-11T12:24:07","date_gmt":"2017-04-11T10:24:07","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=39"},"modified":"2020-02-14T16:54:37","modified_gmt":"2020-02-14T15:54:37","slug":"cerniere","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/cerniere/","title":{"rendered":"Cerniere"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"cerniere","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Cerniere","sub_category_name_en":"Hinges","sub_category_description_it":"","sub_category_description_en":"","index_order":"02_06","sub_category_name_ru":"ПЕТЛИ ","sub_category_description_ru":"","sub_category_name_ru_latin":"PETLI"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/39"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=39"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":36,"date":"2017-04-11T12:19:10","date_gmt":"2017-04-11T10:19:10","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=36"},"modified":"2020-02-14T16:55:06","modified_gmt":"2020-02-14T15:55:06","slug":"scontrini","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/scontrini/","title":{"rendered":"Scontrini"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"scontrini","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Scontrini","sub_category_name_en":"Pin Vangers","sub_category_description_it":"","sub_category_description_en":"","index_order":"02_07","sub_category_name_ru":"ФИКСАТОРЫ","sub_category_description_ru":"","sub_category_name_ru_latin":"FIKSATORЫ"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/36"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=36"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":35,"date":"2017-04-11T12:18:42","date_gmt":"2017-04-11T10:18:42","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=35"},"modified":"2020-03-05T16:06:08","modified_gmt":"2020-03-05T15:06:08","slug":"aste-di-collegamento","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/aste-di-collegamento/","title":{"rendered":"Aste di collegamento"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"aste_di_collegamento","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Aste di collegamento","sub_category_name_en":"Connecting rods","sub_category_description_it":"","sub_category_description_en":"","index_order":"02_03","sub_category_name_ru":"СОЕДИНИТЕЛЬНЫЕ СТЕРЖНИ","sub_category_description_ru":"","sub_category_name_ru_latin":"SOEDINITELʹNYE STERŽNI"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/35"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=35"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":34,"date":"2017-04-11T12:17:51","date_gmt":"2017-04-11T10:17:51","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=34"},"modified":"2020-03-05T16:05:23","modified_gmt":"2020-03-05T15:05:23","slug":"serrandole","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/serrandole/","title":{"rendered":"Serrandole"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"serrandole","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Serrandole","sub_category_name_en":"Locking Gears","sub_category_description_it":"","sub_category_description_en":"","index_order":"02_02","sub_category_name_ru":"БЛОКИРОВКА ПЕРЕДАЧ","sub_category_description_ru":"","sub_category_name_ru_latin":"BLOKIROVKA PEREDAČ"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/34"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=34"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":33,"date":"2017-04-11T12:17:18","date_gmt":"2017-04-11T10:17:18","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=33"},"modified":"2022-11-17T17:29:59","modified_gmt":"2022-11-17T16:29:59","slug":"sistemi-di-chiusura-pneumatici-ed-elettrici","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/sistemi-di-chiusura-pneumatici-ed-elettrici/","title":{"rendered":"Sistemi di chiusura pneumatici ed elettrici"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"sistemi_di_chiusura_pneumatici_ed_elettrici","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Sistemi di chiusura pneumatici ed elettrici","sub_category_name_en":"Electric and pneumatic locking devices","sub_category_description_it":"","sub_category_description_en":"","index_order":"02_01","sub_category_name_ru":"ПНЕВМАТИЧЕСКИЕ И ЭЛЕКТРИЧЕСКИЕ СИСТЕМЫ ЗАКРЫТИЯ","sub_category_description_ru":"","sub_category_name_ru_latin":"PNEVMATIČESKIE I ЭLEKTRIČESKIE SISTEMЫ ZAKRЫTIЯ","nascondi_in_home_page":true},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/33"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=33"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":32,"date":"2017-04-11T12:15:22","date_gmt":"2017-04-11T10:15:22","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=32"},"modified":"2020-03-05T15:19:06","modified_gmt":"2020-03-05T14:19:06","slug":"serrature-maniglie","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/serrature-maniglie/","title":{"rendered":"Serrature maniglie"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"serrature_maniglie","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Serrature maniglie","sub_category_name_en":"Key lock","sub_category_description_it":"","sub_category_description_en":"","index_order":"01_05","sub_category_name_ru":"ЗАМКИ / ЗАМКИ ДЛЯ АВТОБУСА","sub_category_description_ru":"","sub_category_name_ru_latin":"ZAMKI / ZAMKI DLJa AVTOBUSA"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/32"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=32"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":31,"date":"2017-04-11T12:14:50","date_gmt":"2017-04-11T10:14:50","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=31"},"modified":"2020-02-14T16:56:25","modified_gmt":"2020-02-14T15:56:25","slug":"maniglie-per-interni","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/maniglie-per-interni/","title":{"rendered":"Maniglie per interni"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"maniglie_per_interni","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Maniglie per interni","sub_category_name_en":"Interior handle","sub_category_description_it":"","sub_category_description_en":"","index_order":"01_04","sub_category_name_ru":"РУЧКИ ДЛЯ ИНТЕРЬЕРОВ","sub_category_description_ru":"","sub_category_name_ru_latin":"RUČKI DLЯ INTERЬEROV"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/31"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=31"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":30,"date":"2017-04-11T12:14:18","date_gmt":"2017-04-11T10:14:18","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=30"},"modified":"2020-02-14T16:56:40","modified_gmt":"2020-02-14T15:56:40","slug":"maniglie-per-porta-passeggeri","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/maniglie-per-porta-passeggeri/","title":{"rendered":"Maniglie per porte passeggeri"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"maniglie_per_porte_passeggeri","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Maniglie per porte passeggeri","sub_category_name_en":"Passenger's doors handle","sub_category_description_it":"","sub_category_description_en":"","index_order":"01_03","sub_category_name_ru":"РУЧКИ ДЛЯ ПАССАЖИРСКИХ ДВЕРЕЙ","sub_category_description_ru":"","sub_category_name_ru_latin":"RUČKI DLЯ PASSAŽIRSKIH DVEREЙ"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/30"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=30"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":29,"date":"2017-04-11T12:13:43","date_gmt":"2017-04-11T10:13:43","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=29"},"modified":"2020-02-14T16:56:54","modified_gmt":"2020-02-14T15:56:54","slug":"maniglie-per-porta-autista","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/maniglie-per-porta-autista/","title":{"rendered":"Maniglie per porta autista"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"maniglie_per_porta_autista","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Maniglie per porta autista","sub_category_name_en":"Driver's door handle","sub_category_description_it":"","sub_category_description_en":"","index_order":"01_02","sub_category_name_ru":"РУЧКИ ДЛЯ ВОДИТЕЛЬСКОЙ ДВЕРИ","sub_category_description_ru":"","sub_category_name_ru_latin":"RUČKI DLЯ VODITELЬSKOЙ DVERI"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/29"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=29"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":28,"date":"2017-04-11T12:12:39","date_gmt":"2017-04-11T10:12:39","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=28"},"modified":"2020-03-05T15:18:21","modified_gmt":"2020-03-05T14:18:21","slug":"maniglie-per-portelloni","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/maniglie-per-portelloni/","title":{"rendered":"Maniglie per portelloni"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"maniglie_per_portelloni","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Maniglie per portelloni","sub_category_name_en":"Luggage door handle","sub_category_description_it":"","sub_category_description_en":"","index_order":"01_01","sub_category_name_ru":"Ручки для двери багажника","sub_category_description_ru":"","sub_category_name_ru_latin":"Ručki dlja dveri bagažnika"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/28"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=28"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":25,"date":"2017-04-11T12:09:30","date_gmt":"2017-04-11T10:09:30","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=25"},"modified":"2022-10-20T14:08:48","modified_gmt":"2022-10-20T12:08:48","slug":"supporti-e-snodi-per-molle-a-gas","status":"publish","type":"sub_categories","link":"https://wp.primaautomotive.it/sub_categories/supporti-e-snodi-per-molle-a-gas/","title":{"rendered":"Supporti e snodi per molle a gas"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"sub_category_id":"supporti_e_snodi_per_molle_a_gas","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_name_it":"Supporti e snodi per molle a gas","sub_category_name_en":"Support and joint for gas spings","sub_category_description_it":"","sub_category_description_en":"","index_order":"08_02","sub_category_name_ru":"ОПОРЫ И СОЕДИНЕНИЯ ДЛЯ ГАЗОВЫХ ПРУЖИН","sub_category_description_ru":"","sub_category_name_ru_latin":"OPORY I SOEDINENIJa DLJa GAZOVYH PRUŽIN"},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories/25"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/sub_categories"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/sub_categories"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=25"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}}]

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

	module.exports = [{"id":1787,"date":"2023-10-02T12:04:10","date_gmt":"2023-10-02T10:04:10","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1787"},"modified":"2023-10-02T12:04:10","modified_gmt":"2023-10-02T10:04:10","slug":"p1150","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p1150/","title":{"rendered":"P1150"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"07_01_13","product_id":"p1150_moon_mini","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":52,"post_author":"1","post_date":"2017-04-11 12:48:35","post_date_gmt":"2017-04-11 10:48:35","post_content":"","post_title":"Cappelliere per bus turistici","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"cappelliere-per-bus-turistici","to_ping":"","pinged":"","post_modified":"2022-10-20 12:16:36","post_modified_gmt":"2022-10-20 10:16:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=52","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Cappelliere per minibus","product_name_en":"Luggage racks for minibuses","product_name_ru":"Luggage racks for minibuses","product_image":false,"product_description_it":"","product_description_en":"","product_description_ru":"","product_variants":"","coaches":false,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2023/10/P1150.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1787"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1787"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1759,"date":"2023-10-02T10:32:30","date_gmt":"2023-10-02T08:32:30","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1759"},"modified":"2023-10-02T17:40:35","modified_gmt":"2023-10-02T15:40:35","slug":"p256","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p256/","title":{"rendered":"P256"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"05_05_03","product_id":"p256","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":376,"post_author":"1","post_date":"2017-05-19 11:05:31","post_date_gmt":"2017-05-19 09:05:31","post_content":"","post_title":"Tasto rialzato","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"tasto-rialzato","to_ping":"","pinged":"","post_modified":"2022-11-17 17:55:55","post_modified_gmt":"2022-11-17 16:55:55","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=376","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Pulsantiera tasto rialzato","product_name_en":"Raised button","product_name_ru":"Raised button","product_image":{"ID":1810,"id":1810,"title":"p386S_1_IMG_9955","filename":"p386S_1_IMG_9955.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2023/10/p386S_1_IMG_9955.jpg","alt":"","author":"1","description":"","caption":"","name":"p386s_1_img_9955","date":"2023-10-02 15:40:20","modified":"2023-10-02 15:40:28","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":4368,"height":2912,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2023/10/p386S_1_IMG_9955-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2023/10/p386S_1_IMG_9955-300x200.jpg","medium-width":300,"medium-height":200,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2023/10/p386S_1_IMG_9955-768x512.jpg","medium_large-width":525,"medium_large-height":350,"large":"https://wp.primaautomotive.it/wp-content/uploads/2023/10/p386S_1_IMG_9955-1024x683.jpg","large-width":525,"large-height":350,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2023/10/p386S_1_IMG_9955-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2023/10/p386S_1_IMG_9955-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"","product_description_en":"","product_description_ru":"","product_variants":"64102,64112,64152,64162,64172","coaches":false,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2023/10/P256.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1759"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1759"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1733,"date":"2023-09-29T15:14:36","date_gmt":"2023-09-29T13:14:36","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1733"},"modified":"2023-09-29T15:14:36","modified_gmt":"2023-09-29T13:14:36","slug":"p37","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p37/","title":{"rendered":"P37"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"02_01_09","product_id":"p37","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":1732,"post_author":"1","post_date":"2023-09-29 15:11:40","post_date_gmt":"2023-09-29 13:11:40","post_content":"","post_title":"Prese USB","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"prese-usb","to_ping":"","pinged":"","post_modified":"2023-09-29 15:11:40","post_modified_gmt":"2023-09-29 13:11:40","post_content_filtered":"","post_parent":0,"guid":"https://wp.primaautomotive.it/?post_type=sub_categories&#038;p=1732","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Presa USB singola","product_name_en":"Single USB socket","product_name_ru":"","product_image":{"ID":1734,"id":1734,"title":"P37_A_B_834_837","filename":"P37_A_B_834_837.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P37_A_B_834_837.jpg","alt":"","author":"1","description":"","caption":"","name":"p37_a_b_834_837","date":"2023-09-29 13:13:25","modified":"2023-09-29 13:13:29","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":2738,"height":2090,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P37_A_B_834_837-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P37_A_B_834_837-300x229.jpg","medium-width":300,"medium-height":229,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P37_A_B_834_837-768x586.jpg","medium_large-width":525,"medium_large-height":401,"large":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P37_A_B_834_837-1024x782.jpg","large-width":525,"large-height":401,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P37_A_B_834_837-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P37_A_B_834_837-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"","product_description_en":"","product_description_ru":"","product_variants":"66440,66450","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P37.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1733"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1733"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1591,"date":"2023-09-28T11:26:31","date_gmt":"2023-09-28T09:26:31","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1591"},"modified":"2023-09-28T11:26:48","modified_gmt":"2023-09-28T09:26:48","slug":"p377","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p377/","title":{"rendered":"P377"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"01_02_05","product_id":"p377","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":29,"post_author":"1","post_date":"2017-04-11 12:13:43","post_date_gmt":"2017-04-11 10:13:43","post_content":"","post_title":"Maniglie per porta autista","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-porta-autista","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:54","post_modified_gmt":"2020-02-14 15:56:54","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=29","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia porta autista","product_name_en":"Driver's door handle","product_name_ru":"Ручка для водительской двери","product_image":{"ID":1592,"id":1592,"title":"P_377_foto","filename":"P_377_foto.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P_377_foto.jpg","alt":"","author":"1","description":"","caption":"","name":"p_377_foto","date":"2023-09-28 09:24:28","modified":"2023-09-28 09:24:31","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":827,"height":591,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P_377_foto-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P_377_foto-300x214.jpg","medium-width":300,"medium-height":214,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P_377_foto-768x549.jpg","medium_large-width":525,"medium_large-height":375,"large":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P_377_foto.jpg","large-width":525,"large-height":375,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P_377_foto.jpg","twentyseventeen-featured-image-width":827,"twentyseventeen-featured-image-height":591,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P_377_foto-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"","product_description_en":"","product_description_ru":"","product_variants":"67459,67469","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P377.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1591"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1591"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1562,"date":"2023-09-28T08:59:42","date_gmt":"2023-09-28T06:59:42","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1562"},"modified":"2023-09-28T08:59:46","modified_gmt":"2023-09-28T06:59:46","slug":"p35","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p35/","title":{"rendered":"P35"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"01_05_04","product_id":"p35","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":32,"post_author":"1","post_date":"2017-04-11 12:15:22","post_date_gmt":"2017-04-11 10:15:22","post_content":"","post_title":"Serrature maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"serrature-maniglie","to_ping":"","pinged":"","post_modified":"2020-03-05 15:19:06","post_modified_gmt":"2020-03-05 14:19:06","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=32","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Serratura","product_name_en":"Key lock","product_name_ru":"Key lock","product_image":{"ID":1563,"id":1563,"title":"P35_879","filename":"P35_879.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P35_879.jpg","alt":"","author":"1","description":"","caption":"","name":"p35_879","date":"2023-09-28 06:56:55","modified":"2023-09-28 06:56:59","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":3361,"height":1993,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P35_879-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P35_879-300x178.jpg","medium-width":300,"medium-height":178,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P35_879-768x455.jpg","medium_large-width":525,"medium_large-height":311,"large":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P35_879-1024x607.jpg","large-width":525,"large-height":311,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P35_879-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P35_879-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"","product_description_en":"","product_description_ru":"","product_variants":"66390,66400,66410,66420,66430","coaches":false,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P35.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1562"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1562"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1556,"date":"2023-09-27T11:59:31","date_gmt":"2023-09-27T09:59:31","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1556"},"modified":"2023-09-27T11:59:31","modified_gmt":"2023-09-27T09:59:31","slug":"p141r","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p141r/","title":{"rendered":"P141R"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"01_01_07","product_id":"p141r","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":28,"post_author":"1","post_date":"2017-04-11 12:12:39","post_date_gmt":"2017-04-11 10:12:39","post_content":"","post_title":"Maniglie per portelloni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-portelloni","to_ping":"","pinged":"","post_modified":"2020-03-05 15:18:21","post_modified_gmt":"2020-03-05 14:18:21","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=28","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":" Maniglia per portelloni","product_name_en":"Luggage door handle","product_name_ru":"","product_image":{"ID":1557,"id":1557,"title":"P141R_A_755.","filename":"P141R_A_755..jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141R_A_755..jpg","alt":"","author":"1","description":"","caption":"","name":"p141r_a_755","date":"2023-09-27 09:57:50","modified":"2023-09-27 09:57:56","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":3253,"height":3549,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141R_A_755.-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141R_A_755.-275x300.jpg","medium-width":275,"medium-height":300,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141R_A_755.-768x838.jpg","medium_large-width":525,"medium_large-height":573,"large":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141R_A_755.-939x1024.jpg","large-width":525,"large-height":573,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141R_A_755.-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141R_A_755.-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"","product_description_en":"","product_description_ru":"","product_variants":"66320,66330","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/Prima_Maniglie_P119R_P141R-1.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1556"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1556"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1553,"date":"2023-09-27T11:55:44","date_gmt":"2023-09-27T09:55:44","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1553"},"modified":"2023-09-27T12:00:00","modified_gmt":"2023-09-27T10:00:00","slug":"p119r","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p119r/","title":{"rendered":"P119R"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"01_01_06","product_id":"p119r","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":28,"post_author":"1","post_date":"2017-04-11 12:12:39","post_date_gmt":"2017-04-11 10:12:39","post_content":"","post_title":"Maniglie per portelloni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-portelloni","to_ping":"","pinged":"","post_modified":"2020-03-05 15:18:21","post_modified_gmt":"2020-03-05 14:18:21","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=28","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per portelloni","product_name_en":"Luggage door handles","product_name_ru":"","product_image":{"ID":1554,"id":1554,"title":"P119R_758","filename":"P119R_758.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P119R_758.jpg","alt":"","author":"1","description":"","caption":"","name":"p119r_758","date":"2023-09-27 09:51:49","modified":"2023-09-27 09:51:57","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":3144,"height":3257,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P119R_758-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P119R_758-290x300.jpg","medium-width":290,"medium-height":300,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P119R_758-768x796.jpg","medium_large-width":525,"medium_large-height":544,"large":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P119R_758-988x1024.jpg","large-width":525,"large-height":544,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P119R_758-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P119R_758-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"","product_description_en":"","product_description_ru":"","product_variants":"66200,66310","coaches":true,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/Prima_Maniglie_P119R_P141R.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1553"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1553"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1545,"date":"2023-09-27T10:52:58","date_gmt":"2023-09-27T08:52:58","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1545"},"modified":"2023-09-29T14:51:59","modified_gmt":"2023-09-29T12:51:59","slug":"p555","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p555/","title":{"rendered":"P555"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"05_01_01","product_id":"p555","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":1561,"post_author":"1","post_date":"2023-09-27 12:53:08","post_date_gmt":"2023-09-27 10:53:08","post_content":"","post_title":"Pannelli richiesta fermata","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"pannelli-richiesta-fermata","to_ping":"","pinged":"","post_modified":"2023-09-27 12:53:08","post_modified_gmt":"2023-09-27 10:53:08","post_content_filtered":"","post_parent":0,"guid":"https://wp.primaautomotive.it/?post_type=sub_categories&#038;p=1561","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Pannello richiesta fermata","product_name_en":"Stop request panel","product_name_ru":"","product_image":{"ID":1546,"id":1546,"title":"P555_748","filename":"P555_748.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P555_748.jpg","alt":"","author":"1","description":"","caption":"","name":"p555_748","date":"2023-09-27 08:50:43","modified":"2023-09-27 08:50:46","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":3272,"height":2258,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P555_748-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P555_748-300x207.jpg","medium-width":300,"medium-height":207,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P555_748-768x530.jpg","medium_large-width":525,"medium_large-height":362,"large":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P555_748-1024x707.jpg","large-width":525,"large-height":362,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P555_748-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P555_748-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"","product_description_en":"","product_description_ru":"","product_variants":"66574","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P555.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1545"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1545"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1543,"date":"2023-09-27T10:13:39","date_gmt":"2023-09-27T08:13:39","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1543"},"modified":"2023-09-29T12:30:09","modified_gmt":"2023-09-29T10:30:09","slug":"p567","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p567/","title":{"rendered":"P567"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"04_02_01","product_id":"p567","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":45,"post_author":"1","post_date":"2017-04-11 12:43:58","post_date_gmt":"2017-04-11 10:43:58","post_content":"","post_title":"Diffusori luce tondi","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-luce-tondi","to_ping":"","pinged":"","post_modified":"2020-03-05 16:28:43","post_modified_gmt":"2020-03-05 15:28:43","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=45","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Tondo fisso","product_name_en":"Round not adjustable","product_name_ru":"","product_image":{"ID":1544,"id":1544,"title":"P567_798","filename":"P567_798.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P567_798.jpg","alt":"","author":"1","description":"","caption":"","name":"p567_798","date":"2023-09-27 07:48:14","modified":"2023-09-27 07:48:19","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":2341,"height":3106,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P567_798-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P567_798-226x300.jpg","medium-width":226,"medium-height":300,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P567_798-768x1019.jpg","medium_large-width":525,"medium_large-height":697,"large":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P567_798-772x1024.jpg","large-width":525,"large-height":696,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P567_798-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P567_798-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"","product_description_en":"","product_description_ru":"","product_variants":"66754","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P567.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1543"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1543"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1540,"date":"2023-09-27T09:10:04","date_gmt":"2023-09-27T07:10:04","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1540"},"modified":"2023-09-28T12:13:27","modified_gmt":"2023-09-28T10:13:27","slug":"p141-e-kit","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p141-e-kit/","title":{"rendered":"P141 e-kit"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"01_01_07","product_id":"p141e-kit","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":28,"post_author":"1","post_date":"2017-04-11 12:12:39","post_date_gmt":"2017-04-11 10:12:39","post_content":"","post_title":"Maniglie per portelloni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-portelloni","to_ping":"","pinged":"","post_modified":"2020-03-05 15:18:21","post_modified_gmt":"2020-03-05 14:18:21","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=28","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per portelloni","product_name_en":"Luggage door handle","product_name_ru":"Ручки для дверей","product_image":{"ID":1541,"id":1541,"title":"P141_Kit_A_772","filename":"P141_Kit_A_772.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141_Kit_A_772.jpg","alt":"","author":"1","description":"","caption":"","name":"p141_kit_a_772","date":"2023-09-27 07:08:45","modified":"2023-09-27 07:08:48","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":3184,"height":2220,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141_Kit_A_772-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141_Kit_A_772-300x209.jpg","medium-width":300,"medium-height":209,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141_Kit_A_772-768x535.jpg","medium_large-width":525,"medium_large-height":366,"large":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141_Kit_A_772-1024x714.jpg","large-width":525,"large-height":366,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141_Kit_A_772-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141_Kit_A_772-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"","product_description_en":"","product_description_ru":"","product_variants":"66208","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/Prima_Maniglie_P119e-kit_P141e-kit-1.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1540"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1540"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1537,"date":"2023-09-27T09:04:42","date_gmt":"2023-09-27T07:04:42","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1537"},"modified":"2023-09-27T12:01:28","modified_gmt":"2023-09-27T10:01:28","slug":"p119-e-kit","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p119-e-kit/","title":{"rendered":"P119 e-kit"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"01_01_06","product_id":"p119e-kit","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":28,"post_author":"1","post_date":"2017-04-11 12:12:39","post_date_gmt":"2017-04-11 10:12:39","post_content":"","post_title":"Maniglie per portelloni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-portelloni","to_ping":"","pinged":"","post_modified":"2020-03-05 15:18:21","post_modified_gmt":"2020-03-05 14:18:21","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=28","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per portelloni","product_name_en":"Luggage door handle","product_name_ru":"Ручки для дверей","product_image":{"ID":1538,"id":1538,"title":"P141_Kit_B_780","filename":"P141_Kit_B_780.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141_Kit_B_780.jpg","alt":"","author":"1","description":"","caption":"","name":"p141_kit_b_780","date":"2023-09-27 07:00:18","modified":"2023-09-27 07:02:10","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":3125,"height":2126,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141_Kit_B_780-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141_Kit_B_780-300x204.jpg","medium-width":300,"medium-height":204,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141_Kit_B_780-768x522.jpg","medium_large-width":525,"medium_large-height":357,"large":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141_Kit_B_780-1024x697.jpg","large-width":525,"large-height":357,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141_Kit_B_780-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/P141_Kit_B_780-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"","product_description_en":"","product_description_ru":"","product_variants":"66340","coaches":true,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2023/09/Prima_Maniglie_P119e-kit_P141e-kit.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1537"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1537"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1523,"date":"2023-04-03T09:59:54","date_gmt":"2023-04-03T07:59:54","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1523"},"modified":"2023-10-05T15:23:42","modified_gmt":"2023-10-05T13:23:42","slug":"p328","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p328/","title":{"rendered":"P328"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"01_04_01","product_id":"p328","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":31,"post_author":"1","post_date":"2017-04-11 12:14:50","post_date_gmt":"2017-04-11 10:14:50","post_content":"","post_title":"Maniglie per interni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-interni","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:25","post_modified_gmt":"2020-02-14 15:56:25","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=31","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per interni","product_name_en":"Interior handle","product_name_ru":"Ручка для интерьеров","product_image":{"ID":1834,"id":1834,"title":"P328_nero_giallo","filename":"P328_nero_giallo.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/P328_nero_giallo.jpg","alt":"","author":"1","description":"","caption":"","name":"p328_nero_giallo","date":"2023-10-05 13:23:35","modified":"2023-10-05 13:23:40","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":3534,"height":2896,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/P328_nero_giallo-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/P328_nero_giallo-300x246.jpg","medium-width":300,"medium-height":246,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/P328_nero_giallo-768x629.jpg","medium_large-width":525,"medium_large-height":430,"large":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/P328_nero_giallo-1024x839.jpg","large-width":525,"large-height":430,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/P328_nero_giallo-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/P328_nero_giallo-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Maniglia appiglio per retro-sedile passeggeri.</p>\n","product_description_en":"<p>Grab handle for passengers ascent and descent.</p>\n","product_description_ru":"","product_variants":"66060,66070","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/P328.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1523"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1523"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1521,"date":"2023-04-03T09:55:49","date_gmt":"2023-04-03T07:55:49","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1521"},"modified":"2023-09-28T09:00:46","modified_gmt":"2023-09-28T07:00:46","slug":"p50","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p50/","title":{"rendered":"P50"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"01_04_02","product_id":"p50","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":31,"post_author":"1","post_date":"2017-04-11 12:14:50","post_date_gmt":"2017-04-11 10:14:50","post_content":"","post_title":"Maniglie per interni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-interni","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:25","post_modified_gmt":"2020-02-14 15:56:25","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=31","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per interni","product_name_en":"Interior handle","product_name_ru":"Ручка для интерьеров","product_image":{"ID":1522,"id":1522,"title":"P601_3780","filename":"P601_3780.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/P601_3780.jpg","alt":"","author":"7","description":"","caption":"","name":"p601_3780","date":"2023-04-03 07:52:47","modified":"2023-04-03 07:52:51","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":3664,"height":2445,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/P601_3780-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/P601_3780-300x200.jpg","medium-width":300,"medium-height":200,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/P601_3780-768x512.jpg","medium_large-width":525,"medium_large-height":350,"large":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/P601_3780-1024x683.jpg","large-width":525,"large-height":350,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/P601_3780-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/P601_3780-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Maniglia appiglio per retro-sedile passeggeri.</p>\n","product_description_en":"<p>Grap handles for passanger&#8217;s seats backrest.</p>\n","product_description_ru":"<p>Поручень для пассажирских сидений.</p>\n","product_variants":"66080","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/Prima_Maniglie_P50.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1521"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1521"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1516,"date":"2023-04-03T09:17:09","date_gmt":"2023-04-03T07:17:09","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1516"},"modified":"2023-10-02T17:34:54","modified_gmt":"2023-10-02T15:34:54","slug":"p159_type-1","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p159_type-1/","title":{"rendered":"P159_type 1"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"07_01_11","product_id":"p159_type1","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":51,"post_author":"1","post_date":"2017-04-11 12:47:58","post_date_gmt":"2017-04-11 10:47:58","post_content":"","post_title":"Multiset","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"multiset","to_ping":"","pinged":"","post_modified":"2020-02-14 16:48:45","post_modified_gmt":"2020-02-14 15:48:45","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=51","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Altoparlanti","product_name_en":"Loudspeaker","product_name_ru":"","product_image":{"ID":1808,"id":1808,"title":"Fp159","filename":"Fp159-1.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/Fp159-1.jpg","alt":"","author":"1","description":"","caption":"","name":"fp159-2","date":"2023-10-02 15:34:49","modified":"2023-10-02 15:34:51","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":1102,"height":787,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/Fp159-1-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/Fp159-1-300x214.jpg","medium-width":300,"medium-height":214,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/Fp159-1-768x548.jpg","medium_large-width":525,"medium_large-height":375,"large":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/Fp159-1-1024x731.jpg","large-width":525,"large-height":375,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/Fp159-1.jpg","twentyseventeen-featured-image-width":1102,"twentyseventeen-featured-image-height":787,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/Fp159-1-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Altoparlante per installazione individuale o in moduli di servizio.</p>\n","product_description_en":"<p>Loudspeaker suitbale for stand alone or installation on multisets.</p>\n","product_description_ru":"","product_variants":"69445,65485,64739,65117,67782,68521","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/P159type1_type2.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1516"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1516"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1514,"date":"2023-04-03T09:09:58","date_gmt":"2023-04-03T07:09:58","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1514"},"modified":"2023-10-02T19:18:12","modified_gmt":"2023-10-02T17:18:12","slug":"p124","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p124/","title":{"rendered":"P124"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"07_01_09","product_id":"p124","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":51,"post_author":"1","post_date":"2017-04-11 12:47:58","post_date_gmt":"2017-04-11 10:47:58","post_content":"","post_title":"Multiset","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"multiset","to_ping":"","pinged":"","post_modified":"2020-02-14 16:48:45","post_modified_gmt":"2020-02-14 15:48:45","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=51","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Modulo di servizio","product_name_en":"Multiset","product_name_ru":"","product_image":{"ID":1812,"id":1812,"title":"p124","filename":"p124.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/p124.jpg","alt":"","author":"1","description":"","caption":"","name":"p124-3","date":"2023-10-02 17:18:01","modified":"2023-10-02 17:18:03","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":2000,"height":2115,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/p124-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/p124-284x300.jpg","medium-width":284,"medium-height":300,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/p124-768x812.jpg","medium_large-width":525,"medium_large-height":555,"large":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/p124-968x1024.jpg","large-width":525,"large-height":555,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/p124-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/p124-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Modulo di servizio singolo con interuttore individuale e diffusori aria orientabili 2D, fornito con lampadine LED.</p>\n","product_description_en":"<p>Single seat multiset with adjustable light with on/off switch and 2D adjustable air diffuser. Supplied with led bulbs.</p>\n","product_description_ru":"","product_variants":"66120,66130,66140,66150,66460","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2023/04/P124.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1514"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1514"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1395,"date":"2022-07-18T12:18:07","date_gmt":"2022-07-18T10:18:07","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1395"},"modified":"2023-09-29T10:04:26","modified_gmt":"2023-09-29T08:04:26","slug":"p355","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p355/","title":{"rendered":"P355"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"03_02_07_1","product_id":"p355","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_name_ru":"Диффузор воздуха","product_image":{"ID":1397,"id":1397,"title":"P355","filename":"P355.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P355.jpg","alt":"","author":"7","description":"","caption":"","name":"p355-3","date":"2022-07-18 10:16:05","modified":"2022-07-18 10:16:08","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":1711,"height":1821,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P355-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P355-282x300.jpg","medium-width":282,"medium-height":300,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P355-768x817.jpg","medium_large-width":525,"medium_large-height":558,"large":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P355-962x1024.jpg","large-width":525,"large-height":559,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P355-1711x1200.jpg","twentyseventeen-featured-image-width":1711,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P355-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Nuovo diffusore aria con regolazione flusso aria e alette direzionali pivottanti su sfera manovrabili direttamente. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>New round air diffuser with air flow regulation and directly orientable and pivotable flow orientation grids. Fixation by clips.</p>\n","product_description_ru":"<p>New round air diffuser with air flow regulation and directly orientable and pivotable flow orientation grids. Fixation by clips.</p>\n","product_variants":"66424,66434","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P355.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1395"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1395"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1379,"date":"2022-07-07T11:02:30","date_gmt":"2022-07-07T09:02:30","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1379"},"modified":"2023-09-29T12:26:47","modified_gmt":"2023-09-29T10:26:47","slug":"p422","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p422/","title":{"rendered":"P422"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"04_01_02","product_id":"p422","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":45,"post_author":"1","post_date":"2017-04-11 12:43:58","post_date_gmt":"2017-04-11 10:43:58","post_content":"","post_title":"Diffusori luce tondi","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-luce-tondi","to_ping":"","pinged":"","post_modified":"2020-03-05 16:28:43","post_modified_gmt":"2020-03-05 15:28:43","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=45","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore luce tondo orientabile","product_name_en":"Round adjustable light","product_name_ru":"","product_image":{"ID":1436,"id":1436,"title":"P422","filename":"P422-1.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P422-1.jpg","alt":"","author":"7","description":"","caption":"??????","name":"p422-4","date":"2022-07-29 12:20:15","modified":"2022-07-29 12:20:17","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":2025,"height":1340,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P422-1-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P422-1-300x199.jpg","medium-width":300,"medium-height":199,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P422-1-768x508.jpg","medium_large-width":525,"medium_large-height":347,"large":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P422-1-1024x678.jpg","large-width":525,"large-height":348,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P422-1-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P422-1-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Diffusore luce stilizzato, accensione/spegnimento individuale con 5 LED di illuminazione bianchi. Fissaggio con clip.</p>\n","product_description_en":"<p>Stylized individually on/off switchable light diffusers with 5 white lighting LED. Fixation by clips.</p>\n","product_description_ru":"","product_variants":"60533,67693,67713,69302,69312,69962,69972","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P422.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1379"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1379"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1375,"date":"2022-07-07T10:43:18","date_gmt":"2022-07-07T08:43:18","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1375"},"modified":"2023-09-29T10:22:38","modified_gmt":"2023-09-29T08:22:38","slug":"p421","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p421/","title":{"rendered":"P421"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"03_02_04","product_id":"p421","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_name_ru":"Диффузор воздуха","product_image":{"ID":1435,"id":1435,"title":"P421","filename":"P421.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P421.jpg","alt":"","author":"7","description":"","caption":"??????","name":"p421-4","date":"2022-07-29 12:19:51","modified":"2022-07-29 12:19:54","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":1861,"height":1432,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P421-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P421-300x231.jpg","medium-width":300,"medium-height":231,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P421-768x591.jpg","medium_large-width":525,"medium_large-height":404,"large":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P421-1024x788.jpg","large-width":525,"large-height":404,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P421-1861x1200.jpg","twentyseventeen-featured-image-width":1861,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P421-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Nuovo diffusore aria con regolazione flusso aria a disco e alette direzionali pivottanti su sfera manovrabili direttamente. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>New round air diffuser with ring operated air flow regulation and directly orientable and pivotable flow orientation grids. Fixation by clips.</p>\n","product_description_ru":"<p>Новый круглый воздушный диффузор с механизмом регулирования потока воздуха и непосредственно ориентируемыми и поворотными решетками. Фиксация зажимами.</p>\n","product_variants":"69202,69212,67763,60513","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":true,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2022/07/P421.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1375"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1375"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1259,"date":"2022-03-03T09:07:27","date_gmt":"2022-03-03T08:07:27","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1259"},"modified":"2023-09-29T14:55:13","modified_gmt":"2023-09-29T12:55:13","slug":"p30","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p30/","title":{"rendered":"P30"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"05_03_01_1","product_id":"p30","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":49,"post_author":"1","post_date":"2017-04-11 12:46:21","post_date_gmt":"2017-04-11 10:46:21","post_content":"","post_title":"Maniglia di presa per urbani","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-di-presa","to_ping":"","pinged":"","post_modified":"2020-02-14 16:49:30","post_modified_gmt":"2020-02-14 15:49:30","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=49","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia di presa per urbani","product_name_en":"City bus catching handle","product_name_ru":"","product_image":{"ID":1260,"id":1260,"title":"P30","filename":"P30.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2022/03/P30.jpg","alt":"","author":"7","description":"","caption":"","name":"p30","date":"2022-03-03 08:03:56","modified":"2022-03-03 08:04:01","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":5120,"height":3840,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2022/03/P30-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2022/03/P30-300x225.jpg","medium-width":300,"medium-height":225,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2022/03/P30-768x576.jpg","medium_large-width":525,"medium_large-height":394,"large":"https://wp.primaautomotive.it/wp-content/uploads/2022/03/P30-1024x768.jpg","large-width":525,"large-height":394,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2022/03/P30-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2022/03/P30-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Maniglie appiglio rigide per autobus urbani.</p>\n","product_description_en":"<p>Rigid cachting handles for city busses.</p>\n","product_description_ru":"","product_variants":"61493","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2022/03/P30.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1259"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1259"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1172,"date":"2021-07-16T12:22:01","date_gmt":"2021-07-16T10:22:01","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1172"},"modified":"2023-10-02T17:33:43","modified_gmt":"2023-10-02T15:33:43","slug":"p110","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p110/","title":{"rendered":"P110"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"03_01_03","product_id":"p110","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":40,"post_author":"1","post_date":"2017-04-11 12:25:08","post_date_gmt":"2017-04-11 10:25:08","post_content":"","post_title":"Diffusori aria rettangolari orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-rettangolari-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:23","post_modified_gmt":"2020-02-14 15:54:23","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=40","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_name_ru":"Диффузор воздуха","product_image":{"ID":1807,"id":1807,"title":"p110_imm_8649","filename":"p110_imm_8649.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2021/07/p110_imm_8649.jpg","alt":"","author":"1","description":"","caption":"","name":"p110_imm_8649","date":"2023-10-02 15:33:31","modified":"2023-10-02 15:33:41","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":4368,"height":2912,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2021/07/p110_imm_8649-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2021/07/p110_imm_8649-300x200.jpg","medium-width":300,"medium-height":200,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2021/07/p110_imm_8649-768x512.jpg","medium_large-width":525,"medium_large-height":350,"large":"https://wp.primaautomotive.it/wp-content/uploads/2021/07/p110_imm_8649-1024x683.jpg","large-width":525,"large-height":350,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2021/07/p110_imm_8649-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2021/07/p110_imm_8649-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Diffusore aria orientabile rettangolare, con rotella di controllo della farfalla regolazione flusso aria. Fissaggio con viti.</p>\n","product_description_en":"<p>Rectangular adjustable air diffuser, with wheel operated air flow control throttle. Fixation by screws.</p>\n","product_description_ru":"<p>Прямоугольный регулируемый воздушный диффузор с дроссельной заслонкой управляемой механизмом. Фиксация винтами</p>\n","product_variants":"64750,67498","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2021/07/P110.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1172"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1172"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":1165,"date":"2021-07-16T12:02:30","date_gmt":"2021-07-16T10:02:30","guid":{"rendered":"https://wp.primaautomotive.it/?post_type=products&#038;p=1165"},"modified":"2023-09-29T09:39:13","modified_gmt":"2023-09-29T07:39:13","slug":"p125","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p125/","title":{"rendered":"P125"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"03_04_09","product_id":"p125","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":1168,"post_author":"7","post_date":"2021-07-16 11:58:09","post_date_gmt":"2021-07-16 09:58:09","post_content":"","post_title":"Valvola di sovrapressione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"valvola-di-sovrapressione","to_ping":"","pinged":"","post_modified":"2022-02-24 10:37:40","post_modified_gmt":"2022-02-24 09:37:40","post_content_filtered":"","post_parent":0,"guid":"https://wp.primaautomotive.it/?post_type=sub_categories&#038;p=1168","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Valvola di sovrapressione","product_name_en":"Overpressure valve","product_name_ru":"клапан избыточного давления","product_image":{"ID":1170,"id":1170,"title":"P125","filename":"P125.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2021/07/P125.jpg","alt":"","author":"7","description":"","caption":"","name":"p125","date":"2021-07-16 10:01:19","modified":"2021-07-16 10:01:24","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":2851,"height":2215,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2021/07/P125-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2021/07/P125-300x233.jpg","medium-width":300,"medium-height":233,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2021/07/P125-768x597.jpg","medium_large-width":525,"medium_large-height":408,"large":"https://wp.primaautomotive.it/wp-content/uploads/2021/07/P125-1024x796.jpg","large-width":525,"large-height":408,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2021/07/P125-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2021/07/P125-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"","product_description_en":"","product_description_ru":"","product_variants":"69623","coaches":false,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2021/07/P125.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/1165"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=1165"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":933,"date":"2019-09-28T12:39:34","date_gmt":"2019-09-28T10:39:34","guid":{"rendered":"https://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=933"},"modified":"2023-09-29T10:09:08","modified_gmt":"2023-09-29T08:09:08","slug":"p370","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p370/","title":{"rendered":"P370"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"03_04_08","product_id":"p370","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":935,"post_author":"1","post_date":"2019-09-28 12:23:17","post_date_gmt":"2019-09-28 10:23:17","post_content":"","post_title":"Rubinetti","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"rubinetti-taps","to_ping":"","pinged":"","post_modified":"2022-02-24 10:38:03","post_modified_gmt":"2022-02-24 09:38:03","post_content_filtered":"","post_parent":0,"guid":"https://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=935","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Rubinetto circuito refrigerazione","product_name_en":"Refrigerant circuit tap","product_image":{"ID":938,"id":938,"title":"p370","filename":"p370.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2019/09/p370.jpg","alt":"","author":"1","description":"","caption":"","name":"p370-2","date":"2019-09-28 10:39:51","modified":"2019-09-28 10:39:55","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":800,"height":428,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2019/09/p370-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2019/09/p370-300x161.jpg","medium-width":300,"medium-height":161,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2019/09/p370-768x411.jpg","medium_large-width":525,"medium_large-height":281,"large":"https://wp.primaautomotive.it/wp-content/uploads/2019/09/p370.jpg","large-width":525,"large-height":281,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2019/09/p370.jpg","twentyseventeen-featured-image-width":800,"twentyseventeen-featured-image-height":428,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2019/09/p370-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"","product_description_en":"","product_variants":"68933,69033,68923,69023","coaches":false,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2019/09/P370.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/933"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=933"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":842,"date":"2019-04-01T11:26:14","date_gmt":"2019-04-01T09:26:14","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=842"},"modified":"2023-09-29T10:07:33","modified_gmt":"2023-09-29T08:07:33","slug":"p366","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p366/","title":{"rendered":"P366"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"03_04_01","product_id":"p366","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":43,"post_author":"1","post_date":"2017-04-11 12:27:13","post_date_gmt":"2017-04-11 10:27:13","post_content":"","post_title":"Riduzioni raccordi e tubi","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"riduzioni-e-raccordi","to_ping":"","pinged":"","post_modified":"2020-03-05 16:39:03","post_modified_gmt":"2020-03-05 15:39:03","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=43","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Raccordo","product_name_en":"Connector","product_image":{"ID":847,"id":847,"title":"Riduzione P415","filename":"Riduzione-P415.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2019/04/Riduzione-P415.jpg","alt":"","author":"5","description":"","caption":"","name":"riduzione-p415","date":"2019-04-08 10:01:42","modified":"2019-04-08 10:01:44","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":969,"height":1200,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2019/04/Riduzione-P415-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2019/04/Riduzione-P415-242x300.jpg","medium-width":242,"medium-height":300,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2019/04/Riduzione-P415-768x951.jpg","medium_large-width":525,"medium_large-height":650,"large":"https://wp.primaautomotive.it/wp-content/uploads/2019/04/Riduzione-P415-827x1024.jpg","large-width":525,"large-height":650,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2019/04/Riduzione-P415-969x1200.jpg","twentyseventeen-featured-image-width":969,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2019/04/Riduzione-P415-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Raccordi per tubi flessibili su diffusori aria.</p>\n","product_description_en":"<p>Connector for flexible hoses.</p>\n","product_variants":"68833","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2019/04/P366.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Фитинг","product_description_ru":"<p>Соединитель для гибких шлангов на воздушных диффузоров.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/842"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=842"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":840,"date":"2019-04-01T11:17:03","date_gmt":"2019-04-01T09:17:03","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=840"},"modified":"2023-09-29T10:21:46","modified_gmt":"2023-09-29T08:21:46","slug":"p415","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p415/","title":{"rendered":"P415"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"03_02_07","product_id":"p415","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":{"ID":846,"id":846,"title":"p415","filename":"p415.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2019/04/p415.jpg","alt":"","author":"5","description":"","caption":"","name":"p415-2","date":"2019-04-08 10:01:23","modified":"2019-04-08 10:01:27","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":1200,"height":1300,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2019/04/p415-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2019/04/p415-277x300.jpg","medium-width":277,"medium-height":300,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2019/04/p415-768x832.jpg","medium_large-width":525,"medium_large-height":569,"large":"https://wp.primaautomotive.it/wp-content/uploads/2019/04/p415-945x1024.jpg","large-width":525,"large-height":569,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2019/04/p415-1200x1200.jpg","twentyseventeen-featured-image-width":1200,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2019/04/p415-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Diffusore aria rotondo, con alette di regolazione ed orientamento del flusso d&#8217;aria manovrabili direttamente. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Round air diffuser, with direct flap&#8217;s regulation and orientation. Fixation by clips.</p>\n","product_variants":"67803,68783","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2019/04/P415.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Круглый воздушный диффузор с прямым управлением ребер для регулирования и ориентации потока воздух. Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/840"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=840"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":470,"date":"2017-09-27T15:58:55","date_gmt":"2017-09-27T13:58:55","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=470"},"modified":"2023-10-02T12:05:22","modified_gmt":"2023-10-02T10:05:22","slug":"p1450","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p1450/","title":{"rendered":"P1450"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"07_01_14","product_id":"p1450","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":53,"post_author":"1","post_date":"2017-04-11 12:49:19","post_date_gmt":"2017-04-11 10:49:19","post_content":"","post_title":"Cappelliere per bus urbani-interurbani","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"cappelliere-per-bus-urbani-e-interurbani","to_ping":"","pinged":"","post_modified":"2022-10-20 12:16:04","post_modified_gmt":"2022-10-20 10:16:04","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=53","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Cappelliere per minibus","product_name_en":"Luggage racks for minibuses","product_image":false,"product_description_it":"<p>Cappelliera per minibus e/o veicoli speciali.</p>\n","product_description_en":"<p>Luggage rack for minibus and/or for special vehicles.</p>\n","product_variants":"63673,63683","coaches":false,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/09/P1450.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/470"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=470"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":463,"date":"2017-07-12T19:28:03","date_gmt":"2017-07-12T17:28:03","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=463"},"modified":"2023-09-29T10:03:43","modified_gmt":"2023-09-29T08:03:43","slug":"p353","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p353/","title":{"rendered":"P353"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"03_02_17","product_id":"p353","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Tondo orientabile","product_name_en":"Round adjustable","product_image":false,"product_description_it":"<p>Diffusore aria rotondo, con alette di regolazione ed orientamento del flusso d&#8217;aria manovrabili direttamente. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Round air diffuser, with direct flap&#8217;s regulation and orientation. Fixation by clips.</p>\n","product_variants":"61403,61153,61413","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":true,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/07/P353.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Регулируемый круглый","product_description_ru":"<p>Круглый воздушный диффузор с прямым управлением ребер для регулирования и ориентации потока воздух. Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/463"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=463"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":437,"date":"2017-06-22T10:38:41","date_gmt":"2017-06-22T08:38:41","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=437"},"modified":"2023-09-28T15:36:43","modified_gmt":"2023-09-28T13:36:43","slug":"p21","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p21/","title":{"rendered":"P21"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"02_04_06","product_id":"p21","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":369,"post_author":"1","post_date":"2017-05-19 10:53:12","post_date_gmt":"2017-05-19 08:53:12","post_content":"","post_title":"Dispositivi di bloccaggio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"dispositivi-di-bloccaggio","to_ping":"","pinged":"","post_modified":"2020-02-14 16:47:02","post_modified_gmt":"2020-02-14 15:47:02","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=369","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Serratura a molla","product_name_en":"Clasp lock","product_image":false,"product_description_it":"<p>Serratura piccola a molla per cofani o sportelli di piccole dimensioni.</p>\n","product_description_en":"<p>Clasp lock (small) for hoods or small flaps.</p>\n","product_variants":"69787","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/06/P20_P21.pdf","documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/437"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=437"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":433,"date":"2017-06-22T10:14:48","date_gmt":"2017-06-22T08:14:48","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=433"},"modified":"2023-10-12T17:29:34","modified_gmt":"2023-10-12T15:29:34","slug":"p187_type2","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p187_type2/","title":{"rendered":"P187_type2"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"02_01_02","product_id":"p187_type2","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":33,"post_author":"1","post_date":"2017-04-11 12:17:18","post_date_gmt":"2017-04-11 10:17:18","post_content":"","post_title":"Sistemi di chiusura pneumatici ed elettrici","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-chiusura-pneumatici-ed-elettrici","to_ping":"","pinged":"","post_modified":"2022-11-17 17:29:59","post_modified_gmt":"2022-11-17 16:29:59","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=33","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Attuatore elettrico","product_name_en":"Electric actuator","product_image":{"ID":1449,"id":1449,"title":"P187_NUOVO","filename":"P187_NUOVO.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2017/06/P187_NUOVO.jpg","alt":"","author":"7","description":"","caption":"??????","name":"p187_nuovo","date":"2022-08-01 13:22:38","modified":"2022-08-01 13:22:41","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":2575,"height":1198,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2017/06/P187_NUOVO-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2017/06/P187_NUOVO-300x140.jpg","medium-width":300,"medium-height":140,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2017/06/P187_NUOVO-768x357.jpg","medium_large-width":525,"medium_large-height":244,"large":"https://wp.primaautomotive.it/wp-content/uploads/2017/06/P187_NUOVO-1024x476.jpg","large-width":525,"large-height":244,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2017/06/P187_NUOVO-2000x1198.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1198,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2017/06/P187_NUOVO-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Attuatore elettrico per sistema di chiusura centralizzati. Versione slim.</p>\n","product_description_en":"<p>Electric actuator for centralized handle&#8217;s locking system. Slim version.</p>\n","product_variants":"66354,66364","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":true,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/06/P187-1.pdf","pdf_manual":"https://wp.primaautomotive.it/wp-content/uploads/2017/06/P187-ver2023-01.pdf","documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/433"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=433"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":428,"date":"2017-06-22T09:57:00","date_gmt":"2017-06-22T07:57:00","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=428"},"modified":"2023-10-02T11:32:40","modified_gmt":"2023-10-02T09:32:40","slug":"p117bis","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p117bis/","title":{"rendered":"P117bis"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"07_01_16","product_id":"p117bis","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":31,"post_author":"1","post_date":"2017-04-11 12:14:50","post_date_gmt":"2017-04-11 10:14:50","post_content":"","post_title":"Maniglie per interni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-interni","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:25","post_modified_gmt":"2020-02-14 15:56:25","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=31","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per interni","product_name_en":"Interior handle","product_image":false,"product_description_it":"<p>Maniglia per sportelli di cappelliere, senza serratura.</p>\n","product_description_en":"<p>Handles for hutrack flaps, not lockable.</p>\n","product_variants":"59735","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/06/P117_P117bis.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Ручка для интерьеров","product_description_ru":"<p>Ручка для дверей багажных полок, без замка.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/428"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=428"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":422,"date":"2017-06-21T18:44:23","date_gmt":"2017-06-21T16:44:23","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=422"},"modified":"2023-09-28T11:40:08","modified_gmt":"2023-09-28T09:40:08","slug":"p397a","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p397a/","title":{"rendered":"P397A"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"index_order":"01_01_04","product_id":"p397_a","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":28,"post_author":"1","post_date":"2017-04-11 12:12:39","post_date_gmt":"2017-04-11 10:12:39","post_content":"","post_title":"Maniglie per portelloni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-portelloni","to_ping":"","pinged":"","post_modified":"2020-03-05 15:18:21","post_modified_gmt":"2020-03-05 14:18:21","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=28","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per portelloni","product_name_en":"Luggage door handle","product_image":false,"product_description_it":"<p>Maniglia per portelloni laterali vani portabagagli di autobus turistici, con impugnatura aperta. Disegno ovale.</p>\n","product_description_en":"<p>Handles for the side luggage compartment door of coaches in execution with open grip. Oval design.</p>\n","product_variants":"65241,65011","coaches":true,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":"https://wp.primaautomotive.it/wp-content/uploads/2017/06/p397a_manual_rev4.pdf","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/06/P397_P397a.pdf","documenti_allegati":[{"nome_documento_it":"Manuale sistema JOK","nome_documento_eng":"JOK system manual","allegato_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/06/MU_Jok-System_rev7.pdf"}],"product_name_ru":"Ручки для дверей","product_description_ru":"<p>Ручка для боковых дверей багажных отсеков туристических автобусов, с открытой рукояткой. Овальной формы.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/422"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=422"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":341,"date":"2017-05-11T12:16:58","date_gmt":"2017-05-11T10:16:58","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=341"},"modified":"2023-09-28T12:04:03","modified_gmt":"2023-09-28T10:04:03","slug":"p630","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p630/","title":{"rendered":"P630"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p630","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":30,"post_author":"1","post_date":"2017-04-11 12:14:18","post_date_gmt":"2017-04-11 10:14:18","post_content":"","post_title":"Maniglie per porte passeggeri","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-porta-passeggeri","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:40","post_modified_gmt":"2020-02-14 15:56:40","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=30","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per porta passeggeri","product_name_en":"Passenger's doors handle","product_image":false,"product_description_it":"<p>Maniglia per porte passeggeri sempre liberamente azionabile dall&#8217;interno. Disponibile in versione manuale, elettrica e elettro-pneumatica. La versione elettrica ed elettro-pneumatica puà essere fornita con uno o due pulsanti esterni apri-porta, che a richiesta possono essere forniti dotati di spia LED. Disegno stilizzato della seria SPACEFORM.</p>\n","product_description_en":"<p>Handles for passenger&#8217;s doors to be always free opened from inside.Available in manual, electric and electropneumatic execution. The electric and the electropneumatic versions could be equipped with one or two door&#8217;s opening buttons,this letter available with LED on demand. Stylised design SPACEFORM series.</p>\n","product_variants":"69502,69512","index_order":"01_03_01","coaches":true,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/p630_manual.pdf","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P630.pdf","documenti_allegati":[{"nome_documento_it":"Manuale sistema JOK","nome_documento_eng":"JOK system manual","allegato_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/MU_Jok-System_rev7-2.pdf"}],"product_name_ru":"Ручка для пассажирской двери","product_description_ru":"<p>Ручка для пассажирских дверей всегда свободно открывается изнутри. Доступна в ручном, электрическом и электропневматическом вариантах. Электрическая и электропневматическая версии могут поставляться с одной или двумя внешними кнопками открытия дверей, которые по запросу могут быть дополнены светодиодным индикатором. Стилизованный дизайн серии SPACEFORM.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/341"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=341"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":340,"date":"2017-05-11T12:15:57","date_gmt":"2017-05-11T10:15:57","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=340"},"modified":"2023-09-28T12:00:46","modified_gmt":"2023-09-28T10:00:46","slug":"p610","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p610/","title":{"rendered":"P610"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p610","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":29,"post_author":"1","post_date":"2017-04-11 12:13:43","post_date_gmt":"2017-04-11 10:13:43","post_content":"","post_title":"Maniglie per porta autista","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-porta-autista","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:54","post_modified_gmt":"2020-02-14 15:56:54","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=29","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia porta autista","product_name_en":"Driver's door handle","product_image":false,"product_description_it":"<p>Maniglia porta autista. Azionamento a pulsante. Pulsante a scorrimento libero a serratura bloccata. Disegno stilizzato della serie SPACEFORM.</p>\n","product_description_en":"<p>Handles for the driver&#8217;s door. Push button operated. Free sliding button when locked. Stylised design SPACEFORM series.</p>\n","product_variants":"67262,67272,67282","index_order":"01_02_01","coaches":true,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/p610_manual_rev0.pdf","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P610.pdf","documenti_allegati":[{"nome_documento_it":"Manuale sistema JOK","nome_documento_eng":"JOK system manual","allegato_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/MU_Jok-System_rev7-1.pdf"}],"product_name_ru":"Ручка для водительской двери","product_description_ru":"<p>Ручка водительской двери. Кнопочное управление. Бесступенчатая кнопка с блокировкой. Стилизованный дизайн серии SPACEFORM.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/340"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=340"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":335,"date":"2017-05-10T18:23:41","date_gmt":"2017-05-10T16:23:41","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=335"},"modified":"2023-10-02T11:59:57","modified_gmt":"2023-10-02T09:59:57","slug":"p1000","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p1000/","title":{"rendered":"P1000"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p1000planet","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":52,"post_author":"1","post_date":"2017-04-11 12:48:35","post_date_gmt":"2017-04-11 10:48:35","post_content":"","post_title":"Cappelliere per bus turistici","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"cappelliere-per-bus-turistici","to_ping":"","pinged":"","post_modified":"2022-10-20 12:16:36","post_modified_gmt":"2022-10-20 10:16:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=52","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Cappelliere per bus turistici","product_name_en":"Luggage racks for coaches","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Cappelliera disponibile in esecuzione per file di sedili singole o doppie, con canale aria condizionata, luce corridoio centrale a richiesta, moduli di servizio singoli o doppi e altoparlanti.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Cappelliera disponibile in esecuzione per file di sedili singole o doppie, con canale aria condizionata, luce corridoio centrale a richiesta, moduli di servizio singoli o doppi e altoparlanti.</span></p>\n","product_description_en":"<p>CKD set of component for self- assembling of the PLANET hutrack model.</p>\n","product_variants":"68039,67131,69199,67141,65289,65571,68991,69311,69321,62529,63551,65279,62091,65259,65299,68981,65582,64017,66189,67152,67162,67172,67182,67629,65452,65319,65462,69289,65472,62101,65482,6747965542,62111,65552,62201,65592,66411","index_order":"07_01_13","coaches":false,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P1000.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/335"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=335"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":329,"date":"2017-05-10T18:20:50","date_gmt":"2017-05-10T16:20:50","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=329"},"modified":"2023-09-28T16:42:28","modified_gmt":"2023-09-28T14:42:28","slug":"p510m","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p510m/","title":{"rendered":"P510M"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p510m","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":343,"post_author":"1","post_date":"2017-05-11 12:50:13","post_date_gmt":"2017-05-11 10:50:13","post_content":"","post_title":"Sistemi di apertura portelloni manuali","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-apertura-portelloni-manuali","to_ping":"","pinged":"","post_modified":"2022-10-20 14:07:56","post_modified_gmt":"2022-10-20 12:07:56","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=343","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Sistema di apertura manuale per portelloni","product_name_en":"Manual opening systems for flaps","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Portellone manuale per vani latarali portabagagli, apertura supportata da molle a gas, per portelloni da 10 a max. 30 kg. &quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Portellone manuale per vani latarali portabagagli, apertura supportata da molle a gas, per portelloni da 10 a max. 30 kg. </span></p>\n","product_description_en":"<p>Manual side hatches opening device, opening movement supported by gas spring, for hatches from 10 to max 30 kg.</p>\n","product_variants":"60242,60252,60262,60272,60282,60342,60352,60952,60362,60372,60962,60382","index_order":"08_01_01","coaches":true,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P510M.pdf","product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/329"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=329"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":327,"date":"2017-05-10T18:17:58","date_gmt":"2017-05-10T16:17:58","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=327"},"modified":"2023-09-29T12:29:26","modified_gmt":"2023-09-29T10:29:26","slug":"p491","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p491/","title":{"rendered":"P491"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p491","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":46,"post_author":"1","post_date":"2017-04-11 12:44:33","post_date_gmt":"2017-04-11 10:44:33","post_content":"","post_title":"Plafoniere","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"plafoniere","to_ping":"","pinged":"","post_modified":"2020-02-14 16:52:34","post_modified_gmt":"2020-02-14 15:52:34","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=46","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Plafoniere","product_name_en":"Lighting board","product_image":false,"product_description_it":"<p>Plafoniera di illuminazione per interni con luci LED.</p>\n","product_description_en":"<p>Central aisle LED lighting ceilings.</p>\n","product_variants":"60183","index_order":"04_04_02","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P491.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/327"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=327"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":326,"date":"2017-05-10T18:17:18","date_gmt":"2017-05-10T16:17:18","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=326"},"modified":"2023-09-29T12:27:58","modified_gmt":"2023-09-29T10:27:58","slug":"p424","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p424/","title":{"rendered":"P424"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p424","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":45,"post_author":"1","post_date":"2017-04-11 12:43:58","post_date_gmt":"2017-04-11 10:43:58","post_content":"","post_title":"Diffusori luce tondi","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-luce-tondi","to_ping":"","pinged":"","post_modified":"2020-03-05 16:28:43","post_modified_gmt":"2020-03-05 15:28:43","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=45","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore luce tondo orientabile","product_name_en":"Round adjustable light","product_image":{"ID":1438,"id":1438,"title":"P424","filename":"P424.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P424.jpg","alt":"","author":"7","description":"","caption":"??????","name":"p424-5","date":"2022-07-29 12:20:55","modified":"2022-07-29 12:20:57","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":2039,"height":1293,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P424-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P424-300x190.jpg","medium-width":300,"medium-height":190,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P424-768x487.jpg","medium_large-width":525,"medium_large-height":333,"large":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P424-1024x649.jpg","large-width":525,"large-height":333,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P424-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P424-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Diffusore luce stilizzato, accensione/spegnimento individuale con 5 LED di illuminazione bianchi. Fissaggio con clip.</p>\n","product_description_en":"<p>Stylized individually on/off switchable light diffusers with 5 white lighting LED. Fixation by clips.</p>\n","product_variants":"67723,67733,69322,69332,69982,69992","index_order":"04_01_02_1","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P424.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/326"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=326"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":325,"date":"2017-05-10T18:16:24","date_gmt":"2017-05-10T16:16:24","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=325"},"modified":"2023-09-29T10:23:25","modified_gmt":"2023-09-29T08:23:25","slug":"p423","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p423/","title":{"rendered":"P423"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p423","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":{"ID":1437,"id":1437,"title":"P423","filename":"P423.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P423.jpg","alt":"","author":"7","description":"","caption":"??????","name":"p423-6","date":"2022-07-29 12:20:37","modified":"2022-07-29 12:20:39","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":1894,"height":1470,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P423-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P423-300x233.jpg","medium-width":300,"medium-height":233,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P423-768x596.jpg","medium_large-width":525,"medium_large-height":407,"large":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P423-1024x795.jpg","large-width":525,"large-height":408,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P423-1894x1200.jpg","twentyseventeen-featured-image-width":1894,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P423-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Nuovo diffusore aria con regolazione flusso aria a disco e alette direzionali pivottanti su sfera manovrabili direttamente. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>New round air diffuser with ring operated air flow regulation and directly orientable and pivotable flow orientation grids. Fixation by clips.</p>\n","product_variants":"69222,69232,67773","index_order":"03_02_04_1","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":true,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P423.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Новый круглый воздушный диффузор с механизмом регулирования потока воздуха и непосредственно ориентируемыми и поворотными решетками. Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/325"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=325"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":324,"date":"2017-05-10T18:15:57","date_gmt":"2017-05-10T16:15:57","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=324"},"modified":"2023-09-29T10:05:13","modified_gmt":"2023-09-29T08:05:13","slug":"p360","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p360/","title":{"rendered":"P360"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p360","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":40,"post_author":"1","post_date":"2017-04-11 12:25:08","post_date_gmt":"2017-04-11 10:25:08","post_content":"","post_title":"Diffusori aria rettangolari orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-rettangolari-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:23","post_modified_gmt":"2020-02-14 15:54:23","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=40","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria semiovale stilizzato, con farfalla di regolazione flusso aria regolabile con rotellina. Fissaggio con viti.</p>\n","product_description_en":"<p>Stylized semioval air diffuser, with wheel operated air flow control throttle. Fixation by screws.</p>\n","product_variants":"67882","index_order":"03_01_01","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P360.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Стилизованный полуовальный воздушный диффузор с регулятором потока воздуха. Фиксация винтами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/324"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=324"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":322,"date":"2017-05-10T18:13:35","date_gmt":"2017-05-10T16:13:35","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=322"},"modified":"2023-09-28T11:57:33","modified_gmt":"2023-09-28T09:57:33","slug":"p601","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p601/","title":{"rendered":"P601"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p601","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":28,"post_author":"1","post_date":"2017-04-11 12:12:39","post_date_gmt":"2017-04-11 10:12:39","post_content":"","post_title":"Maniglie per portelloni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-portelloni","to_ping":"","pinged":"","post_modified":"2020-03-05 15:18:21","post_modified_gmt":"2020-03-05 14:18:21","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=28","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per portelloni","product_name_en":"Luggage door handle","product_image":false,"product_description_it":"<p>Maniglia di presa per portelloni laterali vani portabagagli di autobus turistici, con impugnatura aperta. Disegno stilizzato della serie SPACEFORM.</p>\n","product_description_en":"<p>Simple grip handle for side luggage compartment doors of coaches, open grip. Stylised design SPACEFORM series.</p>\n","product_variants":"67342","index_order":"01_01_02","coaches":true,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P601.pdf","documenti_allegati":false,"product_name_ru":"Ручки для дверей","product_description_ru":"<p>Ручка для боковых дверей багажных отсеков туристических автобусов, с открытой рукояткой. Стилизованный дизайн серии SPACEFORM.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/322"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=322"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":321,"date":"2017-05-10T18:12:47","date_gmt":"2017-05-10T16:12:47","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=321"},"modified":"2023-09-28T11:54:06","modified_gmt":"2023-09-28T09:54:06","slug":"p600","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p600/","title":{"rendered":"P600"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p600","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":28,"post_author":"1","post_date":"2017-04-11 12:12:39","post_date_gmt":"2017-04-11 10:12:39","post_content":"","post_title":"Maniglie per portelloni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-portelloni","to_ping":"","pinged":"","post_modified":"2020-03-05 15:18:21","post_modified_gmt":"2020-03-05 14:18:21","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=28","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per portelloni","product_name_en":"Luggage door handle","product_image":false,"product_description_it":"<p>Maniglie per portelloni bagagli laterali autobus con impugnature aperte. Possono essere fornite con o senza riflettore e luce integrata a LED. Design stilizzato, serie SpaceFORM.</p>\n","product_description_en":"<p>Handles for the side luggage compartment door of coaches,open grip. Could be supplied without or with reflector and integrated LED light. Stylised design, SpaceFORM series.</p>\n","product_variants":"67372,69082,67382,69092,69102","index_order":"01_01_01","coaches":true,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/p600_manual_rev0.pdf","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/P600.pdf","documenti_allegati":[{"nome_documento_it":"Manuale sistema JOK","nome_documento_eng":"JOK system manual","allegato_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/05/MU_Jok-System_rev7.pdf"}],"product_name_ru":"Ручки для дверей","product_description_ru":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Ручки боковых дверей багажника для автобусов с откытой рукояткой . \\n \\nМогут поставляться как с рефлектором и встроенным светодиодом, так и без них. \\nСтилизованный дизайн, серия SpaceFORM. \\n\\n&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:15357,&quot;3&quot;:{&quot;1&quot;:0},&quot;5&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:[null,2,0]},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;6&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:[null,2,0]},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;7&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:[null,2,0]},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;8&quot;:{&quot;1&quot;:[{&quot;1&quot;:2,&quot;2&quot;:0,&quot;5&quot;:[null,2,0]},{&quot;1&quot;:0,&quot;2&quot;:0,&quot;3&quot;:3},{&quot;1&quot;:1,&quot;2&quot;:0,&quot;4&quot;:1}]},&quot;9&quot;:0,&quot;10&quot;:0,&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,0],&quot;15&quot;:&quot;Arial&quot;,&quot;16&quot;:10}\">Ручки боковых дверей багажника для автобусов с откытой рукояткой .</p>\n<p>Могут поставляться как с рефлектором и встроенным светодиодом, так и без них.<br />\nСтилизованный дизайн, серия SpaceFORM.</p>\n<p></span></p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/321"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=321"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":278,"date":"2017-04-14T12:03:42","date_gmt":"2017-04-14T10:03:42","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=278"},"modified":"2023-09-28T11:51:59","modified_gmt":"2023-09-28T09:51:59","slug":"p474","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p474/","title":{"rendered":"P474"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p474","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":32,"post_author":"1","post_date":"2017-04-11 12:15:22","post_date_gmt":"2017-04-11 10:15:22","post_content":"","post_title":"Serrature maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"serrature-maniglie","to_ping":"","pinged":"","post_modified":"2020-03-05 15:19:06","post_modified_gmt":"2020-03-05 14:19:06","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=32","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Serratura","product_name_en":"Key lock","product_image":false,"product_description_it":"<p>Nottolino per serratura con sistema JOK. Il sistema JOK consente di installare nottolini della stessa mappatura su tutte le maniglie installate su un veicolo.</p>\n","product_description_en":"<p>Key lock barrel for J.O.K. system (Just One Key). The JOK systems permits to install on all locked doors the same key combination.</p>\n","product_variants":"63999,64009,64019,64029,64039,64049,64059,64069,64079,64089,64099,64109,64119,64129,64139,64149,64159,64169,64179,64189,64199,64209,64219,64229,64239,64249,64259,64269,64279,64289,64299,64309,64319,64329,64339,64349,64359,64369,64379,64389,69209,-,55824,55834,55844,55854,65617,65627,65637,65647,54837,65657,69251,68401,64591,69991,69261,69271,68591,60012,69681,66441,65401,60022,66441,65861,61462,60932,64231,60712,60592,65121,p73,61533,61543,61553,61563,61573,61583,61593,61603,61613,61623,61633,62069,62089,63049,63089,65369,67418","index_order":"01_05_03","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P474.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Замок","product_description_ru":"<p>Серцевина для замка с системой JOK. Система JOK позволяет устанавливать серцевину с одним и тем же расположением на все ручки, установленные на транспортном средстве.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/278"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=278"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":277,"date":"2017-04-14T12:03:20","date_gmt":"2017-04-14T10:03:20","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=277"},"modified":"2023-09-28T10:48:28","modified_gmt":"2023-09-28T08:48:28","slug":"p221j","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p221j/","title":{"rendered":"P221J"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p221_j","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":32,"post_author":"1","post_date":"2017-04-11 12:15:22","post_date_gmt":"2017-04-11 10:15:22","post_content":"","post_title":"Serrature maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"serrature-maniglie","to_ping":"","pinged":"","post_modified":"2020-03-05 15:19:06","post_modified_gmt":"2020-03-05 14:19:06","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=32","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Serratura","product_name_en":"Key lock","product_image":false,"product_description_it":"<p>Leva per serrature J.O.K <a href=\"http://primaautomotive.local/en/products/24/side-hatches-opening-systems/24/support-and-joint-for-gas-spings/p53j\">P53J</a></p>\n","product_description_en":"<p>Lever for <a href=\"http://primaautomotive.local/en/products/24/side-hatches-opening-systems/24/support-and-joint-for-gas-spings/p53j\">P53J</a> J.O.K. key locks</p>\n","product_variants":"65699,65709,65719,65729,65739,67009,65749,65759,65769,65779,67019,62228","index_order":"01_05_05","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P221_221J-1.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Замок","product_description_ru":"<p>Блокировочный рычаг J.O.K P53J</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/277"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=277"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":276,"date":"2017-04-14T12:01:36","date_gmt":"2017-04-14T10:01:36","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=276"},"modified":"2023-09-28T10:47:04","modified_gmt":"2023-09-28T08:47:04","slug":"p221","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p221/","title":{"rendered":"P221"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p221","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":32,"post_author":"1","post_date":"2017-04-11 12:15:22","post_date_gmt":"2017-04-11 10:15:22","post_content":"","post_title":"Serrature maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"serrature-maniglie","to_ping":"","pinged":"","post_modified":"2020-03-05 15:19:06","post_modified_gmt":"2020-03-05 14:19:06","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=32","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Serratura","product_name_en":"Key lock","product_image":false,"product_description_it":"<p>Leva per serratura <a href=\"/it/prodotti/24/sistemi-per-portelloni/24/supporti-e-snodi-per-molle-a-gas/p53\">P53</a>.</p>\n","product_description_en":"<p>Lever for key locks <a href=\"/en/products/24/system-for-luggage-door/24/support-and-joint-for-gas-spings/p53\">P53</a>.</p>\n","product_variants":"68827,68837,61658,64419,65828","index_order":"01_05_04","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P221_221J.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Замок","product_description_ru":"<p>Блокировочный рычаг P53.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/276"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=276"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":275,"date":"2017-04-14T12:01:10","date_gmt":"2017-04-14T10:01:10","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=275"},"modified":"2023-09-28T09:14:01","modified_gmt":"2023-09-28T07:14:01","slug":"p53","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p53/","title":{"rendered":"P53"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p53","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":32,"post_author":"1","post_date":"2017-04-11 12:15:22","post_date_gmt":"2017-04-11 10:15:22","post_content":"","post_title":"Serrature maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"serrature-maniglie","to_ping":"","pinged":"","post_modified":"2020-03-05 15:19:06","post_modified_gmt":"2020-03-05 14:19:06","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=32","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Serratura","product_name_en":"Key lock","product_image":false,"product_description_it":"<p>Serratura per vani-portaoggetti.</p>\n","product_description_en":"<p>Key lock for storage compartment.</p>\n","product_variants":"67397,68847,68857,68867,68877,68887,68897,68907,68917,68927,61968,61978,64138,64148,64158,64168,64178,64188,64198,64208,64218,64228,64238,64248,64258,64268,64278,64288,65408,65418,68061,68071,68081,68091,60791,68653,63161,66631","index_order":"01_05_01","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P53_53J.pdf","pdf_manual":false,"documenti_allegati":[{"nome_documento_it":"Manuale sistema JOK ","nome_documento_eng":"JOK system manual","allegato_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/MU_Jok-System_rev7.pdf"}],"product_name_ru":"Замок","product_description_ru":"<p>Замок для бардачков.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/275"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=275"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":274,"date":"2017-04-14T12:00:45","date_gmt":"2017-04-14T10:00:45","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=274"},"modified":"2023-09-28T12:19:09","modified_gmt":"2023-09-28T10:19:09","slug":"p53j","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p53j/","title":{"rendered":"P53J"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p53_j","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":32,"post_author":"1","post_date":"2017-04-11 12:15:22","post_date_gmt":"2017-04-11 10:15:22","post_content":"","post_title":"Serrature maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"serrature-maniglie","to_ping":"","pinged":"","post_modified":"2020-03-05 15:19:06","post_modified_gmt":"2020-03-05 14:19:06","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=32","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Serratura","product_name_en":"Key lock","product_image":false,"product_description_it":"<p>Serratura per vani-portaoggetti, sistema JOK.</p>\n","product_description_en":"<p>Key lock for storage compartment J.O.K. System.</p>\n","product_variants":"65639,68541","index_order":"01_05_02","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P53_53J-1.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Замок","product_description_ru":"<p>Замок для бардачков, система JOK.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/274"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=274"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":273,"date":"2017-04-14T12:00:13","date_gmt":"2017-04-14T10:00:13","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=273"},"modified":"2023-09-28T11:11:28","modified_gmt":"2023-09-28T09:11:28","slug":"p267","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p267/","title":{"rendered":"P267"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p267","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":31,"post_author":"1","post_date":"2017-04-11 12:14:50","post_date_gmt":"2017-04-11 10:14:50","post_content":"","post_title":"Maniglie per interni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-interni","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:25","post_modified_gmt":"2020-02-14 15:56:25","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=31","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per interni","product_name_en":"Interior handle","product_image":false,"product_description_it":"<p>Maniglia per cofanetti.</p>\n","product_description_en":"<p>Lifting grap handles.</p>\n","product_variants":"62208","index_order":"01_04_06","coaches":false,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P267.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Ручка для интерьеров","product_description_ru":"<p>Ручка для шкафчиков.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/273"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=273"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":272,"date":"2017-04-14T11:59:52","date_gmt":"2017-04-14T09:59:52","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=272"},"modified":"2023-10-02T11:33:10","modified_gmt":"2023-10-02T09:33:10","slug":"p117","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p117/","title":{"rendered":"P117"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p117","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":31,"post_author":"1","post_date":"2017-04-11 12:14:50","post_date_gmt":"2017-04-11 10:14:50","post_content":"","post_title":"Maniglie per interni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-interni","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:25","post_modified_gmt":"2020-02-14 15:56:25","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=31","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per interni","product_name_en":"Interior handle","product_image":false,"product_description_it":"<p>Maniglia per sportelli di cappelliere, senza serratura.</p>\n","product_description_en":"<p>Handles for hutrack flaps, not lockable.</p>\n","product_variants":"65630,69718","index_order":"07_01_15","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P117_P117bis.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Ручка для интерьеров","product_description_ru":"<p>Ручка для дверей багажных полок, без замка.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/272"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=272"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":270,"date":"2017-04-14T11:58:45","date_gmt":"2017-04-14T09:58:45","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=270"},"modified":"2023-09-28T09:19:03","modified_gmt":"2023-09-28T07:19:03","slug":"p58","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p58/","title":{"rendered":"P58"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p58","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":31,"post_author":"1","post_date":"2017-04-11 12:14:50","post_date_gmt":"2017-04-11 10:14:50","post_content":"","post_title":"Maniglie per interni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-interni","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:25","post_modified_gmt":"2020-02-14 15:56:25","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=31","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per interni","product_name_en":"Interior handle","product_image":false,"product_description_it":"<p>Maniglia appiglio per retro-sedile passeggeri.</p>\n","product_description_en":"<p>Grap handles for passanger&#8217;s seats backrest.</p>\n","product_variants":"66337,64449","index_order":"01_04_05","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P58.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Ручка для интерьеров","product_description_ru":"<p>Поручень для пассажирских сидений.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/270"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=270"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":269,"date":"2017-04-14T11:58:25","date_gmt":"2017-04-14T09:58:25","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=269"},"modified":"2023-09-28T09:17:20","modified_gmt":"2023-09-28T07:17:20","slug":"p57","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p57/","title":{"rendered":"P57"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p57","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":31,"post_author":"1","post_date":"2017-04-11 12:14:50","post_date_gmt":"2017-04-11 10:14:50","post_content":"","post_title":"Maniglie per interni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-interni","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:25","post_modified_gmt":"2020-02-14 15:56:25","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=31","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per interni","product_name_en":"Interior handle","product_image":false,"product_description_it":"<p>Maniglia appiglio per retro-sedile passeggeri.</p>\n","product_description_en":"<p>Grap handles for passanger&#8217;s seats backrest.</p>\n","product_variants":"65277","index_order":"01_04_04","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P57.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Ручка для интерьеров","product_description_ru":"<p>Поручень для пассажирских сидений.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/269"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=269"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":268,"date":"2017-04-14T11:58:11","date_gmt":"2017-04-14T09:58:11","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=268"},"modified":"2023-09-28T09:15:40","modified_gmt":"2023-09-28T07:15:40","slug":"p56","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p56/","title":{"rendered":"P56"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p56","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":31,"post_author":"1","post_date":"2017-04-11 12:14:50","post_date_gmt":"2017-04-11 10:14:50","post_content":"","post_title":"Maniglie per interni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-interni","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:25","post_modified_gmt":"2020-02-14 15:56:25","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=31","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per interni","product_name_en":"Interior handle","product_image":false,"product_description_it":"<p>Maniglia appiglio per retro-sedile passeggeri.</p>\n","product_description_en":"<p>Grap handles for passanger&#8217;s seats backrest.</p>\n","product_variants":"66327,67538,67478","index_order":"01_04_03","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P56.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Ручка для интерьеров","product_description_ru":"<p>Поручень для пассажирских сидений.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/268"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=268"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":266,"date":"2017-04-14T11:57:27","date_gmt":"2017-04-14T09:57:27","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=266"},"modified":"2023-09-28T11:08:47","modified_gmt":"2023-09-28T09:08:47","slug":"p247","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p247/","title":{"rendered":"P247"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p247","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":30,"post_author":"1","post_date":"2017-04-11 12:14:18","post_date_gmt":"2017-04-11 10:14:18","post_content":"","post_title":"Maniglie per porte passeggeri","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-porta-passeggeri","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:40","post_modified_gmt":"2020-02-14 15:56:40","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=30","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per porta passeggeri","product_name_en":"Passenger's doors handle","product_image":{"ID":1559,"id":1559,"title":"P247_n2_M_Emerg_3780","filename":"P247_n2_M_Emerg_3780.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P247_n2_M_Emerg_3780.jpg","alt":"","author":"1","description":"","caption":"","name":"p247_n2_m_emerg_3780","date":"2023-09-27 10:31:40","modified":"2023-09-27 10:31:45","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":3664,"height":2657,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P247_n2_M_Emerg_3780-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P247_n2_M_Emerg_3780-300x218.jpg","medium-width":300,"medium-height":218,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P247_n2_M_Emerg_3780-768x557.jpg","medium_large-width":525,"medium_large-height":381,"large":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P247_n2_M_Emerg_3780-1024x743.jpg","large-width":525,"large-height":381,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P247_n2_M_Emerg_3780-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P247_n2_M_Emerg_3780-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Maniglia interna per porte di uscita di emergenza, con azionamento indiretto per mezzo di cavo Bowden.</p>\n","product_description_en":"<p>Internal emergency door handles for indirect opening. Operating by bowden cables.</p>\n","product_variants":"62178,65938,65728,66050,65898,65918,65908","index_order":"01_03_06","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P247.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Ручка для пассажирской двери","product_description_ru":"<p>Внутренняя ручка для дверей аварийных выходов, с непрямым приводом через трос Боудена</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/266"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=266"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":265,"date":"2017-04-14T11:56:59","date_gmt":"2017-04-14T09:56:59","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=265"},"modified":"2023-09-28T11:05:27","modified_gmt":"2023-09-28T09:05:27","slug":"p230","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p230/","title":{"rendered":"P230"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p230","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":30,"post_author":"1","post_date":"2017-04-11 12:14:18","post_date_gmt":"2017-04-11 10:14:18","post_content":"","post_title":"Maniglie per porte passeggeri","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-porta-passeggeri","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:40","post_modified_gmt":"2020-02-14 15:56:40","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=30","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per porta passeggeri","product_name_en":"Passenger's doors handle","product_image":false,"product_description_it":"<p>Maniglia per porte passeggeri sempre liberamente azionabile dall&#8217;interno. Disponibile in versione manuale, elettrica e elettro-pneumatica. La versione elettrica ed elettro-pneumatica può essere fornita con un pulsante esterno apri-porta, con cappuccio di copertura in gomma termoplastica. Su richiesta il pulsante può essere fornito in versione metallica con o senza spia LED. Disegno squadrato.</p>\n","product_description_en":"<p>Handles for passenger&#8217;s doors to be always free opened from inside. Available in manual, electric and electropneumatic execution. The electric and the electropneumatic versions are equipped with a door opening button with thermoplastic cap. On demand, the push button could be supplied in metallic version with or without LED light. Square design.</p>\n","product_variants":"61478,62078,62088,62098,62108,62118,62128,62138,62148,62158,67918,67928,67938,67948,67958,67968,67978,62648,67988,67998,65409,64631,66878,65399,64621,67977,68737,68747,68757,68767,68777,68787,68797,68807,68817,61928,61938,63818,63828,63838,63848,63858,63868,63878,63888,63959,64641,66109,64611,69171,6698","index_order":"01_03_02","coaches":true,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p230j_manual_rev5.pdf","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P230.pdf","documenti_allegati":[{"nome_documento_it":"Manuale sistema JOK","nome_documento_eng":"JOK system manual","allegato_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/MU_Jok-System_rev7-6.pdf"}],"product_name_ru":"Ручка для пассажирской двери","product_description_ru":"<p>Ручка для пассажирских дверей всегда свободно открывается изнутри. Доступна в ручном, электрическом и электропневматическом вариантах. Электрическая и электропневматическая версии могут поставляться с внешней кнопкой открытия двери, с колпачком из термопластичной резины. По запросу кнопка может поставляться в металлическом исполнении как со светодиодным индикатором, так и без него. Квадратной формы.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/265"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=265"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":264,"date":"2017-04-14T11:56:38","date_gmt":"2017-04-14T09:56:38","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=264"},"modified":"2023-09-28T10:45:11","modified_gmt":"2023-09-28T08:45:11","slug":"p217","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p217/","title":{"rendered":"P217"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p217","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":30,"post_author":"1","post_date":"2017-04-11 12:14:18","post_date_gmt":"2017-04-11 10:14:18","post_content":"","post_title":"Maniglie per porte passeggeri","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-porta-passeggeri","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:40","post_modified_gmt":"2020-02-14 15:56:40","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=30","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per porta passeggeri","product_name_en":"Passenger's doors handle","product_image":false,"product_description_it":"<p>Maniglia interna per porte di uscita di emergenza, per installazione diretta sulla barra di apertura.</p>\n","product_description_en":"<p>Internal handles for emergency doors, for direct installation on the opening rods.</p>\n","product_variants":"67067,67697,64418","index_order":"01_03_05","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P217.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Ручка для пассажирской двери","product_description_ru":"<p>Внутренняя ручка для дверей аварийных выходов, для непосредственного монтажа на штангу открытия.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/264"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=264"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":263,"date":"2017-04-14T11:56:20","date_gmt":"2017-04-14T09:56:20","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=263"},"modified":"2023-09-28T10:43:28","modified_gmt":"2023-09-28T08:43:28","slug":"p216","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p216/","title":{"rendered":"P216"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p216","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":30,"post_author":"1","post_date":"2017-04-11 12:14:18","post_date_gmt":"2017-04-11 10:14:18","post_content":"","post_title":"Maniglie per porte passeggeri","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-porta-passeggeri","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:40","post_modified_gmt":"2020-02-14 15:56:40","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=30","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per porta passeggeri","product_name_en":"Passenger's doors handle","product_image":false,"product_description_it":"<p>Maniglia esterna per porta di uscita di emergenza.</p>\n","product_description_en":"<p>External handles for emergency doors.</p>\n","product_variants":"60768,66721,66967,60688,60698,60708,60718,60728,60738,60748,60758,63821,63831,63841,63851,63861,63871,63881,63891,63901,63511,63911,63491,60811,63921,62281,63041,63931,63941,63951,63331,63631,64111,67737","index_order":"01_03_04","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P216.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Ручка для пассажирской двери","product_description_ru":"<p>Внешняя ручка для двери аварийного выхода.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/263"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=263"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":262,"date":"2017-04-14T11:55:56","date_gmt":"2017-04-14T09:55:56","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=262"},"modified":"2023-09-28T10:38:56","modified_gmt":"2023-09-28T08:38:56","slug":"p203","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p203/","title":{"rendered":"P203"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p203","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":30,"post_author":"1","post_date":"2017-04-11 12:14:18","post_date_gmt":"2017-04-11 10:14:18","post_content":"","post_title":"Maniglie per porte passeggeri","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-porta-passeggeri","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:40","post_modified_gmt":"2020-02-14 15:56:40","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=30","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per porta passeggeri","product_name_en":"Passenger's doors handle","product_image":false,"product_description_it":"<p>Maniglia per porte passeggeri sempre liberamente azionabile dall&#8217;interno. Disponibile con manopola di azionamento a ritorno automatico. Disegno squadrato.</p>\n","product_description_en":"<p>Handles for passenger&#8217;s doors to be always free opened from inside. Available in manual, electric and electropneumatic execution. The electric and the electropneumatic versions are equipped with a door opening button with thermoplastic cap. On demand, the push button could be supplied in metallic version with or withou LED light. Square design.</p>\n","product_variants":"67777,67767,67787,67797,67807,67817,67827,67837,67867,67857,63501,63481,60801,62271,63021,63321,63011,66059,67449,65951,65931,65941","index_order":"01_03_03","coaches":true,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p203J_manual_rev4.pdf","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P203.pdf","documenti_allegati":[{"nome_documento_it":"Manuale sistema JOK","nome_documento_eng":"JOK system manual","allegato_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/MU_Jok-System_rev7-5.pdf"}],"product_name_ru":"Ручка для пассажирской двери","product_description_ru":"<p>Ручка для пассажирских дверей всегда свободно открывается изнутри. Поставляется с ручкой автоматического возврата. Квадратной формы.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/262"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=262"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":261,"date":"2017-04-14T11:55:30","date_gmt":"2017-04-14T09:55:30","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=261"},"modified":"2023-09-28T11:36:15","modified_gmt":"2023-09-28T09:36:15","slug":"p392","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p392/","title":{"rendered":"P392"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p392","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":29,"post_author":"1","post_date":"2017-04-11 12:13:43","post_date_gmt":"2017-04-11 10:13:43","post_content":"","post_title":"Maniglie per porta autista","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-porta-autista","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:54","post_modified_gmt":"2020-02-14 15:56:54","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=29","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia porta autista","product_name_en":"Driver's door handle","product_image":false,"product_description_it":"<p>Maniglia porta autista. Azionamento a pulsante. Pulsante a scorrimento libero a serratura bloccata. Impugnatura con carcassa squadrata.</p>\n","product_description_en":"<p>Handles for the driver&#8217;s door. Push button operated. Free sliding button when locked. Grip handle with square frame.</p>\n","product_variants":"67249","index_order":"01_02_04","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P392.pdf","pdf_manual":false,"documenti_allegati":[{"nome_documento_it":"Manuale sistema JOK","nome_documento_eng":"JOK system manual","allegato_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/MU_Jok-System_rev7-9.pdf"}],"product_name_ru":"Ручка для водительской двери","product_description_ru":"<p>Ручка водительской двери. Кнопочное управление. Бесступенчатая кнопка с блокировкой. Ручка с квадратным каркасом.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/261"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=261"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":260,"date":"2017-04-14T11:55:11","date_gmt":"2017-04-14T09:55:11","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=260"},"modified":"2023-09-28T11:14:01","modified_gmt":"2023-09-28T09:14:01","slug":"p285","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p285/","title":{"rendered":"P285"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p285","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":29,"post_author":"1","post_date":"2017-04-11 12:13:43","post_date_gmt":"2017-04-11 10:13:43","post_content":"","post_title":"Maniglie per porta autista","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-porta-autista","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:54","post_modified_gmt":"2020-02-14 15:56:54","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=29","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia porta autista","product_name_en":"Driver's door handle","product_image":false,"product_description_it":"<p>Maniglia porta autista. Azionamento a pulsante. Pulsante a scorrimento libero a serratura bloccata. Impugnatura senza carcassa.</p>\n","product_description_en":"<p>Handles for the driver&#8217;s door. Push button operated. Free sliding button when locked. Grip handle without frame</p>\n","product_variants":"62488,62498,62508,62518,62528,62538,62548,62558,62568,62578,64321,64331,64341,64351,64361,64371,64381,64391,64401,64411,64421,64431,64441,64451,64461,64471,64481,64491,64501,64511,64521,64531,64541,64551,64561,64571,68021,68031,68041,68051,68389","index_order":"01_02_02","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P285.pdf","pdf_manual":false,"documenti_allegati":[{"nome_documento_it":"Manuale sistema JOK","nome_documento_eng":"JOK system manual","allegato_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/MU_Jok-System_rev7-7.pdf"}],"product_name_ru":"Ручка для водительской двери","product_description_ru":"<p>Ручка водительской двери. Кнопочное управление. Бесступенчатая кнопка с блокировкой. Ручка без каркаса.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/260"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=260"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":259,"date":"2017-04-14T11:54:50","date_gmt":"2017-04-14T09:54:50","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=259"},"modified":"2023-09-28T11:06:33","modified_gmt":"2023-09-28T09:06:33","slug":"p246bis","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p246bis/","title":{"rendered":"P246bis"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p246_bis","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":29,"post_author":"1","post_date":"2017-04-11 12:13:43","post_date_gmt":"2017-04-11 10:13:43","post_content":"","post_title":"Maniglie per porta autista","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-porta-autista","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:54","post_modified_gmt":"2020-02-14 15:56:54","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=29","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia porta autista","product_name_en":"Driver's door handle","product_image":false,"product_description_it":"<p>Maniglia interna per porta autista.</p>\n","product_description_en":"<p>Internal door unlocking handles for driver&#8217;s door.</p>\n","product_variants":"68138,63311","index_order":"01_02_05","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P246bis.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Ручка для водительской двери","product_description_ru":"<p>Ручка для внутренней двери водителя.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/259"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=259"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":258,"date":"2017-04-14T11:54:19","date_gmt":"2017-04-14T09:54:19","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=258"},"modified":"2023-09-28T09:24:06","modified_gmt":"2023-09-28T07:24:06","slug":"p61","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p61/","title":{"rendered":"P61"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p61","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":29,"post_author":"1","post_date":"2017-04-11 12:13:43","post_date_gmt":"2017-04-11 10:13:43","post_content":"","post_title":"Maniglie per porta autista","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-porta-autista","to_ping":"","pinged":"","post_modified":"2020-02-14 16:56:54","post_modified_gmt":"2020-02-14 15:56:54","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=29","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia porta autista","product_name_en":"Driver's door handle","product_image":false,"product_description_it":"<p>Maniglia porta autista. Azionamento a pulsante. Pulsante a scorrimento libero a serratura bloccata. Impugnatura con carcassa ovale.</p>\n","product_description_en":"<p>Handles for the driver&#8217;s door. Push button operated. Free sliding button when locked. Grip handle with oval frame.</p>\n","product_variants":"69857,69867,69877,69887,69897,69907,69917,69927,69937,69947,67409,67279","index_order":"01_02_03","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P61.pdf","pdf_manual":false,"documenti_allegati":[{"nome_documento_it":"Manuale sistema JOK","nome_documento_eng":"JOK system manual","allegato_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/MU_Jok-System_rev7-1.pdf"}],"product_name_ru":"Ручка для водительской двери","product_description_ru":"<p>Ручка водительской двери. Кнопочное управление. Бесступенчатая кнопка с блокировкой. Ручка с овальным каркасом.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/258"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=258"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":257,"date":"2017-04-14T11:54:01","date_gmt":"2017-04-14T09:54:01","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=257"},"modified":"2023-09-28T11:41:43","modified_gmt":"2023-09-28T09:41:43","slug":"p400","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p400/","title":{"rendered":"P400"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p400","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":28,"post_author":"1","post_date":"2017-04-11 12:12:39","post_date_gmt":"2017-04-11 10:12:39","post_content":"","post_title":"Maniglie per portelloni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-portelloni","to_ping":"","pinged":"","post_modified":"2020-03-05 15:18:21","post_modified_gmt":"2020-03-05 14:18:21","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=28","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per portelloni","product_name_en":"Luggage door handle","product_image":false,"product_description_it":"<p>Maniglia per portelloni laterali vani portabagagli di autobus turistici di piccola e media taglia, con impugnatura aperta. Disegno ovale.</p>\n","product_description_en":"<p>Handles for the side luggage compartment door of mini and midi busses. Open grip, oval design.</p>\n","product_variants":"66301,66311,69021","index_order":"01_01_05","coaches":false,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p400_manual_rev2.pdf","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P400.pdf","documenti_allegati":[{"nome_documento_it":"Manuale sistema JOK","nome_documento_eng":"JOK system manual","allegato_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/MU_Jok-System_rev7-11.pdf"}],"product_name_ru":"Ручки для дверей","product_description_ru":"<p>Ручка для боковых дверей багажных отсеков средне- и малогабаритных туристических автобусов, с открытой рукояткой. Овальной формы.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/257"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=257"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":255,"date":"2017-04-14T11:53:23","date_gmt":"2017-04-14T09:53:23","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=255"},"modified":"2023-09-28T11:38:50","modified_gmt":"2023-09-28T09:38:50","slug":"p397","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p397/","title":{"rendered":"P397"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p397","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":28,"post_author":"1","post_date":"2017-04-11 12:12:39","post_date_gmt":"2017-04-11 10:12:39","post_content":"","post_title":"Maniglie per portelloni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-portelloni","to_ping":"","pinged":"","post_modified":"2020-03-05 15:18:21","post_modified_gmt":"2020-03-05 14:18:21","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=28","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per portelloni","product_name_en":"Luggage door handle","product_image":false,"product_description_it":"<p>Maniglia per portelloni laterali vani portabagagli di autobus turistici, con impugnatura a barra. Disegno ovale.</p>\n","product_description_en":"<p>Handles for the side luggage compartment door of coaches in execution with straight grip bar. Oval design.</p>\n","product_variants":"63071,69809,61861,63061,69829,69819,63081,69839","index_order":"01_01_03","coaches":true,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p397_manual_rev4.pdf","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P397_P397a.pdf","documenti_allegati":[{"nome_documento_it":"Manuale sistema JOK","nome_documento_eng":"JOK system manual","allegato_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/MU_Jok-System_rev7-10.pdf"}],"product_name_ru":"Ручки для дверей","product_description_ru":"<p>Ручка для боковых дверей багажных отсеков туристических автобусов, с рукояткой в виде штанги. Овальной формы.</p>\n","product_with_jok_system":["si"]},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/255"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=255"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":254,"date":"2017-04-14T11:53:05","date_gmt":"2017-04-14T09:53:05","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=254"},"modified":"2023-09-28T11:19:40","modified_gmt":"2023-09-28T09:19:40","slug":"p332","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p332/","title":{"rendered":"P332"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p332","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":28,"post_author":"1","post_date":"2017-04-11 12:12:39","post_date_gmt":"2017-04-11 10:12:39","post_content":"","post_title":"Maniglie per portelloni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-portelloni","to_ping":"","pinged":"","post_modified":"2020-03-05 15:18:21","post_modified_gmt":"2020-03-05 14:18:21","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=28","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per portelloni","product_name_en":"Luggage door handle","product_image":false,"product_description_it":"<p>Maniglia per portelloni laterali vani portabagagli di autobus turistici, con apertura a battente e barra di appiglio rigida. Disegno squadrato di grandi dimensioni.</p>\n","product_description_en":"<p>Handles for the side luggage compartment door of coaches, flap form opening lever and straight grip bar. Square design very large.</p>\n","product_variants":"63969,68501","index_order":"01_01_10","coaches":true,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p332j_manual_rev4.pdf","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P332.pdf","documenti_allegati":[{"nome_documento_it":"Manuale sistema JOK","nome_documento_eng":"JOK system manual","allegato_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/MU_Jok-System_rev7-8.pdf"}],"product_name_ru":"Ручки для дверей","product_description_ru":"<p>Ручка для боковых дверей багажных отделений туристических автобусов, со створчатой системой открытия и жесткой зацепной штангой. Квадратной формы, крупные размеры.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/254"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=254"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":253,"date":"2017-04-14T11:52:48","date_gmt":"2017-04-14T09:52:48","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=253"},"modified":"2023-09-28T10:36:43","modified_gmt":"2023-09-28T08:36:43","slug":"p199","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p199/","title":{"rendered":"P199"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p199","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":28,"post_author":"1","post_date":"2017-04-11 12:12:39","post_date_gmt":"2017-04-11 10:12:39","post_content":"","post_title":"Maniglie per portelloni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-portelloni","to_ping":"","pinged":"","post_modified":"2020-03-05 15:18:21","post_modified_gmt":"2020-03-05 14:18:21","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=28","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per portelloni","product_name_en":"Luggage door handle","product_image":false,"product_description_it":"<p>Maniglia di presa per portelloni laterali vani portabagagli di autobus turistici, con impugnatura aperta. Disegno squadrato.</p>\n","product_description_en":"<p>Simple grap handle for side doors of busses. Square design.</p>\n","product_variants":"66517,63869","index_order":"01_01_12","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P199.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Ручки для дверей","product_description_ru":"<p>Ручка для боковых дверей багажных отсеков туристических автобусов, с открытой рукояткой. Квадратной формы.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/253"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=253"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":252,"date":"2017-04-14T11:52:24","date_gmt":"2017-04-14T09:52:24","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=252"},"modified":"2023-09-28T10:35:45","modified_gmt":"2023-09-28T08:35:45","slug":"p183","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p183/","title":{"rendered":"P183"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p183","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":28,"post_author":"1","post_date":"2017-04-11 12:12:39","post_date_gmt":"2017-04-11 10:12:39","post_content":"","post_title":"Maniglie per portelloni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-portelloni","to_ping":"","pinged":"","post_modified":"2020-03-05 15:18:21","post_modified_gmt":"2020-03-05 14:18:21","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=28","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per portelloni","product_name_en":"Luggage door handle","product_image":false,"product_description_it":"<p>Maniglia per portelloni laterali vani portabagagli di autobus turistici, con impugnatura basculante. Disegno squadrato.</p>\n","product_description_en":"<p>Handles for the side luggage compartment door of coaches with tilting grip. Square design.</p>\n","product_variants":"69767,66247","index_order":"01_01_09","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P183.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Ручки для дверей","product_description_ru":"<p>Ручка для боковых дверей отсеков багажника туристических автобусов с разворачиваемой ручкой. Квадратной формы.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/252"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=252"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":251,"date":"2017-04-14T11:51:54","date_gmt":"2017-04-14T09:51:54","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=251"},"modified":"2023-09-28T10:33:54","modified_gmt":"2023-09-28T08:33:54","slug":"p179","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p179/","title":{"rendered":"P179"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p179","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":28,"post_author":"1","post_date":"2017-04-11 12:12:39","post_date_gmt":"2017-04-11 10:12:39","post_content":"","post_title":"Maniglie per portelloni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-portelloni","to_ping":"","pinged":"","post_modified":"2020-03-05 15:18:21","post_modified_gmt":"2020-03-05 14:18:21","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=28","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per portelloni","product_name_en":"Luggage door handle","product_image":false,"product_description_it":"<p>Maniglia di presa per portelloni laterali vani portabagagli di autobus turistici, con impugnatura aperta. Disegno squadrato.</p>\n","product_description_en":"<p>Simple grap handle for side doors of busses. Square design.</p>\n","product_variants":"65737","index_order":"01_01_13","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P179.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Ручки для дверей","product_description_ru":"<p>Ручка для боковых дверей багажных отсеков туристических автобусов, с открытой рукояткой. Квадратной формы.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/251"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=251"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":250,"date":"2017-04-14T11:51:35","date_gmt":"2017-04-14T09:51:35","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=250"},"modified":"2023-09-28T10:32:06","modified_gmt":"2023-09-28T08:32:06","slug":"p178","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p178/","title":{"rendered":"P178"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p178","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":28,"post_author":"1","post_date":"2017-04-11 12:12:39","post_date_gmt":"2017-04-11 10:12:39","post_content":"","post_title":"Maniglie per portelloni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-portelloni","to_ping":"","pinged":"","post_modified":"2020-03-05 15:18:21","post_modified_gmt":"2020-03-05 14:18:21","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=28","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per portelloni","product_name_en":"Luggage door handle","product_image":false,"product_description_it":"<p>Maniglia per portelloni laterali vani portabagagli di autobus turistici, con impugnatura basculante. Disegno squadrato.</p>\n","product_description_en":"<p>Handles for the side luggage compartment door of coaches with tilting grip. Square design.</p>\n","product_variants":"69587,69597,69607,69617,69627,69637,69647,69657,69667,69677,64869,66139,69267,69277,69287,69297,69307,69317,69327,69337,69347,69357,64879,65708,69899","index_order":"01_01_08","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P178.pdf","pdf_manual":false,"documenti_allegati":[{"nome_documento_it":"Manuale sistema JOK","nome_documento_eng":"JOK manual system","allegato_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/MU_Jok-System_rev7-4.pdf"}],"product_name_ru":"Ручки для дверей","product_description_ru":"<p>Ручка для боковых дверей отсеков багажника туристических автобусов с разворачиваемой ручкой. Квадратной формы.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/250"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=250"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":249,"date":"2017-04-14T11:51:16","date_gmt":"2017-04-14T09:51:16","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=249"},"modified":"2023-09-28T10:29:11","modified_gmt":"2023-09-28T08:29:11","slug":"p141","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p141/","title":{"rendered":"P141"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p141","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":28,"post_author":"1","post_date":"2017-04-11 12:12:39","post_date_gmt":"2017-04-11 10:12:39","post_content":"","post_title":"Maniglie per portelloni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-portelloni","to_ping":"","pinged":"","post_modified":"2020-03-05 15:18:21","post_modified_gmt":"2020-03-05 14:18:21","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=28","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per portelloni","product_name_en":"Luggage door handle","product_image":false,"product_description_it":"<p>Maniglia per portelloni laterali vani portabagagli di autobus turistici, con impugnatura aperta. Disegno rettangolare.</p>\n","product_description_en":"<p>Handles for the side luggage compartment door of coaches in execution with open grip. Rectangular design.</p>\n","product_variants":"60482,60492,60502,60512,68635,68645,68655,68665,68675,68685,61868,61878,63238,63348,63358,63368,63378,63388,63398,63408,63418,63428,63438,63448,63458,63468,63478,63488,64808,64818,67791,66681,69111,68361,69121,69131,67661,67671,63151,66641,67681,64642,64652,64662,63757,63929,66119,60532,60542,60552,60562,68695,68705,68715,68725,68735,68745,61888,61898,69549,69559,69569,69579,69589,69599,69609,69619,63578,60142,67691,67701,67711,61881,62141,60522,63939,66499,69387,69397,69407,69417,69427,66537,66547,66557,66567,69437,65672,65682,63182,66051,66621,67301,63192,67471,67311,67321,67921,67931,65372,63172,68891,68901,68741,68911,65342,65352,65362,61781,67027,67832,63361,63101,68481,68769,66652,64972","index_order":"01_01_07","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P141.pdf","pdf_manual":false,"documenti_allegati":[{"nome_documento_it":"Manuale sistema JOK","nome_documento_eng":"JOK system manual","allegato_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/MU_Jok-System_rev7-3.pdf"}],"product_name_ru":"Ручки для дверей","product_description_ru":"<p>Ручка для боковых дверей багажных отсеков туристических автобусов, с открытой рукояткой. Прямоугольной формы.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/249"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=249"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":248,"date":"2017-04-14T11:50:57","date_gmt":"2017-04-14T09:50:57","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=248"},"modified":"2023-09-28T09:54:37","modified_gmt":"2023-09-28T07:54:37","slug":"p119","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p119/","title":{"rendered":"P119"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p119","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":28,"post_author":"1","post_date":"2017-04-11 12:12:39","post_date_gmt":"2017-04-11 10:12:39","post_content":"","post_title":"Maniglie per portelloni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-portelloni","to_ping":"","pinged":"","post_modified":"2020-03-05 15:18:21","post_modified_gmt":"2020-03-05 14:18:21","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=28","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per portelloni","product_name_en":"Luggage door handle","product_image":false,"product_description_it":"<p>Maniglia per portelloni laterali vani portabagagli di autobus turistici, con impugnatura a battente. Disegno squadrato.</p>\n","product_description_en":"<p>Handles for the side luggage compartment door of coaches in execution with flap form grip. Square design.</p>\n","product_variants":"51221,51231,51241,52131,68515,68525,68535,68545,68555,68565,61828,61838,62918,62928,62938,62948,62958,62968,62978,62988,62998,63008,63018,63028,63038,63048,63058,63068,64588,64598,64608,52441,52451,52461,52161,68575,68585,68595,68605,68615,68625,61848,61858,69469,69479,69489,69499,69509,69519,69529,69539,63158,69447,69457,69467,69477,69487,69497,69507,69517,69527,69537,62109,68419,64618,64628,64638,64648,64658,64668,64678,65528,65538,68571,67731,63131,67741,61871,64612,64622,64632,66129,60662,69411,67761,67781,66960,64409,61901,63141","index_order":"01_01_06","coaches":true,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P119.pdf","documenti_allegati":[{"nome_documento_it":"Manuale sistema JOK","nome_documento_eng":"JOK system manual","allegato_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/MU_Jok-System_rev7-2.pdf"}],"product_name_ru":"Ручки для дверей","product_description_ru":"<p>Ручка для боковых дверей багажных отсеков туристических автобусов, с откидной рукояткой. Квадратной формы.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/248"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=248"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":247,"date":"2017-04-14T11:50:35","date_gmt":"2017-04-14T09:50:35","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=247"},"modified":"2023-09-28T09:34:41","modified_gmt":"2023-09-28T07:34:41","slug":"p68","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p68/","title":{"rendered":"P68"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p68","category_id":[{"ID":24,"post_author":"1","post_date":"2017-04-11 12:06:55","post_date_gmt":"2017-04-11 10:06:55","post_content":"","post_title":"Maniglie","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie","to_ping":"","pinged":"","post_modified":"2023-09-29 10:28:49","post_modified_gmt":"2023-09-29 08:28:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=24","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":28,"post_author":"1","post_date":"2017-04-11 12:12:39","post_date_gmt":"2017-04-11 10:12:39","post_content":"","post_title":"Maniglie per portelloni","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-per-portelloni","to_ping":"","pinged":"","post_modified":"2020-03-05 15:18:21","post_modified_gmt":"2020-03-05 14:18:21","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=28","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia per portelloni","product_name_en":"Luggage door handle","product_image":false,"product_description_it":"<p>Maniglia per portelloni laterali vani portabagagli di autobus turistici, con impugnatura basculante. Disegno trapezoidale.</p>\n","product_description_en":"<p>Handles for the side luggage compartment door of coaches with tilting grip. Trapezoidal design.</p>\n","product_variants":"56271,62831,56101,56141,66297,63401","index_order":"01_01_11","coaches":false,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P68.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Ручки для дверей","product_description_ru":"<p>Ручка для боковых дверей багажного отсека туристических автобусов с разворачиваемой ручкой. Трапециевидной формы..</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/247"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=247"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":246,"date":"2017-04-14T11:49:53","date_gmt":"2017-04-14T09:49:53","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=246"},"modified":"2023-09-28T16:21:34","modified_gmt":"2023-09-28T14:21:34","slug":"p322","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p322/","title":{"rendered":"P322"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p322","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":39,"post_author":"1","post_date":"2017-04-11 12:24:07","post_date_gmt":"2017-04-11 10:24:07","post_content":"","post_title":"Cerniere","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"cerniere","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:37","post_modified_gmt":"2020-02-14 15:54:37","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=39","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Cerniera","product_name_en":"Hinges","product_image":false,"product_description_it":"<p>Cerniere in acciaio inossidabile.</p>\n","product_description_en":"<p>Stainless stell hinges.</p>\n","product_variants":"68218,67678,63729","index_order":"02_06_01","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P322.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/246"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=246"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":245,"date":"2017-04-14T11:49:39","date_gmt":"2017-04-14T09:49:39","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=245"},"modified":"2023-09-28T16:19:41","modified_gmt":"2023-09-28T14:19:41","slug":"p295","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p295/","title":{"rendered":"P295"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p295","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":39,"post_author":"1","post_date":"2017-04-11 12:24:07","post_date_gmt":"2017-04-11 10:24:07","post_content":"","post_title":"Cerniere","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"cerniere","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:37","post_modified_gmt":"2020-02-14 15:54:37","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=39","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Cerniera","product_name_en":"Hinges","product_image":false,"product_description_it":"<p>Ceniere in plastica.</p>\n","product_description_en":"<p>Plastic hinges.</p>\n","product_variants":"64488,64498,64508,62888,64518","index_order":"02_06_02","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P295.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/245"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=245"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":241,"date":"2017-04-14T11:45:18","date_gmt":"2017-04-14T09:45:18","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=241"},"modified":"2024-01-30T15:46:45","modified_gmt":"2024-01-30T14:46:45","slug":"p271","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p271/","title":{"rendered":"P271"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p271","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":369,"post_author":"1","post_date":"2017-05-19 10:53:12","post_date_gmt":"2017-05-19 08:53:12","post_content":"","post_title":"Dispositivi di bloccaggio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"dispositivi-di-bloccaggio","to_ping":"","pinged":"","post_modified":"2020-02-14 16:47:02","post_modified_gmt":"2020-02-14 15:47:02","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=369","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Serratura a molla","product_name_en":"Clasp lock","product_image":false,"product_description_it":"<p>Serratura grande a molla per cofani o sportelli di medie dimensioni.</p>\n","product_description_en":"<p>Clasp lock (large) for hoods or medium sized flaps.</p>\n","product_variants":"62238","index_order":"02_04_05","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P271-2.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/241"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=241"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":240,"date":"2017-04-14T11:44:31","date_gmt":"2017-04-14T09:44:31","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=240"},"modified":"2023-09-28T16:16:18","modified_gmt":"2023-09-28T14:16:18","slug":"p238","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p238/","title":{"rendered":"P238"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p238","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":369,"post_author":"1","post_date":"2017-05-19 10:53:12","post_date_gmt":"2017-05-19 08:53:12","post_content":"","post_title":"Dispositivi di bloccaggio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"dispositivi-di-bloccaggio","to_ping":"","pinged":"","post_modified":"2020-02-14 16:47:02","post_modified_gmt":"2020-02-14 15:47:02","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=369","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Perno di chiusura","product_name_en":"Sliding pin","product_image":false,"product_description_it":"<p>Perno scorrevole per maniglie interne porte passeggeri.</p>\n","product_description_en":"<p>Sliding pin for internal emergency passenger door handles.</p>\n","index_order":"02_04_08","product_variants":"67967","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P238.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/240"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=240"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":239,"date":"2017-04-14T11:44:05","date_gmt":"2017-04-14T09:44:05","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=239"},"modified":"2023-09-28T15:55:47","modified_gmt":"2023-09-28T13:55:47","slug":"p130","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p130/","title":{"rendered":"P130"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p130","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":369,"post_author":"1","post_date":"2017-05-19 10:53:12","post_date_gmt":"2017-05-19 08:53:12","post_content":"","post_title":"Dispositivi di bloccaggio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"dispositivi-di-bloccaggio","to_ping":"","pinged":"","post_modified":"2020-02-14 16:47:02","post_modified_gmt":"2020-02-14 15:47:02","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=369","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Perno di riscontro","product_name_en":"Striker pin","product_image":false,"product_description_it":"<p>Riscontro triangolare per serrature a forcella.</p>\n","product_description_en":"<p>Striker pin (large) for forked locks.</p>\n","product_variants":"52121,56521","index_order":"02_04_04","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P130.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/239"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=239"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":238,"date":"2017-04-14T11:43:43","date_gmt":"2017-04-14T09:43:43","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=238"},"modified":"2023-09-28T15:43:36","modified_gmt":"2023-09-28T13:43:36","slug":"p70","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p70/","title":{"rendered":"P70"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p70","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":369,"post_author":"1","post_date":"2017-05-19 10:53:12","post_date_gmt":"2017-05-19 08:53:12","post_content":"","post_title":"Dispositivi di bloccaggio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"dispositivi-di-bloccaggio","to_ping":"","pinged":"","post_modified":"2020-02-14 16:47:02","post_modified_gmt":"2020-02-14 15:47:02","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=369","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Serratura a forcella","product_name_en":"Forked lock","product_image":false,"product_description_it":"<p>Serratura a forcella per portelloni laterali vani portabagagli.</p>\n","product_description_en":"<p>Forked lock for luggage compartment handles.</p>\n","product_variants":"66940,51700,67218,67208,64967,64957","index_order":"02_04_01","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P70.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/238"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=238"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":237,"date":"2017-04-14T11:43:17","date_gmt":"2017-04-14T09:43:17","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=237"},"modified":"2023-09-28T15:45:20","modified_gmt":"2023-09-28T13:45:20","slug":"p70bis","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p70bis/","title":{"rendered":"P70bis"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p70_bis","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":369,"post_author":"1","post_date":"2017-05-19 10:53:12","post_date_gmt":"2017-05-19 08:53:12","post_content":"","post_title":"Dispositivi di bloccaggio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"dispositivi-di-bloccaggio","to_ping":"","pinged":"","post_modified":"2020-02-14 16:47:02","post_modified_gmt":"2020-02-14 15:47:02","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=369","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Perno di riscontro","product_name_en":"Striker pin","product_image":false,"product_description_it":"<p>Riscontro per serrature a forcella.</p>\n","product_description_en":"<p>Striker pin (small) for forked locks.</p>\n","product_variants":"64548,64981","index_order":"02_04_03","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P70bis.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/237"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=237"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":236,"date":"2017-04-14T11:42:49","date_gmt":"2017-04-14T09:42:49","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=236"},"modified":"2023-09-28T15:39:34","modified_gmt":"2023-09-28T13:39:34","slug":"p62","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p62/","title":{"rendered":"P62"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p62","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":369,"post_author":"1","post_date":"2017-05-19 10:53:12","post_date_gmt":"2017-05-19 08:53:12","post_content":"","post_title":"Dispositivi di bloccaggio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"dispositivi-di-bloccaggio","to_ping":"","pinged":"","post_modified":"2020-02-14 16:47:02","post_modified_gmt":"2020-02-14 15:47:02","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=369","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Serratura porta autista","product_name_en":"Lock","product_image":false,"product_description_it":"<p>Serratura per maniglia porta-autista, con sicura.</p>\n","product_description_en":"<p>Lock for driver’s door with safety lock.</p>\n","product_variants":"66374,65532","index_order":"02_04_02","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P62.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/236"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=236"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":234,"date":"2017-04-14T11:41:51","date_gmt":"2017-04-14T09:41:51","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=234"},"modified":"2023-09-28T15:35:35","modified_gmt":"2023-09-28T13:35:35","slug":"p20","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p20/","title":{"rendered":"P20"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p20","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":369,"post_author":"1","post_date":"2017-05-19 10:53:12","post_date_gmt":"2017-05-19 08:53:12","post_content":"","post_title":"Dispositivi di bloccaggio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"dispositivi-di-bloccaggio","to_ping":"","pinged":"","post_modified":"2020-02-14 16:47:02","post_modified_gmt":"2020-02-14 15:47:02","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=369","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Perno di riscontro","product_name_en":"Striker pin","product_image":false,"product_description_it":"<p>Riscontro per serratura a molla.</p>\n","product_description_en":"<p>Striker for clasp lock (small) for hoods or small flaps.</p>\n","product_variants":"69777","index_order":"02_04_06","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":true,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P20_P21.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/234"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=234"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":233,"date":"2017-04-14T11:41:30","date_gmt":"2017-04-14T09:41:30","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=233"},"modified":"2023-09-28T16:20:31","modified_gmt":"2023-09-28T14:20:31","slug":"p301","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p301/","title":{"rendered":"P301"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p301","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":36,"post_author":"1","post_date":"2017-04-11 12:19:10","post_date_gmt":"2017-04-11 10:19:10","post_content":"","post_title":"Scontrini","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"scontrini","to_ping":"","pinged":"","post_modified":"2020-02-14 16:55:06","post_modified_gmt":"2020-02-14 15:55:06","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=36","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Scontrino","product_name_en":"Pin vanger","product_image":false,"product_description_it":"<p>Scontrino per perno porte passeggeri.</p>\n","product_description_en":"<p>Pin vanger for passenger&#8217;s doors.</p>\n","product_variants":"65628","index_order":"02_07_01","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P301.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/233"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=233"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":232,"date":"2017-04-14T11:41:12","date_gmt":"2017-04-14T09:41:12","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=232"},"modified":"2023-09-28T16:18:29","modified_gmt":"2023-09-28T14:18:29","slug":"p294","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p294/","title":{"rendered":"P294"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p294","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":36,"post_author":"1","post_date":"2017-04-11 12:19:10","post_date_gmt":"2017-04-11 10:19:10","post_content":"","post_title":"Scontrini","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"scontrini","to_ping":"","pinged":"","post_modified":"2020-02-14 16:55:06","post_modified_gmt":"2020-02-14 15:55:06","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=36","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Guida per chiusura porta","product_name_en":"Slide way","product_image":false,"product_description_it":"<p>Guida per chiusura porte passeggeri.</p>\n","product_description_en":"<p>Slide way for passenger&#8217;s doors.</p>\n","product_variants":"62828,65698","index_order":"02_07_02","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P294.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/232"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=232"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":230,"date":"2017-04-14T11:40:32","date_gmt":"2017-04-14T09:40:32","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=230"},"modified":"2023-09-28T16:39:49","modified_gmt":"2023-09-28T14:39:49","slug":"p219","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p219/","title":{"rendered":"P219"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p219","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":35,"post_author":"1","post_date":"2017-04-11 12:18:42","post_date_gmt":"2017-04-11 10:18:42","post_content":"","post_title":"Aste di collegamento","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"aste-di-collegamento","to_ping":"","pinged":"","post_modified":"2020-03-05 16:06:08","post_modified_gmt":"2020-03-05 15:06:08","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=35","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Asta di collegamento","product_name_en":"Connecting rod","product_image":false,"product_description_it":"<p>Asta di collegamento per sistemi di apertura di porte di emergenza.</p>\n","product_description_en":"<p>Connecting rod for emergency door opening systems.</p>\n","product_variants":"67759,65578,60141,67558,65588,60131,67687,67077,67677,62758,67248,62651,66938,62688,62421,67087,62249,67618,66609,67788,67717,64308,62121","index_order":"02_03_01","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P219.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/230"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=230"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":229,"date":"2017-04-14T11:40:15","date_gmt":"2017-04-14T09:40:15","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=229"},"modified":"2023-09-28T15:50:38","modified_gmt":"2023-09-28T13:50:38","slug":"p99","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p99/","title":{"rendered":"P99"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p99","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":35,"post_author":"1","post_date":"2017-04-11 12:18:42","post_date_gmt":"2017-04-11 10:18:42","post_content":"","post_title":"Aste di collegamento","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"aste-di-collegamento","to_ping":"","pinged":"","post_modified":"2020-03-05 16:06:08","post_modified_gmt":"2020-03-05 15:06:08","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=35","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Asta di collegamento","product_name_en":"Connecting rod","product_image":{"ID":780,"id":780,"title":"p99_IMG_8107","filename":"p99_IMG_8107.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p99_IMG_8107.jpg","alt":"","author":"5","description":"","caption":"","name":"p99_img_8107","date":"2018-10-09 09:04:51","modified":"2018-10-09 09:04:56","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":4478,"height":2062,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p99_IMG_8107-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p99_IMG_8107-300x138.jpg","medium-width":300,"medium-height":138,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p99_IMG_8107-768x354.jpg","medium_large-width":525,"medium_large-height":242,"large":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p99_IMG_8107-1024x472.jpg","large-width":525,"large-height":242,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p99_IMG_8107-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p99_IMG_8107-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Asta di collegamento per maniglie portelloni laterali vani portabagagli.</p>\n","product_description_en":"<p>Connecting rod for luggage compartment handles.</p>\n","product_variants":"66828, 66838","index_order":"02_03_02","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P99.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/229"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=229"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":228,"date":"2017-04-14T11:39:57","date_gmt":"2017-04-14T09:39:57","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=228"},"modified":"2023-09-28T16:25:19","modified_gmt":"2023-09-28T14:25:19","slug":"p335","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p335/","title":{"rendered":"P335"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p335","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":34,"post_author":"1","post_date":"2017-04-11 12:17:51","post_date_gmt":"2017-04-11 10:17:51","post_content":"","post_title":"Serrandole","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"serrandole","to_ping":"","pinged":"","post_modified":"2020-03-05 16:05:23","post_modified_gmt":"2020-03-05 15:05:23","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=34","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Serrandola","product_name_en":"Locking pin","product_image":false,"product_description_it":"<p>Asta di collegamento per sistemi di apertura di porte di emergenza.</p>\n","product_description_en":"<p>Locking spring loaded pin.</p>\n","product_variants":"60839,60849,64861","index_order":"02_02_04","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P335.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/228"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=228"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":226,"date":"2017-04-14T11:38:14","date_gmt":"2017-04-14T09:38:14","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=226"},"modified":"2023-09-28T16:40:15","modified_gmt":"2023-09-28T14:40:15","slug":"p214","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p214/","title":{"rendered":"P214"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p214","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":34,"post_author":"1","post_date":"2017-04-11 12:17:51","post_date_gmt":"2017-04-11 10:17:51","post_content":"","post_title":"Serrandole","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"serrandole","to_ping":"","pinged":"","post_modified":"2020-03-05 16:05:23","post_modified_gmt":"2020-03-05 15:05:23","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=34","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Serrandola","product_name_en":"Locking gear","product_image":false,"product_description_it":"<p>Serrandola per sistemi di apertura porte di uscita di emergenza.</p>\n","product_description_en":"<p>Locking gear for opening systems of emergency doors.</p>\n","product_variants":"61068,67707,65958,67057,66788,67727,67007,69739,69979,69989,65868,65878,65598,65608,60192,60209,67917,60199,66148,66987,67698,61129,63611,67167,67658,67757,66977,66997,66138,66968,60163,60203,60213,60223,60143,60153,62308,62318,66953","index_order":"02_02_01","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P214.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/226"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=226"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":223,"date":"2017-04-14T11:36:51","date_gmt":"2017-04-14T09:36:51","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=223"},"modified":"2023-10-02T10:22:26","modified_gmt":"2023-10-02T08:22:26","slug":"p220","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p220/","title":{"rendered":"P220"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p220","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":384,"post_author":"1","post_date":"2017-05-19 11:13:16","post_date_gmt":"2017-05-19 09:13:16","post_content":"","post_title":"Interruttori e pulsanti","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"interruttori-e-pulsanti","to_ping":"","pinged":"","post_modified":"2022-11-17 18:00:49","post_modified_gmt":"2022-11-17 17:00:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=384","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Pulsante","product_name_en":"Push button","product_image":false,"product_description_it":"<p>Pulsante per sistemi elettropneumatici di bloccaggio serrature porte. Da installarsi su cruscotto comandi.</p>\n","product_description_en":"<p>Push button for centralized electropneumatic door&#8217;s locking systems. To be installed on the dashboard.</p>\n","product_variants":"66907","index_order":"06_01_06","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P220.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/223"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=223"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":220,"date":"2017-04-14T11:35:28","date_gmt":"2017-04-14T09:35:28","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=220"},"modified":"2023-10-12T17:28:59","modified_gmt":"2023-10-12T15:28:59","slug":"p187_type1","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p187_type1/","title":{"rendered":"P187_type1"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p187_type1","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":33,"post_author":"1","post_date":"2017-04-11 12:17:18","post_date_gmt":"2017-04-11 10:17:18","post_content":"","post_title":"Sistemi di chiusura pneumatici ed elettrici","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-chiusura-pneumatici-ed-elettrici","to_ping":"","pinged":"","post_modified":"2022-11-17 17:29:59","post_modified_gmt":"2022-11-17 16:29:59","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=33","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Attuatore elettrico","product_name_en":"Electric actuator","product_image":false,"product_description_it":"<p>Attuatore elettrico per sistema di chiusura centralizzati. Versione compatta.</p>\n","product_description_en":"<p>Electric actuator for centralized handle&#8217;s locking system. Compact version.</p>\n","product_variants":"61499,61509,64571,64761","index_order":"02_01_01","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":true,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P187-1.pdf","pdf_manual":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P187-ver2023-01.pdf","documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/220"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=220"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":218,"date":"2017-04-14T11:34:15","date_gmt":"2017-04-14T09:34:15","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=218"},"modified":"2023-09-29T17:01:22","modified_gmt":"2023-09-29T15:01:22","slug":"p149","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p149/","title":{"rendered":"P149"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p149","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":384,"post_author":"1","post_date":"2017-05-19 11:13:16","post_date_gmt":"2017-05-19 09:13:16","post_content":"","post_title":"Interruttori e pulsanti","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"interruttori-e-pulsanti","to_ping":"","pinged":"","post_modified":"2022-11-17 18:00:49","post_modified_gmt":"2022-11-17 17:00:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=384","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Spia luminosa","product_name_en":"Warning light","product_image":false,"product_description_it":"<p>Spia luminosa di segnalazione per sistemi elettropneumatici di bloccaggio serrature porte. Da installarsi su cruscotto comandi.</p>\n","product_description_en":"<p>Warning light for centralized electropneumatic door&#8217;s locking systems. To be installed on the dashboard.</p>\n","product_variants":"65527","index_order":"02_01_07","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P149.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/218"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=218"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":217,"date":"2017-04-14T11:13:24","date_gmt":"2017-04-14T09:13:24","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=217"},"modified":"2023-09-28T15:57:01","modified_gmt":"2023-09-28T13:57:01","slug":"p132","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p132/","title":{"rendered":"P132"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p132","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":33,"post_author":"1","post_date":"2017-04-11 12:17:18","post_date_gmt":"2017-04-11 10:17:18","post_content":"","post_title":"Sistemi di chiusura pneumatici ed elettrici","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-chiusura-pneumatici-ed-elettrici","to_ping":"","pinged":"","post_modified":"2022-11-17 17:29:59","post_modified_gmt":"2022-11-17 16:29:59","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=33","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Centralina elettropneumatica","product_name_en":"Electropneumatic control unit","product_image":false,"product_description_it":"<p>Centralina di controllo per sistemi elettropneumatici di bloccaggio serrature porte.</p>\n","product_description_en":"<p>Control unit for centralized electropneumatic door&#8217;s locking systems.</p>\n","product_variants":"53721","index_order":"02_01_05","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P132.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/217"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=217"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":216,"date":"2017-04-14T11:12:36","date_gmt":"2017-04-14T09:12:36","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=216"},"modified":"2023-10-05T10:50:11","modified_gmt":"2023-10-05T08:50:11","slug":"p365","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p365/","title":{"rendered":"P365"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p365","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":43,"post_author":"1","post_date":"2017-04-11 12:27:13","post_date_gmt":"2017-04-11 10:27:13","post_content":"","post_title":"Riduzioni raccordi e tubi","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"riduzioni-e-raccordi","to_ping":"","pinged":"","post_modified":"2020-03-05 16:39:03","post_modified_gmt":"2020-03-05 15:39:03","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=43","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Raccordo","product_name_en":"Connector","product_image":{"ID":1828,"id":1828,"title":"P365_Modif_3787","filename":"P365_Modif_3787-1.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P365_Modif_3787-1.jpg","alt":"","author":"7","description":"","caption":"","name":"p365_modif_3787-2","date":"2023-10-05 08:49:57","modified":"2023-10-05 08:50:04","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":6543,"height":7795,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P365_Modif_3787-1-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P365_Modif_3787-1-252x300.jpg","medium-width":252,"medium-height":300,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P365_Modif_3787-1-768x915.jpg","medium_large-width":525,"medium_large-height":625,"large":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P365_Modif_3787-1-860x1024.jpg","large-width":525,"large-height":625,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P365_Modif_3787-1.jpg","twentyseventeen-featured-image-width":1007,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P365_Modif_3787-1-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Raccordi per tubi flessibili su diffusori aria.</p>\n","product_description_en":"<p>Connector for flexible hoses.</p>\n","product_variants":"66842,66852,66510,66520,66882,66892","index_order":"03_04_02","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P365-2.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Фитинг","product_description_ru":"<p>Соединитель для гибких шлангов на воздушных диффузоров.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/216"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=216"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":214,"date":"2017-04-14T11:11:15","date_gmt":"2017-04-14T09:11:15","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=214"},"modified":"2023-09-29T10:00:09","modified_gmt":"2023-09-29T08:00:09","slug":"p325","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p325/","title":{"rendered":"P325"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p325","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":43,"post_author":"1","post_date":"2017-04-11 12:27:13","post_date_gmt":"2017-04-11 10:27:13","post_content":"","post_title":"Riduzioni raccordi e tubi","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"riduzioni-e-raccordi","to_ping":"","pinged":"","post_modified":"2020-03-05 16:39:03","post_modified_gmt":"2020-03-05 15:39:03","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=43","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Tubo flessibile","product_name_en":"Hose","product_image":false,"product_description_it":"<p>Tubi flessibili per diffusori aria.</p>\n","product_description_en":"<p>Flexible hoses for air diffusers.</p>\n","product_variants":"64881,68198,68208","index_order":"03_04_07","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P325.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Гибкий шланг","product_description_ru":"<p>Гибкие шланги для диффузоров воздуха.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/214"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=214"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":213,"date":"2017-04-14T11:10:54","date_gmt":"2017-04-14T09:10:54","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=213"},"modified":"2023-09-29T09:41:20","modified_gmt":"2023-09-29T07:41:20","slug":"p129","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p129/","title":{"rendered":"P129"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p129","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":43,"post_author":"1","post_date":"2017-04-11 12:27:13","post_date_gmt":"2017-04-11 10:27:13","post_content":"","post_title":"Riduzioni raccordi e tubi","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"riduzioni-e-raccordi","to_ping":"","pinged":"","post_modified":"2020-03-05 16:39:03","post_modified_gmt":"2020-03-05 15:39:03","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=43","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Raccordo","product_name_en":"Connector","product_image":false,"product_description_it":"<p>Raccordi per tubi flessibili su diffusori aria.</p>\n","product_description_en":"<p>Connector for flexible hoses.</p>\n","product_variants":"63639,63649,63659,63669,63679,63689,66137,65707,65717,65887,65897,65727","index_order":"03_04_01","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P129.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Фитинг","product_description_ru":"<p>Соединитель для гибких шлангов на воздушных диффузоров.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/213"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=213"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":212,"date":"2017-04-14T11:10:32","date_gmt":"2017-04-14T09:10:32","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=212"},"modified":"2023-09-29T09:36:29","modified_gmt":"2023-09-29T07:36:29","slug":"p111","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p111/","title":{"rendered":"P111"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p111","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":43,"post_author":"1","post_date":"2017-04-11 12:27:13","post_date_gmt":"2017-04-11 10:27:13","post_content":"","post_title":"Riduzioni raccordi e tubi","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"riduzioni-e-raccordi","to_ping":"","pinged":"","post_modified":"2020-03-05 16:39:03","post_modified_gmt":"2020-03-05 15:39:03","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=43","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Raccordo","product_name_en":"Connector","product_image":false,"product_description_it":"<p>Raccordi per tubi flessibili su diffusori aria.</p>\n","product_description_en":"<p>Connector for flexible hoses.</p>\n","product_variants":"52111","index_order":"03_04_06","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P111.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Фитинг","product_description_ru":"<p>Соединитель для гибких шлангов на воздушных диффузоров.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/212"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=212"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":211,"date":"2017-04-14T11:10:20","date_gmt":"2017-04-14T09:10:20","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=211"},"modified":"2023-09-29T09:32:33","modified_gmt":"2023-09-29T07:32:33","slug":"p88","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p88/","title":{"rendered":"P88"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p88","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":43,"post_author":"1","post_date":"2017-04-11 12:27:13","post_date_gmt":"2017-04-11 10:27:13","post_content":"","post_title":"Riduzioni raccordi e tubi","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"riduzioni-e-raccordi","to_ping":"","pinged":"","post_modified":"2020-03-05 16:39:03","post_modified_gmt":"2020-03-05 15:39:03","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=43","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Raccordo","product_name_en":"Connector","product_image":false,"product_description_it":"<p>Raccordo a 45° per diffusori aria.</p>\n","product_description_en":"<p>45° connector for air diffusers.</p>\n","product_variants":"51900,65469,69183,69723","index_order":"03_04_04","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P88.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Фитинг","product_description_ru":"<p>Разъем под углом 45° для воздушных диффузоров</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/211"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=211"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":210,"date":"2017-04-14T11:10:05","date_gmt":"2017-04-14T09:10:05","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=210"},"modified":"2023-09-29T09:31:22","modified_gmt":"2023-09-29T07:31:22","slug":"p87","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p87/","title":{"rendered":"P87"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p87","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":43,"post_author":"1","post_date":"2017-04-11 12:27:13","post_date_gmt":"2017-04-11 10:27:13","post_content":"","post_title":"Riduzioni raccordi e tubi","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"riduzioni-e-raccordi","to_ping":"","pinged":"","post_modified":"2020-03-05 16:39:03","post_modified_gmt":"2020-03-05 15:39:03","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=43","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Raccordo","product_name_en":"Connector","product_image":false,"product_description_it":"<p>Raccordo a 90° per diffusori aria.</p>\n","product_description_en":"<p>90° connector for air diffusers.</p>\n","product_variants":"51890,63129,69163,69173","index_order":"03_04_03","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P87.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Фитинг","product_description_ru":"<p>Разъем под углом 90° для воздушных диффузоров</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/210"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=210"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":209,"date":"2017-04-14T11:09:41","date_gmt":"2017-04-14T09:09:41","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=209"},"modified":"2023-10-05T12:50:20","modified_gmt":"2023-10-05T10:50:20","slug":"p382","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p382/","title":{"rendered":"P382"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p382","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":42,"post_author":"1","post_date":"2017-04-11 12:26:39","post_date_gmt":"2017-04-11 10:26:39","post_content":"","post_title":"Diffusori aria fissi e griglie di areazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-fissi-a-griglie-di-areazione","to_ping":"","pinged":"","post_modified":"2020-02-14 16:53:44","post_modified_gmt":"2020-02-14 15:53:44","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=42","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Griglia","product_name_en":"Grid","product_image":{"ID":1833,"id":1833,"title":"p382","filename":"p382.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p382.jpg","alt":"","author":"1","description":"","caption":"","name":"p382-3","date":"2023-10-05 10:50:12","modified":"2023-10-05 10:50:17","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":1400,"height":1401,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p382-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p382-300x300.jpg","medium-width":300,"medium-height":300,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p382-768x769.jpg","medium_large-width":525,"medium_large-height":526,"large":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p382-1024x1024.jpg","large-width":525,"large-height":525,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p382-1400x1200.jpg","twentyseventeen-featured-image-width":1400,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p382-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Griglia aria rotonda con getto d&#8217;aria direzionato a 45°. fissaggio a mezzo dentini ad incastro.</p>\n","product_description_en":"<p>Round grid with 45° deflected open air flow. Fixation by clips.</p>\n","product_variants":"65669,60122,68393,66504","index_order":"03_03_13","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P382.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Решетка","product_description_ru":"<p>Круглая вентиляционная решетка с направляемым потоком воздуха под 45° . Крепление с помощью фиксирующих зажимов.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/209"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=209"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":208,"date":"2017-04-14T11:09:28","date_gmt":"2017-04-14T09:09:28","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=208"},"modified":"2023-09-29T10:12:49","modified_gmt":"2023-09-29T08:12:49","slug":"p381","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p381/","title":{"rendered":"P381"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p381","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":42,"post_author":"1","post_date":"2017-04-11 12:26:39","post_date_gmt":"2017-04-11 10:26:39","post_content":"","post_title":"Diffusori aria fissi e griglie di areazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-fissi-a-griglie-di-areazione","to_ping":"","pinged":"","post_modified":"2020-02-14 16:53:44","post_modified_gmt":"2020-02-14 15:53:44","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=42","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Sbrinatore vetri","product_name_en":"Glass defrosting","product_image":false,"product_description_it":"<p>Sbrinatori con getto d&#8217;aria diritto. Fissaggio per mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Defroster with straìght open air flow. Clip-in fixation.</p>\n","product_variants":"65629,65619","index_order":"03_03_10","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P381.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Размораживатель стекла","product_description_ru":"<p>Системы обогрева с прямой струей воздуха. Крепление с помощью фиксирующих зажимов.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/208"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=208"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":207,"date":"2017-04-14T11:08:43","date_gmt":"2017-04-14T09:08:43","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=207"},"modified":"2023-09-29T10:10:48","modified_gmt":"2023-09-29T08:10:48","slug":"p378","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p378/","title":{"rendered":"P378"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p378","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":42,"post_author":"1","post_date":"2017-04-11 12:26:39","post_date_gmt":"2017-04-11 10:26:39","post_content":"","post_title":"Diffusori aria fissi e griglie di areazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-fissi-a-griglie-di-areazione","to_ping":"","pinged":"","post_modified":"2020-02-14 16:53:44","post_modified_gmt":"2020-02-14 15:53:44","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=42","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Griglia di ventilazione","product_name_en":"Air grid","product_image":false,"product_description_it":"<p>Griglia aperta con getto d&#8217;aria diritto. Fissaggio a mezzo di viti.</p>\n","product_description_en":"<p>Open straigh air flow grid. Fixation by screws.</p>\n","product_variants":"65249,65331","index_order":"03_03_03","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P378.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Вентиляционная решетка","product_description_ru":"<p>Открытый гриль со струей воздуха. Фиксация винтами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/207"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=207"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":206,"date":"2017-04-14T11:08:24","date_gmt":"2017-04-14T09:08:24","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=206"},"modified":"2023-09-29T10:09:52","modified_gmt":"2023-09-29T08:09:52","slug":"p375","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p375/","title":{"rendered":"P375"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p375","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":42,"post_author":"1","post_date":"2017-04-11 12:26:39","post_date_gmt":"2017-04-11 10:26:39","post_content":"","post_title":"Diffusori aria fissi e griglie di areazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-fissi-a-griglie-di-areazione","to_ping":"","pinged":"","post_modified":"2020-02-14 16:53:44","post_modified_gmt":"2020-02-14 15:53:44","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=42","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Griglia di ventilazione","product_name_en":"Air grid","product_image":false,"product_description_it":"<p>Griglia aperta con getto d&#8217;aria diritto. Fissaggio ad interferenza.</p>\n","product_description_en":"<p>Open straigh air flow grid. Fixation by interference.</p>\n","product_variants":"63149","index_order":"03_03_04","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P375.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Вентиляционная решетка","product_description_ru":"<p>Открытый гриль со струей воздуха. Импульсное крепление</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/206"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=206"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":205,"date":"2017-04-14T11:08:05","date_gmt":"2017-04-14T09:08:05","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=205"},"modified":"2023-09-29T09:54:18","modified_gmt":"2023-09-29T07:54:18","slug":"p225","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p225/","title":{"rendered":"P225"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p225","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":42,"post_author":"1","post_date":"2017-04-11 12:26:39","post_date_gmt":"2017-04-11 10:26:39","post_content":"","post_title":"Diffusori aria fissi e griglie di areazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-fissi-a-griglie-di-areazione","to_ping":"","pinged":"","post_modified":"2020-02-14 16:53:44","post_modified_gmt":"2020-02-14 15:53:44","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=42","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Sbrinatore vetri","product_name_en":"Glass defrosting","product_image":false,"product_description_it":"<p>Sbrinatori parabrezza diritti e curvi. Fissaggio con viti o dentini ad incastro.</p>\n","product_description_en":"<p>Straight and curved defroster for Windscreen. fixation by screws or clip.</p>\n","product_variants":"60268,66847,61521,67957,66857,60018,63392,66180,66160","index_order":"03_03_05","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P225.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Размораживатель стекла","product_description_ru":"<p>Прямые и изогнутые системы обогрева ветрового стекла. Крепление винтами или при помощи защелкивающихся зажимов.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/205"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=205"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":204,"date":"2017-04-14T11:07:51","date_gmt":"2017-04-14T09:07:51","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=204"},"modified":"2023-09-29T09:53:00","modified_gmt":"2023-09-29T07:53:00","slug":"p194","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p194/","title":{"rendered":"P194"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p194","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":42,"post_author":"1","post_date":"2017-04-11 12:26:39","post_date_gmt":"2017-04-11 10:26:39","post_content":"","post_title":"Diffusori aria fissi e griglie di areazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-fissi-a-griglie-di-areazione","to_ping":"","pinged":"","post_modified":"2020-02-14 16:53:44","post_modified_gmt":"2020-02-14 15:53:44","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=42","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Griglia di ventilazione","product_name_en":"Air grid","product_image":false,"product_description_it":"<p>Griglia aperta con getto d&#8217;aria diritto. Fissaggio con rotella dentata su perni.</p>\n","product_description_en":"<p>Open straigh air flow grid. Fixation by pins and toothed washer.</p>\n","product_variants":"65767,67319,60172,65911,67943,68383","index_order":"03_03_01","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P194.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Вентиляционная решетка","product_description_ru":"<p>Открытая решетка с прямой струей воздуха. Фиксация штифтами и зубчатой шайбой.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/204"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=204"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":203,"date":"2017-04-14T11:07:35","date_gmt":"2017-04-14T09:07:35","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=203"},"modified":"2023-09-29T09:49:40","modified_gmt":"2023-09-29T07:49:40","slug":"p169bis","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p169bis/","title":{"rendered":"P169bis"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p169_bis","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":42,"post_author":"1","post_date":"2017-04-11 12:26:39","post_date_gmt":"2017-04-11 10:26:39","post_content":"","post_title":"Diffusori aria fissi e griglie di areazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-fissi-a-griglie-di-areazione","to_ping":"","pinged":"","post_modified":"2020-02-14 16:53:44","post_modified_gmt":"2020-02-14 15:53:44","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=42","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Sbrinatore vetri","product_name_en":"Glass defrosting","product_image":false,"product_description_it":"<p>Sbrinatori parabrezza con getto d&#8217;aria libero a ventaglio di 30°. Fissaggio con viti.</p>\n","product_description_en":"<p>Defroster for windscreen, with open by 30° deflected air flow. Fixation by screws.</p>\n","product_variants":"64007,67509,68373,69693","index_order":"03_03_07","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P169bis.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Размораживатель стекла","product_description_ru":"<p>Системы обогрева ветрового стекла со свободной веерообразной струей воздуха под 30°. Крепление винтами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/203"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=203"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":202,"date":"2017-04-14T11:07:14","date_gmt":"2017-04-14T09:07:14","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=202"},"modified":"2023-09-29T09:48:30","modified_gmt":"2023-09-29T07:48:30","slug":"p169","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p169/","title":{"rendered":"P169"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p169","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":42,"post_author":"1","post_date":"2017-04-11 12:26:39","post_date_gmt":"2017-04-11 10:26:39","post_content":"","post_title":"Diffusori aria fissi e griglie di areazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-fissi-a-griglie-di-areazione","to_ping":"","pinged":"","post_modified":"2020-02-14 16:53:44","post_modified_gmt":"2020-02-14 15:53:44","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=42","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Sbrinatore vetri","product_name_en":"Glass defrosting","product_image":false,"product_description_it":"<p>Sbrinatori parabrezza con getto d&#8217;aria libero a ventaglio di 30°. Fissaggio con viti.</p>\n","product_description_en":"<p>Defroster for windscreen, with open by 30° deflected air flow. Fixation by screws.</p>\n","product_variants":"64017,63459,68363,66792,69703,63919,64929,63193,67232,66630","index_order":"03_03_06","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P169.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Размораживатель стекла","product_description_ru":"<p>Системы обогрева ветрового стекла со свободной веерообразной струей воздуха под 30°. Крепление винтами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/202"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=202"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":201,"date":"2017-04-14T11:07:00","date_gmt":"2017-04-14T09:07:00","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=201"},"modified":"2023-09-29T09:46:13","modified_gmt":"2023-09-29T07:46:13","slug":"p168","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p168/","title":{"rendered":"P168"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p168","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":42,"post_author":"1","post_date":"2017-04-11 12:26:39","post_date_gmt":"2017-04-11 10:26:39","post_content":"","post_title":"Diffusori aria fissi e griglie di areazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-fissi-a-griglie-di-areazione","to_ping":"","pinged":"","post_modified":"2020-02-14 16:53:44","post_modified_gmt":"2020-02-14 15:53:44","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=42","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Sbrinatore vetri","product_name_en":"Glass defrosting","product_image":false,"product_description_it":"<p>Sbrinatori parabrezza con getto d&#8217;aria libero diritto. Fissaggio con viti.</p>\n","product_description_en":"<p>Defroster for windscreen, with straìght open air flow. Fixation by screws or bushes.</p>\n","product_variants":"63987,69459","index_order":"03_03_08","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P168.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Размораживатель стекла","product_description_ru":"<p>Системы обогрева ветрового стекла со свободной прямой струей воздуха. Крепление винтами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/201"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=201"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":200,"date":"2017-04-14T11:06:43","date_gmt":"2017-04-14T09:06:43","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=200"},"modified":"2023-09-29T09:38:12","modified_gmt":"2023-09-29T07:38:12","slug":"p123","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p123/","title":{"rendered":"P123"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p123","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":42,"post_author":"1","post_date":"2017-04-11 12:26:39","post_date_gmt":"2017-04-11 10:26:39","post_content":"","post_title":"Diffusori aria fissi e griglie di areazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-fissi-a-griglie-di-areazione","to_ping":"","pinged":"","post_modified":"2020-02-14 16:53:44","post_modified_gmt":"2020-02-14 15:53:44","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=42","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Griglia di ventilazione","product_name_en":"Air grid","product_image":false,"product_description_it":"<p>Griglia aperta con getto d&#8217;aria direzionato a 45°. Fissaggio a mezzo di viti.</p>\n","product_description_en":"<p>Open by 45° deflected air flow grid. Fixation by screws.</p>\n","product_variants":"68900,65582,64562","index_order":"03_03_02","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P123.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Вентиляционная решетка","product_description_ru":"<p>Открытый гриль со струей воздуха, направляемой под 45° . Крепление с помощью винтов.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/200"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=200"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":198,"date":"2017-04-14T11:06:10","date_gmt":"2017-04-14T09:06:10","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=198"},"modified":"2023-09-29T09:28:52","modified_gmt":"2023-09-29T07:28:52","slug":"p85","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p85/","title":{"rendered":"P85"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p85","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":42,"post_author":"1","post_date":"2017-04-11 12:26:39","post_date_gmt":"2017-04-11 10:26:39","post_content":"","post_title":"Diffusori aria fissi e griglie di areazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-fissi-a-griglie-di-areazione","to_ping":"","pinged":"","post_modified":"2020-02-14 16:53:44","post_modified_gmt":"2020-02-14 15:53:44","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=42","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Sbrinatore vetri","product_name_en":"Glass defrosting","product_image":false,"product_description_it":"<p>Sbrinatori con getto d&#8217;aria diritto e farfalla di regolazione flusso operata tramite leva. Collegabile a tubazioni centralizzate. fissaggio per mezzo di viti.</p>\n","product_description_en":"<p>Defroster with straight open air flow, but lever operated air flow regulation throttle. Connectable to air converyor hoses. Fixation be screws.</p>\n","product_variants":"52050,68178","index_order":"03_03_11","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P85.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Размораживатель стекла","product_description_ru":"<p>Система обогрева прямым потоком воздуха и с рычажным регулятором. Возможно подключение к централизованной трубопроводной системе. Крепление винтами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/198"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=198"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":196,"date":"2017-04-14T11:05:38","date_gmt":"2017-04-14T09:05:38","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=196"},"modified":"2023-09-29T09:26:55","modified_gmt":"2023-09-29T07:26:55","slug":"p82","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p82/","title":{"rendered":"P82"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p82","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":42,"post_author":"1","post_date":"2017-04-11 12:26:39","post_date_gmt":"2017-04-11 10:26:39","post_content":"","post_title":"Diffusori aria fissi e griglie di areazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-fissi-a-griglie-di-areazione","to_ping":"","pinged":"","post_modified":"2020-02-14 16:53:44","post_modified_gmt":"2020-02-14 15:53:44","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=42","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Griglia","product_name_en":"Grid","product_image":false,"product_description_it":"<p>Griglia rotonda con getto d&#8217;aria diritto. Fissaggio per mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Round grid with straight open air flow. Click-in fixation.</p>\n","product_variants":"51880","index_order":"03_03_12","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P82.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Решетка","product_description_ru":"<p>Круглая решетка с прямой струей воздуха. Крепление с помощью фиксирующих зажимов.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/196"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=196"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":195,"date":"2017-04-14T11:05:19","date_gmt":"2017-04-14T09:05:19","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=195"},"modified":"2023-09-29T09:26:07","modified_gmt":"2023-09-29T07:26:07","slug":"p81","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p81/","title":{"rendered":"P81"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p81","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":42,"post_author":"1","post_date":"2017-04-11 12:26:39","post_date_gmt":"2017-04-11 10:26:39","post_content":"","post_title":"Diffusori aria fissi e griglie di areazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-fissi-a-griglie-di-areazione","to_ping":"","pinged":"","post_modified":"2020-02-14 16:53:44","post_modified_gmt":"2020-02-14 15:53:44","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=42","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Griglia","product_name_en":"Grid","product_image":false,"product_description_it":"<p>Griglia aperta con getto d&#8217;aria a ventaglio di 45°. Fissaggio a mezzo di viti.</p>\n","product_description_en":"<p>Open by 45° deflected air flow grid. Fixation by screws.</p>\n","product_variants":"51870,66367,65041","index_order":"03_03_09","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P81.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Решетка","product_description_ru":"<p>Открытая решетка радиатора с веерообразной струей воздуха под 45°. Крепление с помощью винтов.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/195"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=195"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":194,"date":"2017-04-14T11:04:49","date_gmt":"2017-04-14T09:04:49","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=194"},"modified":"2023-09-29T10:20:10","modified_gmt":"2023-09-29T08:20:10","slug":"p410","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p410/","title":{"rendered":"P410"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p410","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria stilizzato, con alette di regolazione ed orientamento del flusso d&#8217;aria manovrabili direttamente. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Stylized round air diffuser, with direct flap&#8217;s regulation and orientation. Fixation by clips.</p>\n","product_variants":"68412,68402","index_order":"03_02_03","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":true,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P410.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Стилизованный круглый воздушный диффузор с прямой регулировкой и ориентацией клапана. Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/194"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=194"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":193,"date":"2017-04-14T11:04:32","date_gmt":"2017-04-14T09:04:32","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=193"},"modified":"2023-10-05T12:30:33","modified_gmt":"2023-10-05T10:30:33","slug":"p405","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p405/","title":{"rendered":"P405"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p405","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":{"ID":1829,"id":1829,"title":"P405_2colori","filename":"P405_2colori.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P405_2colori.jpg","alt":"","author":"1","description":"","caption":"","name":"p405_2colori","date":"2023-10-05 10:30:19","modified":"2023-10-05 10:30:30","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":3260,"height":2854,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P405_2colori-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P405_2colori-300x263.jpg","medium-width":300,"medium-height":263,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P405_2colori-768x672.jpg","medium_large-width":525,"medium_large-height":459,"large":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P405_2colori-1024x896.jpg","large-width":525,"large-height":459,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P405_2colori-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P405_2colori-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Diffusore aria stilizzato top di gamma, con regolazione a rotella della farfalla di limitazione del flusso d&#8217;aria e alette di orientamento manovrabili direttamente. Disponibile nelle versioni con anello esterno nero o cromato. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>High end stylized round air diffuser, with wheel operated air flow throttle and directly orientable and pivotable grids. Available in version with or black or chromed outher ring. Fixation by clips.</p>\n","product_variants":"68413,68423,68433,66464,66454,66764","index_order":"03_02_02","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":true,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P405.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Высококачественный стилизованный круглый воздушный диффузор с механизмом регулирующей и ограничивающей расход воздуха, а также с прямым управлением ребрами для ориентации потока воздуха. Доступен в версии с черным или хромированным наружным кольцом. Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/193"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=193"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":192,"date":"2017-04-14T11:04:18","date_gmt":"2017-04-14T09:04:18","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=192"},"modified":"2023-09-29T10:14:54","modified_gmt":"2023-09-29T08:14:54","slug":"p388","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p388/","title":{"rendered":"P388"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p388","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria stilizzato top di gamma, con alette di regolazione ed orientamento del flusso d&#8217;aria manovrabili direttamente. Disponibile nelle versioni con o senza verniciatura SOFT-TOUCH, in combinazione con anello esterno nero o cromato. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>High end stylized round air diffuser, with direct flap&#8217;s regulation and orientation. Available in version with or without soft-touch flap&#8217;s surface painting in combination with black or chromed outher ring. Fixation by clips.</p>\n","product_variants":"67871,67881,65032,64942,65152,63832,63842,61093,65202,68382","index_order":"03_02_01","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":true,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P388.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Высококачественный стилизованный круглый воздушный диффузор с прямой регулировкой и ориентыцией клапана. Доступен в версии С или БЕЗ &#8220;SOFT-TOUCH&#8221; лакировки поверхности в сочетании с черным или хромированным внешним кольцом. Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/192"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=192"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":191,"date":"2017-04-14T11:04:03","date_gmt":"2017-04-14T09:04:03","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=191"},"modified":"2023-09-29T10:02:38","modified_gmt":"2023-09-29T08:02:38","slug":"p350","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p350/","title":{"rendered":"P350"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p350","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria rotondo, con alette di regolazione ed orientamento del flusso d&#8217;aria manovrabili direttamente. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Round air diffuser, with direct flap&#8217;s regulation and orientation. Fixation by clips.</p>\n","product_variants":"62562","index_order":"03_02_05","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":true,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P350.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Круглый воздушный диффузор с прямым управлением ребер для регулирования и ориентации потока воздух. Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/191"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=191"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":190,"date":"2017-04-14T11:03:49","date_gmt":"2017-04-14T09:03:49","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=190"},"modified":"2023-09-29T10:01:41","modified_gmt":"2023-09-29T08:01:41","slug":"p343","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p343/","title":{"rendered":"P343"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p343","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria rotondo, con alette di regolazione ed orientamento del flusso d&#8217;aria manovrabili direttamente. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Round air diffuser, with direct flap&#8217;s regulation and orientation. Fixation by clips.</p>\n","product_variants":"62349,64671","index_order":"03_02_13","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":true,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P343.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Круглый воздушный диффузор с прямым управлением ребер для регулирования и ориентации потока воздух. Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/190"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=190"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":189,"date":"2017-04-14T11:03:31","date_gmt":"2017-04-14T09:03:31","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=189"},"modified":"2023-09-29T09:59:19","modified_gmt":"2023-09-29T07:59:19","slug":"p316","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p316/","title":{"rendered":"P316"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p316","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria rotondo, con alette di regolazione ed orientamento del flusso d&#8217;aria manovrabili direttamente. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Round air diffuser, with direct flap&#8217;s regulation and orientation. Fixation by clips.</p>\n","product_variants":"67088,65061","index_order":"03_02_09","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":true,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P316.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Круглый воздушный диффузор с прямым управлением ребер для регулирования и ориентации потока воздух. Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/189"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=189"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":188,"date":"2017-04-14T11:03:12","date_gmt":"2017-04-14T09:03:12","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=188"},"modified":"2023-10-05T12:49:40","modified_gmt":"2023-10-05T10:49:40","slug":"p236","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p236/","title":{"rendered":"P236"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p236","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":{"ID":1832,"id":1832,"title":"p236","filename":"p236.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p236.jpg","alt":"","author":"1","description":"","caption":"","name":"p236-3","date":"2023-10-05 10:42:58","modified":"2023-10-05 10:43:02","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":1138,"height":1138,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p236-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p236-300x300.jpg","medium-width":300,"medium-height":300,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p236-768x768.jpg","medium_large-width":525,"medium_large-height":525,"large":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p236-1024x1024.jpg","large-width":525,"large-height":525,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p236.jpg","twentyseventeen-featured-image-width":1138,"twentyseventeen-featured-image-height":1138,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p236-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p>Diffusore aria rotondo, con alette di regolazione ed orientamento del flusso d&#8217;aria manovrabili direttamente. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Round air diffuser, with direct flap&#8217;s regulation and orientation. Fixation by clips.</p>\n","product_variants":"63009,65718,60051,67597,61712,62921,66484","index_order":"03_02_06","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":true,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P236.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Круглый воздушный диффузор с прямым управлением ребер для регулирования и ориентации потока воздух. Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/188"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=188"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":187,"date":"2017-04-14T11:02:48","date_gmt":"2017-04-14T09:02:48","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=187"},"modified":"2023-09-29T09:51:37","modified_gmt":"2023-09-29T07:51:37","slug":"p193","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p193/","title":{"rendered":"P193"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p193","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria (stile aeroplano) con carcassa rotonda. L&#8217;apertura/chiusura del flusso d&#8217;aria tramite dispositivo a spillo, direzionabile tramite una sfera basculante. Versione per sistemi canalizzati. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Round air diffuser (airplaine style). Air flow to be regulated, opened/closed by a needle shaped device and directionable by a spheric swiveling nozzle, for ductet air supplies. Fixation by clips.</p>\n","product_variants":"66347","index_order":"03_02_14","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P193.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Круглый воздушный диффузор (самолетный тип). Открытие/закрытие потока воздуха с помощью устройства, направляемого воздух с помощью разворачиваемой сферы. Версия для канализированных систем. Фиксация кзажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/187"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=187"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":186,"date":"2017-04-14T11:02:26","date_gmt":"2017-04-14T09:02:26","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=186"},"modified":"2023-09-29T09:50:37","modified_gmt":"2023-09-29T07:50:37","slug":"p184","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p184/","title":{"rendered":"P184"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p184","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria (stile aeroplano) con carcassa rotonda. L&#8217;apertura/chiusura del flusso d&#8217;aria tramite dispositivo a spillo, direzionabile tramite una sfera basculante. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Round air diffuser (airplaine style). Air flow to be regulated, opened/closed by a needle shaped device and directionable by a spheric swiveling nozzle. Fixation by clips.</p>\n","product_variants":"66087,66097,62859,62899","index_order":"03_02_15","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P184.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Круглый воздушный диффузор (самолетный тип). Открытие/закрытие потока воздуха с помощью устройства, направляемого воздух с помощью разворачиваемой сферы. Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/186"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=186"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":185,"date":"2017-04-14T11:02:09","date_gmt":"2017-04-14T09:02:09","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=185"},"modified":"2023-09-29T09:43:28","modified_gmt":"2023-09-29T07:43:28","slug":"p145","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p145/","title":{"rendered":"P145"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p145","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria rotondo, con alette di regolazione ed orientamento del flusso d&#8217;aria manovrabili direttamente. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Round air diffuser, with direct flap&#8217;s regulation and orientation. Fixation by clips.</p>\n","product_variants":"61819,61839,62892,63119,61829,61849,62292,69945,68431,63109,65021,68097,66731","index_order":"03_02_10","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":true,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P145.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Круглый воздушный диффузор с прямым управлением ребер для регулирования и ориентации потока воздух. Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/185"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=185"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":184,"date":"2017-04-14T11:01:51","date_gmt":"2017-04-14T09:01:51","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=184"},"modified":"2023-09-29T09:37:17","modified_gmt":"2023-09-29T07:37:17","slug":"p115","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p115/","title":{"rendered":"P115"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p115","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria rotondo, con alette di regolazione ed orientamento del flusso d&#8217;aria manovrabili direttamente. Fissaggio a mezzo di viti o dentini ad incastro.</p>\n","product_description_en":"<p>Round air diffuser, with direct flap&#8217;s regulation and orientation. Fixation by clips and/or screws.</p>\n","product_variants":"66221,66231","index_order":"03_02_08","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P115.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Круглый воздушный диффузор с прямым управлением ребер для регулирования и ориентации потока воздух. Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/184"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=184"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":183,"date":"2017-04-14T11:01:35","date_gmt":"2017-04-14T09:01:35","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=183"},"modified":"2023-09-29T09:27:59","modified_gmt":"2023-09-29T07:27:59","slug":"p83","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p83/","title":{"rendered":"P83"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p83","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria rotondo, con alette di regolazione ed orientamento del flusso d&#8217;aria manovrabili direttamente. Fissaggio a mezzo di viti o dentini ad incastro.</p>\n","product_description_en":"<p>Round air diffuser, with direct flap&#8217;s regulation and orientation. Fixation by clips and/or screws.</p>\n","product_variants":"66201,65371,66211,60118,62561","index_order":"03_02_07","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P83.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Круглый воздушный диффузор с прямым управлением ребер для регулирования и ориентации потока воздух. Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/183"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=183"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":181,"date":"2017-04-14T11:00:59","date_gmt":"2017-04-14T09:00:59","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=181"},"modified":"2023-09-29T09:24:56","modified_gmt":"2023-09-29T07:24:56","slug":"p79","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p79/","title":{"rendered":"P79"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p79","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria con sfera liberamente ruotante e foro conico di passaggio flusso aria.</p>\n","product_description_en":"<p>Round air diffuser with free rotating globe and conic open air nozzle.</p>\n","product_variants":"51810,61951","index_order":"03_02_16","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P79.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Диффузор воздуха со свободно вращающейся сферой и коническим отверстием, пропускающим воздух.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/181"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=181"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":180,"date":"2017-04-14T11:00:44","date_gmt":"2017-04-14T09:00:44","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=180"},"modified":"2023-09-29T09:24:05","modified_gmt":"2023-09-29T07:24:05","slug":"p29bis","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p29bis/","title":{"rendered":"P29bis"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p29_bis","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria rotondo, con alette di regolazione ed orientamento del flusso d&#8217;aria manovrabili direttamente. Bloccaggio a mezzo di molla.</p>\n","product_description_en":"<p>Round air diffuser, with direct flap&#8217;s regulation and orientation. Spring loaded fastener.</p>\n","product_variants":"61528,60028,63001","index_order":"03_02_12","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P29_P29bis-1.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Круглый воздушный диффузор с прямым управлением ребер для регулирования и ориентации потока воздух. Пружинная застежка.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/180"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=180"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":179,"date":"2017-04-14T11:00:25","date_gmt":"2017-04-14T09:00:25","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=179"},"modified":"2023-09-29T09:20:32","modified_gmt":"2023-09-29T07:20:32","slug":"p29","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p29/","title":{"rendered":"P29"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p29","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":41,"post_author":"1","post_date":"2017-04-11 12:25:52","post_date_gmt":"2017-04-11 10:25:52","post_content":"","post_title":"Diffusori aria tondi orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-tondi-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:00","post_modified_gmt":"2020-02-14 15:54:00","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=41","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria rotondo, con alette di regolazione ed orientamento del flusso d&#8217;aria manovrabili direttamente. Bloccaggio a mezzo di molla.</p>\n","product_description_en":"<p>Round air diffuser, with direct flap&#8217;s regulation and orientation. Spring loaded fastener.</p>\n","product_variants":"62769,63422","index_order":"03_02_11","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P29_P29bis.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Круглый воздушный диффузор с прямым управлением ребер для регулирования и ориентации потока воздух. Пружинная застежка.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/179"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=179"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":178,"date":"2017-04-14T11:00:01","date_gmt":"2017-04-14T09:00:01","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=178"},"modified":"2023-09-29T10:17:44","modified_gmt":"2023-09-29T08:17:44","slug":"p398","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p398/","title":{"rendered":"P398"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p398","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":40,"post_author":"1","post_date":"2017-04-11 12:25:08","post_date_gmt":"2017-04-11 10:25:08","post_content":"","post_title":"Diffusori aria rettangolari orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-rettangolari-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:23","post_modified_gmt":"2020-02-14 15:54:23","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=40","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria rettangolare orientabile, con sistema di controllo flusso aria a mezzo di rotellina e griglie di orientamento montate su copro pivottante. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Rectangular adjustable air diffuser, with wheel operated air flow control and pivotable air orienting grids. Fixation by clips.</p>\n","product_variants":"61891","index_order":"03_01_08","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P398.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Прямоугольный регулируемый воздушный диффузор системой регулирования расхода воздуха и направляющими решетками, устанавливаемыми на поворотном корпусе.Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/178"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=178"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":177,"date":"2017-04-14T10:59:42","date_gmt":"2017-04-14T08:59:42","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=177"},"modified":"2023-09-29T10:16:58","modified_gmt":"2023-09-29T08:16:58","slug":"p391","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p391/","title":{"rendered":"P391"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p391","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":40,"post_author":"1","post_date":"2017-04-11 12:25:08","post_date_gmt":"2017-04-11 10:25:08","post_content":"","post_title":"Diffusori aria rettangolari orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-rettangolari-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:23","post_modified_gmt":"2020-02-14 15:54:23","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=40","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria orientabile rettangolare, con 5 alette direzionali flusso aria. Fissaggio con viti o con dentini ad incastro.</p>\n","product_description_en":"<p>Rectangular adjustable air diffuser, with 5 air control flaps. Fixation by clips or screws.</p>\n","product_variants":"66579,67699,66789,67709","index_order":"03_01_02","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":true,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P391.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Прямоугольный регулируемый воздушный диффузор с 5ю заслонками. Фиксация зажимами или винтами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/177"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=177"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":176,"date":"2017-04-14T10:59:19","date_gmt":"2017-04-14T08:59:19","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=176"},"modified":"2023-09-29T10:01:01","modified_gmt":"2023-09-29T08:01:01","slug":"p330","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p330/","title":{"rendered":"P330"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p330","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":40,"post_author":"1","post_date":"2017-04-11 12:25:08","post_date_gmt":"2017-04-11 10:25:08","post_content":"","post_title":"Diffusori aria rettangolari orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-rettangolari-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:23","post_modified_gmt":"2020-02-14 15:54:23","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=40","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Raccordo","product_name_en":"Connector","product_image":false,"product_description_it":"<p>Raccordo rettangolare per diffusore aria <a href=\"/it/prodotti/22/sistemi-per-portelloni/22/supporti-e-snodi-per-molle-a-gas/p233\">P233</a>.</p>\n","product_description_en":"<p>Rectangular connector for air diffuser <a href=\"/en/products/22/system-for-luggage-door/22/support-and-joint-for-gas-spings/p233\">P233</a>.</p>\n","product_variants":"69808","index_order":"03_04_05","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P330.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Фитинг","product_description_ru":"<p>Прямоугольный разъем для воздушных диффузоров Р233.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/176"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=176"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":175,"date":"2017-04-14T10:58:59","date_gmt":"2017-04-14T08:58:59","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=175"},"modified":"2023-09-29T09:58:00","modified_gmt":"2023-09-29T07:58:00","slug":"p280","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p280/","title":{"rendered":"P280"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p280","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":40,"post_author":"1","post_date":"2017-04-11 12:25:08","post_date_gmt":"2017-04-11 10:25:08","post_content":"","post_title":"Diffusori aria rettangolari orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-rettangolari-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:23","post_modified_gmt":"2020-02-14 15:54:23","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=40","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore rettangolare orientabile, con farfalla di regolazione flusso aria e griglie di orientamento su corpo pivottante. Può essere collegato a condotti aria flessibili. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Rectangular adjustable air diffuser, with wheel operated air flow control throttle and pivotable air orienting grids, connectable to air conveyor hoses. Fixation by clips.</p>\n","product_variants":"62338,62348","index_order":"03_01_07","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P280.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Прямоугольный регулируемый воздушный диффузор с дроссельной заслонкой, управляемой механизмом и направляющими решетками на поворотном корпусе. Возможно подключение к гибким воздуховодам. Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/175"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=175"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":174,"date":"2017-04-14T10:58:34","date_gmt":"2017-04-14T08:58:34","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=174"},"modified":"2023-09-29T09:57:11","modified_gmt":"2023-09-29T07:57:11","slug":"p252","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p252/","title":{"rendered":"P252"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p252","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":40,"post_author":"1","post_date":"2017-04-11 12:25:08","post_date_gmt":"2017-04-11 10:25:08","post_content":"","post_title":"Diffusori aria rettangolari orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-rettangolari-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:23","post_modified_gmt":"2020-02-14 15:54:23","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=40","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria orientabile rettangolare, con sistema a rotella per la regolazione del flusso e dell&#8217;orientamento dell&#8217;aria. Fissaggio a mezzo di viti o dentini ad incastro.</p>\n","product_description_en":"<p>Rectangular adjustable air diffuser, with wheel operated air closing and flow orientable devices. Fixation by clips or screws.</p>\n","product_variants":"63489,61358,69189","index_order":"03_01_04","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P252.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Прямоугольный регулируемый воздушный диффузор с заслонкой, управляемой механизмом для регулирования расхода и ориентации воздуха. Фиксация зажимами или винтами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/174"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=174"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":172,"date":"2017-04-14T10:56:35","date_gmt":"2017-04-14T08:56:35","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=172"},"modified":"2023-09-29T09:55:03","modified_gmt":"2023-09-29T07:55:03","slug":"p233","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p233/","title":{"rendered":"P233"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p233","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":40,"post_author":"1","post_date":"2017-04-11 12:25:08","post_date_gmt":"2017-04-11 10:25:08","post_content":"","post_title":"Diffusori aria rettangolari orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-rettangolari-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:23","post_modified_gmt":"2020-02-14 15:54:23","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=40","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria rettangolare orientabile, con farfalla di regolazione e griglia basculante per l&#8217;orientamento del flusso aria. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Rectangular adjustable air diffuser, with lever operated air flow throttle and pivotable air orienting grids. Fixation by clips.</p>\n","product_variants":"67377,67387","index_order":"03_01_05","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P233.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Прямоугольный регулируемый воздушный диффузор с рычажным дросселем потока воздуха и воздухораспределительными решетками. Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/172"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=172"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":171,"date":"2017-04-14T10:56:14","date_gmt":"2017-04-14T08:56:14","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=171"},"modified":"2023-09-29T09:45:10","modified_gmt":"2023-09-29T07:45:10","slug":"p162","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p162/","title":{"rendered":"P162"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p162","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":40,"post_author":"1","post_date":"2017-04-11 12:25:08","post_date_gmt":"2017-04-11 10:25:08","post_content":"","post_title":"Diffusori aria rettangolari orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-rettangolari-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:23","post_modified_gmt":"2020-02-14 15:54:23","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=40","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria (stile aeroplano) con carcassa rettangolare. L&#8217;apertura/chiusura del flusso d&#8217;aria tramite dispositivo a spillo, direzionabile tramite una sfera basculante. Disponibile nella versione adatta ad essere canalizzato. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Air diffuser (airplaine style) with rectangular frame. Air flow to be regulated, opened/closed by a needle shaped device and directionable by a spheric swiveling device. Available in version for ductet air supplies. Fixation by clips.</p>\n","product_variants":"65907,65846,65856","index_order":"03_01_09","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P162.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Воздушный диффузор с прямоугольным корпусом. Открытие/закрытие потока воздуха с помощью игольчатого устройства, управляемого с помощью разворачиваемой сферы. Поставляется в версии, пригодной для монтажа в воздуховод. Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/171"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=171"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":168,"date":"2017-04-14T10:55:31","date_gmt":"2017-04-14T08:55:31","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=168"},"modified":"2023-09-29T09:42:21","modified_gmt":"2023-09-29T07:42:21","slug":"p136","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p136/","title":{"rendered":"P136"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p136","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":40,"post_author":"1","post_date":"2017-04-11 12:25:08","post_date_gmt":"2017-04-11 10:25:08","post_content":"","post_title":"Diffusori aria rettangolari orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-rettangolari-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:23","post_modified_gmt":"2020-02-14 15:54:23","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=40","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria rettangolare orientabile, con farfalla di regolazione e alette direzionali del flusso aria. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Rectangular adjustable air diffuser, with lever operated air flow throttle and orientable air grids. Fixation by clips.</p>\n","product_variants":"68550,68560,67941,67951","index_order":"03_01_06","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P136.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Прямоугольный регулируемый воздушный диффузор с рычагом управления воздушным потоком и ориентируемый воздушными решетками. Фиксация зажимами.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/168"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=168"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":166,"date":"2017-04-14T10:54:34","date_gmt":"2017-04-14T08:54:34","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=166"},"modified":"2023-09-29T09:35:25","modified_gmt":"2023-09-29T07:35:25","slug":"p110bis","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p110bis/","title":{"rendered":"P110bis"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p110_bis","category_id":[{"ID":22,"post_author":"1","post_date":"2017-04-11 12:05:54","post_date_gmt":"2017-04-11 10:05:54","post_content":"","post_title":"Sistemi di diffusione aria / HVAC","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-di-diffusione-aria","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:39","post_modified_gmt":"2023-09-29 10:34:39","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=22","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":40,"post_author":"1","post_date":"2017-04-11 12:25:08","post_date_gmt":"2017-04-11 10:25:08","post_content":"","post_title":"Diffusori aria rettangolari orientabili","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-aria-rettangolari-orientabili","to_ping":"","pinged":"","post_modified":"2020-02-14 16:54:23","post_modified_gmt":"2020-02-14 15:54:23","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=40","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore aria","product_name_en":"Air diffuser","product_image":false,"product_description_it":"<p>Diffusore aria orientabile rettangolare, con rotella di controllo della farfalla regolazione flusso aria. Fissaggio con viti.</p>\n","product_description_en":"<p>Rectangular adjustable air diffuser, with wheel operated air flow control throttle. Fixation by screws.</p>\n","product_variants":"60138,67987,65411,66118,64941","index_order":"03_01_03_1","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P110bis.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"Диффузор воздуха","product_description_ru":"<p>Прямоугольный регулируемый воздушный диффузор с дроссельной заслонкой управляемой механизмом. Фиксация винтами</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/166"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=166"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":165,"date":"2017-04-14T10:53:33","date_gmt":"2017-04-14T08:53:33","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=165"},"modified":"2023-09-29T12:21:31","modified_gmt":"2023-09-29T10:21:31","slug":"p394","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p394/","title":{"rendered":"P394"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p394","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":372,"post_author":"1","post_date":"2017-05-19 10:59:37","post_date_gmt":"2017-05-19 08:59:37","post_content":"","post_title":"Reglette e strisce luce LED","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"reglette-e-strisce-luce-led","to_ping":"","pinged":"","post_modified":"2020-03-05 16:30:06","post_modified_gmt":"2020-03-05 15:30:06","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=372","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Strisce led","product_name_en":"Led strips","product_image":false,"product_description_it":"<p>Strisce LED per plafoniere di illuminazione corridoio centrale.</p>\n","product_description_en":"<p>LED strips for central aisle lighting.</p>\n","product_variants":"67152,67162,67172,67182","index_order":"04_03_01","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P394.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/165"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=165"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":164,"date":"2017-04-14T10:53:15","date_gmt":"2017-04-14T08:53:15","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=164"},"modified":"2023-09-29T12:20:17","modified_gmt":"2023-09-29T10:20:17","slug":"p342c","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p342c/","title":{"rendered":"P342C"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p342_c","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":46,"post_author":"1","post_date":"2017-04-11 12:44:33","post_date_gmt":"2017-04-11 10:44:33","post_content":"","post_title":"Plafoniere","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"plafoniere","to_ping":"","pinged":"","post_modified":"2020-02-14 16:52:34","post_modified_gmt":"2020-02-14 15:52:34","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=46","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Plafoniere","product_name_en":"Lighting board","product_image":false,"product_description_it":"<p>Plafoniere di illuminazione per corridoio centrale per lampade fluorescenti. Sono disponibili nella versione con luci LED.</p>\n","product_description_en":"<p>Central aisle lighting ceilings for fluorescent lamps, but LED version is available</p>\n","product_variants":"65642","index_order":"04_04_01","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P342C.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/164"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=164"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":162,"date":"2017-04-14T10:52:39","date_gmt":"2017-04-14T08:52:39","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=162"},"modified":"2023-09-29T12:25:03","modified_gmt":"2023-09-29T10:25:03","slug":"p411","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p411/","title":{"rendered":"P411"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p411","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":45,"post_author":"1","post_date":"2017-04-11 12:43:58","post_date_gmt":"2017-04-11 10:43:58","post_content":"","post_title":"Diffusori luce tondi","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-luce-tondi","to_ping":"","pinged":"","post_modified":"2020-03-05 16:28:43","post_modified_gmt":"2020-03-05 15:28:43","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=45","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore luce tondo fisso","product_name_en":"Round not adjustable","product_image":false,"product_description_it":"<p>Diffusori luce stilizzato, accensione/spegnimento individuale con LED ad alta intensità. disponibile con o senza pulsante chiamata Hostess (LED rosso) e luce notte (LED blu). Fissaggio a mezzo viti o molla di ritegno.</p>\n","product_description_en":"<p>Stylized on/off individually switchable light diffusers with high intensity white lighting LED. Available with or without Hostess call button (red LED) and night light (blue LED). Fixation by clips or retention springs.</p>\n","product_variants":"68133,68123,68113,68103","index_order":"04_01_01","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P411.pdf","documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/162"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=162"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":161,"date":"2017-04-14T10:52:21","date_gmt":"2017-04-14T08:52:21","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=161"},"modified":"2023-09-29T12:24:02","modified_gmt":"2023-09-29T10:24:02","slug":"p399","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p399/","title":{"rendered":"P399"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p399","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":45,"post_author":"1","post_date":"2017-04-11 12:43:58","post_date_gmt":"2017-04-11 10:43:58","post_content":"","post_title":"Diffusori luce tondi","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-luce-tondi","to_ping":"","pinged":"","post_modified":"2020-03-05 16:28:43","post_modified_gmt":"2020-03-05 15:28:43","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=45","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore luce tondo orientabile","product_name_en":"Round adjustable light","product_image":false,"product_description_it":"<p>Diffusore luce rotondo a LED per sistemi di illuminazione centralizzati. Fissaggio con dentini ad incastro ma facilmente rimovibile tramite apposito attrezzo.</p>\n","product_description_en":"<p>Round LED light diffuser for centralized lighting systems. Click-in clips but easily removable by means of a specific tool.</p>\n","product_variants":"67552","index_order":"04_01_03","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P399.pdf","documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/161"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=161"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":160,"date":"2017-04-14T10:51:54","date_gmt":"2017-04-14T08:51:54","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=160"},"modified":"2023-09-29T12:14:46","modified_gmt":"2023-09-29T10:14:46","slug":"p163","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p163/","title":{"rendered":"P163"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p163","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":45,"post_author":"1","post_date":"2017-04-11 12:43:58","post_date_gmt":"2017-04-11 10:43:58","post_content":"","post_title":"Diffusori luce tondi","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-luce-tondi","to_ping":"","pinged":"","post_modified":"2020-03-05 16:28:43","post_modified_gmt":"2020-03-05 15:28:43","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=45","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore luce tondo orientabile","product_name_en":"Round adjustable light","product_image":false,"product_description_it":"<p>Diffusore luce rotondo con lampadina ad incandescenza per sistemi di illuminazione centralizzati. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Round filament bulb light diffuser for centralized lighting systems. Click in clips.</p>\n","product_variants":"64597,69915","index_order":"04_01_04","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P163.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/160"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=160"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":159,"date":"2017-04-14T10:51:36","date_gmt":"2017-04-14T08:51:36","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=159"},"modified":"2023-10-06T09:56:24","modified_gmt":"2023-10-06T07:56:24","slug":"p161","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p161/","title":{"rendered":"P161"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p161","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":45,"post_author":"1","post_date":"2017-04-11 12:43:58","post_date_gmt":"2017-04-11 10:43:58","post_content":"","post_title":"Diffusori luce tondi","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-luce-tondi","to_ping":"","pinged":"","post_modified":"2020-03-05 16:28:43","post_modified_gmt":"2020-03-05 15:28:43","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=45","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore luce tondo orientabile","product_name_en":"Round adjustable light","product_image":false,"product_description_it":"<p>Diffusore luce rotondo con lampadina ad incandescenza per sistemi di illuminazione centralizzati. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Round filament bulb light diffuser, for centralized lighting systems. Click in clips.</p>\n","product_variants":"65547,65557","index_order":"04_01_06","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P161.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/159"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=159"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":158,"date":"2017-04-14T10:51:01","date_gmt":"2017-04-14T08:51:01","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=158"},"modified":"2023-09-29T12:13:56","modified_gmt":"2023-09-29T10:13:56","slug":"p80bis","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p80bis/","title":{"rendered":"P80bis"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p80_bis","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":45,"post_author":"1","post_date":"2017-04-11 12:43:58","post_date_gmt":"2017-04-11 10:43:58","post_content":"","post_title":"Diffusori luce tondi","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-luce-tondi","to_ping":"","pinged":"","post_modified":"2020-03-05 16:28:43","post_modified_gmt":"2020-03-05 15:28:43","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=45","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore luce tondo orientabile","product_name_en":"Round adjustable light","product_image":false,"product_description_it":"<p>Diffusore luce rotondo con interruttore individuale e lampadina ad incandescenza. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Round filament bulb light diffuser, individually on/off swichtable. Click in clips.</p>\n","product_variants":"51860,63539","index_order":"04_01_05","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P80bis.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/158"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=158"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":157,"date":"2017-04-14T10:50:32","date_gmt":"2017-04-14T08:50:32","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=157"},"modified":"2023-09-29T12:12:28","modified_gmt":"2023-09-29T10:12:28","slug":"p80","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p80/","title":{"rendered":"P80"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p80","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":45,"post_author":"1","post_date":"2017-04-11 12:43:58","post_date_gmt":"2017-04-11 10:43:58","post_content":"","post_title":"Diffusori luce tondi","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-luce-tondi","to_ping":"","pinged":"","post_modified":"2020-03-05 16:28:43","post_modified_gmt":"2020-03-05 15:28:43","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=45","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore luce tondo orientabile","product_name_en":"Round adjustable light","product_image":false,"product_description_it":"<p>Diffusore luce rotondo con lampadina ad incandescenza per sistemi di illuminazione centralizzati. Fissaggio a mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Round filament bulb light diffuser, for centralized lighitng systems. Click in clips.</p>\n","product_variants":"61161,51830,65721,66988","index_order":"04_01_07","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P80.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/157"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=157"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":156,"date":"2017-04-14T10:49:25","date_gmt":"2017-04-14T08:49:25","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=156"},"modified":"2023-09-29T12:22:27","modified_gmt":"2023-09-29T10:22:27","slug":"p396","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p396/","title":{"rendered":"P396"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p396","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":44,"post_author":"1","post_date":"2017-04-11 12:42:52","post_date_gmt":"2017-04-11 10:42:52","post_content":"","post_title":"Diffusori luce rettangolari","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-luce-rettangolari","to_ping":"","pinged":"","post_modified":"2020-03-05 16:29:22","post_modified_gmt":"2020-03-05 15:29:22","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=44","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore luce rettangolare fisso","product_name_en":"Rectangular not adjustable","product_image":false,"product_description_it":"<p>Modulo di illuminazione rettangolare, con interruttore individuale e lampadina ad incandescenza. Fissaggio per mezzo di dentini ad incastro.</p>\n","product_description_en":"<p>Lighting module individually on/off swichtable, with filament bulb lamp. Fixation by clips.</p>\n","product_variants":"65671","index_order":"04_02_01","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":false,"pdf_manual":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P396.pdf","documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/156"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=156"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":155,"date":"2017-04-14T10:48:54","date_gmt":"2017-04-14T08:48:54","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=155"},"modified":"2023-09-29T12:18:55","modified_gmt":"2023-09-29T10:18:55","slug":"p339","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p339/","title":{"rendered":"P339"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p339","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":44,"post_author":"1","post_date":"2017-04-11 12:42:52","post_date_gmt":"2017-04-11 10:42:52","post_content":"","post_title":"Diffusori luce rettangolari","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-luce-rettangolari","to_ping":"","pinged":"","post_modified":"2020-03-05 16:29:22","post_modified_gmt":"2020-03-05 15:29:22","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=44","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Luce basculante","product_name_en":"Tilting light","product_image":false,"product_description_it":"<p>Luce di lettura per passeggeri o autista.</p>\n","product_description_en":"<p>Reading lamp for passengers or drivers.</p>\n","product_variants":"61679,68351","index_order":"04_02_03","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P339.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/155"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=155"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":154,"date":"2017-04-14T10:48:20","date_gmt":"2017-04-14T08:48:20","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=154"},"modified":"2023-09-29T12:17:53","modified_gmt":"2023-09-29T10:17:53","slug":"p289","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p289/","title":{"rendered":"P289"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p289","category_id":[{"ID":21,"post_author":"1","post_date":"2017-04-11 12:05:15","post_date_gmt":"2017-04-11 10:05:15","post_content":"","post_title":"Sistemi e componenti di illuminazione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-illuminazione","to_ping":"","pinged":"","post_modified":"2023-09-29 12:34:16","post_modified_gmt":"2023-09-29 10:34:16","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=21","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":44,"post_author":"1","post_date":"2017-04-11 12:42:52","post_date_gmt":"2017-04-11 10:42:52","post_content":"","post_title":"Diffusori luce rettangolari","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"diffusori-luce-rettangolari","to_ping":"","pinged":"","post_modified":"2020-03-05 16:29:22","post_modified_gmt":"2020-03-05 15:29:22","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=44","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Diffusore luce rettangolare fisso","product_name_en":"Rectangular not adjustable","product_image":false,"product_description_it":"<p>Luce di cortesia per gradini di salita.</p>\n","product_description_en":"<p>Step watch lamp.</p>\n","product_variants":"62788","index_order":"04_02_04","coaches":true,"midi_minibusses":false,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P289.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/154"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=154"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":152,"date":"2017-04-14T10:47:07","date_gmt":"2017-04-14T08:47:07","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=152"},"modified":"2023-10-02T10:49:21","modified_gmt":"2023-10-02T08:49:21","slug":"p318","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p318/","title":{"rendered":"P318"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p318","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":49,"post_author":"1","post_date":"2017-04-11 12:46:21","post_date_gmt":"2017-04-11 10:46:21","post_content":"","post_title":"Maniglia di presa per urbani","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-di-presa","to_ping":"","pinged":"","post_modified":"2020-02-14 16:49:30","post_modified_gmt":"2020-02-14 15:49:30","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=49","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia di presa per urbani","product_name_en":"City bus catching handle","product_image":false,"product_description_it":"<p>Maniglie appiglio flessibili per autobus urbani.</p>\n","product_description_en":"<p>Soft cachting handles for city busses.</p>\n","product_variants":"60879,60081,67969,65701,66199,65772,66742,66866,67098,69653,61651,61102,61122,64602","index_order":"05_03_02","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":true,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P318.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/152"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=152"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":150,"date":"2017-04-14T10:46:21","date_gmt":"2017-04-14T08:46:21","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=150"},"modified":"2023-09-29T14:58:03","modified_gmt":"2023-09-29T12:58:03","slug":"p31","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p31/","title":{"rendered":"P31"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p31","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":49,"post_author":"1","post_date":"2017-04-11 12:46:21","post_date_gmt":"2017-04-11 10:46:21","post_content":"","post_title":"Maniglia di presa per urbani","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"maniglie-di-presa","to_ping":"","pinged":"","post_modified":"2020-02-14 16:49:30","post_modified_gmt":"2020-02-14 15:49:30","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=49","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Maniglia di presa per urbani","product_name_en":"City bus catching handle","product_image":false,"product_description_it":"<p>Maniglie appiglio rigide antibatteriche per autobus urbani.</p>\n","product_description_en":"<p>Rigid antibacterial cachting handles for city busses.</p>\n","product_variants":"65212,65232,65242,65272,65222,65262,65252,65082,64872,64862,64832,64882,64842,64852","index_order":"05_03_01","coaches":true,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P31.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/150"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=150"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":146,"date":"2017-04-14T10:41:50","date_gmt":"2017-04-14T08:41:50","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=146"},"modified":"2023-10-05T09:56:28","modified_gmt":"2023-10-05T07:56:28","slug":"p288","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p288/","title":{"rendered":"P288"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p288","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":376,"post_author":"1","post_date":"2017-05-19 11:05:31","post_date_gmt":"2017-05-19 09:05:31","post_content":"","post_title":"Tasto rialzato","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"tasto-rialzato","to_ping":"","pinged":"","post_modified":"2022-11-17 17:55:55","post_modified_gmt":"2022-11-17 16:55:55","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=376","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Pulsantiera tasto rialzato","product_name_en":"Raised button","product_image":false,"product_description_it":"<p>Pulsantiere cablate per tubi, forma affusolata, tasto basculante.</p>\n","product_description_en":"<p>Wired push bells for poles, slim shape, tilting slim button.</p>\n","product_variants":"61463,61013,61063,68829,62608,67522,68582,61023,68131,67058,66808,61352,60933,69241,60872,62001,60973,66712,62618,68722,65968,62898,67863,61692,66972,67212,65678,62749,68952,60092,63662,63972,69851,67388,67378,62011,67408,67398,62628","index_order":"05_05_01","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P288-1.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/146"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=146"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":144,"date":"2017-04-14T10:41:13","date_gmt":"2017-04-14T08:41:13","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=144"},"modified":"2023-10-05T09:55:46","modified_gmt":"2023-10-05T07:55:46","slug":"p167e","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p167e/","title":{"rendered":"P167E"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p167_e","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":376,"post_author":"1","post_date":"2017-05-19 11:05:31","post_date_gmt":"2017-05-19 09:05:31","post_content":"","post_title":"Tasto rialzato","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"tasto-rialzato","to_ping":"","pinged":"","post_modified":"2022-11-17 17:55:55","post_modified_gmt":"2022-11-17 16:55:55","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=376","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Pulsantiera tasto rialzato","product_name_en":"Raised button","product_image":false,"product_description_it":"<p>Pulsantiere cablate per parete con tasto quadrato rialzato.</p>\n","product_description_en":"<p>Wired push bells for walls, raised square button.</p>\n","product_variants":"67719,69401,68013,69871,68191,62312,68701,66722,60388,62572,62462,62029,69042,66888,61142,65612,63661,69062,61079,63812,60963,67851,63412,64072,61043,60922,61572,60822,63152,63143,66371,66381,65261,61022,69891,66701,61163,69151,62072,62031,66702,68522,68482,68652,62422,64931,68662,64107,68452,68791,62042,64317,64307,62062,68422,61972,60212,63341,68001,65461,61218,67542,61238,64812,65171,66007,65292,67989,61228,61248,67559,67499,61132,67332,61143,60152,61833,61843,63573,60004,69273,69293,68841,69162,69107,69137,68281,61442,61452,69127,68753,61982,69117,67527","index_order":"05_05_04","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P167E.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/144"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=144"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":143,"date":"2017-04-14T10:40:51","date_gmt":"2017-04-14T08:40:51","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=143"},"modified":"2023-10-05T09:55:11","modified_gmt":"2023-10-05T07:55:11","slug":"p167bis","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p167bis/","title":{"rendered":"P167bis"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p167_bis","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":376,"post_author":"1","post_date":"2017-05-19 11:05:31","post_date_gmt":"2017-05-19 09:05:31","post_content":"","post_title":"Tasto rialzato","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"tasto-rialzato","to_ping":"","pinged":"","post_modified":"2022-11-17 17:55:55","post_modified_gmt":"2022-11-17 16:55:55","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=376","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Pulsantiera tasto rialzato","product_name_en":"Raised button","product_image":false,"product_description_it":"<p>Pulsantiere cablate per parete con tasto rialzato e luce di attenzione rossa.</p>\n","product_description_en":"<p>Wired push bells for walls, raised square button with warning red light.</p>\n","product_variants":"63171,60038,63181,65641,66801,60048,60058,66451,63301,66404,65641","index_order":"05_05_05","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P167BIS.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/143"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=143"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":142,"date":"2017-04-14T10:40:25","date_gmt":"2017-04-14T08:40:25","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=142"},"modified":"2023-10-05T09:54:17","modified_gmt":"2023-10-05T07:54:17","slug":"p167","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p167/","title":{"rendered":"P167"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p167","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":377,"post_author":"1","post_date":"2017-05-19 11:06:19","post_date_gmt":"2017-05-19 09:06:19","post_content":"","post_title":"Tasto non rialzato","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"tasto-non-rialzato","to_ping":"","pinged":"","post_modified":"2022-11-17 17:55:59","post_modified_gmt":"2022-11-17 16:55:59","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=377","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Pulsantiera tasto non rialzato","product_name_en":"Not raised button","product_image":false,"product_description_it":"<p>Pulsantiere cablate per parete con tasto quadrato non rialzato.</p>\n","product_description_en":"<p>Wired push bells for walls, flat square button.</p>\n","product_variants":"64047,64027,67877,64137,64127,64097,64087,64077,64057,64067,64247,64227,64037,64337,64327,62669,60682,64297,64287,64277,64257,64267,69791,60692,60011,66992,68003,65312,65221,63701,64792,67359,67349,65648,67959,60338,63651,60861,61028,68053,64358,68239,61569,69669,64802,64117,66744,69107,69137,68281,61442,61452,69127,61982,69117,67527","index_order":"05_06_05","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P167-1.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/142"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=142"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":141,"date":"2017-04-14T10:40:04","date_gmt":"2017-04-14T08:40:04","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=141"},"modified":"2023-10-05T09:52:56","modified_gmt":"2023-10-05T07:52:56","slug":"p107","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p107/","title":{"rendered":"P107"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p107","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":377,"post_author":"1","post_date":"2017-05-19 11:06:19","post_date_gmt":"2017-05-19 09:06:19","post_content":"","post_title":"Tasto non rialzato","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"tasto-non-rialzato","to_ping":"","pinged":"","post_modified":"2022-11-17 17:55:59","post_modified_gmt":"2022-11-17 16:55:59","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=377","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Pulsantiera tasto non rialzato","product_name_en":"Not raised button","product_image":false,"product_description_it":"<p>Pulsantiere cablata per parete con tasto ovale non rialzato. Versione speciale per sedi sagomate.</p>\n","product_description_en":"<p>Wired push bells for walls, flat oval button. Special version for preset location.</p>\n","product_variants":"61400,63251,63261,63231,63241","index_order":"05_06_03","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P107-1.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/141"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=141"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":140,"date":"2017-04-14T10:39:45","date_gmt":"2017-04-14T08:39:45","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=140"},"modified":"2023-10-05T09:52:24","modified_gmt":"2023-10-05T07:52:24","slug":"p106","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p106/","title":{"rendered":"P106"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p106","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":377,"post_author":"1","post_date":"2017-05-19 11:06:19","post_date_gmt":"2017-05-19 09:06:19","post_content":"","post_title":"Tasto non rialzato","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"tasto-non-rialzato","to_ping":"","pinged":"","post_modified":"2022-11-17 17:55:59","post_modified_gmt":"2022-11-17 16:55:59","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=377","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Pulsantiera tasto non rialzato","product_name_en":"Not raised button","product_image":false,"product_description_it":"<p>Pulsantiere cablate per parete con tasto ovale non rialzato.</p>\n","product_description_en":"<p>Wired push bells for walls, flat oval button.</p>\n","product_variants":"61390,61899,68398,65839,68017,61292,66452,63281,66462,63191,63221","index_order":"05_06_02","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P106-1.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/140"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=140"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":139,"date":"2017-04-14T10:39:09","date_gmt":"2017-04-14T08:39:09","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=139"},"modified":"2023-10-05T09:51:47","modified_gmt":"2023-10-05T07:51:47","slug":"p105l","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p105l/","title":{"rendered":"P105L"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p105_l","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":376,"post_author":"1","post_date":"2017-05-19 11:05:31","post_date_gmt":"2017-05-19 09:05:31","post_content":"","post_title":"Tasto rialzato","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"tasto-rialzato","to_ping":"","pinged":"","post_modified":"2022-11-17 17:55:55","post_modified_gmt":"2022-11-17 16:55:55","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=376","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Pulsantiera tasto rialzato","product_name_en":"Raised button","product_image":false,"product_description_it":"<p>Pulsantiere cablate per tubi, con tasto quadrato rialzato e luci LED di segnalazione status.</p>\n","product_description_en":"<p>Wired push bells for poles, raised square button with LED lights for status modus.</p>\n","index_order":"05_05_03","product_variants":"61422,61562,67973,68232,66174","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P105L-1.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/139"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=139"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":136,"date":"2017-04-14T10:37:44","date_gmt":"2017-04-14T08:37:44","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=136"},"modified":"2023-10-05T09:49:40","modified_gmt":"2023-10-05T07:49:40","slug":"p105bis","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p105bis/","title":{"rendered":"P105bis"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p105_bis","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":377,"post_author":"1","post_date":"2017-05-19 11:06:19","post_date_gmt":"2017-05-19 09:06:19","post_content":"","post_title":"Tasto non rialzato","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"tasto-non-rialzato","to_ping":"","pinged":"","post_modified":"2022-11-17 17:55:59","post_modified_gmt":"2022-11-17 16:55:59","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=377","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Pulsantiera tasto non rialzato","product_name_en":"Not raised button","product_image":false,"product_description_it":"<p>Pulsantiere cablate per tubi con tasto quadrato non rialzato.</p>\n","product_description_en":"<p>Wired push bells for poles, flat square button.</p>\n","product_variants":"68408,69768,69049,66027,64547,69769,66017,64567,65321,64587,68643,68519,68677,64557,64717,64707,64687,64697,60112,61059,61432,64757,61069,69631,64747,64727,64737,69781,60472,66982,68023,65211,66948,63641,60871,61188,67939,61372,61032,64468,64458,60591,61042,65999,63402,65939,65989,65392,62582,67329,67339,69339,69349,68418,69778,69059,69759,65067,67747,65817,67281,65077,68529,60298,61428,65638,60134,69472,69143,69063,67843,64782,68453,64728","index_order":"05_06_04","coaches":true,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P105BIS.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/136"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=136"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":135,"date":"2017-04-14T10:37:06","date_gmt":"2017-04-14T08:37:06","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=135"},"modified":"2023-10-05T09:50:54","modified_gmt":"2023-10-05T07:50:54","slug":"p105e","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p105e/","title":{"rendered":"P105E"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p105_e","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":376,"post_author":"1","post_date":"2017-05-19 11:05:31","post_date_gmt":"2017-05-19 09:05:31","post_content":"","post_title":"Tasto rialzato","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"tasto-rialzato","to_ping":"","pinged":"","post_modified":"2022-11-17 17:55:55","post_modified_gmt":"2022-11-17 16:55:55","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=376","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Pulsantiera tasto rialzato","product_name_en":"Raised button","product_image":false,"product_description_it":"<p>Pulsantiere cablate per tubi, linea forma affusolata, tasto basculante.</p>\n","product_description_en":"<p>Wired push bells for poles, raised square button.</p>\n","product_variants":"60702,60852,60902,63552,61162,61582,61072,61112,63162,63982,61173,60892,60582,61182,62492,62649,62322,61772,61472,65161,60882,61722,61092,60572,60912,65481,60983,65471,60842,66542,64932,64062,68181,64012,69231,68129,67502,67528,67507,65811,60179,63133,68121,65251,63582,69881,65512,68139,69091,62502,69961,67662,68532,65651,67548,68171,68462,68771,61453,69157,69147,66552,65871,63452,60222,67427,69211,61258,67532,61278,65997,65182,69309,61268,61288,64749,66038,68033,61561,69861,64142,65979,65969,65899,67929,68099,67991,64982,66781,64952,61581,65949,60581,65929,65959,60982,65291,62409,69901,68011,60232,69181,68211,69995,67422,63173,61513,64503,67322,68831,66164,68733,60073,69213,68723,68903,68403,60995,60403,68743,66786,66766,66746,66796,66816,66806,69167,69187,69197,69177,69207,69227,69237,69217,66444","index_order":"05_05_02","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P105E.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/135"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=135"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":133,"date":"2017-04-14T10:35:59","date_gmt":"2017-04-14T08:35:59","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=133"},"modified":"2023-10-02T10:52:34","modified_gmt":"2023-10-02T08:52:34","slug":"p348","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p348/","title":{"rendered":"P348"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p348","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":47,"post_author":"1","post_date":"2017-04-11 12:45:07","post_date_gmt":"2017-04-11 10:45:07","post_content":"","post_title":"Morsetti in plastica per urbani","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetteria-per-urbani","to_ping":"","pinged":"","post_modified":"2020-02-14 16:52:03","post_modified_gmt":"2020-02-14 15:52:03","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=47","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Morsetto per urbani","product_name_en":"City bus support","product_image":false,"product_description_it":"<p>Supporti a parete chiusi e passanti per paleria di autobus urbani.</p>\n","product_description_en":"<p>Ceiling end caps and pass-through supports for city bus poles.</p>\n","product_variants":"63619,63609","index_order":"05_01_11","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P348.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/133"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=133"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":132,"date":"2017-04-14T10:35:42","date_gmt":"2017-04-14T08:35:42","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=132"},"modified":"2023-10-02T10:51:53","modified_gmt":"2023-10-02T08:51:53","slug":"p327","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p327/","title":{"rendered":"P327"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p327","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":47,"post_author":"1","post_date":"2017-04-11 12:45:07","post_date_gmt":"2017-04-11 10:45:07","post_content":"","post_title":"Morsetti in plastica per urbani","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetteria-per-urbani","to_ping":"","pinged":"","post_modified":"2020-02-14 16:52:03","post_modified_gmt":"2020-02-14 15:52:03","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=47","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Morsetto per urbani","product_name_en":"City bus support","product_image":false,"product_description_it":"<p>Supporti ovali a parete chiusi e passanti per paleria di autobus urbani.</p>\n","product_description_en":"<p>Oval ceiling end caps and pass-through supports for city bus poles.</p>\n","product_variants":"69098,69078,63499,61392,63509,60021,61382","index_order":"05_01_10","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P327.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/132"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=132"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":131,"date":"2017-04-14T10:35:16","date_gmt":"2017-04-14T08:35:16","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=131"},"modified":"2023-10-02T10:47:34","modified_gmt":"2023-10-02T08:47:34","slug":"p315","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p315/","title":{"rendered":"P315"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p315","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":47,"post_author":"1","post_date":"2017-04-11 12:45:07","post_date_gmt":"2017-04-11 10:45:07","post_content":"","post_title":"Morsetti in plastica per urbani","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetteria-per-urbani","to_ping":"","pinged":"","post_modified":"2020-02-14 16:52:03","post_modified_gmt":"2020-02-14 15:52:03","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=47","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Morsetto per urbani","product_name_en":"City bus support","product_image":false,"product_description_it":"<p>Morsetti a 90° per paleria di autobus urbani.</p>\n","product_description_en":"<p>90° fittings for city bus poles.</p>\n","product_variants":"67078,67158,67148,69301,67168,67188,67178","index_order":"05_01_09","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P315.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/131"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=131"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":130,"date":"2017-04-14T10:34:58","date_gmt":"2017-04-14T08:34:58","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=130"},"modified":"2023-10-02T10:45:39","modified_gmt":"2023-10-02T08:45:39","slug":"p314","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p314/","title":{"rendered":"P314"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p314","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":47,"post_author":"1","post_date":"2017-04-11 12:45:07","post_date_gmt":"2017-04-11 10:45:07","post_content":"","post_title":"Morsetti in plastica per urbani","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetteria-per-urbani","to_ping":"","pinged":"","post_modified":"2020-02-14 16:52:03","post_modified_gmt":"2020-02-14 15:52:03","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=47","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Morsetto per urbani","product_name_en":"City bus support","product_image":false,"product_description_it":"<p>Terminali paleria a parete per paleria di autobus urbani.</p>\n","product_description_en":"<p>Ceiling end caps for city bus poles.</p>\n","product_variants":"67068,67138,67128,69588,69598,69608","index_order":"05_01_08","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P314.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/130"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=130"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":129,"date":"2017-04-14T10:34:39","date_gmt":"2017-04-14T08:34:39","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=129"},"modified":"2023-09-29T15:19:31","modified_gmt":"2023-09-29T13:19:31","slug":"p42bis","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p42bis/","title":{"rendered":"P42bis"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p42_bis","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":47,"post_author":"1","post_date":"2017-04-11 12:45:07","post_date_gmt":"2017-04-11 10:45:07","post_content":"","post_title":"Morsetti in plastica per urbani","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetteria-per-urbani","to_ping":"","pinged":"","post_modified":"2020-02-14 16:52:03","post_modified_gmt":"2020-02-14 15:52:03","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=47","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Morsetto per urbani","product_name_en":"City bus support","product_image":false,"product_description_it":"<p>Morsetto a 3 vie universale per paleria di autobus urbani. Non richiede fori di fissaggio sui tubi.</p>\n","product_description_en":"<p>Universal 3-way fittings for city bus poles. No need to drill holes in the poles.</p>\n","product_variants":"69949,69929,69939","index_order":"05_01_02","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P42bis.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/129"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=129"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":128,"date":"2017-04-14T10:34:18","date_gmt":"2017-04-14T08:34:18","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=128"},"modified":"2023-09-29T15:18:44","modified_gmt":"2023-09-29T13:18:44","slug":"p42","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p42/","title":{"rendered":"P42"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p42","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":47,"post_author":"1","post_date":"2017-04-11 12:45:07","post_date_gmt":"2017-04-11 10:45:07","post_content":"","post_title":"Morsetti in plastica per urbani","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetteria-per-urbani","to_ping":"","pinged":"","post_modified":"2020-02-14 16:52:03","post_modified_gmt":"2020-02-14 15:52:03","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=47","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Morsetto per urbani","product_name_en":"City bus support","product_image":false,"product_description_it":"<p>Morsetto a 3 vie per paleria di autobus urbani.</p>\n","product_description_en":"<p>3-way fittings for city bus poles.</p>\n","product_variants":"68937,66448,66438,68969,63529,68949,63519,64922,68959,68947,66468,66458,65748","index_order":"05_01_01","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P42.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/128"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=128"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":127,"date":"2017-04-14T10:34:01","date_gmt":"2017-04-14T08:34:01","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=127"},"modified":"2023-09-29T15:17:09","modified_gmt":"2023-09-29T13:17:09","slug":"p41bis","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p41bis/","title":{"rendered":"P41bis"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p41_bis","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":47,"post_author":"1","post_date":"2017-04-11 12:45:07","post_date_gmt":"2017-04-11 10:45:07","post_content":"","post_title":"Morsetti in plastica per urbani","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetteria-per-urbani","to_ping":"","pinged":"","post_modified":"2020-02-14 16:52:03","post_modified_gmt":"2020-02-14 15:52:03","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=47","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Morsetto per urbani","product_name_en":"City bus support","product_image":false,"product_description_it":"<p>Morsetto a 4 vie universale per paleria di autobus urbani. Non richiede fori di fissaggio sui tubi.</p>\n","product_description_en":"<p>Universal 4-way fittings for city bus poles. No need to drill holes in the poles.</p>\n","product_variants":"69959","index_order":"05_01_04","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P41bis.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/127"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=127"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":126,"date":"2017-04-14T10:33:41","date_gmt":"2017-04-14T08:33:41","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=126"},"modified":"2023-09-29T15:16:04","modified_gmt":"2023-09-29T13:16:04","slug":"p41","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p41/","title":{"rendered":"P41"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p41","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":47,"post_author":"1","post_date":"2017-04-11 12:45:07","post_date_gmt":"2017-04-11 10:45:07","post_content":"","post_title":"Morsetti in plastica per urbani","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetteria-per-urbani","to_ping":"","pinged":"","post_modified":"2020-02-14 16:52:03","post_modified_gmt":"2020-02-14 15:52:03","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=47","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Morsetto per urbani","product_name_en":"City bus support","product_image":false,"product_description_it":"<p>Morsetto a 4 vie per paleria di autobus urbani.</p>\n","product_description_en":"<p>4-way fittings for city bus poles.</p>\n","product_variants":"68957,66488,66478,69291,68967,66508,66498,65738","index_order":"05_01_03","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p41_manual_rev4.pdf","product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P41.pdf","documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/126"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=126"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":125,"date":"2017-04-14T10:33:24","date_gmt":"2017-04-14T08:33:24","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=125"},"modified":"2023-09-29T15:06:19","modified_gmt":"2023-09-29T13:06:19","slug":"p36","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p36/","title":{"rendered":"P36"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p36","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":47,"post_author":"1","post_date":"2017-04-11 12:45:07","post_date_gmt":"2017-04-11 10:45:07","post_content":"","post_title":"Morsetti in plastica per urbani","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetteria-per-urbani","to_ping":"","pinged":"","post_modified":"2020-02-14 16:52:03","post_modified_gmt":"2020-02-14 15:52:03","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=47","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Morsetto per urbani","product_name_en":"City bus support","product_image":false,"product_description_it":"<p>Morsetti per paretine di separazione.</p>\n","product_description_en":"<p>Fittings for partition walls.</p>\n","product_variants":"68977,66248,66238,69281,68987,66268,66258,68997,66288,66278,69009,69007,66308,66298,69017,66328,66318,69027,6348,66338,64438,66368,66358,64448,66388,66378","index_order":"05_01_05","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P36.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/125"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=125"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":124,"date":"2017-04-14T10:33:08","date_gmt":"2017-04-14T08:33:08","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=124"},"modified":"2023-09-29T15:03:58","modified_gmt":"2023-09-29T13:03:58","slug":"p34","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p34/","title":{"rendered":"P34"},"content":{"rendered":"<p>pr</p>\n","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p34","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":373,"post_author":"1","post_date":"2017-05-19 11:01:40","post_date_gmt":"2017-05-19 09:01:40","post_content":"","post_title":"Tubo rivestito","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"tubo-rivestito","to_ping":"","pinged":"","post_modified":"2020-02-14 16:46:34","post_modified_gmt":"2020-02-14 15:46:34","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=373","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Tubo rivestito","product_name_en":"City bus poles","product_image":false,"product_description_it":"<p>Paleria per autobus urbani rivestita in PVC.</p>\n","product_description_en":"<p>PVC coated poles for city busses.</p>\n","product_variants":"61879,60159,66392,66889,69077,62219,60169,62059,69087,61729","index_order":"05_02_01","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P34.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/124"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=124"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":123,"date":"2017-04-14T10:32:49","date_gmt":"2017-04-14T08:32:49","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=123"},"modified":"2023-09-29T15:02:49","modified_gmt":"2023-09-29T13:02:49","slug":"p33","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p33/","title":{"rendered":"P33"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p33","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":47,"post_author":"1","post_date":"2017-04-11 12:45:07","post_date_gmt":"2017-04-11 10:45:07","post_content":"","post_title":"Morsetti in plastica per urbani","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetteria-per-urbani","to_ping":"","pinged":"","post_modified":"2020-02-14 16:52:03","post_modified_gmt":"2020-02-14 15:52:03","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=47","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Morsetto per urbani","product_name_en":"City bus support","product_image":false,"product_description_it":"<p>Base ovale per paleria di autobus urbani.</p>\n","product_description_en":"<p>Oval base for city bus poles.</p>\n","product_variants":"69057,66408,66398,68989,69067,66428,66418,68999","index_order":"05_01_07","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P33.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/123"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=123"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":122,"date":"2017-04-14T10:32:26","date_gmt":"2017-04-14T08:32:26","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=122"},"modified":"2023-09-29T15:01:43","modified_gmt":"2023-09-29T13:01:43","slug":"p32","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p32/","title":{"rendered":"P32"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p32","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":47,"post_author":"1","post_date":"2017-04-11 12:45:07","post_date_gmt":"2017-04-11 10:45:07","post_content":"","post_title":"Morsetti in plastica per urbani","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetteria-per-urbani","to_ping":"","pinged":"","post_modified":"2020-02-14 16:52:03","post_modified_gmt":"2020-02-14 15:52:03","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=47","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Morsetto per urbani","product_name_en":"City bus support","product_image":false,"product_description_it":"<p>Base rotonda per paleria di autobus urbani.</p>\n","product_description_en":"<p>Round base for city bus poles.</p>\n","product_variants":"69037,66208,66198,69047,66228,66218","index_order":"05_01_06","coaches":false,"midi_minibusses":false,"city_busses":true,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P32.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/122"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=122"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":121,"date":"2017-04-14T10:32:02","date_gmt":"2017-04-14T08:32:02","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=121"},"modified":"2023-10-02T10:50:50","modified_gmt":"2023-10-02T08:50:50","slug":"p326","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p326/","title":{"rendered":"P326"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p326","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":382,"post_author":"1","post_date":"2017-05-19 11:10:55","post_date_gmt":"2017-05-19 09:10:55","post_content":"","post_title":"Gancio appendiabiti","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"gancio-appendiabiti","to_ping":"","pinged":"","post_modified":"2022-10-20 13:37:27","post_modified_gmt":"2022-10-20 11:37:27","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=382","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Gancio appendiabiti","product_name_en":"Hanger","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Appendiabito retrattile per montaggio a parete&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Appendiabito retrattile per montaggio a parete.</span></p>\n","product_description_en":"<p>Retractile hanger for wall mounting.</p>\n","product_variants":"61662","index_order":"06_04_03","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P326.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/121"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=121"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":120,"date":"2017-04-14T10:31:48","date_gmt":"2017-04-14T08:31:48","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=120"},"modified":"2023-10-02T10:44:35","modified_gmt":"2023-10-02T08:44:35","slug":"p297","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p297/","title":{"rendered":"P297"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p297","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":379,"post_author":"1","post_date":"2017-05-19 11:08:45","post_date_gmt":"2017-05-19 09:08:45","post_content":"","post_title":"Portaoggetti","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"posaceneri","to_ping":"","pinged":"","post_modified":"2022-10-20 13:35:24","post_modified_gmt":"2022-10-20 11:35:24","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=379","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Portaoggetti","product_name_en":"Storage compartment","product_image":false,"product_description_it":"<p>Portaoggetti per installazione in orizzontale.</p>\n","product_description_en":"<p>Storage compartment for horizontal mounting.</p>\n","product_variants":"62868","index_order":"06_02_03","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P297.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/120"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=120"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":119,"date":"2017-04-14T10:31:32","date_gmt":"2017-04-14T08:31:32","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=119"},"modified":"2023-10-02T10:43:42","modified_gmt":"2023-10-02T08:43:42","slug":"p293","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p293/","title":{"rendered":"P293"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p293","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":382,"post_author":"1","post_date":"2017-05-19 11:10:55","post_date_gmt":"2017-05-19 09:10:55","post_content":"","post_title":"Gancio appendiabiti","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"gancio-appendiabiti","to_ping":"","pinged":"","post_modified":"2022-10-20 13:37:27","post_modified_gmt":"2022-10-20 11:37:27","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=382","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Gancio appendiabiti","product_name_en":"Hanger","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Appendiabiti fisso per montaggio a parete&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Appendiabiti fisso per montaggio a parete.</span></p>\n","product_description_en":"<p>Fix hanger for wall mounting.</p>\n","product_variants":"62818","index_order":"06_04_01","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P293.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/119"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=119"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":118,"date":"2017-04-14T10:31:17","date_gmt":"2017-04-14T08:31:17","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=118"},"modified":"2023-09-29T17:04:48","modified_gmt":"2023-09-29T15:04:48","slug":"p165","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p165/","title":{"rendered":"P165"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p165","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":378,"post_author":"1","post_date":"2017-05-19 11:08:07","post_date_gmt":"2017-05-19 09:08:07","post_content":"","post_title":"Martello emergenza frangivetro","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"martello-emergenza-frangivetro","to_ping":"","pinged":"","post_modified":"2022-10-20 13:35:08","post_modified_gmt":"2022-10-20 11:35:08","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=378","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Martello d’emergenza frangivetro","product_name_en":"Emergency hammer","product_image":false,"product_description_it":"<p>Martelletto frangivetro pesante per vetri temprati sino 8 mm di spessore. Montaggio o soffitto o a parete, con o senza cavo anti-furto e avvolgicavo, microinterruttore di allarme distacco, lama tagliacintura. A richiesta è disponibile una versione con striscia luminescente che rende visibile il martelletto anche al buoi completo.</p>\n","product_description_en":"<p>Large emergency hammer for tempered glasses up to 8 mm, wall or ceiluing mounting, with or without anti-theft steel cable and cable reel, alarming micro-switch, seat belt cutter. Luminescent stripe on handgrip is available for make the hammer visible in total darkness conditions.</p>\n","product_variants":"60026,60752,60772,60762,60036,60047,65062,68822,68832,60722,60782,60802,60792,61272,68872,68842,68852,68862,66034,66761,64721","index_order":"06_01_02","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":true,"beauty_wellness_equipments":false,"pdf_manual":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/MU_P165_rev2.pdf","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P165.pdf","documenti_allegati":false,"product_name_ru":"АВАРИЙНЫЙ МОЛОТОК ДЛЯ РАЗБИВАНИЯ СТЕКЛА","product_description_ru":"<p>Большой аварийный молоток для закаленного стекла толщиной до 8мм. Установка на потолок или стену, как с противоугонным кабелем и кабельным барабаном, так и без них, микровыключатель аварийного отключения. По запросу поставляется версия с люминесцентной полосой, благодаря которой молоток видно даже в полной темноте.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/118"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=118"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":117,"date":"2017-04-14T10:30:51","date_gmt":"2017-04-14T08:30:51","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=117"},"modified":"2023-09-29T17:00:09","modified_gmt":"2023-09-29T15:00:09","slug":"p146","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p146/","title":{"rendered":"P146"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p146","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":381,"post_author":"1","post_date":"2017-05-19 11:10:17","post_date_gmt":"2017-05-19 09:10:17","post_content":"","post_title":"Portalattine e sportello di protezione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"portalattine-e-sportello-di-protezione","to_ping":"","pinged":"","post_modified":"2022-11-17 18:00:06","post_modified_gmt":"2022-11-17 17:00:06","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=381","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Portabicchiere","product_name_en":"Glass holder","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Portabicchiere per retrosedile&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Portabicchiere per retrosedile.</span></p>\n","product_description_en":"<p>Cup holder for seatback.</p>\n","product_variants":"66067,63923","index_order":"06_03_01","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P146.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/117"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=117"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":116,"date":"2017-04-14T10:30:37","date_gmt":"2017-04-14T08:30:37","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=116"},"modified":"2023-09-29T16:58:14","modified_gmt":"2023-09-29T14:58:14","slug":"p144","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p144/","title":{"rendered":"P144"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p144","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":381,"post_author":"1","post_date":"2017-05-19 11:10:17","post_date_gmt":"2017-05-19 09:10:17","post_content":"","post_title":"Portalattine e sportello di protezione","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"portalattine-e-sportello-di-protezione","to_ping":"","pinged":"","post_modified":"2022-11-17 18:00:06","post_modified_gmt":"2022-11-17 17:00:06","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=381","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Sportellino di protezione","product_name_en":"Door lock guard","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Copriserrature ovali e quadrati&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Copriserrature ovali e quadrati.</span></p>\n","product_description_en":"<p>Square and oval lock guards.</p>\n","product_variants":"62853,65631","index_order":"06_03_02","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P144.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/116"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=116"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":114,"date":"2017-04-14T10:30:24","date_gmt":"2017-04-14T08:30:24","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=114"},"modified":"2023-10-02T11:05:38","modified_gmt":"2023-10-02T09:05:38","slug":"p138","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p138/","title":{"rendered":"P138"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p138","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":384,"post_author":"1","post_date":"2017-05-19 11:13:16","post_date_gmt":"2017-05-19 09:13:16","post_content":"","post_title":"Interruttori e pulsanti","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"interruttori-e-pulsanti","to_ping":"","pinged":"","post_modified":"2022-11-17 18:00:49","post_modified_gmt":"2022-11-17 17:00:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=384","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Pulsante","product_name_en":"Push-button","product_image":false,"product_description_it":"<p>Pulsante rotondo</p>\n","product_description_en":"<p>Round push-button.</p>\n","product_variants":"55591,55601,55611,55641,65986","index_order":"06_06_04","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P137_P138-1.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/114"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=114"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":113,"date":"2017-04-14T10:30:10","date_gmt":"2017-04-14T08:30:10","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=113"},"modified":"2023-09-29T16:57:20","modified_gmt":"2023-09-29T14:57:20","slug":"p137","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p137/","title":{"rendered":"P137"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p137","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":384,"post_author":"1","post_date":"2017-05-19 11:13:16","post_date_gmt":"2017-05-19 09:13:16","post_content":"","post_title":"Interruttori e pulsanti","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"interruttori-e-pulsanti","to_ping":"","pinged":"","post_modified":"2022-11-17 18:00:49","post_modified_gmt":"2022-11-17 17:00:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=384","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Interruttore","product_name_en":"Switch","product_image":false,"product_description_it":"<p>Interuttore rotondo.</p>\n","product_description_en":"<p>Round switch.</p>\n","product_variants":" 55501,55511,55521,55531,55571,55581,55591,55601,556611,55641,65986","index_order":"06_06_03","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P137_P138.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/113"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=113"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":111,"date":"2017-04-14T10:29:42","date_gmt":"2017-04-14T08:29:42","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=111"},"modified":"2023-09-29T15:55:43","modified_gmt":"2023-09-29T13:55:43","slug":"p92","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p92/","title":{"rendered":"P92"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p92","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":382,"post_author":"1","post_date":"2017-05-19 11:10:55","post_date_gmt":"2017-05-19 09:10:55","post_content":"","post_title":"Gancio appendiabiti","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"gancio-appendiabiti","to_ping":"","pinged":"","post_modified":"2022-10-20 13:37:27","post_modified_gmt":"2022-10-20 11:37:27","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=382","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Gancio appendiabiti","product_name_en":"Hanger","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Appendiabiti fisso per montaggio a parete&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Appendiabiti fisso per montaggio a parete.</span></p>\n","product_description_en":"<p>Fix hanger for wall mounting.</p>\n","product_variants":"67137,60778","index_order":"06_04_02","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P92.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/111"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=111"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":110,"date":"2017-04-14T10:29:26","date_gmt":"2017-04-14T08:29:26","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=110"},"modified":"2023-09-29T15:54:34","modified_gmt":"2023-09-29T13:54:34","slug":"p86","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p86/","title":{"rendered":"P86"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p86","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":378,"post_author":"1","post_date":"2017-05-19 11:08:07","post_date_gmt":"2017-05-19 09:08:07","post_content":"","post_title":"Martello emergenza frangivetro","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"martello-emergenza-frangivetro","to_ping":"","pinged":"","post_modified":"2022-10-20 13:35:08","post_modified_gmt":"2022-10-20 11:35:08","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=378","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Martello d’emergenza frangivetro","product_name_en":"Emergency hammer","product_image":false,"product_description_it":"<p>Martelletto frangivetro leggero per vetri temprati sino 4 mm di spessore. Montaggio o soffitto o a parete, con o senza cavo anti-furto e avvolgicavo, microinterruttore di allarme distacco, lama tagliacintura.</p>\n","product_description_en":"<p>Small emergency hammer for tempered glasses up to 4 mm, wall or ceiluing mounting, with or without anti-theft steel cable and cable reel, alarming micro-switch, seat belt cutter.</p>\n","product_variants":"52080,66027,64478,66519,69097,57720,60951,64318,65851,65282,66037,66034,68225,64721,60813","index_order":"06_01_01","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p86_manual_rev6.pdf","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P86.pdf","documenti_allegati":false,"product_name_ru":"АВАРИЙНЫЙ МОЛОТОК ДЛЯ РАЗБИВАНИЯ СТЕКЛА","product_description_ru":"<p>Небольшой аварийный молоток для закаленных стекол толщиной до 4мм. Установка на потолок или стену, как с противоугонным кабелем и кабельным барабаном (так и без них), микровыключатель аварийного отключения.</p>\n","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/110"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=110"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":108,"date":"2017-04-14T10:28:59","date_gmt":"2017-04-14T08:28:59","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=108"},"modified":"2023-09-29T15:21:02","modified_gmt":"2023-09-29T13:21:02","slug":"p64","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p64/","title":{"rendered":"P64"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p64","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":384,"post_author":"1","post_date":"2017-05-19 11:13:16","post_date_gmt":"2017-05-19 09:13:16","post_content":"","post_title":"Interruttori e pulsanti","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"interruttori-e-pulsanti","to_ping":"","pinged":"","post_modified":"2022-11-17 18:00:49","post_modified_gmt":"2022-11-17 17:00:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=384","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Interruttore","product_name_en":"Switch","product_image":false,"product_description_it":"<p>Interrutore quadrato.</p>\n","product_description_en":"<p>Square switch.</p>\n","product_variants":"65377,65387","index_order":"06_06_02","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P63_P64-1.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/108"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=108"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":107,"date":"2017-04-14T10:28:45","date_gmt":"2017-04-14T08:28:45","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=107"},"modified":"2023-09-29T15:20:29","modified_gmt":"2023-09-29T13:20:29","slug":"p63","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p63/","title":{"rendered":"P63"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p63","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":384,"post_author":"1","post_date":"2017-05-19 11:13:16","post_date_gmt":"2017-05-19 09:13:16","post_content":"","post_title":"Interruttori e pulsanti","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"interruttori-e-pulsanti","to_ping":"","pinged":"","post_modified":"2022-11-17 18:00:49","post_modified_gmt":"2022-11-17 17:00:49","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=384","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Pulsante","product_name_en":"Push-button","product_image":false,"product_description_it":"<p>Pulsante quadrato.</p>\n","product_description_en":"<p>Square push-button.</p>\n","product_variants":"64378,66787","index_order":"06_06_01","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P63_P64.pdf","pdf_manual":false,"documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/107"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=107"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":105,"date":"2017-04-14T10:28:17","date_gmt":"2017-04-14T08:28:17","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=105"},"modified":"2023-09-29T14:53:10","modified_gmt":"2023-09-29T12:53:10","slug":"p19","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p19/","title":{"rendered":"P19"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p19","category_id":[{"ID":20,"post_author":"1","post_date":"2017-04-11 12:04:39","post_date_gmt":"2017-04-11 10:04:39","post_content":"","post_title":"Accessori x Interni Bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"morsetterie-e-pulsantiere","to_ping":"","pinged":"","post_modified":"2023-10-05 10:00:53","post_modified_gmt":"2023-10-05 08:00:53","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=20","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":1442,"post_author":"7","post_date":"2022-08-01 10:47:19","post_date_gmt":"2022-08-01 08:47:19","post_content":"","post_title":"Posacenere","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"posacenere","to_ping":"","pinged":"","post_modified":"2022-11-17 17:57:02","post_modified_gmt":"2022-11-17 16:57:02","post_content_filtered":"","post_parent":0,"guid":"https://wp.primaautomotive.it/?post_type=sub_categories&#038;p=1442","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Posacenere","product_name_en":"Ashtray","product_image":false,"product_description_it":"<p>Posacenere per installazione in orizzontale.</p>\n","product_description_en":"<p>Ashtray for horizontal mounting.</p>\n","product_variants":"67627","index_order":"06_02_01","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p19_cod41262_manual_rev2.pdf","product_name_ru":"Пепельница","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P19.pdf","documenti_allegati":false,"product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/105"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=105"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":98,"date":"2017-04-14T10:25:21","date_gmt":"2017-04-14T08:25:21","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=98"},"modified":"2023-10-02T11:51:26","modified_gmt":"2023-10-02T09:51:26","slug":"p412","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p412/","title":{"rendered":"P412"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p412","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":51,"post_author":"1","post_date":"2017-04-11 12:47:58","post_date_gmt":"2017-04-11 10:47:58","post_content":"","post_title":"Multiset","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"multiset","to_ping":"","pinged":"","post_modified":"2020-02-14 16:48:45","post_modified_gmt":"2020-02-14 15:48:45","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=51","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Modulo di servizio","product_name_en":"Multiset","product_image":{"ID":670,"id":670,"title":"p412_3640_imm","filename":"p412_3640_imm.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p412_3640_imm.jpg","alt":"","author":"1","description":"","caption":"","name":"p412_3640_imm","date":"2018-03-27 08:33:38","modified":"2018-03-27 08:33:40","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":600,"height":351,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p412_3640_imm-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p412_3640_imm-300x176.jpg","medium-width":300,"medium-height":176,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p412_3640_imm.jpg","medium_large-width":525,"medium_large-height":307,"large":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p412_3640_imm.jpg","large-width":525,"large-height":307,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p412_3640_imm.jpg","twentyseventeen-featured-image-width":600,"twentyseventeen-featured-image-height":351,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p412_3640_imm-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Modulo di servizio singolo stilizzato. Dotato di luci LED e diffusori aria orientabili 2D: Interruttore individuale, pulsante chiamata hostess o fermata e spia rossa di avviso. Luce blu notturna. A richiesta u00e8 possibile dotare le &quot;ali&quot; di luce LED notturna blu.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Modulo di servizio singolo stilizzato. Dotato di luci LED e diffusori aria orientabili 2D: Interruttore individuale, pulsante chiamata hostess o fermata e spia rossa di avviso. Luce blu notturna. A richiesta è possibile dotare le &#8220;ali&#8221; di luce LED notturna blu.</span></p>\n","product_description_en":"<p>Stylized single seat multiset for minibusses. LED light and 2D air diffuser. Ligthing unit with on/off switch, hostess or stop call button and red warning light. Blue night light. On demand the &#8220;wings&#8221; could be equipped with a blue night light strip.</p>\n","product_variants":"61223,61183","index_order":"07_01_10","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p412_manual_rev2.pdf","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P412.pdf","documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/98"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=98"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":97,"date":"2017-04-14T10:24:59","date_gmt":"2017-04-14T08:24:59","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=97"},"modified":"2023-10-02T18:42:53","modified_gmt":"2023-10-02T16:42:53","slug":"p390","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p390/","title":{"rendered":"P390"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p390","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":51,"post_author":"1","post_date":"2017-04-11 12:47:58","post_date_gmt":"2017-04-11 10:47:58","post_content":"","post_title":"Multiset","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"multiset","to_ping":"","pinged":"","post_modified":"2020-02-14 16:48:45","post_modified_gmt":"2020-02-14 15:48:45","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=51","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Modulo di servizio","product_name_en":"Multiset","product_image":{"ID":1811,"id":1811,"title":"p390","filename":"p390.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p390.jpg","alt":"","author":"1","description":"","caption":"","name":"p390-3","date":"2023-10-02 16:42:44","modified":"2023-10-02 16:42:49","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":3624,"height":2547,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p390-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p390-300x211.jpg","medium-width":300,"medium-height":211,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p390-768x540.jpg","medium_large-width":525,"medium_large-height":369,"large":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p390-1024x720.jpg","large-width":525,"large-height":369,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p390-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p390-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Modulo di servizio doppio per autobus turistici. Luce orientabile (lampadina ad incandescenza) con interuttore individuale e diffusore aria orientabile 3D. I moduli di diffusione aria/luce sono combinabili a piacere.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Modulo di servizio doppio per autobus turistici. Luce orientabile (lampadina ad incandescenza) con interuttore individuale e diffusore aria orientabile 3D. I moduli di diffusione aria/luce sono combinabili a piacere.</span></p>\n","product_description_en":"<p>Flat double seat modules with fix light (filament bulb lamp only) and on/off switches, 3D adjustable air diffuser. Lighting and ventilation units could be combined. On demand and configurated with double light or double air or light and air unit.</p>\n","product_variants":"66929,66939,66919,67209,66470","index_order":"07_01_05","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P390.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/97"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=97"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":93,"date":"2017-04-14T10:23:41","date_gmt":"2017-04-14T08:23:41","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=93"},"modified":"2023-10-02T11:49:38","modified_gmt":"2023-10-02T09:49:38","slug":"p235","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p235/","title":{"rendered":"P235"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p235","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":51,"post_author":"1","post_date":"2017-04-11 12:47:58","post_date_gmt":"2017-04-11 10:47:58","post_content":"","post_title":"Multiset","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"multiset","to_ping":"","pinged":"","post_modified":"2020-02-14 16:48:45","post_modified_gmt":"2020-02-14 15:48:45","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=51","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Modulo di servizio","product_name_en":"Multiset","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Modulo di ventilazione con diffusori aria orientabili 3D.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Modulo di ventilazione con diffusori aria orientabili 3D.</span></p>\n","product_description_en":"<p>Flat double seat 3D adjustable air diffuser module.</p>\n","product_variants":"67467","index_order":"07_01_08","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P235.pdf","documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/93"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=93"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":92,"date":"2017-04-14T10:23:25","date_gmt":"2017-04-14T08:23:25","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=92"},"modified":"2023-10-02T11:48:48","modified_gmt":"2023-10-02T09:48:48","slug":"p234","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p234/","title":{"rendered":"P234"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p234","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":51,"post_author":"1","post_date":"2017-04-11 12:47:58","post_date_gmt":"2017-04-11 10:47:58","post_content":"","post_title":"Multiset","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"multiset","to_ping":"","pinged":"","post_modified":"2020-02-14 16:48:45","post_modified_gmt":"2020-02-14 15:48:45","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=51","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Modulo di servizio","product_name_en":"Multiset","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Modulo di ventilazione con diffusori aria orientabili 2D.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Modulo di ventilazione con diffusori aria orientabili 2D.</span></p>\n","product_description_en":"<p>Flat double seat 2D adjustable air diffuser module.</p>\n","product_variants":"67447,67457","index_order":"07_01_07","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P234.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/92"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=92"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":88,"date":"2017-04-14T10:21:54","date_gmt":"2017-04-14T08:21:54","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=88"},"modified":"2023-10-02T11:47:59","modified_gmt":"2023-10-02T09:47:59","slug":"p160","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p160/","title":{"rendered":"P160"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p160","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":51,"post_author":"1","post_date":"2017-04-11 12:47:58","post_date_gmt":"2017-04-11 10:47:58","post_content":"","post_title":"Multiset","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"multiset","to_ping":"","pinged":"","post_modified":"2020-02-14 16:48:45","post_modified_gmt":"2020-02-14 15:48:45","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=51","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Modulo di servizio","product_name_en":"Multiset","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Modulo di servizio singolo con interuttore individuale e diffusori aria orientabili 2D, su richiesta possono essere forniti con luci LED&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Modulo di servizio singolo con interuttore individuale e diffusori aria orientabili 2D, su richiesta possono essere forniti con luci LED.</span></p>\n","product_description_en":"<p>Single seat multiset with adjustable light with on/off switch and 2D adjustable air diffuser. On demand it could be supplied with LED lamps.</p>\n","product_variants":"65157,60128,64859,68621,69341,66926","index_order":"07_01_06","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P160.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/88"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=88"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":87,"date":"2017-04-14T10:21:35","date_gmt":"2017-04-14T08:21:35","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=87"},"modified":"2023-10-05T12:35:36","modified_gmt":"2023-10-05T10:35:36","slug":"p159","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p159/","title":{"rendered":"P159_type 2"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p159_type2","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":51,"post_author":"1","post_date":"2017-04-11 12:47:58","post_date_gmt":"2017-04-11 10:47:58","post_content":"","post_title":"Multiset","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"multiset","to_ping":"","pinged":"","post_modified":"2020-02-14 16:48:45","post_modified_gmt":"2020-02-14 15:48:45","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=51","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Altoparlanti","product_name_en":"Loudspeaker","product_image":{"ID":1830,"id":1830,"title":"p159_imm_9449","filename":"p159_imm_9449.jpg","url":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p159_imm_9449.jpg","alt":"","author":"1","description":"","caption":"","name":"p159_imm_9449","date":"2023-10-05 10:35:31","modified":"2023-10-05 10:35:34","mime_type":"image/jpeg","type":"image","icon":"https://wp.primaautomotive.it/wp-includes/images/media/default.png","width":2700,"height":2700,"sizes":{"thumbnail":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p159_imm_9449-150x150.jpg","thumbnail-width":150,"thumbnail-height":150,"medium":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p159_imm_9449-300x300.jpg","medium-width":300,"medium-height":300,"medium_large":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p159_imm_9449-768x768.jpg","medium_large-width":525,"medium_large-height":525,"large":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p159_imm_9449-1024x1024.jpg","large-width":525,"large-height":525,"twentyseventeen-featured-image":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p159_imm_9449-2000x1200.jpg","twentyseventeen-featured-image-width":2000,"twentyseventeen-featured-image-height":1200,"twentyseventeen-thumbnail-avatar":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/p159_imm_9449-100x100.jpg","twentyseventeen-thumbnail-avatar-width":100,"twentyseventeen-thumbnail-avatar-height":100}},"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Altoparlante per installazione individuale o in moduli di servizio&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Altoparlante per installazione individuale o in moduli di servizio.</span></p>\n","product_description_en":"<p>Loudspeaker suitbale for stand alone or installation on multisets.</p>\n","product_variants":"69445,65485,64739,65117,67782,68521","index_order":"07_01_12","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P159type1_type2.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/87"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=87"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":86,"date":"2017-04-14T10:21:18","date_gmt":"2017-04-14T08:21:18","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=86"},"modified":"2023-10-02T11:42:02","modified_gmt":"2023-10-02T09:42:02","slug":"p158","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p158/","title":{"rendered":"P158"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p158","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":51,"post_author":"1","post_date":"2017-04-11 12:47:58","post_date_gmt":"2017-04-11 10:47:58","post_content":"","post_title":"Multiset","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"multiset","to_ping":"","pinged":"","post_modified":"2020-02-14 16:48:45","post_modified_gmt":"2020-02-14 15:48:45","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=51","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Modulo di servizio","product_name_en":"Multiset","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Modulo di servizio doppio per autobus turistici. Luce orientabile (lampadina ad incandescenza) con interuttore individuale e diffusore aria orientabile 2D. Su richiesta sono dotabili di puldanti chiamata Hostess e/o fermata, spia rossa di avviso, altoparlante e luci LED.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Modulo di servizio doppio per autobus turistici. Luce orientabile (lampadina ad incandescenza) con interuttore individuale e diffusore aria orientabile 2D. Su richiesta sono dotabili di puldanti chiamata Hostess e/o fermata, spia rossa di avviso, altoparlante e luci LED.</span></p>\n","product_description_en":"<p>Square double seat multiset for coaches. Adjuststable light diffuser (filament bulb lamp) with dedicated on/off switches. 2D adjustable air diffuser. On request may be supplied with Hostess and/or stop call button, loudspeaker, red call request lamp and LED lighting.</p>\n","product_variants":"61601,61611,62869,65837,62351,63583,67407","index_order":"07_01_01","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P158.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/86"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=86"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":85,"date":"2017-04-14T10:20:59","date_gmt":"2017-04-14T08:20:59","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=85"},"modified":"2023-10-02T11:40:06","modified_gmt":"2023-10-02T09:40:06","slug":"p148","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p148/","title":{"rendered":"P148"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p148","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":51,"post_author":"1","post_date":"2017-04-11 12:47:58","post_date_gmt":"2017-04-11 10:47:58","post_content":"","post_title":"Multiset","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"multiset","to_ping":"","pinged":"","post_modified":"2020-02-14 16:48:45","post_modified_gmt":"2020-02-14 15:48:45","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=51","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Modulo di servizio","product_name_en":"Multiset","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Modulo di servizio doppio per autobus turistici. Luce orientabile (lampadina ad incandescenza) con interuttore individuale e diffusore aria orientabile 2D. Su richiesta sono dotabili di puldanti chiamata Hostess e/o fermata, spia rossa di avviso, altoparlante e luci LED.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Modulo di servizio doppio per autobus turistici. Luce orientabile (lampadina ad incandescenza) con interuttore individuale e diffusore aria orientabile 2D. Su richiesta sono dotabili di puldanti chiamata Hostess e/o fermata, spia rossa di avviso, altoparlante e luci LED.</span></p>\n","product_description_en":"<p>Square double seat multiset for coaches. Adjuststable light diffuser (filament bulb lamp) with dedicated on/off switches. 2D adjustable air diffuser. On request may be supplied with Hostess and/or stop call button, loudspeaker, red call request lamp and LED lamps.</p>\n","product_variants":"67393,67403","index_order":"07_01_02","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P148.pdf","product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/85"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=85"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":84,"date":"2017-04-14T10:20:36","date_gmt":"2017-04-14T08:20:36","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=84"},"modified":"2023-10-02T11:37:20","modified_gmt":"2023-10-02T09:37:20","slug":"p140","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p140/","title":{"rendered":"P140"},"content":{"rendered":"<p>p140</p>\n","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p140","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":51,"post_author":"1","post_date":"2017-04-11 12:47:58","post_date_gmt":"2017-04-11 10:47:58","post_content":"","post_title":"Multiset","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"multiset","to_ping":"","pinged":"","post_modified":"2020-02-14 16:48:45","post_modified_gmt":"2020-02-14 15:48:45","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=51","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Modulo di servizio","product_name_en":"Multiset","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Modulo di servizio doppio per autobus turistici. Luce orientabile (lampadina ad incandescenza) con interuttore individuale e diffusore aria orientabile 2D. Su richiesta sono dotabili di puldanti chiamata Hostess e/o fermata, spia rossa di avviso, altoparlante e luci LED.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Modulo di servizio doppio per autobus turistici. Luce orientabile (lampadina ad incandescenza) con interuttore individuale e diffusore aria orientabile 2D. Su richiesta sono dotabili di puldanti chiamata Hostess e/o fermata, spia rossa di avviso, altoparlante e luci LED.</span></p>\n","product_description_en":"<p>Square double seat multiset for coaches. Adjuststable light diffuser (filament bulb lamp) with dedicated on/off switches. 2D adjustable air diffuser. On request may be supplied with Hostess and/or stop call button, red call request lamp and LED lamps.</p>\n","product_variants":"68141,65652,68312,68302,68352,68342","index_order":"07_01_03","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"pdf_manual":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P140.pdf","product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/84"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=84"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":82,"date":"2017-04-14T10:19:55","date_gmt":"2017-04-14T08:19:55","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=82"},"modified":"2023-10-02T11:26:54","modified_gmt":"2023-10-02T09:26:54","slug":"p78r","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p78r/","title":{"rendered":"P78R"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p78_r","category_id":[{"ID":367,"post_author":"1","post_date":"2017-05-19 10:47:33","post_date_gmt":"2017-05-19 08:47:33","post_content":"","post_title":"Moduli di servizio","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"moduli-di-servizio-e-cappelliere","to_ping":"","pinged":"","post_modified":"2023-10-02 12:27:36","post_modified_gmt":"2023-10-02 10:27:36","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=367","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":51,"post_author":"1","post_date":"2017-04-11 12:47:58","post_date_gmt":"2017-04-11 10:47:58","post_content":"","post_title":"Multiset","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"multiset","to_ping":"","pinged":"","post_modified":"2020-02-14 16:48:45","post_modified_gmt":"2020-02-14 15:48:45","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=51","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Modulo di servizio","product_name_en":"Multiset","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Modulo di servizio doppio per minibus e turistici. Luce orientabile (lampadina ad incandescenza) con interuttore individuale e diffusore aria a flusso libero orientabile 3D a 360u00b0. Su richiesta sono dotabili di puldanti chiamata Hostess o fermata, spia rossa di avviso.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Modulo di servizio doppio per minibus e turistici. Luce orientabile (lampadina ad incandescenza) con interuttore individuale e diffusore aria a flusso libero orientabile 3D a 360°. Su richiesta sono dotabili di puldanti chiamata Hostess o fermata, spia rossa di avviso.</span></p>\n","product_description_en":"<p>Square double seat multiset for coaches and minibusses. Adjuststable light diffuser (filament bulb lamp) with dedicated on/off switches. 3D and 360° orientable free flow ball shaped air diffuser. On request may be supplied with Hostess or stop call button and red call request lamp.</p>\n","product_variants":"50971,50981,67907","index_order":"07_01_04","coaches":true,"midi_minibusses":true,"city_busses":false,"off_road_industrial_vehicles":false,"special_vehicles":false,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P78R.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/82"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=82"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":70,"date":"2017-04-12T17:35:31","date_gmt":"2017-04-12T15:35:31","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=70"},"modified":"2023-09-28T16:15:34","modified_gmt":"2023-09-28T14:15:34","slug":"p229","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p229/","title":{"rendered":"P229"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p229","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":25,"post_author":"1","post_date":"2017-04-11 12:09:30","post_date_gmt":"2017-04-11 10:09:30","post_content":"","post_title":"Supporti e snodi per molle a gas","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"supporti-e-snodi-per-molle-a-gas","to_ping":"","pinged":"","post_modified":"2022-10-20 14:08:48","post_modified_gmt":"2022-10-20 12:08:48","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=25","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Supporti e snodi","product_name_en":"Supports and joints","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Snodo sferico per molle a gas.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Snodo sferico per molle a gas.</span></p>\n","product_description_en":"<p>Spherical joint for gas springs.</p>\n","product_variants":"60178","index_order":"08_02_06","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P229.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/70"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=70"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":69,"date":"2017-04-12T17:34:55","date_gmt":"2017-04-12T15:34:55","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=69"},"modified":"2023-09-28T16:14:55","modified_gmt":"2023-09-28T14:14:55","slug":"p224","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p224/","title":{"rendered":"P224"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p224","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":25,"post_author":"1","post_date":"2017-04-11 12:09:30","post_date_gmt":"2017-04-11 10:09:30","post_content":"","post_title":"Supporti e snodi per molle a gas","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"supporti-e-snodi-per-molle-a-gas","to_ping":"","pinged":"","post_modified":"2022-10-20 14:08:48","post_modified_gmt":"2022-10-20 12:08:48","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=25","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Supporti e snodi","product_name_en":"Supports and joints","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Snodo in alluminio per molle a gas&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Snodo in alluminio per molle a gas.</span></p>\n","product_description_en":"<p>Aluminium joint for gas springs.</p>\n","product_variants":"60168","index_order":"08_02_01","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P224.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/69"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=69"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":68,"date":"2017-04-12T17:34:16","date_gmt":"2017-04-12T15:34:16","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=68"},"modified":"2023-09-28T16:13:55","modified_gmt":"2023-09-28T14:13:55","slug":"p223","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p223/","title":{"rendered":"P223"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p223","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":25,"post_author":"1","post_date":"2017-04-11 12:09:30","post_date_gmt":"2017-04-11 10:09:30","post_content":"","post_title":"Supporti e snodi per molle a gas","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"supporti-e-snodi-per-molle-a-gas","to_ping":"","pinged":"","post_modified":"2022-10-20 14:08:48","post_modified_gmt":"2022-10-20 12:08:48","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=25","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Supporto ad angolo","product_name_en":"Supports and joints","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Supporto sferico a 90u00b0 per molle a gas.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Supporto sferico a 90° per molle a gas.</span></p>\n","product_description_en":"<p>90° angled spherical support fo gas springs.</p>\n","product_variants":"69807,69817","index_order":"08_02_08","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P223.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/68"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=68"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":67,"date":"2017-04-12T17:33:50","date_gmt":"2017-04-12T15:33:50","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=67"},"modified":"2023-09-28T15:54:19","modified_gmt":"2023-09-28T13:54:19","slug":"p114","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p114/","title":{"rendered":"P114"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p114","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":25,"post_author":"1","post_date":"2017-04-11 12:09:30","post_date_gmt":"2017-04-11 10:09:30","post_content":"","post_title":"Supporti e snodi per molle a gas","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"supporti-e-snodi-per-molle-a-gas","to_ping":"","pinged":"","post_modified":"2022-10-20 14:08:48","post_modified_gmt":"2022-10-20 12:08:48","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=25","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Snodo","product_name_en":"Supports and joints","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Supporto sferico per molle a gas&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Supporto sferico per molle a gas</span></p>\n","product_description_en":"<p>Spherical support for gas springs.</p>\n","product_variants":"65517","index_order":"08_02_07","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P114.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/67"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=67"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":66,"date":"2017-04-12T17:33:02","date_gmt":"2017-04-12T15:33:02","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=66"},"modified":"2023-09-28T15:53:13","modified_gmt":"2023-09-28T13:53:13","slug":"p101","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p101/","title":{"rendered":"P101"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p101","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":25,"post_author":"1","post_date":"2017-04-11 12:09:30","post_date_gmt":"2017-04-11 10:09:30","post_content":"","post_title":"Supporti e snodi per molle a gas","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"supporti-e-snodi-per-molle-a-gas","to_ping":"","pinged":"","post_modified":"2022-10-20 14:08:48","post_modified_gmt":"2022-10-20 12:08:48","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=25","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Supporti e snodi","product_name_en":"Supports and joints","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Supporto in plastica per molle a gas.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Supporto in plastica per molle a gas.</span></p>\n","product_description_en":"<p>Plastic support for gas springs.</p>\n","product_variants":"52110,65831","index_order":"08_02_05","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P101.pdf","pdf_manual":false,"documenti_allegati":false,"product_name_ru":"","product_description_ru":"","product_with_jok_system":""},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/66"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=66"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":65,"date":"2017-04-12T17:32:19","date_gmt":"2017-04-12T15:32:19","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=65"},"modified":"2023-09-28T15:51:18","modified_gmt":"2023-09-28T13:51:18","slug":"p100","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p100/","title":{"rendered":"P100"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p100","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":25,"post_author":"1","post_date":"2017-04-11 12:09:30","post_date_gmt":"2017-04-11 10:09:30","post_content":"","post_title":"Supporti e snodi per molle a gas","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"supporti-e-snodi-per-molle-a-gas","to_ping":"","pinged":"","post_modified":"2022-10-20 14:08:48","post_modified_gmt":"2022-10-20 12:08:48","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=25","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Supporti e snodi","product_name_en":"Supports and joints","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Snodo in plastica per molle a gas.&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Snodo in plastica per molle a gas.</span></p>\n","product_description_en":"<p>Plastic joint for gas springs.</p>\n","product_variants":"52100","index_order":"08_02_04","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P100.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/65"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=65"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":64,"date":"2017-04-12T17:31:37","date_gmt":"2017-04-12T15:31:37","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=64"},"modified":"2023-09-28T15:49:43","modified_gmt":"2023-09-28T13:49:43","slug":"p93","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p93/","title":{"rendered":"P93"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p93","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":25,"post_author":"1","post_date":"2017-04-11 12:09:30","post_date_gmt":"2017-04-11 10:09:30","post_content":"","post_title":"Supporti e snodi per molle a gas","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"supporti-e-snodi-per-molle-a-gas","to_ping":"","pinged":"","post_modified":"2022-10-20 14:08:48","post_modified_gmt":"2022-10-20 12:08:48","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=25","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Supporti e snodi","product_name_en":"Supports and joints","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Supporto per molle a gas&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Supporto per molle a gas.</span></p>\n","product_description_en":"<p>Support for gas springs.</p>\n","product_variants":"69797","index_order":"08_02_03","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P93.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/64"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=64"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":63,"date":"2017-04-12T17:31:00","date_gmt":"2017-04-12T15:31:00","guid":{"rendered":"http://wp.primaautomotive.it/wordpress/?post_type=products&#038;p=63"},"modified":"2023-09-28T15:47:16","modified_gmt":"2023-09-28T13:47:16","slug":"p89","status":"publish","type":"products","link":"https://wp.primaautomotive.it/products/p89/","title":{"rendered":"P89"},"content":{"rendered":"","protected":false},"featured_media":0,"template":"","acf":{"product_id":"p89","category_id":[{"ID":23,"post_author":"1","post_date":"2017-04-11 12:06:27","post_date_gmt":"2017-04-11 10:06:27","post_content":"","post_title":"Sistemi e componenti per portelloni bus","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"sistemi-e-componenti-di-chiusura","to_ping":"","pinged":"","post_modified":"2024-01-30 15:47:38","post_modified_gmt":"2024-01-30 14:47:38","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=product_categories&#038;p=23","menu_order":0,"post_type":"product_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"sub_category_id":[{"ID":25,"post_author":"1","post_date":"2017-04-11 12:09:30","post_date_gmt":"2017-04-11 10:09:30","post_content":"","post_title":"Supporti e snodi per molle a gas","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"supporti-e-snodi-per-molle-a-gas","to_ping":"","pinged":"","post_modified":"2022-10-20 14:08:48","post_modified_gmt":"2022-10-20 12:08:48","post_content_filtered":"","post_parent":0,"guid":"http://wp.primaautomotive.it/wordpress/?post_type=sub_categories&#038;p=25","menu_order":0,"post_type":"sub_categories","post_mime_type":"","comment_count":"0","filter":"raw"}],"product_name_it":"Supporti e snodi","product_name_en":"Supports and joints","product_image":false,"product_description_it":"<p><span data-sheets-value=\"{&quot;1&quot;:2,&quot;2&quot;:&quot;Snodo in plastica per molle a gas&quot;}\" data-sheets-userformat=\"{&quot;2&quot;:2817,&quot;3&quot;:[null,0],&quot;11&quot;:4,&quot;12&quot;:0,&quot;14&quot;:[null,2,6989903]}\">Snodo in plastica per molle a gas.</span></p>\n","product_description_en":"<p>Plastic joint for gas springs.</p>\n","product_variants":"66737","index_order":"08_02_02","coaches":true,"midi_minibusses":true,"city_busses":true,"off_road_industrial_vehicles":true,"special_vehicles":true,"underground_rail_railways":false,"beauty_wellness_equipments":false,"product_name_ru":"","product_description_ru":"","scheda_prodotto_pdf":"https://wp.primaautomotive.it/wp-content/uploads/2017/04/P89.pdf","pdf_manual":false,"product_with_jok_system":"","documenti_allegati":false},"_links":{"self":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products/63"}],"collection":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/products"}],"about":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/types/products"}],"wp:attachment":[{"href":"https://wp.primaautomotive.it/wp-json/wp/v2/media?parent=63"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}}]

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {$(document).ready( function() {
	
		// Product page
		$('#ask-product-infos-top').click( function(e) {
	
			dataLayer.push({
				event: "ask-product-infos-top",
				event_category: "cta",
				event_label: $('h2').text() + "-" + $('html').prop("lang")
		 	});
	
			ym(57269581, 'reachGoal', 'ask-product-infos-top', {
				category: 'cta',
				lang: $('html').prop("lang"),
				product: $('h2').text(),
			});
	
		})
	
		$('#ask-product-infos-bottom').click( function(e) {
	
			dataLayer.push({
				event: "ask-product-infos-bottom",
				event_category: "cta",
				event_label: $('h2').text() + "-" + $('html').prop("lang"),
		 	});
	
			ym(57269581, 'reachGoal', 'ask-product-infos-bottom', {
				category: 'cta',
				lang: $('html').prop("lang"),
				product: $('h2').text(),
			});
	
		})
	
	
		/*
		 * Contatti
		 */
		$('a[href^="mailto:"]').click( function(e) {
	
			var email = $(this).prop('href').replace("mailto:", "");
	
			dataLayer.push({
				event: "click-mailto-link",
				event_category: "contacts",
				event_label: email + " - " + $('html').prop("lang"),
		 	});
	
			ym(57269581, 'reachGoal', 'click-mailto-link', {
				category: "contacts",
				lang: $('html').prop("lang"),
				email: email + " - " + $('html').prop("lang"),
			});
	
		});
	
		// Contact page events in _contact.js
	
	
		/*
		 * Documents download
		 */
	
		// tech sheet
		$('.dl-tech-sheet').click( function(e) {
	
			var filename = $(this).prop('href').split('/').pop();
	
			dataLayer.push({
				event: "dl-tech-sheet",
				event_category: "doc-download",
				event_label: filename + " - " + $('html').prop("lang"),
		 	});
	
			ym(57269581, 'reachGoal', 'dl-tech-sheet', {
				category: "doc-download",
				lang: $('html').prop("lang"),
				filename: filename
			});
	
		});
	
		// dl-manual
		$('.dl-manual').click( function(e) {
	
			var filename = $(this).prop('href').split('/').pop();
	
			dataLayer.push({
				event: "dl-manual",
				event_category: "doc-download",
				event_label: filename + " - " + $('html').prop("lang"),
		 	});
	
			ym(57269581, 'reachGoal', 'dl-manual', {
				category: "doc-download",
				lang: $('html').prop("lang"),
				filename: filename
			});
	
		});
	
		// dl-additional-document
		$('.dl-additional-document').click( function(e) {
	
			var filename = $(this).prop('href').split('/').pop();
	
			dataLayer.push({
				event: "dl-additional-document",
				event_category: "doc-download",
				event_label: filename + " - " + $('html').prop("lang"),
		 	});
	
			ym(57269581, 'reachGoal', 'dl-additional-document', {
				category: "doc-download",
				lang: $('html').prop("lang"),
				filename: filename
			});
	
		});
	
		// dl-regulations
		$('.dl-regulations').click( function(e) {
	
			var filename = $(this).prop('href').split('/').pop();
	
			dataLayer.push({
				event: "dl-regulations",
				event_category: "doc-download",
				event_label: filename + " - " + $('html').prop("lang"),
		 	});
	
			ym(57269581, 'reachGoal', 'dl-regulations', {
				category: "doc-download",
				lang: $('html').prop("lang"),
				filename: filename
			});
	
		});
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {$(document).ready( function() {
	
		$('.view-more-butt').click( function() {
			$('.view-more').toggle();
			$('.view-more-butt label.more').toggle();
			$('.view-more-butt label.less').toggle();
		} );
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {$(document).ready(function() {
	
		$("#send-email").on("click tap", function() {
	
			var lang = window.location.pathname.split("/")[1].toLowerCase();
	
			var name = $("#name").val();
			if (name == "") {
				$("#name").addClass("error");
				return;
			}
	
			var surname = $("#surname").val();
			if (surname == "") {
				$("#surname").addClass("error");
				return;
			}
	
			var email = $("#email").val();
			if (!validateEmail(email)) {
				$("#email").addClass("error");
				return;
			}
	
			var city = $("#city").val();
			if (city == "") {
				$("#city").addClass("error");
				return;
			}
	
			var cap = $("#cap").val();
	
			var nation = $("#nation").val();
			if (nation == "") {
				$("#nation").addClass("error");
				return;
			}
	
			var company = $("#company").val();
	
			var website = $("#website").val();
	
			var obj = $(".box-product-navigator .active").data("type");
	
			if (obj == "") {
				$(".product-navigator").addClass("error");
				return;
			} else {
				switch (obj) {
					case "job":
						email_to = "info";
						obj = "Candidatura da sito da sito";
						break;
					case "support":
						email_to = "info";
						obj = "Richiesta supporto tecnico da sito";
						break;
					case "prod":
						email_to = "info";
						obj =
							"Richiesta informazioni prodotto " +
							$(".box-product-navigator .active").data("prod") +
							" da sito";
						break;
					case "general":
						email_to = "info";
						obj = "Richiesta informazioni generali da sito";
						break;
					case "proposal":
						email_to = "info";
						obj = "Proposta di collaborazione";
						break;
					default:
				}
			}
	
			var text = $("#form-contact-text").val();
	
			if (text == "") {
				$("#form-contact-text").addClass("error");
				return;
			}
	
			if (!$(".privacy .check-privacy").hasClass("active")) {
				$(".alert-error-privacy")
					.fadeIn()
					.css("display", "flex");
				return console.log("not privacy");
			}
			$(".alert-error-privacy").fadeOut();
	
			if ($(".privacy .check-newsletter").hasClass("active")) {
				// subscribeToMail(email);
			}
	
			grecaptcha.execute('6LdmYdUUAAAAABRYbbWo1MaE-wSfGzijyc-Q9QGo', {action: 'submit_contact_form'}).then(function(token) {
	
				var dataEmail = {
					name: name,
					surname: surname,
					nation: nation,
					company: company,
					city: city,
					cap: cap,
					email: email,
					website: website,
					email_to: email_to,
					obj: obj,
					text: text,
					token: token,
				};
	
				$.post("/send-mail", dataEmail, function(success) {
	
					if(success) {
	
						dataLayer.push({
							event: "form-message-sent",
							event_category: "contact-form",
							event_label: $("#email").val() + "-" + $('html').prop("lang"),
						});
	
					} else {
	
						dataLayer.push({
							event: "form-message-blocked",
							event_category: "contact-form",
							event_label: $("#email").val() + "-" + $('html').prop("lang"),
						});
	
					}
	
					// reset form
					$("#name").val("");
					$("#surname").val("");
					$("#nation").val("");
					$("#company").val("");
					$("#email").val("");
					$("#website").val("");
					$("#city").val("");
					$("#cap").val("");
	
					$("#form-contact-text").val("");
					$('.check-privacy').removeClass('active');
					// $('.check-newsletter').removeClass('active');
					$(".success")
					.fadeIn()
					.delay(15000)
					.fadeOut();
	
				});
	
			});
	
		});
	
		$("#section-contact input, #form-contact-text").on("focus", function() {
			$(this).removeClass("error");
		});
	});
	
	function validateEmail(email) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}
	
	function subscribeToMail(email) {
		var lang = window.location.pathname.split("/")[1].toLowerCase();
		$.post(
			"/mail-list/subscribe",
			{
				email: email,
				lang: lang
			},
			function(data) {}
		);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {$(document).ready(function() {
		if (!localStorage.cookies && localStorage.cookies != "false") {
			$(".cookie-box").fadeIn();
		} else {
			$(".cookie-box").css("display", "none");
			if (localStorage.cookies == "true") {
				dataLayer.push({ event: "cookieConsentGiven" });
			}
		}
	
		$(".privacy").click(function() {
			if (
				$(this)
					.children(".checkbox")
					.hasClass("tech-cookies")
			) {
				return; // non si può deselezionare i tech cookies
			}
			if (
				$(this)
					.children(".checkbox")
					.hasClass("active")
			) {
				$(this)
					.children(".checkbox")
					.removeClass("active");
			} else {
				$(this)
					.children(".checkbox")
					.addClass("active");
			}
		});
	
		$(".cookie-btn").on("click tap", function() {
			var check = false;
			$(".cookie-box .third-party-cookies").each(function() {
				if ($(this).hasClass("active")) {
					check = true;
				}
			});
			if (check) {
				console.log("check");
				$(".cookie-box").fadeOut();
				localStorage.cookies = true;
				dataLayer.push({ event: "cookieConsentGiven" });
			} else {
				$(".cookie-box").fadeOut();
				localStorage.cookies = false;
			}
		});
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {$(document).ready(function() {
	
	  var mySwiper = new Swiper('.swiper-container', {
	    // Optional parameters
	    direction: 'horizontal',
	    loop: true,
	    autoplay: 3000,
	    autoplayDisableOnInteraction: true,
	    pagination: '.swiper-pagination',
	  });
	
	  var sub_header_height =
	    $('#sub-header-text-section').height() +
	    parseInt($('#sub-header-text-section').css('marginTop')) * 2;
	  var main_header_height =
	    $(window).height() -
	    sub_header_height -
	    parseInt($('.main-header').css('margin-top'));
	  $('.main-header').height(main_header_height);
	
	  squareBoxCategorySubclasses();
	  if ($(window).width() < 1200 || $('nav').hasClass('nav-fullscreen')) {
	    positionSubNavDesktop(true);
	  } else {
	    positionSubNavDesktop();
	  }
	  $('#product-class .box-category').on('click tap', function(e) {
	    var $this = $(this);
	    if ($(window).width() < 1100) {
	      if (!$this.hasClass('open-box')) {
	        e.preventDefault();
	      }
	
	      console.log('add Open');
	
	      $('#product-class .box-category').each(function() {
	        if ($(window).width() < 768) {
	          $(this).removeClass('open-mobile');
	          $(this).height(heightCategoryBoxTitle);
	        }
	
	        $(this).removeClass('open-box');
	      });
	      $this.addClass('open-box');
	      $this.height($('#product-class .box-category').width());
	    }
	  });
	});
	
	$(window).on('resize', function() {
	  squareBoxCategorySubclasses();
	
	  positionSubNavDesktop();
	});
	const heightCategoryBoxTitle = 99;
	function squareBoxCategorySubclasses() {
	  var height = $('#product-class .box-category').width();
	  if ($(window).width() < 768) {
	    height = heightCategoryBoxTitle;
	  }
	  $('#product-class .box-category').each(function() {
	    $(this).height(height);
	  });
	}
	
	// $(document).on('scroll', function() {
	//   if ($('nav').hasClass('nav-fullscreen') && !$('nav').hasClass('product')) {
	//     if ($(document).scrollTop() < 200) {
	//       //$('nav').removeClass('nav-fullscreen');
	//       setTimeout(function() {
	//         positionSubNavDesktop();
	//       }, 350);
	//     }
	//     return;
	//   }
	//   if ($(document).scrollTop() > 200 && !$('nav').hasClass('product')) {
	//     //$('nav').addClass('nav-fullscreen');
	//     setTimeout(function() {
	
	//       positionSubNavDesktop(true);
	//     }, 350);
	//   }
	// });
	
	var dropBox = '';
	var $ancorLiNav = $();
	var close_search_timeout;
	
	$('.link-container-desktop li.dropdown').hover(
	  function() {
	    dropBox = $(this).data('dropdown');
	    $ancorLiNav = $(this);
	
	    close_search_timeout = setTimeout(function() {
	      $('.search-container').removeClass('open');
	      $('.back-black').fadeOut('fast');
	    }, 200);
	
	    $('nav .sub-nav ul').each(function() {
	      $(this);
	    });
	    $ancorLiNav.addClass('hover');
	
	    if ($ancorLiNav.hasClass('dropdown')) {
	      $('nav .sub-nav ' + dropBox).addClass('active');
	    }
	  },
	  function() {
	    if (close_search_timeout) clearTimeout(close_search_timeout);
	
	    $(this).removeClass('hover');
	    dropBox = $(this).data('dropdown');
	    $('nav .sub-nav ' + dropBox).removeClass('active');
	  }
	);
	
	$('.sub-nav ul').hover(
	  function() {
	    $('nav .sub-nav ' + dropBox).addClass('active');
	    $ancorLiNav.addClass('hover');
	  },
	  function() {
	    $ancorLiNav.removeClass('hover');
	    if ($('nav .sub-nav ' + dropBox).hasClass('active')) {
	      if (!$('nav .sub-nav').hasClass('open')) {
	        $('nav .sub-nav ' + dropBox).removeClass('active');
	      }
	    }
	  }
	);
	
	// NAV MOBILE EVENT
	$('nav .hamb-icon').on('click tap', function() {
	  if ($(this).hasClass('open')) {
	    $('.nav-collapse').removeClass('visible');
	    $(this).attr('src', '/spike-compiled/img/icon/prima-automotive-hamb.png');
	    $(this).removeClass('open');
	  } else {
	    $('.nav-collapse').addClass('visible');
	    $(this).attr('src', '/spike-compiled/img/icon/prima-automotive-close.png');
	    $(this).addClass('open');
	  }
	});
	
	$('.nav-collapse .dropdown-mobile').on('click tap', function(e) {
	  e.preventDefault();
	  var $this = $(this);
	  if ($this.hasClass('open')) {
	    window.location = $(this)
	      .children()
	      .attr('href');
	    $this.removeClass('open');
	    $this.children('.dropdown-box').removeClass('open');
	    $('.nav-collapse .link-list-nav-mobile').removeClass(
	      'open-children-dropdown'
	    );
	    return;
	  }
	  $('.nav-collapse .dropdown-mobile').each(function() {
	    $(this).removeClass('open');
	    $(this)
	      .children('.dropdown-box')
	      .removeClass('open');
	  });
	  $this.addClass('open');
	  $('.nav-collapse .link-list-nav-mobile').addClass('open-children-dropdown');
	  $this.children('.dropdown-box').addClass('open');
	});
	$('.nav-collapse .dropdown-mobile .category-mobile').on('click tap', function(
	  e
	) {
	  console.log(
	    $(this)
	      .children()
	      .attr('href')
	  );
	  window.location = $(this)
	    .children()
	    .attr('href');
	});
	
	function positionSubNavDesktop(full) {
	  $('.link-container-desktop li').each(function() {
	    $li = $(this);
	    var offsetLeft = $li.offset().left;
	    var idDropdown = $li.data('dropdown');
	    var liWidth = $li.width();
	    var margin = 0;
	    // if (!full) {
	    //   margin = offsetLeft - 100 - 160 + liWidth / 2;
	    // } else {
	    margin = offsetLeft - 160 + liWidth / 2;
	    // }
	    // if ($(window).width() == ($('nav .nav-container').width() + 100))
	
	    $('.sub-nav ' + idDropdown).css('margin-left', margin);
	  });
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {function validateEmail(email) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}
	$(document).ready(function() {
		var lang = window.location.pathname.split("/")[1].toLowerCase();
	
		$("#submit-contact-form").on("click tap", function() {
			var email = $("#mail-contact").val();
			var text = "";
			var classError = "";
			if (validateEmail(email)) {
				console.log(email);
				$.post(
					"/mail-list/subscribe",
					{
						email: email,
						lang: lang
					},
					function(data) {
						console.log(data);
						var res = JSON.parse(data);
						console.log(typeof res, res.status);
						classError = "green";
						switch (res.status) {
							case "subscribed":
								switch (lang) {
									case "it":
										text =
											"Ti sei registrato correttamente alla newsletter della Prima Automotive!";
										break;
									case "en":
										console.log("RESPO true");
										text =
											"You have registered correctly with Prima Automotive newsletters!";
										break;
									default:
								}
								break;
							case 400:
								switch (lang) {
									case "it":
										text = "Sei già iscritto alla newsletter!";
										break;
									case "en":
										text = email + " is already a member of newsletter";
										break;
									default:
								}
							default:
						}
						$(".footer-box-contacts .error").removeClass("red green");
						$(".footer-box-contacts .error").addClass(classError);
						$(".footer-box-contacts .error span").text(text);
					}
				);
			} else {
				//email non valida
				classError = "red";
	
				switch (lang) {
					case "it":
						text = "Email non valida";
						break;
					case "en":
						text = "Invalid Email";
						break;
					default:
				}
			}
			console.log(classError, text);
			$(".footer-box-contacts .error").removeClass("red green");
			$(".footer-box-contacts .error").addClass(classError);
			$(".footer-box-contacts .error span").text(text);
		});
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!***************************************************
	 * mark.js v8.9.0
	 * https://github.com/julmot/mark.js
	 * Copyright (c) 2014–2017, Julian Motz
	 * Released under the MIT license https://git.io/vwTVl
	 *****************************************************/
	"use strict";function _classCallCheck(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")}var _extends=Object.assign||function(a){for(var b=1;b<arguments.length;b++){var c=arguments[b];for(var d in c)Object.prototype.hasOwnProperty.call(c,d)&&(a[d]=c[d])}return a},_createClass=function(){function a(a,b){for(var c=0;c<b.length;c++){var d=b[c];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(a,d.key,d)}}return function(b,c,d){return c&&a(b.prototype,c),d&&a(b,d),b}}(),_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&"function"==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?"symbol":typeof a};!function(a,b,c){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function(d){return a(b,c,d)}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"===("undefined"==typeof module?"undefined":_typeof(module))&&module.exports?module.exports=a(b,c,require("jquery")):a(b,c,jQuery)}(function(a,b,c){var d=function(){function c(b){_classCallCheck(this,c),this.ctx=b,this.ie=!1;var d=a.navigator.userAgent;(d.indexOf("MSIE")>-1||d.indexOf("Trident")>-1)&&(this.ie=!0)}return _createClass(c,[{key:"log",value:function a(b){var c=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"debug",a=this.opt.log;this.opt.debug&&"object"===("undefined"==typeof a?"undefined":_typeof(a))&&"function"==typeof a[c]&&a[c]("mark.js: "+b)}},{key:"escapeStr",value:function(a){return a.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&")}},{key:"createRegExp",value:function(a){return"disabled"!==this.opt.wildcards&&(a=this.setupWildcardsRegExp(a)),a=this.escapeStr(a),Object.keys(this.opt.synonyms).length&&(a=this.createSynonymsRegExp(a)),this.opt.ignoreJoiners&&(a=this.setupIgnoreJoinersRegExp(a)),this.opt.diacritics&&(a=this.createDiacriticsRegExp(a)),a=this.createMergedBlanksRegExp(a),this.opt.ignoreJoiners&&(a=this.createIgnoreJoinersRegExp(a)),"disabled"!==this.opt.wildcards&&(a=this.createWildcardsRegExp(a)),a=this.createAccuracyRegExp(a)}},{key:"createSynonymsRegExp",value:function(a){var b=this.opt.synonyms,c=this.opt.caseSensitive?"":"i";for(var d in b)if(b.hasOwnProperty(d)){var e=b[d],f="disabled"!==this.opt.wildcards?this.setupWildcardsRegExp(d):this.escapeStr(d),g="disabled"!==this.opt.wildcards?this.setupWildcardsRegExp(e):this.escapeStr(e);""!==f&&""!==g&&(a=a.replace(new RegExp("("+f+"|"+g+")","gm"+c),"("+f+"|"+g+")"))}return a}},{key:"setupWildcardsRegExp",value:function(a){return a=a.replace(/(?:\\)*\?/g,function(a){return"\\"===a.charAt(0)?"?":""}),a.replace(/(?:\\)*\*/g,function(a){return"\\"===a.charAt(0)?"*":""})}},{key:"createWildcardsRegExp",value:function(a){var b="withSpaces"===this.opt.wildcards;return a.replace(/\u0001/g,b?"[\\S\\s]?":"\\S?").replace(/\u0002/g,b?"[\\S\\s]*?":"\\S*")}},{key:"setupIgnoreJoinersRegExp",value:function(a){return a.replace(/[^(|)\\]/g,function(a,b,c){var d=c.charAt(b+1);return/[(|)\\]/.test(d)||""===d?a:a+"\0"})}},{key:"createIgnoreJoinersRegExp",value:function(a){return a.split("\0").join("[\\u00ad|\\u200b|\\u200c|\\u200d]?")}},{key:"createDiacriticsRegExp",value:function(a){var b=this.opt.caseSensitive?"":"i",c=this.opt.caseSensitive?["aàáâãäåāąă","AÀÁÂÃÄÅĀĄĂ","cçćč","CÇĆČ","dđď","DĐĎ","eèéêëěēę","EÈÉÊËĚĒĘ","iìíîïī","IÌÍÎÏĪ","lł","LŁ","nñňń","NÑŇŃ","oòóôõöøō","OÒÓÔÕÖØŌ","rř","RŘ","sšśșş","SŠŚȘŞ","tťțţ","TŤȚŢ","uùúûüůū","UÙÚÛÜŮŪ","yÿý","YŸÝ","zžżź","ZŽŻŹ"]:["aàáâãäåāąăAÀÁÂÃÄÅĀĄĂ","cçćčCÇĆČ","dđďDĐĎ","eèéêëěēęEÈÉÊËĚĒĘ","iìíîïīIÌÍÎÏĪ","lłLŁ","nñňńNÑŇŃ","oòóôõöøōOÒÓÔÕÖØŌ","rřRŘ","sšśșşSŠŚȘŞ","tťțţTŤȚŢ","uùúûüůūUÙÚÛÜŮŪ","yÿýYŸÝ","zžżźZŽŻŹ"],d=[];return a.split("").forEach(function(e){c.every(function(c){if(c.indexOf(e)!==-1){if(d.indexOf(c)>-1)return!1;a=a.replace(new RegExp("["+c+"]","gm"+b),"["+c+"]"),d.push(c)}return!0})}),a}},{key:"createMergedBlanksRegExp",value:function(a){return a.replace(/[\s]+/gim,"[\\s]+")}},{key:"createAccuracyRegExp",value:function(a){var b=this,c="!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~¡¿",d=this.opt.accuracy,e="string"==typeof d?d:d.value,f="string"==typeof d?[]:d.limiters,g="";switch(f.forEach(function(a){g+="|"+b.escapeStr(a)}),e){case"partially":default:return"()("+a+")";case"complementary":return g="\\s"+(g?g:this.escapeStr(c)),"()([^"+g+"]*"+a+"[^"+g+"]*)";case"exactly":return"(^|\\s"+g+")("+a+")(?=$|\\s"+g+")"}}},{key:"getSeparatedKeywords",value:function(a){var b=this,c=[];return a.forEach(function(a){b.opt.separateWordSearch?a.split("/,| /").forEach(function(a){a.trim()&&c.indexOf(a)===-1&&c.push(a)}):a.trim()&&c.indexOf(a)===-1&&c.push(a)}),{keywords:c.sort(function(a,b){return b.length-a.length}),length:c.length}}},{key:"getTextNodes",value:function(a){var b=this,c="",d=[];this.iterator.forEachNode(NodeFilter.SHOW_TEXT,function(a){d.push({start:c.length,end:(c+=a.textContent).length,node:a})},function(a){return b.matchesExclude(a.parentNode)?NodeFilter.FILTER_REJECT:NodeFilter.FILTER_ACCEPT},function(){a({value:c,nodes:d})})}},{key:"matchesExclude",value:function(a){return e.matches(a,this.opt.exclude.concat(["script","style","title","head","html"]))}},{key:"wrapRangeInTextNode",value:function(a,c,d){var e=this.opt.element?this.opt.element:"mark",f=a.splitText(c),g=f.splitText(d-c),h=b.createElement(e);return h.setAttribute("data-markjs","true"),this.opt.className&&h.setAttribute("class",this.opt.className),h.textContent=f.textContent,f.parentNode.replaceChild(h,f),g}},{key:"wrapRangeInMappedTextNode",value:function(a,b,c,d,e){var f=this;a.nodes.every(function(g,h){var i=a.nodes[h+1];if("undefined"==typeof i||i.start>b){var j=function(){if(!d(g.node))return{v:!1};var i=b-g.start,j=(c>g.end?g.end:c)-g.start,k=a.value.substr(0,g.start),l=a.value.substr(j+g.start);return g.node=f.wrapRangeInTextNode(g.node,i,j),a.value=k+l,a.nodes.forEach(function(b,c){c>=h&&(a.nodes[c].start>0&&c!==h&&(a.nodes[c].start-=j),a.nodes[c].end-=j)}),c-=j,e(g.node.previousSibling,g.start),c>g.end?void(b=g.end):{v:!1}}();if("object"===("undefined"==typeof j?"undefined":_typeof(j)))return j.v}return!0})}},{key:"wrapMatches",value:function(a,b,c,d,e){var f=this,g=0===b?0:b+1;this.getTextNodes(function(b){b.nodes.forEach(function(b){b=b.node;for(var e=void 0;null!==(e=a.exec(b.textContent))&&""!==e[g];)if(c(e[g],b)){var h=e.index;if(0!==g)for(var i=1;i<g;i++)h+=e[i].length;b=f.wrapRangeInTextNode(b,h,h+e[g].length),d(b.previousSibling),a.lastIndex=0}}),e()})}},{key:"wrapMatchesAcrossElements",value:function(a,b,c,d,e){var f=this,g=0===b?0:b+1;this.getTextNodes(function(b){for(var h=void 0;null!==(h=a.exec(b.value))&&""!==h[g];){var i=h.index;if(0!==g)for(var j=1;j<g;j++)i+=h[j].length;var k=i+h[g].length;f.wrapRangeInMappedTextNode(b,i,k,function(a){return c(h[g],a)},function(b,c){a.lastIndex=c,d(b)})}e()})}},{key:"unwrapMatches",value:function(a){for(var c=a.parentNode,d=b.createDocumentFragment();a.firstChild;)d.appendChild(a.removeChild(a.firstChild));c.replaceChild(d,a),this.ie?this.normalizeTextNode(c):c.normalize()}},{key:"normalizeTextNode",value:function(a){if(a){if(3===a.nodeType)for(;a.nextSibling&&3===a.nextSibling.nodeType;)a.nodeValue+=a.nextSibling.nodeValue,a.parentNode.removeChild(a.nextSibling);else this.normalizeTextNode(a.firstChild);this.normalizeTextNode(a.nextSibling)}}},{key:"markRegExp",value:function(a,b){var c=this;this.opt=b,this.log('Searching with expression "'+a+'"');var d=0,e="wrapMatches",f=function(a){d++,c.opt.each(a)};this.opt.acrossElements&&(e="wrapMatchesAcrossElements"),this[e](a,this.opt.ignoreGroups,function(a,b){return c.opt.filter(b,a,d)},f,function(){0===d&&c.opt.noMatch(a),c.opt.done(d)})}},{key:"mark",value:function(a,b){var c=this;this.opt=b;var d=0,e="wrapMatches",f=this.getSeparatedKeywords("string"==typeof a?[a]:a),g=f.keywords,h=f.length,i=this.opt.caseSensitive?"":"i",j=function a(b){var f=new RegExp(c.createRegExp(b),"gm"+i),j=0;c.log('Searching with expression "'+f+'"'),c[e](f,1,function(a,e){return c.opt.filter(e,b,d,j)},function(a){j++,d++,c.opt.each(a)},function(){0===j&&c.opt.noMatch(b),g[h-1]===b?c.opt.done(d):a(g[g.indexOf(b)+1])})};this.opt.acrossElements&&(e="wrapMatchesAcrossElements"),0===h?this.opt.done(d):j(g[0])}},{key:"unmark",value:function(a){var b=this;this.opt=a;var c=this.opt.element?this.opt.element:"*";c+="[data-markjs]",this.opt.className&&(c+="."+this.opt.className),this.log('Removal selector "'+c+'"'),this.iterator.forEachNode(NodeFilter.SHOW_ELEMENT,function(a){b.unwrapMatches(a)},function(a){var d=e.matches(a,c),f=b.matchesExclude(a);return!d||f?NodeFilter.FILTER_REJECT:NodeFilter.FILTER_ACCEPT},this.opt.done)}},{key:"opt",set:function(b){this._opt=_extends({},{element:"",className:"",exclude:[],iframes:!1,iframesTimeout:5e3,separateWordSearch:!0,diacritics:!0,synonyms:{},accuracy:"partially",acrossElements:!1,caseSensitive:!1,ignoreJoiners:!1,ignoreGroups:0,wildcards:"disabled",each:function(){},noMatch:function(){},filter:function(){return!0},done:function(){},debug:!1,log:a.console},b)},get:function(){return this._opt}},{key:"iterator",get:function(){return this._iterator||(this._iterator=new e(this.ctx,this.opt.iframes,this.opt.exclude,this.opt.iframesTimeout)),this._iterator}}]),c}(),e=function(){function a(b){var c=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],d=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[],e=arguments.length>3&&void 0!==arguments[3]?arguments[3]:5e3;_classCallCheck(this,a),this.ctx=b,this.iframes=c,this.exclude=d,this.iframesTimeout=e}return _createClass(a,[{key:"getContexts",value:function(){var a=void 0,c=[];return a="undefined"!=typeof this.ctx&&this.ctx?NodeList.prototype.isPrototypeOf(this.ctx)?Array.prototype.slice.call(this.ctx):Array.isArray(this.ctx)?this.ctx:"string"==typeof this.ctx?Array.prototype.slice.call(b.querySelectorAll(this.ctx)):[this.ctx]:[],a.forEach(function(a){var b=c.filter(function(b){return b.contains(a)}).length>0;c.indexOf(a)!==-1||b||c.push(a)}),c}},{key:"getIframeContents",value:function(a,b){var c=arguments.length>2&&void 0!==arguments[2]?arguments[2]:function(){},d=void 0;try{var e=a.contentWindow;if(d=e.document,!e||!d)throw new Error("iframe inaccessible")}catch(a){c()}d&&b(d)}},{key:"isIframeBlank",value:function(a){var b="about:blank",c=a.getAttribute("src").trim(),d=a.contentWindow.location.href;return d===b&&c!==b&&c}},{key:"observeIframeLoad",value:function(a,b,c){var d=this,e=!1,f=null,g=function g(){if(!e){e=!0,clearTimeout(f);try{d.isIframeBlank(a)||(a.removeEventListener("load",g),d.getIframeContents(a,b,c))}catch(a){c()}}};a.addEventListener("load",g),f=setTimeout(g,this.iframesTimeout)}},{key:"onIframeReady",value:function(a,b,c){try{"complete"===a.contentWindow.document.readyState?this.isIframeBlank(a)?this.observeIframeLoad(a,b,c):this.getIframeContents(a,b,c):this.observeIframeLoad(a,b,c)}catch(a){c()}}},{key:"waitForIframes",value:function(a,b){var c=this,d=0;this.forEachIframe(a,function(){return!0},function(a){d++,c.waitForIframes(a.querySelector("html"),function(){--d||b()})},function(a){a||b()})}},{key:"forEachIframe",value:function(b,c,d){var e=this,f=arguments.length>3&&void 0!==arguments[3]?arguments[3]:function(){},g=b.querySelectorAll("iframe"),h=g.length,i=0;g=Array.prototype.slice.call(g);var j=function(){--h<=0&&f(i)};h||j(),g.forEach(function(b){a.matches(b,e.exclude)?j():e.onIframeReady(b,function(a){c(b)&&(i++,d(a)),j()},j)})}},{key:"createIterator",value:function(a,c,d){return b.createNodeIterator(a,c,d,!1)}},{key:"createInstanceOnIframe",value:function(b){return new a(b.querySelector("html"),this.iframes)}},{key:"compareNodeIframe",value:function(a,b,c){var d=a.compareDocumentPosition(c),e=Node.DOCUMENT_POSITION_PRECEDING;if(d&e){if(null===b)return!0;var f=b.compareDocumentPosition(c),g=Node.DOCUMENT_POSITION_FOLLOWING;if(f&g)return!0}return!1}},{key:"getIteratorNode",value:function(a){var b=a.previousNode(),c=void 0;return c=null===b?a.nextNode():a.nextNode()&&a.nextNode(),{prevNode:b,node:c}}},{key:"checkIframeFilter",value:function(a,b,c,d){var e=!1,f=!1;return d.forEach(function(a,b){a.val===c&&(e=b,f=a.handled)}),this.compareNodeIframe(a,b,c)?(e!==!1||f?e===!1||f||(d[e].handled=!0):d.push({val:c,handled:!0}),!0):(e===!1&&d.push({val:c,handled:!1}),!1)}},{key:"handleOpenIframes",value:function(a,b,c,d){var e=this;a.forEach(function(a){a.handled||e.getIframeContents(a.val,function(a){e.createInstanceOnIframe(a).forEachNode(b,c,d)})})}},{key:"iterateThroughNodes",value:function(a,b,c,d,e){for(var f=this,g=this.createIterator(b,a,d),h=[],i=[],j=void 0,k=void 0,l=function(){var a=f.getIteratorNode(g);return k=a.prevNode,j=a.node};l();)this.iframes&&this.forEachIframe(b,function(a){return f.checkIframeFilter(j,k,a,h)},function(b){f.createInstanceOnIframe(b).forEachNode(a,c,d)}),i.push(j);i.forEach(function(a){c(a)}),this.iframes&&this.handleOpenIframes(h,a,c,d),e()}},{key:"forEachNode",value:function(a,b,c){var d=this,e=arguments.length>3&&void 0!==arguments[3]?arguments[3]:function(){},f=this.getContexts(),g=f.length;g||e(),f.forEach(function(f){var h=function(){d.iterateThroughNodes(a,f,b,c,function(){--g<=0&&e()})};d.iframes?d.waitForIframes(f,h):h()})}}],[{key:"matches",value:function(a,b){var c="string"==typeof b?[b]:b,d=a.matches||a.matchesSelector||a.msMatchesSelector||a.mozMatchesSelector||a.oMatchesSelector||a.webkitMatchesSelector;if(d){var e=!1;return c.every(function(b){return!d.call(a,b)||(e=!0,!1)}),e}return!1}}]),a}();return c.fn.mark=function(a,b){return new d(this.get()).mark(a,b),this},c.fn.markRegExp=function(a,b){return new d(this.get()).markRegExp(a,b),this},c.fn.unmark=function(a){return new d(this.get()).unmark(a),this},c},window,document);


/***/ }),

/***/ 12:
/***/ (function(module, exports) {



/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var positionActiveElement = [];
	var positionMobileElement = [];
	var lastSizeWindow = 0;
	var activeContactPosition = 0;
	var activeNewsPosition = 0;
	var activeNewsYearPosition = 0;
	var nNewsActive = 0;
	var categoryNews = [];
	var trans = __webpack_require__(19);
	
	var allNews = [];
	
	function filterNewsFun() {
	  var beforeDate = '';
	  var afterDate = '';
	  var categoryNews = $('.product-navigator .category-news .active').data(
	    'idcat'
	  );
	
	  var after =
	    $('.news-year-query .active').data('after') != ''
	      ? $('.news-year-query .active').data('after')
	      : '';
	  var before =
	    $('.news-year-query .active').data('before') != ''
	      ? $('.news-year-query .active').data('before')
	      : '';
	  if (after != '') {
	    afterDate = new Date(after);
	  }
	  if (before != '') {
	    beforeDate = new Date(before);
	  }
	
	  if (!allNews.length) {
	    return;
	  }
	  filterNews = [];
	
	  allNews.forEach(function(news) {
	    if (afterDate != '' || beforeDate != '') {
	      var dateNews = new Date(news.date);
	    }
	    if (dateNews && afterDate != '' && dateNews < afterDate) {
	      console.log('News troppo vecchia');
	      return;
	    }
	    if (dateNews && beforeDate != '' && dateNews > beforeDate) {
	      console.log('News troppo Nuova');
	      return;
	    }
	    if (categoryNews && categoryNews != news.acf.category.ID) {
	      console.log('News Non in categoria');
	      return;
	    }
	    filterNews.push(news);
	  });
	
	  publicNews(filterNews);
	  return;
	}
	function checkIfQuerySetted() {
	  console.log(
	    $('.product-navigator .category-news .active').data('idcat'),
	    $('.news-year-query .active').data('after'),
	    $('.news-year-query .active').data('before')
	  );
	  if (
	    $('.product-navigator .category-news .active').data('idcat') ||
	    $('.news-year-query .active').data('after') ||
	    $('.news-year-query .active').data('before')
	  ) {
	    return true;
	  }
	  return false;
	}
	function publicNews(arr, append) {
	  var html = getHtmlNews(arr);
	  console.log('aapned => ' + append);
	  if (!append) {
	    $('.news-category').html('');
	  }
	  $('.news-category').append(html);
	  checkIfLoadMore(filterNews.length);
	  filterNewsByCategory();
	  if (!checkIfQuerySetted()) {
	    filterNews = [];
	  }
	  if (filterNews.length < 6) {
	    filterNews = [];
	  } else {
	    filterNews.splice(0, 6);
	    console.log(filterNews);
	  }
	}
	$(document).ready(function() {
	  nNewsActive = 6;
	  if ($('.product-navigator').length) {
	    moveBoxToActive();
	    lastSizeWindow = $(window).width();
	  }
	  $('.container-product-navigator').on('click tap', '.open .link', function(e) {
	    e.preventDefault();
	    console.log('Click On Active');
	    if ($(this).data('link')) {
	      window.location = $(this).data('link');
	    }
	  });
	  if ($('#section-contact').length) {
	    checkQueryObj();
	    $('.box-product-navigator .box-category').on('click tap', function() {
	      var $this = $(this);
	      $('.product-navigator').removeClass('error');
	      if ($(this).hasClass('active')) {
	        return;
	      }
	      $('.box-product-navigator .box-category').each(function() {
	        $(this).removeClass('active');
	      });
	      $this.addClass('active');
	      moveBoxToActive();
	      $('.product-navigator .father').removeClass('open');
	      $('.product-navigator .father').css({
	        top: 0,
	        'max-height': '60px',
	      });
	    });
	  }
	
	  $('.category-news .box-category').on('click tap', function() {
	    if (!allNews.length) {
	      return;
	    }
	
	    var $this = $(this);
	    if ($(this).hasClass('active')) {
	      return;
	    }
	    $('.categories .box-category').each(function() {
	      $(this).removeClass('active');
	    });
	    $this.addClass('active');
	    moveBoxToActive('category');
	    $('.product-navigator .father').removeClass('open');
	    $('.product-navigator .father').css({
	      top: 0,
	      'max-height': '60px',
	    });
	
	    filterNewsFun();
	  });
	  $('.news-year-query .box-category').on('click tap', function() {
	    if (!allNews.length) {
	      return;
	    }
	    var $this = $(this);
	    if ($(this).hasClass('active')) {
	      return;
	    }
	    $('.news-year-query .box-category').each(function() {
	      $(this).removeClass('active');
	    });
	    $this.addClass('active');
	    moveBoxToActive('year');
	    $('.product-navigator .father').removeClass('open');
	    $('.product-navigator .father').css({
	      top: 0,
	      'max-height': '60px',
	    });
	    var after = $this.data('after');
	    var before = $this.data('before');
	    // if (after) {
	    // 	filterNewsByYear(after, before);
	    filterNewsFun();
	    // 	return
	    // } else {
	    // 	filterNewsByYear(false);
	    // }
	    // var catId = $('.container .category-news .active').data('idcat');
	    //
	    // filterNewsByCategory(catId);
	  });
	});
	
	$(window).resize(function() {
	  if ($('.product-navigator').length && !$('#section-contact').length) {
	    var nowSizeWindow = $(window).width();
	    if (lastSizeWindow < 768 && nowSizeWindow >= 768) {
	      triggerHover();
	    }
	    if (lastSizeWindow >= 768 && nowSizeWindow < 768) {
	      triggerHover();
	    }
	    lastSizeWindow = nowSizeWindow;
	    return;
	  }
	});
	function moveBoxToActive(where) {
	  var diff = 0;
	  var productNavigatorOffset = $('.product-navigator').offset().top;
	  $('.product-navigator .box-product-navigator').each(function() {
	    if ($(this).children('.box-category.active').length) {
	      var divActivePosition = $(this)
	        .children('.box-category.active')
	        .offset().top;
	      if (where) {
	        switch (where) {
	          case 'year':
	            console.log($(this).hasClass('news-year-query'));
	            if (!$(this).hasClass('news-year-query')) {
	              return;
	            }
	            break;
	          case 'category':
	            if (!$(this).hasClass('category-news')) {
	              return;
	            }
	            break;
	          default:
	        }
	      }
	    } else {
	      return;
	    }
	    var position = productNavigatorOffset - divActivePosition;
	    if ($('#section-contact').length) {
	      activeContactPosition = position;
	    }
	    if (where) {
	      switch (where) {
	        case 'year':
	          activeNewsYearPosition = position;
	          break;
	        case 'category':
	          activeNewsPosition = position;
	          break;
	        default:
	      }
	    }
	
	    positionActiveElement.push(position);
	    if ($(window).width() < 768) {
	      var offset = $(this).offset().top;
	      position = offset - divActivePosition;
	
	      positionMobileElement.push(position);
	    }
	    $(this).css('top', position);
	  });
	}
	
	$('.product-navigator .father').hover(
	  function(e) {
	    e.preventDefault();
	    var index = parseInt($(this).data('index'));
	    position = 0;
	
	    $(this).css({
	      top: position,
	      'max-height': '2000px',
	    });
	    $(this)
	      .children('.box-product-navigator')
	      .css({
	        top: 0,
	      });
	    $(this).addClass('open');
	    var $this = $(this);
	    setTimeout(function() {
	      if (!$('#section-contact').length && !$('#news').length) {
	        $this
	          .children()
	          .children('.active')
	          .addClass('link');
	      }
	    }, 430);
	  },
	  function(e) {
	    $(this).removeClass('open');
	    var index = parseInt($(this).data('index'));
	    var position = positionActiveElement[index];
	    if ($(window).width() < 768) {
	      position = positionMobileElement[index];
	    }
	    $(this)
	      .children()
	      .children('.active')
	      .removeClass('link');
	
	    $(this).css({
	      top: 0,
	      'max-height': '60px',
	    });
	    if (!$('#section-contact').length && !$('#news').length) {
	      $(this)
	        .children('.box-product-navigator')
	        .css({
	          top: position,
	        });
	      return;
	    }
	    if ($('#news').length) {
	      if ($(this).hasClass('categories')) {
	        $(this)
	          .children('.box-product-navigator')
	          .css({
	            top: activeNewsPosition,
	          });
	        return;
	      }
	      if ($(this).hasClass('years')) {
	        $(this)
	          .children('.box-product-navigator')
	          .css({
	            top: activeNewsYearPosition,
	          });
	        return;
	      }
	    }
	    if ($('#section-contact').length) {
	      $(this)
	        .children('.box-product-navigator')
	        .css({
	          top: activeContactPosition,
	        });
	    }
	  }
	);
	function triggerHover() {
	  $('.product-navigator .father').each(function() {
	    $(this).removeClass('open');
	    var index = parseInt($(this).data('index'));
	    var position = positionActiveElement[index];
	    if ($(window).width() < 768) {
	      position = positionMobileElement[index];
	    }
	    $(this).css({
	      top: 0,
	      'max-height': '60px',
	    });
	    $(this)
	      .children('.box-product-navigator')
	      .css({
	        top: position,
	      });
	  });
	}
	function checkQueryObj() {
	  if (checkQueryUrl('prod')) {
	    var lang = window.location.pathname.split('/')[1].toLowerCase();
	    var prod = getParameterByName('prod');
			var prod = prod.replace(/[^a-zA-Z0-9]/g, '');
	    var text = trans.subject_product_informations[lang] + ' ' + prod;
	    // switch (lang) {
	    //   case 'it':
	    //     text = 'INFORMAZIONI PRODOTTTO ' + prod;
	    //     break;
	    //   case 'en':
	    //     text = 'INFORMATIONS ABOUT PRODUCT ' + prod;
	    //     break;
	    //   default:
	    // }
	    var html =
	      '<div class="box-category active" data-type="prod" data-prod="' +
	      prod +
	      '"><div class="name flex-col-center"><div class="flex-center"><div class="icon-row-product-navigator"></div><div class="flex-col-center"><span>' +
	      text +
	      '</span></div></div></div></div>';
	    $('.parent-product-category .active').removeClass('active');
	    $('.box-product-navigator').append(html);
	    moveBoxToActive();
	  }
	}
	
	function checkQueryUrl(field) {
	  var url = window.location.href;
	  if (url.indexOf('?' + field + '=') != -1) return true;
	  else if (url.indexOf('&' + field + '=') != -1) return true;
	  return false;
	}
	function getParameterByName(name, url) {
	  if (!url) url = window.location.href;
	  name = name.replace(/[\[\]]/g, '\\$&');
	  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
	    results = regex.exec(url);
	  if (!results) return null;
	  if (!results[2]) return '';
	  return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}
	
	function filterNewsByCategory(catId) {
	  $('.news-category .news').each(function() {
	    $(this)
	      .fadeIn()
	      .css('display', 'flex');
	    $(this).removeClass('hidden-news');
	    return;
	  });
	  setFocusNews();
	}
	
	function setFocusNews() {
	  // var c = 0;
	  // $('.news-category .news').each(function () {
	  // 	if (c < 2 && !$(this).hasClass('hidden-news')) {
	  // 		$(this).addClass('news-focus');
	  // 		$(this).find('.big-news').removeClass('hide');
	  // 		$(this).find('.small-news').addClass('hide');
	  // 		$(this).find('.small-title-news').removeClass('small-title-news');
	  // 		c++
	  // 	} else {
	  // 		if (!$(this).hasClass('hidden-news')) {
	  // 			$(this).removeClass('news-focus');
	  // 			$(this).find('.big-news').addClass('hide');
	  // 			$(this).find('.small-news').removeClass('hide');
	  // 			$(this).find('.title-box').addClass('small-title-news');
	  // 		}
	  // 	}
	  // })
	  // squareBoxNewsFocus()
	}
	
	var filterNews = [];
	$(document).ready(function() {
	  if ($('#news').length) {
	    setTimeout(function() {
	      // squareBoxNewsFocus()
	    }, 200);
	    $.get(
	      'https://wp.primaautomotive.it/wp-json/wp/v2/news_category?per_page=300',
	      function(data) {
	        categoryNews = data;
	      }
	    );
	    $.get(
	      'https://wp.primaautomotive.it/wp-json/wp/v2/news?per_page=300',
	      function(data) {
	        allNews = data;
	      }
	    );
	    $('#load-more').on('click tap', function() {
	      if (!allNews.length) {
	        return;
	      }
	      console.log('QUI');
	      if (filterNews.length) {
	        console.log('QUsssI');
	
	        publicNews(filterNews);
	        return;
	      }
	
	      if (!checkIfQuerySetted()) {
	        console.log('no filter');
	
	        var c = 0;
	        var newsToAdd = [];
	        allNews.forEach(function(news, index) {
	          if (index < nNewsActive) {
	            return;
	          }
	          if (c == 6) {
	            return;
	          }
	          c++;
	          newsToAdd.push(news);
	        });
	        console.log('Append => True');
	        publicNews(newsToAdd, true);
	        nNewsActive += c;
	      }
	    });
	  }
	});
	
	$(window).on('resize', function() {
	  // squareBoxNewsFocus()
	});
	// function squareBoxNewsFocus () {
	// 	var height = $('.news-category .news-focus').width()
	// 	$('.news-category .news').each(function() {
	// 		if ($(this).hasClass('news-focus')) {
	// 			if ($(window).width() < 768) {
	// 				$(this).height('auto')
	// 			} else {
	// 				$(this).height(height)
	// 			}
	// 			return
	// 		}
	// 		if ($(window).width() < 768) {
	// 			$(this).height('auto')
	// 			return
	// 		}
	// 		$(this).height(height/2 + 50)
	
	// 	})
	// }
	
	function checkIfLoadMore(length) {
	  if (length >= 6) {
	    $('.view-all-box').fadeIn();
	    return true;
	  }
	  $('.view-all-box').fadeOut();
	  return false;
	}
	
	function getHtmlNews(data, loadMore) {
	  var lang = window.location.pathname.split('/')[1].toLowerCase();
	  var html = '';
	  var c = 0;
	  data.forEach(function(news, index) {
	    if (index > 5) {
	      return;
	    }
	    var title = '';
	    var text = '';
	    var category = '';
	    var titleUrl = '';
	    switch (lang) {
	      case 'it':
	        var text = $(news.acf.text_it).text();
	        // text = text.substr(0, 100) + '...'
	        var contentIt = text.replace(/([\[\]])(?:(?=(\\?))\2.)*/g, '');
	        contentIt = contentIt.substr(0, 120) + '...';
	        lastIndex = contentIt.lastIndexOf(' ');
	        contentIt = contentIt.substring(0, lastIndex) + '...';
	        var titleIt = news.acf.title_it;
	        if (titleIt.length > 65) {
	          titleIt = titleIt.substr(0, 65);
	          lastIndex = titleIt.lastIndexOf(' ');
	          titleIt = titleIt.substring(0, lastIndex) + '...';
	        }
	        categoryNews.forEach(function(category) {
	          if (category.id == news.acf.category.ID) {
	            category = category.acf.name_it;
	          }
	        });
	        title = titleIt;
	        text = contentIt;
	        titleUrl = news.acf.title_en
	          .split(' ')
	          .join('-')
	          .toLowerCase();
	        break;
	      case 'en':
	        var text = $(news.acf.text_en).text();
	        // text = text.substr(0, 100) + '...'
	        var contentEn = text.replace(/([\[\]])(?:(?=(\\?))\2.)*/g, '');
	        contentEn = contentEn.substr(0, 120);
	        lastIndex = contentEn.lastIndexOf(' ');
	
	        categoryNews.forEach(function(cat) {
	          if (cat.id == news.acf.category.ID) {
	            category = cat.acf.name_en;
	          }
	        });
	        contentEn = contentEn.substring(0, lastIndex) + '...';
	        var titleEn = news.acf.title_en;
	
	        if (titleEn.length > 65) {
	          titleEn = titleEn.substr(0, 65);
	          lastIndex = titleEn.lastIndexOf(' ');
	          titleEn = titleEn.substring(0, lastIndex) + '...';
	        }
	        title = titleEn;
	        text = contentEn;
	        titleUrl = news.acf.title_en
	          .split(' ')
	          .join('-')
	          .toLowerCase();
	        break;
	      default:
	    }
	
	    html +=
	      '<div data-category="' +
	      news.acf.category.ID +
	      '" class="news flex-center hide ' +
	      (index <= 2 && !loadMore ? '' : '') +
	      '"> <div class="flex-col-center img-news-box"> <div style="background-image: url(' +
	      news.acf.placeholder +
	      ')" class="img-news"></div></div><div class="info-news-box flex-col-space-around"> <div class="title flex-col-start"> <div class="title-box flex-col-space-between ' +
	      (index < 2 && !loadMore ? 'small-title-news' : 'small-title-news') +
	      '"><span>' +
	      title +
	      '</span> <div class="big-news ' +
	      (index <= 2 && !loadMore ? 'hide' : 'hide') +
	      '"> <div class="flex-space-between"> <a href="" class="cat-link hidden-mobile ipad desktop"><span class="black second-title">' +
	      category +
	      '</span></a><a href="/' +
	      lang +
	      '/news/' +
	      news.id +
	      '/' +
	      titleUrl +
	      '" class="read-more">READ MORE</a> </div></div></div></div><div class="small-news ' +
	      (index > 2 && !loadMore ? '' : '') +
	      '"> <div class="margin-bot-15"><span class="second-title">' +
	      text +
	      '</span></div></div><div class="small-news ' +
	      (index > 2 && !loadMore ? '' : '') +
	      '"><a href="/' +
	      lang +
	      '/news/' +
	      news.id +
	      '/' +
	      titleUrl +
	      '">READ MORE</a></div></div></div>';
	    c++;
	  });
	  nNewsActive = c;
	  return html;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var countProduct = 0;
	var $boxGridProduct = $('.box-grid-projects');
	
	$(document).ready(function() {
	  squareBoxProductsLanding();
	  $boxGridProduct.children('.box-product-landing').each(function() {
	    countProduct++;
	  });
	  checkLayoutProduct();
	});
	
	$(window).on('resize', function() {
	  squareBoxProductsLanding();
	  checkLayoutProduct();
	});
	
	function checkLayoutProduct() {
	  var windowWidth = $(window).width();
	
	  removeEmptyProduct();
	
	  if (windowWidth > 767) {
	    if (windowWidth > 991) {
	      if (windowWidth > 1199) {
	        if (windowWidth > 1599) {
	          addPaddingRightProduct(8);
	          addPaddingBottomProduct(8);
	          if (checkBorderTopContainer(8)) {
	            addEmptyProduct(8, windowWidth);
	          } else {
	            addOneEmptyProduct(8, windowWidth);
	          }
	        } else {
	          addPaddingRightProduct(4);
	          addPaddingBottomProduct(4);
	          if (checkBorderTopContainer(4)) {
	            addEmptyProduct(4, windowWidth);
	          } else {
	            addOneEmptyProduct(4, windowWidth);
	          }
	        }
	      } else {
	        //ipad Landscape 33%
	        addPaddingRightProduct(3);
	        addPaddingBottomProduct(3);
	        if (checkBorderTopContainer(3)) {
	          addEmptyProduct(3, windowWidth);
	        } else {
	          addOneEmptyProduct(3, windowWidth);
	        }
	      }
	    } else {
	      //ipad portrait 50%
	      addPaddingRightProduct(2);
	      addPaddingBottomProduct(2);
	      if (checkBorderTopContainer(2)) {
	        addEmptyProduct(2, windowWidth);
	      } else {
	        addOneEmptyProduct(2, windowWidth);
	      }
	    }
	  } else {
	    addPaddingRightProduct(1);
	    addPaddingBottomProduct(1);
	  }
	}
	
	function checkBorderTopContainer(nForLine) {
	  if (nForLine > countProduct) {
	    return false;
	  } else {
	    return true;
	  }
	}
	
	function addPaddingBottomProduct(numbToAdd) {
	  var borderBottomToAdd = parseInt(countProduct % numbToAdd);
	
	  if (numbToAdd == 1) {
	    borderBottomToAdd++;
	  }
	  if (!borderBottomToAdd) {
	    borderBottomToAdd = numbToAdd;
	  }
	  $(
	    $('.box-grid-projects').children('.box-product-landing').get().reverse()
	  ).each(function() {
	    if (borderBottomToAdd || mobile) {
	      $(this).addClass('border-bottom');
	      borderBottomToAdd--;
	      mobile = false;
	    }
	  });
	  squareBoxProductsLanding();
	}
	
	function addPaddingRightProduct(numbToAdd) {
	  var borderRightToAdd =
	    parseInt(countProduct % numbToAdd) + parseInt(countProduct / numbToAdd);
	  var c = 1;
	  $('.box-grid-projects').children('.box-product-landing').each(function() {
	    if (c % numbToAdd == 0) {
	      $(this).addClass('border-right');
	    }
	    c++;
	  });
	}
	function addEmptyProduct(divider, windowWidth) {
	  var mod = countProduct % divider;
	  if (mod != 0) {
	    var divToAdd = divider - mod;
	    var html = '';
	    for (var i = 0; i < divToAdd; i++) {
	      if (i == 0) {
	        html += "<div class='empty box-product-landing border-left'></div>";
	      } else {
	        html += "<div class='empty box-product-landing'></div>";
	      }
	    }
	
	    $boxGridProduct.append(html);
	    squareBoxProductsLanding();
	  }
	}
	
	function addOneEmptyProduct(divider, windowWidth) {
	  var html = "<div class='empty box-product-landing border-only-left'></div>";
	  $boxGridProduct.append(html);
	  squareBoxProductsLanding();
	}
	function removeEmptyProduct() {
	  $boxGridProduct.children('.box-product-landing').each(function() {
	    $(this).removeClass('border-bottom');
	    $(this).removeClass('border-right');
	    if ($(this).hasClass('empty')) {
	      $(this).remove();
	    }
	  });
	}
	function squareBoxProductsLanding() {
	  var height = $('.box-grid-projects .box-product-landing').width();
	  $('.box-grid-projects .box-product-landing').each(function() {
	    if ($(this).hasClass('border-only-left')) {
	      $(this).height(height + 10);
	    } else {
	      $(this).height(height);
	    }
	  });
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {$(document).ready(function () {
		if ($('.media-gallery-box').length && $('.media-gallery-box').hasClass('news')) {
			var mediaGallerySwiper = new Swiper('.media-gallery-box', {
				autoplay: 3000,
				nextButton: $('.media-gallery-box .swiper-button-next'),
				prevButton: $('.media-gallery-box .swiper-button-prev'),
				loop: true,
				slidesPerView: 1,
				breakpoints: {
					768: {
						slidesPerView: 1,
						spaceBetween: 0
					},
					1200: {
						slidesPerView: 3,
						spaceBetween: 19
					},
					1600: {
						slidesPerView: 3,
						spaceBetween: 19
					},
					3600: {
						slidesPerView: 3,
						spaceBetween: 19
					}
				}
			})
		} else {
			if ($('.media-gallery-box').length) {
				var mediaGallerySwiper = new Swiper('.media-gallery-box', {
					autoplay: 3000,
					nextButton: $('.media-gallery-box .swiper-button-next'),
					prevButton: $('.media-gallery-box .swiper-button-prev'),
					loop: true,
					slidesPerView: 1,
					breakpoints: {
						768: {
							slidesPerView: 1,
							spaceBetween: 0
						},
						1200: {
							slidesPerView: 3,
							spaceBetween: 19
						},
						1600: {
							slidesPerView: 4,
							spaceBetween: 19
						},
						3600: {
							slidesPerView: 5,
							spaceBetween: 19
						}
					}
				})
	
			}
		}
		if ($('.media-gallery-box').length) {
			var slide = 0
			$('.media-gallery-box .swiper-slide').each(function () {
				slide++
			})
			var mediaGalleryLightboxSwiper = new Swiper('.media-gallery-lightbox', {
				nextButton: $('.media-gallery-lightbox .swiper-button-next'),
				prevButton: $('.media-gallery-lightbox .swiper-button-prev'),
				slidesPerView: "auto",
				loopedSlides: slide,
				width: $(window).width(),
				autoHeight: true,
				centeredSlides: true
			})
			$('.media-gallery-box').on('click tap', '.swiper-slide', function () {
				var index = parseInt($(this).data('index'))
				$('#media-gallery-lightbox').addClass('open')
				mediaGalleryLightboxSwiper.slideTo(index, 300, true)
			})
			$(window).resize(function() {
				mediaGalleryLightboxSwiper.update(true)
				mediaGallerySwiper.update(true)
			})
	
			$('#media-gallery-lightbox').on('click tap', function (e) {
				if (e.target.id == $(this).attr('id')) {
					$('#media-gallery-lightbox').removeClass('open')
				}
			})
		}
	
	})
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var products = __webpack_require__(4);
	var product_categories = __webpack_require__(2);
	var product_subcategories = __webpack_require__(3);
	
	var lang = window.location.pathname.split("/")[1].toLowerCase();
	
	$(document).ready(function () {
		squareBoxRecentProduct();
		if ($("#recent-products").length && !$(".container-single-news").length) {
			var idProd = parseInt($("#product-info").data("product"));
			if (localStorage.recentProducts) {
				getRecentProduct();
			} else {
				$("#recent-products").remove();
			}
			addProductToLocal(idProd);
		}
		if ($(".container-single-news").length) {
			getRecentProduct();
		}
	});
	
	function cleanArray(actual) {
		var newArray = new Array();
		for (var i = 0; i < actual.length; i++) {
			if (actual[i]) {
				newArray.push(actual[i]);
			}
		}
		return newArray;
	}
	
	function getRecentProduct() {
	
		var arrRecentProducts = [];
	
		if ($(".container-single-news").length) {
			arrRecentProducts = featuredProduct
				.split("/,| /")
				.join("")
				.split(",");
		} else {
			arrRecentProducts = JSON.parse(localStorage.recentProducts);
		}
	
		var arrProd = [];
		arrRecentProducts = cleanArray(arrRecentProducts);
	
		arrRecentProducts.forEach(function (idProd, index) {
	
			if (index < 5 && idProd) {
				products.forEach(function (prod) {
					if (
						prod.id == idProd ||
						(typeof idProd == "string" && idProd.toLowerCase() == prod.slug)
					) {
	
						var catId = 0;
						if (prod.acf.category_id[0]) {
							catId = prod.acf.category_id[0].ID;
						}
						var catName = getCatName(catId, "cat");
	
						var subId = 0;
						if (prod.acf.sub_category_id[0]) {
							subId = prod.acf.sub_category_id[0].ID;
						}
						if (!subId) {
							return;
						}
						var subName = getCatName(subId, "sub");
	
						var link = "/" + lang + "/products/" + catId + "/" + catName[lang] + "/" + subId + "/" + subName[lang] + "/" + prod.acf.product_id;
	
						var obj = {
							name: prod.slug,
							link: link,
							img:
								"/images/" +
								prod.acf.category_id[0].post_name +
								"/" +
								prod.slug +
								"-300px.jpg" +
								"?prod_image_wp_url=" +
								prod.acf.product_image.url
						};
						arrProd.push(obj);
					}
				});
			}
		});
		var html = "";
		arrProd.forEach(function (prod) {
			html +=
				'<div class="recent-prod-box"><a href="' +
				prod.link +
				'"><div class="flex-col-center"><div class="img-product"><div class="img-bg" style="background-image: url(' +
				prod.img +
				')"></div></div><div class="name-prod"><span>' +
				prod.name.toUpperCase() +
				"</span></div></div></a></div></div>";
		});
		$(".recent-product-container, .featured-product-container").html("");
		$(".recent-product-container, .featured-product-container").append(html);
		squareBoxRecentProduct();
	}
	
	function getCatName(id, what) {
		var obj = {};
		switch (what) {
			case "cat":
				product_categories.forEach(function (cate) {
	
					if (cate.id == id) {
	
						var catLinkEn = cate.acf.category_name_en
							.split("/,| /")
							.join("-")
							.split(" ")
							.join("-")
							.split("'")
							.join("-")
							.toLowerCase()
							.replace('/', '');
						var catLinkIt = cate.acf.category_name_it
							.split("/,| /")
							.join("-")
							.split(" ")
							.join("-")
							.split("'")
							.join("-")
							.toLowerCase()
							.replace('/', '');
	
						obj = {
							it: catLinkIt,
							en: catLinkEn,
						};
	
					}
				});
				break;
	
			case "sub":
	
				product_subcategories.forEach(function (sub) {
	
					if (sub.id == id) {
	
						var catLinkEn = sub.acf.sub_category_name_en
							.split("/,| /")
							.join("-")
							.split(" ")
							.join("-")
							.split("'")
							.join("-")
							.toLowerCase()
							.replace('/', '');
						var catLinkIt = sub.acf.sub_category_name_it
							.split("/,| /")
							.join("-")
							.split(" ")
							.join("-")
							.split("'")
							.join("-")
							.toLowerCase()
							.replace('/', '');
	
						obj = {
							it: catLinkIt,
							en: catLinkEn,
						};
	
					}
				});
				break;
			default:
		}
	
		return obj;
	}
	function addProductToLocal(id) {
		if (localStorage.recentProducts) {
			var arrRecentProducts = JSON.parse(localStorage.recentProducts);
			var boolPush = true;
			arrRecentProducts = cleanArray(arrRecentProducts);
			for (var i = 0; i < arrRecentProducts.length; i++) {
				if (id == arrRecentProducts[i] && i < 5) {
					boolPush = false;
				}
			}
			if (boolPush) {
				arrRecentProducts.unshift(id);
				localStorage.recentProducts = JSON.stringify(arrRecentProducts);
			}
		} else {
			var arr = [id];
			localStorage.recentProducts = JSON.stringify(arr);
		}
	}
	$(window).on("resize", function () {
		squareBoxRecentProduct();
	});
	function squareBoxRecentProduct() {
		var height = $(".recent-prod-box").width();
		$(".recent-prod-box .img-product").each(function () {
			$(this).height(height - 14);
		});
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(11);
	
	var product_categories = __webpack_require__(2);
	var products = __webpack_require__(4);
	var product_subcategories = __webpack_require__(3);
	var numberProductResult = 0;
	
	var keyup_timeout;
	
	$("#search-input").on("keyup", function() {
		$input = $(this);
	
		if (keyup_timeout) clearTimeout(keyup_timeout);
	
		keyup_timeout = setTimeout(function() {
			if ($input.val().length >= 2) {
				findResultSearch($input.val().toLowerCase());
			}
		}, 500);
	});
	
	$("#search-img, .search-icon").on("click tap", function() {
		if ($(".search-container").hasClass("open")) {
			$(".search-container").removeClass("open");
			$(".back-black").fadeOut("fast");
			return;
		}
		$(".back-black").fadeIn("fast");
		$(".search-container").addClass("open");
		$(".search-container #search-input").focus();
	});
	$(".close-search-box").on("click tap", function() {
		if ($(".search-container").hasClass("open")) {
			$(".search-container").removeClass("open");
			$(".back-black").fadeOut("fast");
			return;
		}
	});
	$(".search-container #search-result ").on(
		"mouseenter",
		".products .object",
		function() {
			if ($(this).hasClass("empty")) {
				return;
			} else {
				$(".search-container #search-result .products").append(
					'<div class="jolly" data-url="' + $(this).data("url") + '"></div>'
				);
				$(".search-container .jolly").css({
					top: $(this).position().top + "px",
					left: $(this).position().left + "px",
					width: $(this).width() + 5 + "px",
					height: $(this).height() + 5 + "px"
				});
			}
		}
	);
	$(".search-container").on("mouseleave", ".jolly", function() {
		removeJolly();
	});
	var doneDown = false;
	var doneUp = false;
	var lastScroll = 0;
	$(window).on("scroll", function() {
		removeJolly();
		if ($(window).width() > 1199) {
			var scrollTop = $(window).scrollTop();
			if (scrollTop > lastScroll) {
				// downscroll code
				if (scrollTop > 200 && !doneDown) {
					setTimeout(function functionName() {
						squareBoxProductsSearchResult();
						checkLayoutProductSearchResult();
					}, 350);
	
					doneDown = true;
					doneUp = false;
				}
			} else {
				if (scrollTop < 190 && !doneUp) {
					setTimeout(function functionName() {
						squareBoxProductsSearchResult();
						checkLayoutProductSearchResult();
					}, 350);
					doneDown = false;
					doneUp = true;
				}
			}
			lastScroll = scrollTop;
		}
	});
	$(".back-black").on("click tap", function() {
		$(this).fadeOut("fast");
		$(".search-container").removeClass("open");
	});
	function removeJolly() {
		$(".search-container .jolly").each(function() {
			$(this).remove();
		});
	}
	$(".search-container #search-result").scroll(function() {
		removeJolly();
	});
	function findResultSearch(string) {
	
		var string = string.split(".").join("");
		var result = [];
		var lang = window.location.pathname.split("/")[1];
		var numberCategories = 0;
		var nameProd = "";
		switch (lang) {
			case "it":
				nameProd = "prodotti";
				break;
			case "en":
				nameProd = "products";
				break;
			default:
		}
	
		/*
		 * Cerca in categorie
		 */
		product_categories.forEach(function(category) {
	
			var obj = {
				id: category.id,
				type: "categories",
				index: numberCategories,
				link: ""
			};
	
			// Categories ITA
			if (
				category.acf.category_name_it.toLowerCase().indexOf(string) > -1
			) {
				numberCategories++;
				obj.name = category.acf.category_name_it;
				obj.link +=
					"/it/prodotti/" +
					category.id +
					"/" +
					category.acf.category_name_it
						.split("/,| /")
						.join("-")
						.split("'")
						.join("-")
						.toLowerCase();
				result.push(obj);
				return;
			}
	
			// Categories EN
			if (
				category.acf.category_name_en.toLowerCase().indexOf(string) > -1
			) {
				numberCategories++;
				obj.name = category.acf.category_name_en;
	
				obj.link +=
					"/en/products/" +
					category.id +
					"/" +
					category.acf.category_name_en
						.split("/,| /")
						.join("-")
						.split("'")
						.join("-")
						.toLowerCase();
	
				result.push(obj);
				return;
			}
		});
	
		/*
		 * Cerca in sotto categorie
		 */
		var numberSubcategories = 0;
		product_subcategories.forEach(function(subcategory) {
			var catId = 0;
			if (subcategory.acf.category_id[0]) {
				catId = subcategory.acf.category_id[0].ID;
			}
			if (!catId) {
				return;
			}
			var catName = getCatName(catId, "cat");
			var obj = {
				id: subcategory.id,
				type: "subcategories",
				index: numberSubcategories,
				link: ""
			};
	
			// Sub Categorie ITA
			if (
				subcategory.acf.sub_category_name_it.toLowerCase().indexOf(string) > -1
			) {
				numberSubcategories++;
				obj.name = subcategory.acf.sub_category_name_it;
				obj.link +=
					"/it/prodotti/" +
					catId +
					"/" +
					catName.it +
					"/" +
					subcategory.id +
					"/" +
					subcategory.acf.sub_category_name_it
						.split("/,| /")
						.join("-")
						.split("'")
						.join("-")
						.toLowerCase();
				subLinkIt = obj.link;
				result.push(obj);
				return;
			}
	
			// Sub Categorie EN
			if (
				subcategory.acf.sub_category_name_en.toLowerCase().startsWith(string) ||
				subcategory.acf.sub_category_name_en.toLowerCase().indexOf(string) > 0
			) {
				numberSubcategories++;
				obj.name = subcategory.acf.sub_category_name_en;
				obj.link +=
					"/en/products/" +
					catId +
					"/" +
					catName.en +
					"/" +
					subcategory.id +
					"/" +
					subcategory.acf.sub_category_name_en
						.split("/,| /")
						.join("-")
						.split("'")
						.join("-")
						.toLowerCase();
				result.push(obj);
				return;
			}
	
		});
	
	
		/*
		 * Cerca in prodotti
		 */
		var numberProduct = 0;
		products.forEach(function(product, index) {
			var catId = 0;
			if (product.acf.category_id[0]) {
				catId = product.acf.category_id[0].ID;
			}
			var catName = getCatName(catId, "cat");
			var subId = 0;
			if (product.acf.category_id[0]) {
				subId = product.acf.category_id[0].ID;
			}
			if (!subId) {
				return;
			}
	
			var subName = getCatName(subId, "sub");
			var link = "/" + lang + "/" + nameProd + "/";
			switch (lang) {
				case "it":
					link +=
						catId +
						"/" +
						catName.it +
						"/" +
						subId +
						"/" +
						subName.it +
						"/" +
						product.acf.product_id;
					break;
				case "en":
					link +=
						catId +
						"/" +
						catName.en +
						"/" +
						subId +
						"/" +
						subName.en +
						"/" +
						product.acf.product_id;
					break;
				default:
			}
	
			var obj = {
				type: "products",
				name: product.title.rendered,
				index: numberProduct,
				link: link,
				wp_image: product.acf.product_image.url
			};
	
			if (
				product.title.rendered.toLowerCase().indexOf(string) > -1
			) {
				numberProduct++;
				result.push(obj);
				return;
			}
	
			var pushed = false;
			result.forEach(function(res) {
				if (
					!pushed &&
					(res.id == product.acf.category_id[0].ID ||
						res.id == product.acf.sub_category_id[0].ID)
				) {
					result.push(obj);
					numberProduct++;
					pushed = true;
					return;
				}
			});
			if (pushed) {
				return;
			}
			if (product.acf.product_variants) {
				var arrVariants = product.acf.product_variants.split(",");
	
				arrVariants.forEach(function(variant) {
					if (
						variant.startsWith(string) ||
						(variant.indexOf(string) > 0 && !pushed)
					) {
						numberProduct++;
						pushed = true;
						obj.variant = variant;
						result.push(obj);
					}
				});
			}
		});
	
	
		/*
		 * Visualizza griglia risultati
		 */
	
		numberProductResult = numberProduct;
		var html = '<div class="search-result-box">';
	
		if (result.length) {
			// Found Product
			result.forEach(function(res, index) {
				if (res.index == 0 && index > 0) {
					html += "</div></div>";
				}
	
				if (res.index == 0) {
					if (res.type == "products") {
						switch (lang) {
							case "it":
								var title = "Prodotti";
								break;
							case "en":
								var title = "Products";
								break;
							default:
						}
						var nameP = res.variant ? res.variant : res.name;
						html +=
							'<div class="box-type ' +
							res.type +
							'"><div class="title"> <span> ' +
							title +
							'</span></div><div class="box-single-result"><div class="object flex-col-center" data-url="' +
							res.link +
							'"><div class="flex-col-center hover" href="/"><div class="name"><span>' +
							nameP +
							'</span></div><div class="img-product" style="background-image: url(/images/categories/' +
							res.name.toLowerCase() +
							"-100px.jpg?prod_image_wp_url=" +
							res.wp_image +
							')"></div></div></div>';
					} else {
						switch (lang) {
							case "it":
								switch (res.type) {
									case "subcategories":
										var title = "Sottocategorie";
										break;
									case "categories":
										var title = "Categorie";
										break;
									default:
								}
								break;
							case "en":
								switch (res.type) {
									case "subcategories":
										var title = "Subcategories";
										break;
									case "categories":
										var title = "Categories";
										break;
									default:
								}
								break;
							default:
						}
						html +=
							'<div class="box-type ' +
							res.type +
							'"><div class="title"><span>' +
							title +
							'</span></div><div class="box-single-result"><div class="object" data-url="' +
							res.link +
							'"><span>' +
							res.name +
							"</span></div>";
					}
				} else {
					if (res.type == "products") {
						var nameP = res.variant ? res.variant : res.name;
						html +=
							'<div class="object flex-col-center" data-url="' +
							res.link +
							'"><div class="flex-col-center hover"><div class="name"><span>' +
							nameP +
							'</span></div><div class="img-product" style="background-image: url(/images/categories/' +
							res.name.toLowerCase() +
							'-100px.jpg)"></div></div></div>';
					} else {
						html +=
							'<div class="object" data-url="' +
							res.link +
							'"><span>' +
							res.name +
							"</span></div></a>";
					}
				}
			});
			html += "</div></div>";
		} else {
			// no result
			html = "";
			html +=
				'<div class="search-result-box flex-col-center no-result"><div class="no-result"><span> Nessun Risultato</span></div>';
		}
		$("#search-result").html("");
		$("#search-result").append(html);
		squareBoxProductsSearchResult();
		checkLayoutProductSearchResult();
		$("#search-result").mark(string, {
			className: "mark"
		});
	}
	
	$(window).resize(function() {
		squareBoxProductsSearchResult();
		checkLayoutProductSearchResult();
	});
	
	function squareBoxProductsSearchResult() {
		var height = $(".search-container .products .object").width();
		$(".search-container .products .object").each(function() {
			if ($(this).hasClass("empty")) {
				$(this).height(height + 3);
				if ($(this).hasClass("border-only-left")) {
					$(this).height(height + 6);
				}
			} else {
				$(this).height(height);
			}
		});
	}
	function removeClear() {
		$(".search-container .clear").each(function() {
			$(this).remove();
		});
	}
	function addClear() {
		$(".search-container .box-single-result").each(function() {
			$(this).append('<div class="clear"></div>');
		});
	}
	function checkLayoutProductSearchResult() {
		var windowWidth = $(window).width();
	
		removeEmptyProductSearchResult();
		removeClear();
	
		if (windowWidth > 767) {
			if (windowWidth > 991) {
				if (windowWidth > 1599) {
					addPaddingRightProductSearchResult(14);
					addPaddingBottomProductSearchResult(14);
					if (checkBorderTopContainerSearchResult(14)) {
						addEmptyProductSearchResult(14, windowWidth);
					} else {
						addOneEmptyProductSearchResult(14, windowWidth);
					}
				} else {
					addPaddingRightProductSearchResult(10);
					addPaddingBottomProductSearchResult(10);
					if (checkBorderTopContainerSearchResult(10)) {
						addEmptyProductSearchResult(10, windowWidth);
					} else {
						addOneEmptyProductSearchResult(10, windowWidth);
					}
				}
			} else {
				//ipad Landscape 33%
				addPaddingRightProductSearchResult(5);
				addPaddingBottomProductSearchResult(5);
				if (checkBorderTopContainerSearchResult(5)) {
					addEmptyProductSearchResult(5, windowWidth);
				} else {
					addOneEmptyProductSearchResult(5, windowWidth);
				}
			}
		} else {
			//ipad portrait 50%
			addPaddingRightProductSearchResult(2);
			addPaddingBottomProductSearchResult(2);
			if (checkBorderTopContainerSearchResult(2)) {
				addEmptyProductSearchResult(2, windowWidth);
			} else {
				addOneEmptyProductSearchResult(2, windowWidth);
			}
		}
		addClear();
	}
	
	function getCatName(id, what) {
		var obj = {};
		switch (what) {
			case "cat":
				product_categories.forEach(function(cate) {
					if (cate.id == id) {
						var catLinkEn = cate.acf.category_name_en
							.split("/,| /")
							.join("-")
							.split(" ")
							.join("-")
							.split("'")
							.join("-")
							.toLowerCase()
							.replace('/', '');
						var catLinkIt = cate.acf.category_name_it
							.split("/,| /")
							.join("-")
							.split(" ")
							.join("-")
							.split("'")
							.join("-")
							.toLowerCase()
							.replace('/', '');
						obj = {
							it: catLinkIt,
							en: catLinkEn
						};
					}
				});
				break;
			case "sub":
				product_subcategories.forEach(function(sub) {
					if ((sub.id = id)) {
						var catLinkEn = sub.acf.sub_category_name_en
							.split("/,| /")
							.join("-")
							.split(" ")
							.join("-")
							.split("'")
							.join("-")
							.toLowerCase()
							.replace('/', '');
						var catLinkIt = sub.acf.sub_category_name_it
							.split("/,| /")
							.join("-")
							.split(" ")
							.join("-")
							.split("'")
							.join("-")
							.toLowerCase()
							.replace('/', '');
						obj = {
							it: catLinkIt,
							en: catLinkEn
						};
					}
				});
				break;
			default:
		}
		return obj;
	}
	
	function removeEmptyProductSearchResult() {
		$(".search-container .products .object").each(function() {
			$(this).removeClass("border-bottom");
			$(this).removeClass("border-right");
			if ($(this).hasClass("empty")) {
				$(this).remove();
			}
		});
	}
	
	function addPaddingRightProductSearchResult(numbToAdd) {
		var borderRightToAdd =
			parseInt(numberProductResult % numbToAdd) +
			parseInt(numberProductResult / numbToAdd);
		var c = 1;
		$(".search-container .products .object").each(function() {
			if (c % numbToAdd == 0) {
				$(this).addClass("border-right");
			}
			c++;
		});
	}
	
	function addPaddingBottomProductSearchResult(numbToAdd) {
		var borderBottomToAdd = parseInt(numberProductResult % numbToAdd);
	
		if (numbToAdd == 1) {
			borderBottomToAdd++;
		}
		if (!borderBottomToAdd) {
			borderBottomToAdd = numbToAdd;
		}
	
		$(
			$(".search-container .products .object")
				.get()
				.reverse()
		).each(function() {
			if (borderBottomToAdd) {
				$(this).addClass("border-bottom");
				borderBottomToAdd--;
			}
		});
		squareBoxProductsSearchResult();
	}
	
	function checkBorderTopContainerSearchResult(nForLine) {
		if (nForLine > numberProductResult) {
			return false;
		} else {
			return true;
		}
	}
	
	function addEmptyProductSearchResult(divider, windowWidth) {
		var mod = numberProductResult % divider;
		if (mod != 0) {
			var divToAdd = divider - mod;
			var html = "";
			for (var i = 0; i < divToAdd; i++) {
				if (i == 0) {
					html += "<div class='empty object border-left'></div>";
				} else {
					html += "<div class='empty object'></div>";
				}
			}
	
			$(".search-container .products .box-single-result").append(html);
			squareBoxProductsSearchResult();
		}
	}
	
	function addOneEmptyProductSearchResult(divider, windowWidth) {
		var html = "<div class='empty object border-only-left'></div>";
		$(".search-container .products .box-single-result").append(html);
		squareBoxProductsSearchResult();
	}
	
	$("#search-result").on("click tap", ".jolly, .object", function() {
		window.location = $(this).data("url");
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(1);
	window.JQuery = $;
	__webpack_require__(123);
	__webpack_require__(9);
	__webpack_require__(10);
	__webpack_require__(13);
	__webpack_require__(15);
	__webpack_require__(14);
	__webpack_require__(17);
	__webpack_require__(16);
	__webpack_require__(12);
	__webpack_require__(7);
	__webpack_require__(8);
	__webpack_require__(5);
	__webpack_require__(6);

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

	module.exports = {
	
		search_input_placeholder: {
			it: 'CERCA PRODOTTI O CATEGORIE',
			en: 'SEARCH FOR PRODUCTS OR CATEGORIES',
			ru: 'ПОИСК ПРОДУКЦИИ ИЛИ КАТЕГОРИЙ'
		},
	
		home_header_title: {
			it: 'Soluzioni all\'avanguardia per i veicoli trasporto passeggeri',
			en: 'State-of-the-art solutions for mass transportation vehicles',
			ru: 'Современные решения для транспортных средств массового передвижения'
		},
	
		home_certification_title: {
			it: 'Costante ricerca della qualità, automazione dei processi, attenzione al cliente, cura dell\'ambiente e del welfare aziendale',
			en: 'Constantly researching for quality, process automation, customer care, care for the environment and for the corporate welfare',
			ru: 'Постоянное исследование и улучшение качества автоматизационных процессов, забота о корпоративном благополучии и особое внимание и обязательство перед клиентами и окружающей средой.'
		},
	
		home_intro_text: {
			it: 'PRIMA Automotive è uno dei più importanti produttori europei di articoli per veicoli industriali e progetta, produce e distribuisce in tutto il mondo componenti e sistemi complessi destinati a costruttori di veicoli per il trasporto pubblico di passeggeri, di macchine operatrici industriali ed agricole, ai settori collaterali come i produttori di cruscotti, cabine ed impianti di condizionamento, arrivando a punte di eccellenza con forniture di particolari esclusivi verso produttori di Super Cars.',
			en: 'Prima Automotive, is one of the most important European manufacturers of components for the automotive and industrial vehicles market designing, developing and distributing all over the World plastic injection molded items for manufacturers of mass transportation vehicles, industrial and agricultural machinery, manufacturers of dashboards, cabins and air conditioning systems reaching to high valuated supplies for Super car producers at whom we supply exclusive designed items.',
			ru: 'Prima Automotive является одним из ведущих европейских производителей промышленной автомобильной продукции и конструкций. Стабильно развивается на рынке авто комплектующих, производит и распространяет сложные компоненты и системы по всему миру для производителей общественных пассажирских транспортных средств, машин промышленных и сельскохозяйственных, а так же для производителей приборных панелей, кабин и систем кондиционирования воздуха, достигая  вершин совершенства, поставляя эксклюзивные запчасти производителям Super Car.'
		},
	
		discover_more: {
			it: 'Scopri di più',
			en: 'Discover more',
			ru: 'УЗНАТЬ БОЛЬШЕ'
		},
	
		view_more: {
			it: 'Vedi di più',
			en: 'View more'
		},
	
		view_less: {
			it: 'Chiudi',
			en: 'View less'
		},
	
		view_all: {
			it: 'Vedi tutti',
			en: 'View all'
		},
	
		// Applicazioni
		autobus: {
			it: 'Autobus',
			en: 'Coaches',
			ru: 'автобус'
		},
	
		minibus: {
			it: 'Mini-bus',
			en: 'Mini-bus',
			ru: 'мини-автобус'
		},
	
		citybus: {
			it: 'Bus urbani',
			en: 'Mini-bus',
			ru: 'мини-автобус'
		},
	
		industrial_vehicles: {
			it: 'Veicoli industriali',
			en: 'Industrial vehicles',
			ru: 'промышленные транспортные средства'
		},
	
		special_vehicles: {
			it: 'Veicoli speciali',
			en: 'Special vehicles',
			ru: 'транспортные средства особого назначения'
		},
	
		underground: {
			it: 'Metropolitana e treni',
			en: 'Underground rail railways',
			ru: 'метро и поезда'
		},
	
		wellness: {
			it: 'Wellness',
			en: 'Wellness',
			ru: 'ОЗДОРОВЛЕНИЕ'
		},
	
		// product page GUI
	
		automotive_components: {
			it: 'Componenti per l\'automotive',
			en: 'Automotive components',
			ru: 'Автокомпоненты'
		},
	
		technical_features: {
			it: 'Specifiche tecniche',
			en: 'Technical features',
			ru: 'Технические характеристики'
		},
	
		ask_for_info: {
			it: 'Richiedi informazioni',
			en: 'Ask for information',
			ru: 'ЗАПРОСИТЬ ИНФОРМАЦИЮ'
		},
	
		download_tech_sheet: {
			it: 'Scarica scheda tecnica',
			en: 'Download tech sheet',
			ru: 'ЗАГРУЗИТЬ СПЕЦИФИКАЦИЮ'
		},
	
		download_manual: {
			it: 'Scarica il manuale',
			en: 'Download manual',
			ru: 'ЗАГРУЗИТЬ РУКОВОДСТВО'
		},
	
		manual_not_available: {
			it: 'Spiacente, per questo prodotto non è disponibile il manuale.',
			en: 'Sorry, no manual available for this product.',
			ru: 'Sorry, no manual available for this product.'
		},
	
		check_technical_sheet: {
			it: 'Consulta la scheda tecnica',
			en: 'View the technical sheet',
			ru: 'View the technical sheet'
		},
	
		download_jok_manual: {
			it: 'Manuale del JOK System',
			en: 'JOK System manual',
			ru: 'JOK System manual'
		},
	
		other_documents: {
			it: 'Altri documenti',
			en: 'Other documents',
			ru: 'ДРУГИЕ ДОКУМЕНТЫ'
		},
	
		all_products: {
			it: 'Tutti i prodotti',
			en: 'All products',
			ru: 'все продукты'
		},
	
		all_categories: {
			it: 'Tutte le categorie',
			en: 'All categories',
			ru: 'все категории'
		},
	
		download_full_catalogue: {
			it: 'SCARICA',
			en: 'DOWNLOAD',
			ru: 'ЗАГРУЗИТЬ ПОЛНУЮ ВЕРСИЮ КАТАЛОГА'
		},
	
		directives_and_regulations: {
			it: 'Direttive e regolamenti',
			en: 'Directives and regulations',
			ru: 'ДИРЕКТИВЫ И ПРАВИЛА'
		},
	
		recently_viewed_product: {
			it: 'Prodotti visti di recente',
			en: 'RECENTLY VIEWED PRODUCTS',
			ru: 'НЕДАВНО ПРОСМОТРЕННЫЕ ПРОДУКТЫ'
		},
	
		interested_in_this: {
			it: 'Interessato a questo prodotto ?',
			en: 'interested in this product ?',
			ru: 'Вы заинтересованы в этом продукте?'
		},
	
		interested_in_this_group: {
			it: 'Interessato a questi prodotti ?',
			en: 'Interested in these products?',
			ru: 'Заинтересованы в этих продуктах?'
		},
	
		// Contacts page
		contact_form_title: {
			it: 'Siamo qui per aiutarti',
			en: 'We are here to help you',
			ru: 'Mы здесь, чтобы помочь вам'
		},
	
		name_label: {
			it: 'Nome',
			en: 'Name',
			ru: 'Имя'
		},
	
		surname_label: {
			it: 'Cognome',
			en: 'Surname',
			ru: 'Фамилия'
		},
	
		nation_label: {
			it: 'Nazione',
			en: 'Nation',
			ru: 'Страна'
		},
	
		company_label: {
			it: 'Azienda',
			en: 'Company',
			ru: 'Компании'
		},
	
		email_label: {
			it: 'Indirizzo email',
			en: 'Email address',
			ru: 'Адрес электронной почты'
		},
	
		website_label: {
			it: 'Sito web',
			en: 'Website',
			ru: 'Сайт'
		},
	
		city_label: {
			it: 'Città',
			en: 'City',
			ru: 'Город'
		},
	
		cap_label: {
			it: 'CAP',
			en: 'ZIP Code',
			ru: 'Индекс'
		},
	
		select_subject: {
			it: 'Seleziona il soggetto',
			en: 'Select subject',
			ru: 'Выберите тему'
		},
	
		subject_job_opportunities: {
			it: 'Opportunità lavorative',
			en: 'Job opportunities',
			ru: 'Вакансии/сотрудничество'
		},
	
		subject_tech_support: {
			it: 'Supporto tecnico',
			en: 'Technical support',
			ru: 'Техническая поддержка'
		},
	
		subject_general_informations: {
			it: 'Informazioni generali',
			en: 'General informations',
			ru: 'Общие сведения'
		},
	
		subject_product_informations: {
			it: 'Informazioni sul prodotto',
			en: 'Informations about product',
			ru: 'Сведения о продукте'
		},
	
		subject_business_proposal: {
			it: 'Proposte di collaborazione',
			en: 'Business proposal',
			ru: 'Business proposal'
		},
	
		write_message: {
			it: 'Scrivi il messaggio',
			en: 'Write your message',
			ru: 'Написать сообщение'
		},
	
		send_butt: {
			it: 'Invia',
			en: 'Send',
			ru: 'Отправить'
		},
	
		// Teams
		team: {
			it: 'Team',
			en: 'Team',
			ru: 'Команда'
		},
	
		plant_manager: {
			it: 'Dir. Stabilimento, Resp. Acquisti',
			en: 'Plant Manager, Supply Man.',
			ru: 'Управляющий, менеджер по закупкам'
		},
	
		quality_manager: {
			it: 'Resp. Sistema Integrato (Qualità, Ambiente e Sicurezza)',
			en: 'Integrated System Manager (Quality, Environment and Security)',
			ru: 'Менеджер интегрированной системы (качество, окружающая среда, безопаснось)'
		},
	
		customer_service: {
			it: 'Assistenza Clienti',
			en: 'Customer service',
			ru: 'Поддержка клиентов'
		},
	
		clients_administration: {
			it: 'Amministrazione clienti',
			en: 'Clients administration',
			ru: 'Управление клиентами'
		},
	
		technical_assistance: {
			it: 'Supporto prodotto, Assistenza tecnica',
			en: 'Technical Assistance',
			ru: 'Поддержка по продукту, техническая помощь'
		},
	
		transport_logistics: {
			it: 'Spedizioni & Logistica',
			en: 'Transport & Logistics',
			ru: 'Доставка и логистика'
		},
	
		commercial_director: {
			it: 'Sales & Marketing manager',
			en: 'Sales & Marketing manager',
			ru: 'Коммерческий директор'
		},
	
		area_1: {
			it: 'Asia, Oceania, America, Europa Occidentale*',
			en: 'Asia, Oceania, America, Western Europe*',
			ru: 'Азия, Океания, Америка, Западная Европа'
		},
	
		area_2: {
			it: '*Norvegia, Svezia, Islanda, Danimarca, Finlandia',
			en: '*Norway, Sweden, Iceland, Denmark, Finland',
			ru: 'Норвегия, Швеция, Исландия, Дания, Финляндия'
		},
	
		area_3: {
			it: 'Italia, San Marino, Europa dell’Est, Europa Occidentale **',
			en: 'Italy, San Marino, Eastern Europe, Western Europe **',
			ru: 'Италия, Сан-Марино, Восточная и Западная Европа'
		},
	
		area_4: {
			it: '**Austria, Germania, Svizzera',
			en: '**Austria, Germany, Switzerland',
			ru: 'Австрия, Германия, Швейцария'
		},
	
		area_5: {
			it: 'Medio Oriente, Africa, Europa Occidentale ***',
			en: 'Middle East, Africa, Western Europe ***',
			ru: 'Средний Восток, Африка, Западная Европа'
		},
	
		area_6: {
			it: '***Irlanda, Francia, Spagna, Portogallo, Benelux, Grecia, Cipro, Malta, Regno Unito',
			en: '***Ireland, France, Spain, Portugal, Benelux, Greece, Cyprus, Malta, United Kingdom',
			ru: 'Ирландия, Франция, Испания, Португалия, Бенилюкс, Греция, Кипр, Мальта, Великобритания'
		}
	
	};

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * Swiper 3.4.2
	 * Most modern mobile touch slider and framework with hardware accelerated transitions
	 * 
	 * http://www.idangero.us/swiper/
	 * 
	 * Copyright 2017, Vladimir Kharlampidi
	 * The iDangero.us
	 * http://www.idangero.us/
	 * 
	 * Licensed under MIT
	 * 
	 * Released on: March 10, 2017
	 */
	(function () {
	    'use strict';
	    var $;
	
	    /*===========================
	    Swiper
	    ===========================*/
	    var Swiper = function (container, params) {
	        if (!(this instanceof Swiper)) return new Swiper(container, params);
	    
	
	        var defaults = {
	            direction: 'horizontal',
	            touchEventsTarget: 'container',
	            initialSlide: 0,
	            speed: 300,
	            // autoplay
	            autoplay: false,
	            autoplayDisableOnInteraction: true,
	            autoplayStopOnLast: false,
	            // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
	            iOSEdgeSwipeDetection: false,
	            iOSEdgeSwipeThreshold: 20,
	            // Free mode
	            freeMode: false,
	            freeModeMomentum: true,
	            freeModeMomentumRatio: 1,
	            freeModeMomentumBounce: true,
	            freeModeMomentumBounceRatio: 1,
	            freeModeMomentumVelocityRatio: 1,
	            freeModeSticky: false,
	            freeModeMinimumVelocity: 0.02,
	            // Autoheight
	            autoHeight: false,
	            // Set wrapper width
	            setWrapperSize: false,
	            // Virtual Translate
	            virtualTranslate: false,
	            // Effects
	            effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
	            coverflow: {
	                rotate: 50,
	                stretch: 0,
	                depth: 100,
	                modifier: 1,
	                slideShadows : true
	            },
	            flip: {
	                slideShadows : true,
	                limitRotation: true
	            },
	            cube: {
	                slideShadows: true,
	                shadow: true,
	                shadowOffset: 20,
	                shadowScale: 0.94
	            },
	            fade: {
	                crossFade: false
	            },
	            // Parallax
	            parallax: false,
	            // Zoom
	            zoom: false,
	            zoomMax: 3,
	            zoomMin: 1,
	            zoomToggle: true,
	            // Scrollbar
	            scrollbar: null,
	            scrollbarHide: true,
	            scrollbarDraggable: false,
	            scrollbarSnapOnRelease: false,
	            // Keyboard Mousewheel
	            keyboardControl: false,
	            mousewheelControl: false,
	            mousewheelReleaseOnEdges: false,
	            mousewheelInvert: false,
	            mousewheelForceToAxis: false,
	            mousewheelSensitivity: 1,
	            mousewheelEventsTarged: 'container',
	            // Hash Navigation
	            hashnav: false,
	            hashnavWatchState: false,
	            // History
	            history: false,
	            // Commong Nav State
	            replaceState: false,
	            // Breakpoints
	            breakpoints: undefined,
	            // Slides grid
	            spaceBetween: 0,
	            slidesPerView: 1,
	            slidesPerColumn: 1,
	            slidesPerColumnFill: 'column',
	            slidesPerGroup: 1,
	            centeredSlides: false,
	            slidesOffsetBefore: 0, // in px
	            slidesOffsetAfter: 0, // in px
	            // Round length
	            roundLengths: false,
	            // Touches
	            touchRatio: 1,
	            touchAngle: 45,
	            simulateTouch: true,
	            shortSwipes: true,
	            longSwipes: true,
	            longSwipesRatio: 0.5,
	            longSwipesMs: 300,
	            followFinger: true,
	            onlyExternal: false,
	            threshold: 0,
	            touchMoveStopPropagation: true,
	            touchReleaseOnEdges: false,
	            // Unique Navigation Elements
	            uniqueNavElements: true,
	            // Pagination
	            pagination: null,
	            paginationElement: 'span',
	            paginationClickable: false,
	            paginationHide: false,
	            paginationBulletRender: null,
	            paginationProgressRender: null,
	            paginationFractionRender: null,
	            paginationCustomRender: null,
	            paginationType: 'bullets', // 'bullets' or 'progress' or 'fraction' or 'custom'
	            // Resistance
	            resistance: true,
	            resistanceRatio: 0.85,
	            // Next/prev buttons
	            nextButton: null,
	            prevButton: null,
	            // Progress
	            watchSlidesProgress: false,
	            watchSlidesVisibility: false,
	            // Cursor
	            grabCursor: false,
	            // Clicks
	            preventClicks: true,
	            preventClicksPropagation: true,
	            slideToClickedSlide: false,
	            // Lazy Loading
	            lazyLoading: false,
	            lazyLoadingInPrevNext: false,
	            lazyLoadingInPrevNextAmount: 1,
	            lazyLoadingOnTransitionStart: false,
	            // Images
	            preloadImages: true,
	            updateOnImagesReady: true,
	            // loop
	            loop: false,
	            loopAdditionalSlides: 0,
	            loopedSlides: null,
	            // Control
	            control: undefined,
	            controlInverse: false,
	            controlBy: 'slide', //or 'container'
	            normalizeSlideIndex: true,
	            // Swiping/no swiping
	            allowSwipeToPrev: true,
	            allowSwipeToNext: true,
	            swipeHandler: null, //'.swipe-handler',
	            noSwiping: true,
	            noSwipingClass: 'swiper-no-swiping',
	            // Passive Listeners
	            passiveListeners: true,
	            // NS
	            containerModifierClass: 'swiper-container-', // NEW
	            slideClass: 'swiper-slide',
	            slideActiveClass: 'swiper-slide-active',
	            slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
	            slideVisibleClass: 'swiper-slide-visible',
	            slideDuplicateClass: 'swiper-slide-duplicate',
	            slideNextClass: 'swiper-slide-next',
	            slideDuplicateNextClass: 'swiper-slide-duplicate-next',
	            slidePrevClass: 'swiper-slide-prev',
	            slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
	            wrapperClass: 'swiper-wrapper',
	            bulletClass: 'swiper-pagination-bullet',
	            bulletActiveClass: 'swiper-pagination-bullet-active',
	            buttonDisabledClass: 'swiper-button-disabled',
	            paginationCurrentClass: 'swiper-pagination-current',
	            paginationTotalClass: 'swiper-pagination-total',
	            paginationHiddenClass: 'swiper-pagination-hidden',
	            paginationProgressbarClass: 'swiper-pagination-progressbar',
	            paginationClickableClass: 'swiper-pagination-clickable', // NEW
	            paginationModifierClass: 'swiper-pagination-', // NEW
	            lazyLoadingClass: 'swiper-lazy',
	            lazyStatusLoadingClass: 'swiper-lazy-loading',
	            lazyStatusLoadedClass: 'swiper-lazy-loaded',
	            lazyPreloaderClass: 'swiper-lazy-preloader',
	            notificationClass: 'swiper-notification',
	            preloaderClass: 'preloader',
	            zoomContainerClass: 'swiper-zoom-container',
	        
	            // Observer
	            observer: false,
	            observeParents: false,
	            // Accessibility
	            a11y: false,
	            prevSlideMessage: 'Previous slide',
	            nextSlideMessage: 'Next slide',
	            firstSlideMessage: 'This is the first slide',
	            lastSlideMessage: 'This is the last slide',
	            paginationBulletMessage: 'Go to slide {{index}}',
	            // Callbacks
	            runCallbacksOnInit: true
	            /*
	            Callbacks:
	            onInit: function (swiper)
	            onDestroy: function (swiper)
	            onBeforeResize: function (swiper)
	            onAfterResize: function (swiper)
	            onClick: function (swiper, e)
	            onTap: function (swiper, e)
	            onDoubleTap: function (swiper, e)
	            onSliderMove: function (swiper, e)
	            onSlideChangeStart: function (swiper)
	            onSlideChangeEnd: function (swiper)
	            onTransitionStart: function (swiper)
	            onTransitionEnd: function (swiper)
	            onImagesReady: function (swiper)
	            onProgress: function (swiper, progress)
	            onTouchStart: function (swiper, e)
	            onTouchMove: function (swiper, e)
	            onTouchMoveOpposite: function (swiper, e)
	            onTouchEnd: function (swiper, e)
	            onReachBeginning: function (swiper)
	            onReachEnd: function (swiper)
	            onSetTransition: function (swiper, duration)
	            onSetTranslate: function (swiper, translate)
	            onAutoplayStart: function (swiper)
	            onAutoplayStop: function (swiper),
	            onLazyImageLoad: function (swiper, slide, image)
	            onLazyImageReady: function (swiper, slide, image)
	            onKeyPress: function (swiper, keyCode)
	            */
	        
	        };
	        var initialVirtualTranslate = params && params.virtualTranslate;
	        
	        params = params || {};
	        var originalParams = {};
	        for (var param in params) {
	            if (typeof params[param] === 'object' && params[param] !== null && !(params[param].nodeType || params[param] === window || params[param] === document || (typeof Dom7 !== 'undefined' && params[param] instanceof Dom7) || (typeof jQuery !== 'undefined' && params[param] instanceof jQuery))) {
	                originalParams[param] = {};
	                for (var deepParam in params[param]) {
	                    originalParams[param][deepParam] = params[param][deepParam];
	                }
	            }
	            else {
	                originalParams[param] = params[param];
	            }
	        }
	        for (var def in defaults) {
	            if (typeof params[def] === 'undefined') {
	                params[def] = defaults[def];
	            }
	            else if (typeof params[def] === 'object') {
	                for (var deepDef in defaults[def]) {
	                    if (typeof params[def][deepDef] === 'undefined') {
	                        params[def][deepDef] = defaults[def][deepDef];
	                    }
	                }
	            }
	        }
	        
	        // Swiper
	        var s = this;
	        
	        // Params
	        s.params = params;
	        s.originalParams = originalParams;
	        
	        // Classname
	        s.classNames = [];
	        /*=========================
	          Dom Library and plugins
	          ===========================*/
	        if (typeof $ !== 'undefined' && typeof Dom7 !== 'undefined'){
	            $ = Dom7;
	        }
	        if (typeof $ === 'undefined') {
	            if (typeof Dom7 === 'undefined') {
	                $ = window.Dom7 || window.Zepto || window.jQuery;
	            }
	            else {
	                $ = Dom7;
	            }
	            if (!$) return;
	        }
	        // Export it to Swiper instance
	        s.$ = $;
	        
	        /*=========================
	          Breakpoints
	          ===========================*/
	        s.currentBreakpoint = undefined;
	        s.getActiveBreakpoint = function () {
	            //Get breakpoint for window width
	            if (!s.params.breakpoints) return false;
	            var breakpoint = false;
	            var points = [], point;
	            for ( point in s.params.breakpoints ) {
	                if (s.params.breakpoints.hasOwnProperty(point)) {
	                    points.push(point);
	                }
	            }
	            points.sort(function (a, b) {
	                return parseInt(a, 10) > parseInt(b, 10);
	            });
	            for (var i = 0; i < points.length; i++) {
	                point = points[i];
	                if (point >= window.innerWidth && !breakpoint) {
	                    breakpoint = point;
	                }
	            }
	            return breakpoint || 'max';
	        };
	        s.setBreakpoint = function () {
	            //Set breakpoint for window width and update parameters
	            var breakpoint = s.getActiveBreakpoint();
	            if (breakpoint && s.currentBreakpoint !== breakpoint) {
	                var breakPointsParams = breakpoint in s.params.breakpoints ? s.params.breakpoints[breakpoint] : s.originalParams;
	                var needsReLoop = s.params.loop && (breakPointsParams.slidesPerView !== s.params.slidesPerView);
	                for ( var param in breakPointsParams ) {
	                    s.params[param] = breakPointsParams[param];
	                }
	                s.currentBreakpoint = breakpoint;
	                if(needsReLoop && s.destroyLoop) {
	                    s.reLoop(true);
	                }
	            }
	        };
	        // Set breakpoint on load
	        if (s.params.breakpoints) {
	            s.setBreakpoint();
	        }
	        
	        /*=========================
	          Preparation - Define Container, Wrapper and Pagination
	          ===========================*/
	        s.container = $(container);
	        if (s.container.length === 0) return;
	        if (s.container.length > 1) {
	            var swipers = [];
	            s.container.each(function () {
	                var container = this;
	                swipers.push(new Swiper(this, params));
	            });
	            return swipers;
	        }
	        
	        // Save instance in container HTML Element and in data
	        s.container[0].swiper = s;
	        s.container.data('swiper', s);
	        
	        s.classNames.push(s.params.containerModifierClass + s.params.direction);
	        
	        if (s.params.freeMode) {
	            s.classNames.push(s.params.containerModifierClass + 'free-mode');
	        }
	        if (!s.support.flexbox) {
	            s.classNames.push(s.params.containerModifierClass + 'no-flexbox');
	            s.params.slidesPerColumn = 1;
	        }
	        if (s.params.autoHeight) {
	            s.classNames.push(s.params.containerModifierClass + 'autoheight');
	        }
	        // Enable slides progress when required
	        if (s.params.parallax || s.params.watchSlidesVisibility) {
	            s.params.watchSlidesProgress = true;
	        }
	        // Max resistance when touchReleaseOnEdges
	        if (s.params.touchReleaseOnEdges) {
	            s.params.resistanceRatio = 0;
	        }
	        // Coverflow / 3D
	        if (['cube', 'coverflow', 'flip'].indexOf(s.params.effect) >= 0) {
	            if (s.support.transforms3d) {
	                s.params.watchSlidesProgress = true;
	                s.classNames.push(s.params.containerModifierClass + '3d');
	            }
	            else {
	                s.params.effect = 'slide';
	            }
	        }
	        if (s.params.effect !== 'slide') {
	            s.classNames.push(s.params.containerModifierClass + s.params.effect);
	        }
	        if (s.params.effect === 'cube') {
	            s.params.resistanceRatio = 0;
	            s.params.slidesPerView = 1;
	            s.params.slidesPerColumn = 1;
	            s.params.slidesPerGroup = 1;
	            s.params.centeredSlides = false;
	            s.params.spaceBetween = 0;
	            s.params.virtualTranslate = true;
	        }
	        if (s.params.effect === 'fade' || s.params.effect === 'flip') {
	            s.params.slidesPerView = 1;
	            s.params.slidesPerColumn = 1;
	            s.params.slidesPerGroup = 1;
	            s.params.watchSlidesProgress = true;
	            s.params.spaceBetween = 0;
	            if (typeof initialVirtualTranslate === 'undefined') {
	                s.params.virtualTranslate = true;
	            }
	        }
	        
	        // Grab Cursor
	        if (s.params.grabCursor && s.support.touch) {
	            s.params.grabCursor = false;
	        }
	        
	        // Wrapper
	        s.wrapper = s.container.children('.' + s.params.wrapperClass);
	        
	        // Pagination
	        if (s.params.pagination) {
	            s.paginationContainer = $(s.params.pagination);
	            if (s.params.uniqueNavElements && typeof s.params.pagination === 'string' && s.paginationContainer.length > 1 && s.container.find(s.params.pagination).length === 1) {
	                s.paginationContainer = s.container.find(s.params.pagination);
	            }
	        
	            if (s.params.paginationType === 'bullets' && s.params.paginationClickable) {
	                s.paginationContainer.addClass(s.params.paginationModifierClass + 'clickable');
	            }
	            else {
	                s.params.paginationClickable = false;
	            }
	            s.paginationContainer.addClass(s.params.paginationModifierClass + s.params.paginationType);
	        }
	        // Next/Prev Buttons
	        if (s.params.nextButton || s.params.prevButton) {
	            if (s.params.nextButton) {
	                s.nextButton = $(s.params.nextButton);
	                if (s.params.uniqueNavElements && typeof s.params.nextButton === 'string' && s.nextButton.length > 1 && s.container.find(s.params.nextButton).length === 1) {
	                    s.nextButton = s.container.find(s.params.nextButton);
	                }
	            }
	            if (s.params.prevButton) {
	                s.prevButton = $(s.params.prevButton);
	                if (s.params.uniqueNavElements && typeof s.params.prevButton === 'string' && s.prevButton.length > 1 && s.container.find(s.params.prevButton).length === 1) {
	                    s.prevButton = s.container.find(s.params.prevButton);
	                }
	            }
	        }
	        
	        // Is Horizontal
	        s.isHorizontal = function () {
	            return s.params.direction === 'horizontal';
	        };
	        // s.isH = isH;
	        
	        // RTL
	        s.rtl = s.isHorizontal() && (s.container[0].dir.toLowerCase() === 'rtl' || s.container.css('direction') === 'rtl');
	        if (s.rtl) {
	            s.classNames.push(s.params.containerModifierClass + 'rtl');
	        }
	        
	        // Wrong RTL support
	        if (s.rtl) {
	            s.wrongRTL = s.wrapper.css('display') === '-webkit-box';
	        }
	        
	        // Columns
	        if (s.params.slidesPerColumn > 1) {
	            s.classNames.push(s.params.containerModifierClass + 'multirow');
	        }
	        
	        // Check for Android
	        if (s.device.android) {
	            s.classNames.push(s.params.containerModifierClass + 'android');
	        }
	        
	        // Add classes
	        s.container.addClass(s.classNames.join(' '));
	        
	        // Translate
	        s.translate = 0;
	        
	        // Progress
	        s.progress = 0;
	        
	        // Velocity
	        s.velocity = 0;
	        
	        /*=========================
	          Locks, unlocks
	          ===========================*/
	        s.lockSwipeToNext = function () {
	            s.params.allowSwipeToNext = false;
	            if (s.params.allowSwipeToPrev === false && s.params.grabCursor) {
	                s.unsetGrabCursor();
	            }
	        };
	        s.lockSwipeToPrev = function () {
	            s.params.allowSwipeToPrev = false;
	            if (s.params.allowSwipeToNext === false && s.params.grabCursor) {
	                s.unsetGrabCursor();
	            }
	        };
	        s.lockSwipes = function () {
	            s.params.allowSwipeToNext = s.params.allowSwipeToPrev = false;
	            if (s.params.grabCursor) s.unsetGrabCursor();
	        };
	        s.unlockSwipeToNext = function () {
	            s.params.allowSwipeToNext = true;
	            if (s.params.allowSwipeToPrev === true && s.params.grabCursor) {
	                s.setGrabCursor();
	            }
	        };
	        s.unlockSwipeToPrev = function () {
	            s.params.allowSwipeToPrev = true;
	            if (s.params.allowSwipeToNext === true && s.params.grabCursor) {
	                s.setGrabCursor();
	            }
	        };
	        s.unlockSwipes = function () {
	            s.params.allowSwipeToNext = s.params.allowSwipeToPrev = true;
	            if (s.params.grabCursor) s.setGrabCursor();
	        };
	        
	        /*=========================
	          Round helper
	          ===========================*/
	        function round(a) {
	            return Math.floor(a);
	        }
	        /*=========================
	          Set grab cursor
	          ===========================*/
	        s.setGrabCursor = function(moving) {
	            s.container[0].style.cursor = 'move';
	            s.container[0].style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
	            s.container[0].style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
	            s.container[0].style.cursor = moving ? 'grabbing': 'grab';
	        };
	        s.unsetGrabCursor = function () {
	            s.container[0].style.cursor = '';
	        };
	        if (s.params.grabCursor) {
	            s.setGrabCursor();
	        }
	        /*=========================
	          Update on Images Ready
	          ===========================*/
	        s.imagesToLoad = [];
	        s.imagesLoaded = 0;
	        
	        s.loadImage = function (imgElement, src, srcset, sizes, checkForComplete, callback) {
	            var image;
	            function onReady () {
	                if (callback) callback();
	            }
	            if (!imgElement.complete || !checkForComplete) {
	                if (src) {
	                    image = new window.Image();
	                    image.onload = onReady;
	                    image.onerror = onReady;
	                    if (sizes) {
	                        image.sizes = sizes;
	                    }
	                    if (srcset) {
	                        image.srcset = srcset;
	                    }
	                    if (src) {
	                        image.src = src;
	                    }
	                } else {
	                    onReady();
	                }
	        
	            } else {//image already loaded...
	                onReady();
	            }
	        };
	        s.preloadImages = function () {
	            s.imagesToLoad = s.container.find('img');
	            function _onReady() {
	                if (typeof s === 'undefined' || s === null || !s) return;
	                if (s.imagesLoaded !== undefined) s.imagesLoaded++;
	                if (s.imagesLoaded === s.imagesToLoad.length) {
	                    if (s.params.updateOnImagesReady) s.update();
	                    s.emit('onImagesReady', s);
	                }
	            }
	            for (var i = 0; i < s.imagesToLoad.length; i++) {
	                s.loadImage(s.imagesToLoad[i], (s.imagesToLoad[i].currentSrc || s.imagesToLoad[i].getAttribute('src')), (s.imagesToLoad[i].srcset || s.imagesToLoad[i].getAttribute('srcset')), s.imagesToLoad[i].sizes || s.imagesToLoad[i].getAttribute('sizes'), true, _onReady);
	            }
	        };
	        
	        /*=========================
	          Autoplay
	          ===========================*/
	        s.autoplayTimeoutId = undefined;
	        s.autoplaying = false;
	        s.autoplayPaused = false;
	        function autoplay() {
	            var autoplayDelay = s.params.autoplay;
	            var activeSlide = s.slides.eq(s.activeIndex);
	            if (activeSlide.attr('data-swiper-autoplay')) {
	                autoplayDelay = activeSlide.attr('data-swiper-autoplay') || s.params.autoplay;
	            }
	            s.autoplayTimeoutId = setTimeout(function () {
	                if (s.params.loop) {
	                    s.fixLoop();
	                    s._slideNext();
	                    s.emit('onAutoplay', s);
	                }
	                else {
	                    if (!s.isEnd) {
	                        s._slideNext();
	                        s.emit('onAutoplay', s);
	                    }
	                    else {
	                        if (!params.autoplayStopOnLast) {
	                            s._slideTo(0);
	                            s.emit('onAutoplay', s);
	                        }
	                        else {
	                            s.stopAutoplay();
	                        }
	                    }
	                }
	            }, autoplayDelay);
	        }
	        s.startAutoplay = function () {
	            if (typeof s.autoplayTimeoutId !== 'undefined') return false;
	            if (!s.params.autoplay) return false;
	            if (s.autoplaying) return false;
	            s.autoplaying = true;
	            s.emit('onAutoplayStart', s);
	            autoplay();
	        };
	        s.stopAutoplay = function (internal) {
	            if (!s.autoplayTimeoutId) return;
	            if (s.autoplayTimeoutId) clearTimeout(s.autoplayTimeoutId);
	            s.autoplaying = false;
	            s.autoplayTimeoutId = undefined;
	            s.emit('onAutoplayStop', s);
	        };
	        s.pauseAutoplay = function (speed) {
	            if (s.autoplayPaused) return;
	            if (s.autoplayTimeoutId) clearTimeout(s.autoplayTimeoutId);
	            s.autoplayPaused = true;
	            if (speed === 0) {
	                s.autoplayPaused = false;
	                autoplay();
	            }
	            else {
	                s.wrapper.transitionEnd(function () {
	                    if (!s) return;
	                    s.autoplayPaused = false;
	                    if (!s.autoplaying) {
	                        s.stopAutoplay();
	                    }
	                    else {
	                        autoplay();
	                    }
	                });
	            }
	        };
	        /*=========================
	          Min/Max Translate
	          ===========================*/
	        s.minTranslate = function () {
	            return (-s.snapGrid[0]);
	        };
	        s.maxTranslate = function () {
	            return (-s.snapGrid[s.snapGrid.length - 1]);
	        };
	        /*=========================
	          Slider/slides sizes
	          ===========================*/
	        s.updateAutoHeight = function () {
	            var activeSlides = [];
	            var newHeight = 0;
	            var i;
	        
	            // Find slides currently in view
	            if(s.params.slidesPerView !== 'auto' && s.params.slidesPerView > 1) {
	                for (i = 0; i < Math.ceil(s.params.slidesPerView); i++) {
	                    var index = s.activeIndex + i;
	                    if(index > s.slides.length) break;
	                    activeSlides.push(s.slides.eq(index)[0]);
	                }
	            } else {
	                activeSlides.push(s.slides.eq(s.activeIndex)[0]);
	            }
	        
	            // Find new height from heighest slide in view
	            for (i = 0; i < activeSlides.length; i++) {
	                if (typeof activeSlides[i] !== 'undefined') {
	                    var height = activeSlides[i].offsetHeight;
	                    newHeight = height > newHeight ? height : newHeight;
	                }
	            }
	        
	            // Update Height
	            if (newHeight) s.wrapper.css('height', newHeight + 'px');
	        };
	        s.updateContainerSize = function () {
	            var width, height;
	            if (typeof s.params.width !== 'undefined') {
	                width = s.params.width;
	            }
	            else {
	                width = s.container[0].clientWidth;
	            }
	            if (typeof s.params.height !== 'undefined') {
	                height = s.params.height;
	            }
	            else {
	                height = s.container[0].clientHeight;
	            }
	            if (width === 0 && s.isHorizontal() || height === 0 && !s.isHorizontal()) {
	                return;
	            }
	        
	            //Subtract paddings
	            width = width - parseInt(s.container.css('padding-left'), 10) - parseInt(s.container.css('padding-right'), 10);
	            height = height - parseInt(s.container.css('padding-top'), 10) - parseInt(s.container.css('padding-bottom'), 10);
	        
	            // Store values
	            s.width = width;
	            s.height = height;
	            s.size = s.isHorizontal() ? s.width : s.height;
	        };
	        
	        s.updateSlidesSize = function () {
	            s.slides = s.wrapper.children('.' + s.params.slideClass);
	            s.snapGrid = [];
	            s.slidesGrid = [];
	            s.slidesSizesGrid = [];
	        
	            var spaceBetween = s.params.spaceBetween,
	                slidePosition = -s.params.slidesOffsetBefore,
	                i,
	                prevSlideSize = 0,
	                index = 0;
	            if (typeof s.size === 'undefined') return;
	            if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
	                spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * s.size;
	            }
	        
	            s.virtualSize = -spaceBetween;
	            // reset margins
	            if (s.rtl) s.slides.css({marginLeft: '', marginTop: ''});
	            else s.slides.css({marginRight: '', marginBottom: ''});
	        
	            var slidesNumberEvenToRows;
	            if (s.params.slidesPerColumn > 1) {
	                if (Math.floor(s.slides.length / s.params.slidesPerColumn) === s.slides.length / s.params.slidesPerColumn) {
	                    slidesNumberEvenToRows = s.slides.length;
	                }
	                else {
	                    slidesNumberEvenToRows = Math.ceil(s.slides.length / s.params.slidesPerColumn) * s.params.slidesPerColumn;
	                }
	                if (s.params.slidesPerView !== 'auto' && s.params.slidesPerColumnFill === 'row') {
	                    slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, s.params.slidesPerView * s.params.slidesPerColumn);
	                }
	            }
	        
	            // Calc slides
	            var slideSize;
	            var slidesPerColumn = s.params.slidesPerColumn;
	            var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
	            var numFullColumns = slidesPerRow - (s.params.slidesPerColumn * slidesPerRow - s.slides.length);
	            for (i = 0; i < s.slides.length; i++) {
	                slideSize = 0;
	                var slide = s.slides.eq(i);
	                if (s.params.slidesPerColumn > 1) {
	                    // Set slides order
	                    var newSlideOrderIndex;
	                    var column, row;
	                    if (s.params.slidesPerColumnFill === 'column') {
	                        column = Math.floor(i / slidesPerColumn);
	                        row = i - column * slidesPerColumn;
	                        if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn-1)) {
	                            if (++row >= slidesPerColumn) {
	                                row = 0;
	                                column++;
	                            }
	                        }
	                        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
	                        slide
	                            .css({
	                                '-webkit-box-ordinal-group': newSlideOrderIndex,
	                                '-moz-box-ordinal-group': newSlideOrderIndex,
	                                '-ms-flex-order': newSlideOrderIndex,
	                                '-webkit-order': newSlideOrderIndex,
	                                'order': newSlideOrderIndex
	                            });
	                    }
	                    else {
	                        row = Math.floor(i / slidesPerRow);
	                        column = i - row * slidesPerRow;
	                    }
	                    slide
	                        .css(
	                            'margin-' + (s.isHorizontal() ? 'top' : 'left'),
	                            (row !== 0 && s.params.spaceBetween) && (s.params.spaceBetween + 'px')
	                        )
	                        .attr('data-swiper-column', column)
	                        .attr('data-swiper-row', row);
	        
	                }
	                if (slide.css('display') === 'none') continue;
	                if (s.params.slidesPerView === 'auto') {
	                    slideSize = s.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
	                    if (s.params.roundLengths) slideSize = round(slideSize);
	                }
	                else {
	                    slideSize = (s.size - (s.params.slidesPerView - 1) * spaceBetween) / s.params.slidesPerView;
	                    if (s.params.roundLengths) slideSize = round(slideSize);
	        
	                    if (s.isHorizontal()) {
	                        s.slides[i].style.width = slideSize + 'px';
	                    }
	                    else {
	                        s.slides[i].style.height = slideSize + 'px';
	                    }
	                }
	                s.slides[i].swiperSlideSize = slideSize;
	                s.slidesSizesGrid.push(slideSize);
	        
	        
	                if (s.params.centeredSlides) {
	                    slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
	                    if(prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - s.size / 2 - spaceBetween;
	                    if (i === 0) slidePosition = slidePosition - s.size / 2 - spaceBetween;
	                    if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
	                    if ((index) % s.params.slidesPerGroup === 0) s.snapGrid.push(slidePosition);
	                    s.slidesGrid.push(slidePosition);
	                }
	                else {
	                    if ((index) % s.params.slidesPerGroup === 0) s.snapGrid.push(slidePosition);
	                    s.slidesGrid.push(slidePosition);
	                    slidePosition = slidePosition + slideSize + spaceBetween;
	                }
	        
	                s.virtualSize += slideSize + spaceBetween;
	        
	                prevSlideSize = slideSize;
	        
	                index ++;
	            }
	            s.virtualSize = Math.max(s.virtualSize, s.size) + s.params.slidesOffsetAfter;
	            var newSlidesGrid;
	        
	            if (
	                s.rtl && s.wrongRTL && (s.params.effect === 'slide' || s.params.effect === 'coverflow')) {
	                s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
	            }
	            if (!s.support.flexbox || s.params.setWrapperSize) {
	                if (s.isHorizontal()) s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
	                else s.wrapper.css({height: s.virtualSize + s.params.spaceBetween + 'px'});
	            }
	        
	            if (s.params.slidesPerColumn > 1) {
	                s.virtualSize = (slideSize + s.params.spaceBetween) * slidesNumberEvenToRows;
	                s.virtualSize = Math.ceil(s.virtualSize / s.params.slidesPerColumn) - s.params.spaceBetween;
	                if (s.isHorizontal()) s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
	                else s.wrapper.css({height: s.virtualSize + s.params.spaceBetween + 'px'});
	                if (s.params.centeredSlides) {
	                    newSlidesGrid = [];
	                    for (i = 0; i < s.snapGrid.length; i++) {
	                        if (s.snapGrid[i] < s.virtualSize + s.snapGrid[0]) newSlidesGrid.push(s.snapGrid[i]);
	                    }
	                    s.snapGrid = newSlidesGrid;
	                }
	            }
	        
	            // Remove last grid elements depending on width
	            if (!s.params.centeredSlides) {
	                newSlidesGrid = [];
	                for (i = 0; i < s.snapGrid.length; i++) {
	                    if (s.snapGrid[i] <= s.virtualSize - s.size) {
	                        newSlidesGrid.push(s.snapGrid[i]);
	                    }
	                }
	                s.snapGrid = newSlidesGrid;
	                if (Math.floor(s.virtualSize - s.size) - Math.floor(s.snapGrid[s.snapGrid.length - 1]) > 1) {
	                    s.snapGrid.push(s.virtualSize - s.size);
	                }
	            }
	            if (s.snapGrid.length === 0) s.snapGrid = [0];
	        
	            if (s.params.spaceBetween !== 0) {
	                if (s.isHorizontal()) {
	                    if (s.rtl) s.slides.css({marginLeft: spaceBetween + 'px'});
	                    else s.slides.css({marginRight: spaceBetween + 'px'});
	                }
	                else s.slides.css({marginBottom: spaceBetween + 'px'});
	            }
	            if (s.params.watchSlidesProgress) {
	                s.updateSlidesOffset();
	            }
	        };
	        s.updateSlidesOffset = function () {
	            for (var i = 0; i < s.slides.length; i++) {
	                s.slides[i].swiperSlideOffset = s.isHorizontal() ? s.slides[i].offsetLeft : s.slides[i].offsetTop;
	            }
	        };
	        
	        /*=========================
	          Dynamic Slides Per View
	          ===========================*/
	        s.currentSlidesPerView = function () {
	            var spv = 1, i, j;
	            if (s.params.centeredSlides) {
	                var size = s.slides[s.activeIndex].swiperSlideSize;
	                var breakLoop;
	                for (i = s.activeIndex + 1; i < s.slides.length; i++) {
	                    if (s.slides[i] && !breakLoop) {
	                        size += s.slides[i].swiperSlideSize;
	                        spv ++;
	                        if (size > s.size) breakLoop = true;
	                    }
	                }
	                for (j = s.activeIndex - 1; j >= 0; j--) {
	                    if (s.slides[j] && !breakLoop) {
	                        size += s.slides[j].swiperSlideSize;
	                        spv ++;
	                        if (size > s.size) breakLoop = true;
	                    }
	                }
	            }
	            else {
	                for (i = s.activeIndex + 1; i < s.slides.length; i++) {
	                    if (s.slidesGrid[i] - s.slidesGrid[s.activeIndex] < s.size) {
	                        spv++;
	                    }
	                }
	            }
	            return spv;
	        };
	        /*=========================
	          Slider/slides progress
	          ===========================*/
	        s.updateSlidesProgress = function (translate) {
	            if (typeof translate === 'undefined') {
	                translate = s.translate || 0;
	            }
	            if (s.slides.length === 0) return;
	            if (typeof s.slides[0].swiperSlideOffset === 'undefined') s.updateSlidesOffset();
	        
	            var offsetCenter = -translate;
	            if (s.rtl) offsetCenter = translate;
	        
	            // Visible Slides
	            s.slides.removeClass(s.params.slideVisibleClass);
	            for (var i = 0; i < s.slides.length; i++) {
	                var slide = s.slides[i];
	                var slideProgress = (offsetCenter + (s.params.centeredSlides ? s.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + s.params.spaceBetween);
	                if (s.params.watchSlidesVisibility) {
	                    var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
	                    var slideAfter = slideBefore + s.slidesSizesGrid[i];
	                    var isVisible =
	                        (slideBefore >= 0 && slideBefore < s.size) ||
	                        (slideAfter > 0 && slideAfter <= s.size) ||
	                        (slideBefore <= 0 && slideAfter >= s.size);
	                    if (isVisible) {
	                        s.slides.eq(i).addClass(s.params.slideVisibleClass);
	                    }
	                }
	                slide.progress = s.rtl ? -slideProgress : slideProgress;
	            }
	        };
	        s.updateProgress = function (translate) {
	            if (typeof translate === 'undefined') {
	                translate = s.translate || 0;
	            }
	            var translatesDiff = s.maxTranslate() - s.minTranslate();
	            var wasBeginning = s.isBeginning;
	            var wasEnd = s.isEnd;
	            if (translatesDiff === 0) {
	                s.progress = 0;
	                s.isBeginning = s.isEnd = true;
	            }
	            else {
	                s.progress = (translate - s.minTranslate()) / (translatesDiff);
	                s.isBeginning = s.progress <= 0;
	                s.isEnd = s.progress >= 1;
	            }
	            if (s.isBeginning && !wasBeginning) s.emit('onReachBeginning', s);
	            if (s.isEnd && !wasEnd) s.emit('onReachEnd', s);
	        
	            if (s.params.watchSlidesProgress) s.updateSlidesProgress(translate);
	            s.emit('onProgress', s, s.progress);
	        };
	        s.updateActiveIndex = function () {
	            var translate = s.rtl ? s.translate : -s.translate;
	            var newActiveIndex, i, snapIndex;
	            for (i = 0; i < s.slidesGrid.length; i ++) {
	                if (typeof s.slidesGrid[i + 1] !== 'undefined') {
	                    if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1] - (s.slidesGrid[i + 1] - s.slidesGrid[i]) / 2) {
	                        newActiveIndex = i;
	                    }
	                    else if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1]) {
	                        newActiveIndex = i + 1;
	                    }
	                }
	                else {
	                    if (translate >= s.slidesGrid[i]) {
	                        newActiveIndex = i;
	                    }
	                }
	            }
	            // Normalize slideIndex
	            if(s.params.normalizeSlideIndex){
	                if (newActiveIndex < 0 || typeof newActiveIndex === 'undefined') newActiveIndex = 0;
	            }
	            // for (i = 0; i < s.slidesGrid.length; i++) {
	                // if (- translate >= s.slidesGrid[i]) {
	                    // newActiveIndex = i;
	                // }
	            // }
	            snapIndex = Math.floor(newActiveIndex / s.params.slidesPerGroup);
	            if (snapIndex >= s.snapGrid.length) snapIndex = s.snapGrid.length - 1;
	        
	            if (newActiveIndex === s.activeIndex) {
	                return;
	            }
	            s.snapIndex = snapIndex;
	            s.previousIndex = s.activeIndex;
	            s.activeIndex = newActiveIndex;
	            s.updateClasses();
	            s.updateRealIndex();
	        };
	        s.updateRealIndex = function(){
	            s.realIndex = parseInt(s.slides.eq(s.activeIndex).attr('data-swiper-slide-index') || s.activeIndex, 10);
	        };
	        
	        /*=========================
	          Classes
	          ===========================*/
	        s.updateClasses = function () {
	            s.slides.removeClass(s.params.slideActiveClass + ' ' + s.params.slideNextClass + ' ' + s.params.slidePrevClass + ' ' + s.params.slideDuplicateActiveClass + ' ' + s.params.slideDuplicateNextClass + ' ' + s.params.slideDuplicatePrevClass);
	            var activeSlide = s.slides.eq(s.activeIndex);
	            // Active classes
	            activeSlide.addClass(s.params.slideActiveClass);
	            if (params.loop) {
	                // Duplicate to all looped slides
	                if (activeSlide.hasClass(s.params.slideDuplicateClass)) {
	                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + s.realIndex + '"]').addClass(s.params.slideDuplicateActiveClass);
	                }
	                else {
	                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + s.realIndex + '"]').addClass(s.params.slideDuplicateActiveClass);
	                }
	            }
	            // Next Slide
	            var nextSlide = activeSlide.next('.' + s.params.slideClass).addClass(s.params.slideNextClass);
	            if (s.params.loop && nextSlide.length === 0) {
	                nextSlide = s.slides.eq(0);
	                nextSlide.addClass(s.params.slideNextClass);
	            }
	            // Prev Slide
	            var prevSlide = activeSlide.prev('.' + s.params.slideClass).addClass(s.params.slidePrevClass);
	            if (s.params.loop && prevSlide.length === 0) {
	                prevSlide = s.slides.eq(-1);
	                prevSlide.addClass(s.params.slidePrevClass);
	            }
	            if (params.loop) {
	                // Duplicate to all looped slides
	                if (nextSlide.hasClass(s.params.slideDuplicateClass)) {
	                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicateNextClass);
	                }
	                else {
	                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicateNextClass);
	                }
	                if (prevSlide.hasClass(s.params.slideDuplicateClass)) {
	                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicatePrevClass);
	                }
	                else {
	                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicatePrevClass);
	                }
	            }
	        
	            // Pagination
	            if (s.paginationContainer && s.paginationContainer.length > 0) {
	                // Current/Total
	                var current,
	                    total = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;
	                if (s.params.loop) {
	                    current = Math.ceil((s.activeIndex - s.loopedSlides)/s.params.slidesPerGroup);
	                    if (current > s.slides.length - 1 - s.loopedSlides * 2) {
	                        current = current - (s.slides.length - s.loopedSlides * 2);
	                    }
	                    if (current > total - 1) current = current - total;
	                    if (current < 0 && s.params.paginationType !== 'bullets') current = total + current;
	                }
	                else {
	                    if (typeof s.snapIndex !== 'undefined') {
	                        current = s.snapIndex;
	                    }
	                    else {
	                        current = s.activeIndex || 0;
	                    }
	                }
	                // Types
	                if (s.params.paginationType === 'bullets' && s.bullets && s.bullets.length > 0) {
	                    s.bullets.removeClass(s.params.bulletActiveClass);
	                    if (s.paginationContainer.length > 1) {
	                        s.bullets.each(function () {
	                            if ($(this).index() === current) $(this).addClass(s.params.bulletActiveClass);
	                        });
	                    }
	                    else {
	                        s.bullets.eq(current).addClass(s.params.bulletActiveClass);
	                    }
	                }
	                if (s.params.paginationType === 'fraction') {
	                    s.paginationContainer.find('.' + s.params.paginationCurrentClass).text(current + 1);
	                    s.paginationContainer.find('.' + s.params.paginationTotalClass).text(total);
	                }
	                if (s.params.paginationType === 'progress') {
	                    var scale = (current + 1) / total,
	                        scaleX = scale,
	                        scaleY = 1;
	                    if (!s.isHorizontal()) {
	                        scaleY = scale;
	                        scaleX = 1;
	                    }
	                    s.paginationContainer.find('.' + s.params.paginationProgressbarClass).transform('translate3d(0,0,0) scaleX(' + scaleX + ') scaleY(' + scaleY + ')').transition(s.params.speed);
	                }
	                if (s.params.paginationType === 'custom' && s.params.paginationCustomRender) {
	                    s.paginationContainer.html(s.params.paginationCustomRender(s, current + 1, total));
	                    s.emit('onPaginationRendered', s, s.paginationContainer[0]);
	                }
	            }
	        
	            // Next/active buttons
	            if (!s.params.loop) {
	                if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
	                    if (s.isBeginning) {
	                        s.prevButton.addClass(s.params.buttonDisabledClass);
	                        if (s.params.a11y && s.a11y) s.a11y.disable(s.prevButton);
	                    }
	                    else {
	                        s.prevButton.removeClass(s.params.buttonDisabledClass);
	                        if (s.params.a11y && s.a11y) s.a11y.enable(s.prevButton);
	                    }
	                }
	                if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
	                    if (s.isEnd) {
	                        s.nextButton.addClass(s.params.buttonDisabledClass);
	                        if (s.params.a11y && s.a11y) s.a11y.disable(s.nextButton);
	                    }
	                    else {
	                        s.nextButton.removeClass(s.params.buttonDisabledClass);
	                        if (s.params.a11y && s.a11y) s.a11y.enable(s.nextButton);
	                    }
	                }
	            }
	        };
	        
	        /*=========================
	          Pagination
	          ===========================*/
	        s.updatePagination = function () {
	            if (!s.params.pagination) return;
	            if (s.paginationContainer && s.paginationContainer.length > 0) {
	                var paginationHTML = '';
	                if (s.params.paginationType === 'bullets') {
	                    var numberOfBullets = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;
	                    for (var i = 0; i < numberOfBullets; i++) {
	                        if (s.params.paginationBulletRender) {
	                            paginationHTML += s.params.paginationBulletRender(s, i, s.params.bulletClass);
	                        }
	                        else {
	                            paginationHTML += '<' + s.params.paginationElement+' class="' + s.params.bulletClass + '"></' + s.params.paginationElement + '>';
	                        }
	                    }
	                    s.paginationContainer.html(paginationHTML);
	                    s.bullets = s.paginationContainer.find('.' + s.params.bulletClass);
	                    if (s.params.paginationClickable && s.params.a11y && s.a11y) {
	                        s.a11y.initPagination();
	                    }
	                }
	                if (s.params.paginationType === 'fraction') {
	                    if (s.params.paginationFractionRender) {
	                        paginationHTML = s.params.paginationFractionRender(s, s.params.paginationCurrentClass, s.params.paginationTotalClass);
	                    }
	                    else {
	                        paginationHTML =
	                            '<span class="' + s.params.paginationCurrentClass + '"></span>' +
	                            ' / ' +
	                            '<span class="' + s.params.paginationTotalClass+'"></span>';
	                    }
	                    s.paginationContainer.html(paginationHTML);
	                }
	                if (s.params.paginationType === 'progress') {
	                    if (s.params.paginationProgressRender) {
	                        paginationHTML = s.params.paginationProgressRender(s, s.params.paginationProgressbarClass);
	                    }
	                    else {
	                        paginationHTML = '<span class="' + s.params.paginationProgressbarClass + '"></span>';
	                    }
	                    s.paginationContainer.html(paginationHTML);
	                }
	                if (s.params.paginationType !== 'custom') {
	                    s.emit('onPaginationRendered', s, s.paginationContainer[0]);
	                }
	            }
	        };
	        /*=========================
	          Common update method
	          ===========================*/
	        s.update = function (updateTranslate) {
	            if (!s) return;
	            s.updateContainerSize();
	            s.updateSlidesSize();
	            s.updateProgress();
	            s.updatePagination();
	            s.updateClasses();
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.set();
	            }
	            var newTranslate;
	            function forceSetTranslate() {
	                var translate = s.rtl ? -s.translate : s.translate;
	                newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
	                s.setWrapperTranslate(newTranslate);
	                s.updateActiveIndex();
	                s.updateClasses();
	            }
	            if (updateTranslate) {
	                var translated;
	                if (s.controller && s.controller.spline) {
	                    s.controller.spline = undefined;
	                }
	                if (s.params.freeMode) {
	                    forceSetTranslate();
	                    if (s.params.autoHeight) {
	                        s.updateAutoHeight();
	                    }
	                }
	                else {
	                    if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
	                        translated = s.slideTo(s.slides.length - 1, 0, false, true);
	                    }
	                    else {
	                        translated = s.slideTo(s.activeIndex, 0, false, true);
	                    }
	                    if (!translated) {
	                        forceSetTranslate();
	                    }
	                }
	            }
	            else if (s.params.autoHeight) {
	                s.updateAutoHeight();
	            }
	        };
	        
	        /*=========================
	          Resize Handler
	          ===========================*/
	        s.onResize = function (forceUpdatePagination) {
	            if (s.params.onBeforeResize) s.params.onBeforeResize(s);
	            //Breakpoints
	            if (s.params.breakpoints) {
	                s.setBreakpoint();
	            }
	        
	            // Disable locks on resize
	            var allowSwipeToPrev = s.params.allowSwipeToPrev;
	            var allowSwipeToNext = s.params.allowSwipeToNext;
	            s.params.allowSwipeToPrev = s.params.allowSwipeToNext = true;
	        
	            s.updateContainerSize();
	            s.updateSlidesSize();
	            if (s.params.slidesPerView === 'auto' || s.params.freeMode || forceUpdatePagination) s.updatePagination();
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.set();
	            }
	            if (s.controller && s.controller.spline) {
	                s.controller.spline = undefined;
	            }
	            var slideChangedBySlideTo = false;
	            if (s.params.freeMode) {
	                var newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
	                s.setWrapperTranslate(newTranslate);
	                s.updateActiveIndex();
	                s.updateClasses();
	        
	                if (s.params.autoHeight) {
	                    s.updateAutoHeight();
	                }
	            }
	            else {
	                s.updateClasses();
	                if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
	                    slideChangedBySlideTo = s.slideTo(s.slides.length - 1, 0, false, true);
	                }
	                else {
	                    slideChangedBySlideTo = s.slideTo(s.activeIndex, 0, false, true);
	                }
	            }
	            if (s.params.lazyLoading && !slideChangedBySlideTo && s.lazy) {
	                s.lazy.load();
	            }
	            // Return locks after resize
	            s.params.allowSwipeToPrev = allowSwipeToPrev;
	            s.params.allowSwipeToNext = allowSwipeToNext;
	            if (s.params.onAfterResize) s.params.onAfterResize(s);
	        };
	        
	        /*=========================
	          Events
	          ===========================*/
	        
	        //Define Touch Events
	        s.touchEventsDesktop = {start: 'mousedown', move: 'mousemove', end: 'mouseup'};
	        if (window.navigator.pointerEnabled) s.touchEventsDesktop = {start: 'pointerdown', move: 'pointermove', end: 'pointerup'};
	        else if (window.navigator.msPointerEnabled) s.touchEventsDesktop = {start: 'MSPointerDown', move: 'MSPointerMove', end: 'MSPointerUp'};
	        s.touchEvents = {
	            start : s.support.touch || !s.params.simulateTouch  ? 'touchstart' : s.touchEventsDesktop.start,
	            move : s.support.touch || !s.params.simulateTouch ? 'touchmove' : s.touchEventsDesktop.move,
	            end : s.support.touch || !s.params.simulateTouch ? 'touchend' : s.touchEventsDesktop.end
	        };
	        
	        
	        // WP8 Touch Events Fix
	        if (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) {
	            (s.params.touchEventsTarget === 'container' ? s.container : s.wrapper).addClass('swiper-wp8-' + s.params.direction);
	        }
	        
	        // Attach/detach events
	        s.initEvents = function (detach) {
	            var actionDom = detach ? 'off' : 'on';
	            var action = detach ? 'removeEventListener' : 'addEventListener';
	            var touchEventsTarget = s.params.touchEventsTarget === 'container' ? s.container[0] : s.wrapper[0];
	            var target = s.support.touch ? touchEventsTarget : document;
	        
	            var moveCapture = s.params.nested ? true : false;
	        
	            //Touch Events
	            if (s.browser.ie) {
	                touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, false);
	                target[action](s.touchEvents.move, s.onTouchMove, moveCapture);
	                target[action](s.touchEvents.end, s.onTouchEnd, false);
	            }
	            else {
	                if (s.support.touch) {
	                    var passiveListener = s.touchEvents.start === 'touchstart' && s.support.passiveListener && s.params.passiveListeners ? {passive: true, capture: false} : false;
	                    touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, passiveListener);
	                    touchEventsTarget[action](s.touchEvents.move, s.onTouchMove, moveCapture);
	                    touchEventsTarget[action](s.touchEvents.end, s.onTouchEnd, passiveListener);
	                }
	                if ((params.simulateTouch && !s.device.ios && !s.device.android) || (params.simulateTouch && !s.support.touch && s.device.ios)) {
	                    touchEventsTarget[action]('mousedown', s.onTouchStart, false);
	                    document[action]('mousemove', s.onTouchMove, moveCapture);
	                    document[action]('mouseup', s.onTouchEnd, false);
	                }
	            }
	            window[action]('resize', s.onResize);
	        
	            // Next, Prev, Index
	            if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
	                s.nextButton[actionDom]('click', s.onClickNext);
	                if (s.params.a11y && s.a11y) s.nextButton[actionDom]('keydown', s.a11y.onEnterKey);
	            }
	            if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
	                s.prevButton[actionDom]('click', s.onClickPrev);
	                if (s.params.a11y && s.a11y) s.prevButton[actionDom]('keydown', s.a11y.onEnterKey);
	            }
	            if (s.params.pagination && s.params.paginationClickable) {
	                s.paginationContainer[actionDom]('click', '.' + s.params.bulletClass, s.onClickIndex);
	                if (s.params.a11y && s.a11y) s.paginationContainer[actionDom]('keydown', '.' + s.params.bulletClass, s.a11y.onEnterKey);
	            }
	        
	            // Prevent Links Clicks
	            if (s.params.preventClicks || s.params.preventClicksPropagation) touchEventsTarget[action]('click', s.preventClicks, true);
	        };
	        s.attachEvents = function () {
	            s.initEvents();
	        };
	        s.detachEvents = function () {
	            s.initEvents(true);
	        };
	        
	        /*=========================
	          Handle Clicks
	          ===========================*/
	        // Prevent Clicks
	        s.allowClick = true;
	        s.preventClicks = function (e) {
	            if (!s.allowClick) {
	                if (s.params.preventClicks) e.preventDefault();
	                if (s.params.preventClicksPropagation && s.animating) {
	                    e.stopPropagation();
	                    e.stopImmediatePropagation();
	                }
	            }
	        };
	        // Clicks
	        s.onClickNext = function (e) {
	            e.preventDefault();
	            if (s.isEnd && !s.params.loop) return;
	            s.slideNext();
	        };
	        s.onClickPrev = function (e) {
	            e.preventDefault();
	            if (s.isBeginning && !s.params.loop) return;
	            s.slidePrev();
	        };
	        s.onClickIndex = function (e) {
	            e.preventDefault();
	            var index = $(this).index() * s.params.slidesPerGroup;
	            if (s.params.loop) index = index + s.loopedSlides;
	            s.slideTo(index);
	        };
	        
	        /*=========================
	          Handle Touches
	          ===========================*/
	        function findElementInEvent(e, selector) {
	            var el = $(e.target);
	            if (!el.is(selector)) {
	                if (typeof selector === 'string') {
	                    el = el.parents(selector);
	                }
	                else if (selector.nodeType) {
	                    var found;
	                    el.parents().each(function (index, _el) {
	                        if (_el === selector) found = selector;
	                    });
	                    if (!found) return undefined;
	                    else return selector;
	                }
	            }
	            if (el.length === 0) {
	                return undefined;
	            }
	            return el[0];
	        }
	        s.updateClickedSlide = function (e) {
	            var slide = findElementInEvent(e, '.' + s.params.slideClass);
	            var slideFound = false;
	            if (slide) {
	                for (var i = 0; i < s.slides.length; i++) {
	                    if (s.slides[i] === slide) slideFound = true;
	                }
	            }
	        
	            if (slide && slideFound) {
	                s.clickedSlide = slide;
	                s.clickedIndex = $(slide).index();
	            }
	            else {
	                s.clickedSlide = undefined;
	                s.clickedIndex = undefined;
	                return;
	            }
	            if (s.params.slideToClickedSlide && s.clickedIndex !== undefined && s.clickedIndex !== s.activeIndex) {
	                var slideToIndex = s.clickedIndex,
	                    realIndex,
	                    duplicatedSlides,
	                    slidesPerView = s.params.slidesPerView === 'auto' ? s.currentSlidesPerView() : s.params.slidesPerView;
	                if (s.params.loop) {
	                    if (s.animating) return;
	                    realIndex = parseInt($(s.clickedSlide).attr('data-swiper-slide-index'), 10);
	                    if (s.params.centeredSlides) {
	                        if ((slideToIndex < s.loopedSlides - slidesPerView/2) || (slideToIndex > s.slides.length - s.loopedSlides + slidesPerView/2)) {
	                            s.fixLoop();
	                            slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + s.params.slideDuplicateClass + ')').eq(0).index();
	                            setTimeout(function () {
	                                s.slideTo(slideToIndex);
	                            }, 0);
	                        }
	                        else {
	                            s.slideTo(slideToIndex);
	                        }
	                    }
	                    else {
	                        if (slideToIndex > s.slides.length - slidesPerView) {
	                            s.fixLoop();
	                            slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + s.params.slideDuplicateClass + ')').eq(0).index();
	                            setTimeout(function () {
	                                s.slideTo(slideToIndex);
	                            }, 0);
	                        }
	                        else {
	                            s.slideTo(slideToIndex);
	                        }
	                    }
	                }
	                else {
	                    s.slideTo(slideToIndex);
	                }
	            }
	        };
	        
	        var isTouched,
	            isMoved,
	            allowTouchCallbacks,
	            touchStartTime,
	            isScrolling,
	            currentTranslate,
	            startTranslate,
	            allowThresholdMove,
	            // Form elements to match
	            formElements = 'input, select, textarea, button, video',
	            // Last click time
	            lastClickTime = Date.now(), clickTimeout,
	            //Velocities
	            velocities = [],
	            allowMomentumBounce;
	        
	        // Animating Flag
	        s.animating = false;
	        
	        // Touches information
	        s.touches = {
	            startX: 0,
	            startY: 0,
	            currentX: 0,
	            currentY: 0,
	            diff: 0
	        };
	        
	        // Touch handlers
	        var isTouchEvent, startMoving;
	        s.onTouchStart = function (e) {
	            if (e.originalEvent) e = e.originalEvent;
	            isTouchEvent = e.type === 'touchstart';
	            if (!isTouchEvent && 'which' in e && e.which === 3) return;
	            if (s.params.noSwiping && findElementInEvent(e, '.' + s.params.noSwipingClass)) {
	                s.allowClick = true;
	                return;
	            }
	            if (s.params.swipeHandler) {
	                if (!findElementInEvent(e, s.params.swipeHandler)) return;
	            }
	        
	            var startX = s.touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	            var startY = s.touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	        
	            // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore
	            if(s.device.ios && s.params.iOSEdgeSwipeDetection && startX <= s.params.iOSEdgeSwipeThreshold) {
	                return;
	            }
	        
	            isTouched = true;
	            isMoved = false;
	            allowTouchCallbacks = true;
	            isScrolling = undefined;
	            startMoving = undefined;
	            s.touches.startX = startX;
	            s.touches.startY = startY;
	            touchStartTime = Date.now();
	            s.allowClick = true;
	            s.updateContainerSize();
	            s.swipeDirection = undefined;
	            if (s.params.threshold > 0) allowThresholdMove = false;
	            if (e.type !== 'touchstart') {
	                var preventDefault = true;
	                if ($(e.target).is(formElements)) preventDefault = false;
	                if (document.activeElement && $(document.activeElement).is(formElements)) {
	                    document.activeElement.blur();
	                }
	                if (preventDefault) {
	                    e.preventDefault();
	                }
	            }
	            s.emit('onTouchStart', s, e);
	        };
	        
	        s.onTouchMove = function (e) {
	            if (e.originalEvent) e = e.originalEvent;
	            if (isTouchEvent && e.type === 'mousemove') return;
	            if (e.preventedByNestedSwiper) {
	                s.touches.startX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                s.touches.startY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                return;
	            }
	            if (s.params.onlyExternal) {
	                // isMoved = true;
	                s.allowClick = false;
	                if (isTouched) {
	                    s.touches.startX = s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                    s.touches.startY = s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                    touchStartTime = Date.now();
	                }
	                return;
	            }
	            if (isTouchEvent && s.params.touchReleaseOnEdges && !s.params.loop) {
	                if (!s.isHorizontal()) {
	                    // Vertical
	                    if (
	                        (s.touches.currentY < s.touches.startY && s.translate <= s.maxTranslate()) ||
	                        (s.touches.currentY > s.touches.startY && s.translate >= s.minTranslate())
	                        ) {
	                        return;
	                    }
	                }
	                else {
	                    if (
	                        (s.touches.currentX < s.touches.startX && s.translate <= s.maxTranslate()) ||
	                        (s.touches.currentX > s.touches.startX && s.translate >= s.minTranslate())
	                        ) {
	                        return;
	                    }
	                }
	            }
	            if (isTouchEvent && document.activeElement) {
	                if (e.target === document.activeElement && $(e.target).is(formElements)) {
	                    isMoved = true;
	                    s.allowClick = false;
	                    return;
	                }
	            }
	            if (allowTouchCallbacks) {
	                s.emit('onTouchMove', s, e);
	            }
	            if (e.targetTouches && e.targetTouches.length > 1) return;
	        
	            s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	            s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	        
	            if (typeof isScrolling === 'undefined') {
	                var touchAngle;
	                if (s.isHorizontal() && s.touches.currentY === s.touches.startY || !s.isHorizontal() && s.touches.currentX === s.touches.startX) {
	                    isScrolling = false;
	                }
	                else {
	                    touchAngle = Math.atan2(Math.abs(s.touches.currentY - s.touches.startY), Math.abs(s.touches.currentX - s.touches.startX)) * 180 / Math.PI;
	                    isScrolling = s.isHorizontal() ? touchAngle > s.params.touchAngle : (90 - touchAngle > s.params.touchAngle);
	                }
	            }
	            if (isScrolling) {
	                s.emit('onTouchMoveOpposite', s, e);
	            }
	            if (typeof startMoving === 'undefined') {
	                if (s.touches.currentX !== s.touches.startX || s.touches.currentY !== s.touches.startY) {
	                    startMoving = true;
	                }
	            }
	            if (!isTouched) return;
	            if (isScrolling)  {
	                isTouched = false;
	                return;
	            }
	            if (!startMoving) {
	                return;
	            }
	            s.allowClick = false;
	            s.emit('onSliderMove', s, e);
	            e.preventDefault();
	            if (s.params.touchMoveStopPropagation && !s.params.nested) {
	                e.stopPropagation();
	            }
	        
	            if (!isMoved) {
	                if (params.loop) {
	                    s.fixLoop();
	                }
	                startTranslate = s.getWrapperTranslate();
	                s.setWrapperTransition(0);
	                if (s.animating) {
	                    s.wrapper.trigger('webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd msTransitionEnd');
	                }
	                if (s.params.autoplay && s.autoplaying) {
	                    if (s.params.autoplayDisableOnInteraction) {
	                        s.stopAutoplay();
	                    }
	                    else {
	                        s.pauseAutoplay();
	                    }
	                }
	                allowMomentumBounce = false;
	                //Grab Cursor
	                if (s.params.grabCursor && (s.params.allowSwipeToNext === true || s.params.allowSwipeToPrev === true)) {
	                    s.setGrabCursor(true);
	                }
	            }
	            isMoved = true;
	        
	            var diff = s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
	        
	            diff = diff * s.params.touchRatio;
	            if (s.rtl) diff = -diff;
	        
	            s.swipeDirection = diff > 0 ? 'prev' : 'next';
	            currentTranslate = diff + startTranslate;
	        
	            var disableParentSwiper = true;
	            if ((diff > 0 && currentTranslate > s.minTranslate())) {
	                disableParentSwiper = false;
	                if (s.params.resistance) currentTranslate = s.minTranslate() - 1 + Math.pow(-s.minTranslate() + startTranslate + diff, s.params.resistanceRatio);
	            }
	            else if (diff < 0 && currentTranslate < s.maxTranslate()) {
	                disableParentSwiper = false;
	                if (s.params.resistance) currentTranslate = s.maxTranslate() + 1 - Math.pow(s.maxTranslate() - startTranslate - diff, s.params.resistanceRatio);
	            }
	        
	            if (disableParentSwiper) {
	                e.preventedByNestedSwiper = true;
	            }
	        
	            // Directions locks
	            if (!s.params.allowSwipeToNext && s.swipeDirection === 'next' && currentTranslate < startTranslate) {
	                currentTranslate = startTranslate;
	            }
	            if (!s.params.allowSwipeToPrev && s.swipeDirection === 'prev' && currentTranslate > startTranslate) {
	                currentTranslate = startTranslate;
	            }
	        
	        
	            // Threshold
	            if (s.params.threshold > 0) {
	                if (Math.abs(diff) > s.params.threshold || allowThresholdMove) {
	                    if (!allowThresholdMove) {
	                        allowThresholdMove = true;
	                        s.touches.startX = s.touches.currentX;
	                        s.touches.startY = s.touches.currentY;
	                        currentTranslate = startTranslate;
	                        s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
	                        return;
	                    }
	                }
	                else {
	                    currentTranslate = startTranslate;
	                    return;
	                }
	            }
	        
	            if (!s.params.followFinger) return;
	        
	            // Update active index in free mode
	            if (s.params.freeMode || s.params.watchSlidesProgress) {
	                s.updateActiveIndex();
	            }
	            if (s.params.freeMode) {
	                //Velocity
	                if (velocities.length === 0) {
	                    velocities.push({
	                        position: s.touches[s.isHorizontal() ? 'startX' : 'startY'],
	                        time: touchStartTime
	                    });
	                }
	                velocities.push({
	                    position: s.touches[s.isHorizontal() ? 'currentX' : 'currentY'],
	                    time: (new window.Date()).getTime()
	                });
	            }
	            // Update progress
	            s.updateProgress(currentTranslate);
	            // Update translate
	            s.setWrapperTranslate(currentTranslate);
	        };
	        s.onTouchEnd = function (e) {
	            if (e.originalEvent) e = e.originalEvent;
	            if (allowTouchCallbacks) {
	                s.emit('onTouchEnd', s, e);
	            }
	            allowTouchCallbacks = false;
	            if (!isTouched) return;
	            //Return Grab Cursor
	            if (s.params.grabCursor && isMoved && isTouched  && (s.params.allowSwipeToNext === true || s.params.allowSwipeToPrev === true)) {
	                s.setGrabCursor(false);
	            }
	        
	            // Time diff
	            var touchEndTime = Date.now();
	            var timeDiff = touchEndTime - touchStartTime;
	        
	            // Tap, doubleTap, Click
	            if (s.allowClick) {
	                s.updateClickedSlide(e);
	                s.emit('onTap', s, e);
	                if (timeDiff < 300 && (touchEndTime - lastClickTime) > 300) {
	                    if (clickTimeout) clearTimeout(clickTimeout);
	                    clickTimeout = setTimeout(function () {
	                        if (!s) return;
	                        if (s.params.paginationHide && s.paginationContainer.length > 0 && !$(e.target).hasClass(s.params.bulletClass)) {
	                            s.paginationContainer.toggleClass(s.params.paginationHiddenClass);
	                        }
	                        s.emit('onClick', s, e);
	                    }, 300);
	        
	                }
	                if (timeDiff < 300 && (touchEndTime - lastClickTime) < 300) {
	                    if (clickTimeout) clearTimeout(clickTimeout);
	                    s.emit('onDoubleTap', s, e);
	                }
	            }
	        
	            lastClickTime = Date.now();
	            setTimeout(function () {
	                if (s) s.allowClick = true;
	            }, 0);
	        
	            if (!isTouched || !isMoved || !s.swipeDirection || s.touches.diff === 0 || currentTranslate === startTranslate) {
	                isTouched = isMoved = false;
	                return;
	            }
	            isTouched = isMoved = false;
	        
	            var currentPos;
	            if (s.params.followFinger) {
	                currentPos = s.rtl ? s.translate : -s.translate;
	            }
	            else {
	                currentPos = -currentTranslate;
	            }
	            if (s.params.freeMode) {
	                if (currentPos < -s.minTranslate()) {
	                    s.slideTo(s.activeIndex);
	                    return;
	                }
	                else if (currentPos > -s.maxTranslate()) {
	                    if (s.slides.length < s.snapGrid.length) {
	                        s.slideTo(s.snapGrid.length - 1);
	                    }
	                    else {
	                        s.slideTo(s.slides.length - 1);
	                    }
	                    return;
	                }
	        
	                if (s.params.freeModeMomentum) {
	                    if (velocities.length > 1) {
	                        var lastMoveEvent = velocities.pop(), velocityEvent = velocities.pop();
	        
	                        var distance = lastMoveEvent.position - velocityEvent.position;
	                        var time = lastMoveEvent.time - velocityEvent.time;
	                        s.velocity = distance / time;
	                        s.velocity = s.velocity / 2;
	                        if (Math.abs(s.velocity) < s.params.freeModeMinimumVelocity) {
	                            s.velocity = 0;
	                        }
	                        // this implies that the user stopped moving a finger then released.
	                        // There would be no events with distance zero, so the last event is stale.
	                        if (time > 150 || (new window.Date().getTime() - lastMoveEvent.time) > 300) {
	                            s.velocity = 0;
	                        }
	                    } else {
	                        s.velocity = 0;
	                    }
	                    s.velocity = s.velocity * s.params.freeModeMomentumVelocityRatio;
	        
	                    velocities.length = 0;
	                    var momentumDuration = 1000 * s.params.freeModeMomentumRatio;
	                    var momentumDistance = s.velocity * momentumDuration;
	        
	                    var newPosition = s.translate + momentumDistance;
	                    if (s.rtl) newPosition = - newPosition;
	                    var doBounce = false;
	                    var afterBouncePosition;
	                    var bounceAmount = Math.abs(s.velocity) * 20 * s.params.freeModeMomentumBounceRatio;
	                    if (newPosition < s.maxTranslate()) {
	                        if (s.params.freeModeMomentumBounce) {
	                            if (newPosition + s.maxTranslate() < -bounceAmount) {
	                                newPosition = s.maxTranslate() - bounceAmount;
	                            }
	                            afterBouncePosition = s.maxTranslate();
	                            doBounce = true;
	                            allowMomentumBounce = true;
	                        }
	                        else {
	                            newPosition = s.maxTranslate();
	                        }
	                    }
	                    else if (newPosition > s.minTranslate()) {
	                        if (s.params.freeModeMomentumBounce) {
	                            if (newPosition - s.minTranslate() > bounceAmount) {
	                                newPosition = s.minTranslate() + bounceAmount;
	                            }
	                            afterBouncePosition = s.minTranslate();
	                            doBounce = true;
	                            allowMomentumBounce = true;
	                        }
	                        else {
	                            newPosition = s.minTranslate();
	                        }
	                    }
	                    else if (s.params.freeModeSticky) {
	                        var j = 0,
	                            nextSlide;
	                        for (j = 0; j < s.snapGrid.length; j += 1) {
	                            if (s.snapGrid[j] > -newPosition) {
	                                nextSlide = j;
	                                break;
	                            }
	        
	                        }
	                        if (Math.abs(s.snapGrid[nextSlide] - newPosition) < Math.abs(s.snapGrid[nextSlide - 1] - newPosition) || s.swipeDirection === 'next') {
	                            newPosition = s.snapGrid[nextSlide];
	                        } else {
	                            newPosition = s.snapGrid[nextSlide - 1];
	                        }
	                        if (!s.rtl) newPosition = - newPosition;
	                    }
	                    //Fix duration
	                    if (s.velocity !== 0) {
	                        if (s.rtl) {
	                            momentumDuration = Math.abs((-newPosition - s.translate) / s.velocity);
	                        }
	                        else {
	                            momentumDuration = Math.abs((newPosition - s.translate) / s.velocity);
	                        }
	                    }
	                    else if (s.params.freeModeSticky) {
	                        s.slideReset();
	                        return;
	                    }
	        
	                    if (s.params.freeModeMomentumBounce && doBounce) {
	                        s.updateProgress(afterBouncePosition);
	                        s.setWrapperTransition(momentumDuration);
	                        s.setWrapperTranslate(newPosition);
	                        s.onTransitionStart();
	                        s.animating = true;
	                        s.wrapper.transitionEnd(function () {
	                            if (!s || !allowMomentumBounce) return;
	                            s.emit('onMomentumBounce', s);
	        
	                            s.setWrapperTransition(s.params.speed);
	                            s.setWrapperTranslate(afterBouncePosition);
	                            s.wrapper.transitionEnd(function () {
	                                if (!s) return;
	                                s.onTransitionEnd();
	                            });
	                        });
	                    } else if (s.velocity) {
	                        s.updateProgress(newPosition);
	                        s.setWrapperTransition(momentumDuration);
	                        s.setWrapperTranslate(newPosition);
	                        s.onTransitionStart();
	                        if (!s.animating) {
	                            s.animating = true;
	                            s.wrapper.transitionEnd(function () {
	                                if (!s) return;
	                                s.onTransitionEnd();
	                            });
	                        }
	        
	                    } else {
	                        s.updateProgress(newPosition);
	                    }
	        
	                    s.updateActiveIndex();
	                }
	                if (!s.params.freeModeMomentum || timeDiff >= s.params.longSwipesMs) {
	                    s.updateProgress();
	                    s.updateActiveIndex();
	                }
	                return;
	            }
	        
	            // Find current slide
	            var i, stopIndex = 0, groupSize = s.slidesSizesGrid[0];
	            for (i = 0; i < s.slidesGrid.length; i += s.params.slidesPerGroup) {
	                if (typeof s.slidesGrid[i + s.params.slidesPerGroup] !== 'undefined') {
	                    if (currentPos >= s.slidesGrid[i] && currentPos < s.slidesGrid[i + s.params.slidesPerGroup]) {
	                        stopIndex = i;
	                        groupSize = s.slidesGrid[i + s.params.slidesPerGroup] - s.slidesGrid[i];
	                    }
	                }
	                else {
	                    if (currentPos >= s.slidesGrid[i]) {
	                        stopIndex = i;
	                        groupSize = s.slidesGrid[s.slidesGrid.length - 1] - s.slidesGrid[s.slidesGrid.length - 2];
	                    }
	                }
	            }
	        
	            // Find current slide size
	            var ratio = (currentPos - s.slidesGrid[stopIndex]) / groupSize;
	        
	            if (timeDiff > s.params.longSwipesMs) {
	                // Long touches
	                if (!s.params.longSwipes) {
	                    s.slideTo(s.activeIndex);
	                    return;
	                }
	                if (s.swipeDirection === 'next') {
	                    if (ratio >= s.params.longSwipesRatio) s.slideTo(stopIndex + s.params.slidesPerGroup);
	                    else s.slideTo(stopIndex);
	        
	                }
	                if (s.swipeDirection === 'prev') {
	                    if (ratio > (1 - s.params.longSwipesRatio)) s.slideTo(stopIndex + s.params.slidesPerGroup);
	                    else s.slideTo(stopIndex);
	                }
	            }
	            else {
	                // Short swipes
	                if (!s.params.shortSwipes) {
	                    s.slideTo(s.activeIndex);
	                    return;
	                }
	                if (s.swipeDirection === 'next') {
	                    s.slideTo(stopIndex + s.params.slidesPerGroup);
	        
	                }
	                if (s.swipeDirection === 'prev') {
	                    s.slideTo(stopIndex);
	                }
	            }
	        };
	        /*=========================
	          Transitions
	          ===========================*/
	        s._slideTo = function (slideIndex, speed) {
	            return s.slideTo(slideIndex, speed, true, true);
	        };
	        s.slideTo = function (slideIndex, speed, runCallbacks, internal) {
	            if (typeof runCallbacks === 'undefined') runCallbacks = true;
	            if (typeof slideIndex === 'undefined') slideIndex = 0;
	            if (slideIndex < 0) slideIndex = 0;
	            s.snapIndex = Math.floor(slideIndex / s.params.slidesPerGroup);
	            if (s.snapIndex >= s.snapGrid.length) s.snapIndex = s.snapGrid.length - 1;
	        
	            var translate = - s.snapGrid[s.snapIndex];
	            // Stop autoplay
	            if (s.params.autoplay && s.autoplaying) {
	                if (internal || !s.params.autoplayDisableOnInteraction) {
	                    s.pauseAutoplay(speed);
	                }
	                else {
	                    s.stopAutoplay();
	                }
	            }
	            // Update progress
	            s.updateProgress(translate);
	        
	            // Normalize slideIndex
	            if(s.params.normalizeSlideIndex){
	                for (var i = 0; i < s.slidesGrid.length; i++) {
	                    if (- Math.floor(translate * 100) >= Math.floor(s.slidesGrid[i] * 100)) {
	                        slideIndex = i;
	                    }
	                }
	            }
	        
	            // Directions locks
	            if (!s.params.allowSwipeToNext && translate < s.translate && translate < s.minTranslate()) {
	                return false;
	            }
	            if (!s.params.allowSwipeToPrev && translate > s.translate && translate > s.maxTranslate()) {
	                if ((s.activeIndex || 0) !== slideIndex ) return false;
	            }
	        
	            // Update Index
	            if (typeof speed === 'undefined') speed = s.params.speed;
	            s.previousIndex = s.activeIndex || 0;
	            s.activeIndex = slideIndex;
	            s.updateRealIndex();
	            if ((s.rtl && -translate === s.translate) || (!s.rtl && translate === s.translate)) {
	                // Update Height
	                if (s.params.autoHeight) {
	                    s.updateAutoHeight();
	                }
	                s.updateClasses();
	                if (s.params.effect !== 'slide') {
	                    s.setWrapperTranslate(translate);
	                }
	                return false;
	            }
	            s.updateClasses();
	            s.onTransitionStart(runCallbacks);
	        
	            if (speed === 0 || s.browser.lteIE9) {
	                s.setWrapperTranslate(translate);
	                s.setWrapperTransition(0);
	                s.onTransitionEnd(runCallbacks);
	            }
	            else {
	                s.setWrapperTranslate(translate);
	                s.setWrapperTransition(speed);
	                if (!s.animating) {
	                    s.animating = true;
	                    s.wrapper.transitionEnd(function () {
	                        if (!s) return;
	                        s.onTransitionEnd(runCallbacks);
	                    });
	                }
	        
	            }
	        
	            return true;
	        };
	        
	        s.onTransitionStart = function (runCallbacks) {
	            if (typeof runCallbacks === 'undefined') runCallbacks = true;
	            if (s.params.autoHeight) {
	                s.updateAutoHeight();
	            }
	            if (s.lazy) s.lazy.onTransitionStart();
	            if (runCallbacks) {
	                s.emit('onTransitionStart', s);
	                if (s.activeIndex !== s.previousIndex) {
	                    s.emit('onSlideChangeStart', s);
	                    if (s.activeIndex > s.previousIndex) {
	                        s.emit('onSlideNextStart', s);
	                    }
	                    else {
	                        s.emit('onSlidePrevStart', s);
	                    }
	                }
	        
	            }
	        };
	        s.onTransitionEnd = function (runCallbacks) {
	            s.animating = false;
	            s.setWrapperTransition(0);
	            if (typeof runCallbacks === 'undefined') runCallbacks = true;
	            if (s.lazy) s.lazy.onTransitionEnd();
	            if (runCallbacks) {
	                s.emit('onTransitionEnd', s);
	                if (s.activeIndex !== s.previousIndex) {
	                    s.emit('onSlideChangeEnd', s);
	                    if (s.activeIndex > s.previousIndex) {
	                        s.emit('onSlideNextEnd', s);
	                    }
	                    else {
	                        s.emit('onSlidePrevEnd', s);
	                    }
	                }
	            }
	            if (s.params.history && s.history) {
	                s.history.setHistory(s.params.history, s.activeIndex);
	            }
	            if (s.params.hashnav && s.hashnav) {
	                s.hashnav.setHash();
	            }
	        
	        };
	        s.slideNext = function (runCallbacks, speed, internal) {
	            if (s.params.loop) {
	                if (s.animating) return false;
	                s.fixLoop();
	                var clientLeft = s.container[0].clientLeft;
	                return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
	            }
	            else return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
	        };
	        s._slideNext = function (speed) {
	            return s.slideNext(true, speed, true);
	        };
	        s.slidePrev = function (runCallbacks, speed, internal) {
	            if (s.params.loop) {
	                if (s.animating) return false;
	                s.fixLoop();
	                var clientLeft = s.container[0].clientLeft;
	                return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
	            }
	            else return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
	        };
	        s._slidePrev = function (speed) {
	            return s.slidePrev(true, speed, true);
	        };
	        s.slideReset = function (runCallbacks, speed, internal) {
	            return s.slideTo(s.activeIndex, speed, runCallbacks);
	        };
	        
	        s.disableTouchControl = function () {
	            s.params.onlyExternal = true;
	            return true;
	        };
	        s.enableTouchControl = function () {
	            s.params.onlyExternal = false;
	            return true;
	        };
	        
	        /*=========================
	          Translate/transition helpers
	          ===========================*/
	        s.setWrapperTransition = function (duration, byController) {
	            s.wrapper.transition(duration);
	            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
	                s.effects[s.params.effect].setTransition(duration);
	            }
	            if (s.params.parallax && s.parallax) {
	                s.parallax.setTransition(duration);
	            }
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.setTransition(duration);
	            }
	            if (s.params.control && s.controller) {
	                s.controller.setTransition(duration, byController);
	            }
	            s.emit('onSetTransition', s, duration);
	        };
	        s.setWrapperTranslate = function (translate, updateActiveIndex, byController) {
	            var x = 0, y = 0, z = 0;
	            if (s.isHorizontal()) {
	                x = s.rtl ? -translate : translate;
	            }
	            else {
	                y = translate;
	            }
	        
	            if (s.params.roundLengths) {
	                x = round(x);
	                y = round(y);
	            }
	        
	            if (!s.params.virtualTranslate) {
	                if (s.support.transforms3d) s.wrapper.transform('translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)');
	                else s.wrapper.transform('translate(' + x + 'px, ' + y + 'px)');
	            }
	        
	            s.translate = s.isHorizontal() ? x : y;
	        
	            // Check if we need to update progress
	            var progress;
	            var translatesDiff = s.maxTranslate() - s.minTranslate();
	            if (translatesDiff === 0) {
	                progress = 0;
	            }
	            else {
	                progress = (translate - s.minTranslate()) / (translatesDiff);
	            }
	            if (progress !== s.progress) {
	                s.updateProgress(translate);
	            }
	        
	            if (updateActiveIndex) s.updateActiveIndex();
	            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
	                s.effects[s.params.effect].setTranslate(s.translate);
	            }
	            if (s.params.parallax && s.parallax) {
	                s.parallax.setTranslate(s.translate);
	            }
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.setTranslate(s.translate);
	            }
	            if (s.params.control && s.controller) {
	                s.controller.setTranslate(s.translate, byController);
	            }
	            s.emit('onSetTranslate', s, s.translate);
	        };
	        
	        s.getTranslate = function (el, axis) {
	            var matrix, curTransform, curStyle, transformMatrix;
	        
	            // automatic axis detection
	            if (typeof axis === 'undefined') {
	                axis = 'x';
	            }
	        
	            if (s.params.virtualTranslate) {
	                return s.rtl ? -s.translate : s.translate;
	            }
	        
	            curStyle = window.getComputedStyle(el, null);
	            if (window.WebKitCSSMatrix) {
	                curTransform = curStyle.transform || curStyle.webkitTransform;
	                if (curTransform.split(',').length > 6) {
	                    curTransform = curTransform.split(', ').map(function(a){
	                        return a.replace(',','.');
	                    }).join(', ');
	                }
	                // Some old versions of Webkit choke when 'none' is passed; pass
	                // empty string instead in this case
	                transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	            }
	            else {
	                transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform  || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	                matrix = transformMatrix.toString().split(',');
	            }
	        
	            if (axis === 'x') {
	                //Latest Chrome and webkits Fix
	                if (window.WebKitCSSMatrix)
	                    curTransform = transformMatrix.m41;
	                //Crazy IE10 Matrix
	                else if (matrix.length === 16)
	                    curTransform = parseFloat(matrix[12]);
	                //Normal Browsers
	                else
	                    curTransform = parseFloat(matrix[4]);
	            }
	            if (axis === 'y') {
	                //Latest Chrome and webkits Fix
	                if (window.WebKitCSSMatrix)
	                    curTransform = transformMatrix.m42;
	                //Crazy IE10 Matrix
	                else if (matrix.length === 16)
	                    curTransform = parseFloat(matrix[13]);
	                //Normal Browsers
	                else
	                    curTransform = parseFloat(matrix[5]);
	            }
	            if (s.rtl && curTransform) curTransform = -curTransform;
	            return curTransform || 0;
	        };
	        s.getWrapperTranslate = function (axis) {
	            if (typeof axis === 'undefined') {
	                axis = s.isHorizontal() ? 'x' : 'y';
	            }
	            return s.getTranslate(s.wrapper[0], axis);
	        };
	        
	        /*=========================
	          Observer
	          ===========================*/
	        s.observers = [];
	        function initObserver(target, options) {
	            options = options || {};
	            // create an observer instance
	            var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
	            var observer = new ObserverFunc(function (mutations) {
	                mutations.forEach(function (mutation) {
	                    s.onResize(true);
	                    s.emit('onObserverUpdate', s, mutation);
	                });
	            });
	        
	            observer.observe(target, {
	                attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
	                childList: typeof options.childList === 'undefined' ? true : options.childList,
	                characterData: typeof options.characterData === 'undefined' ? true : options.characterData
	            });
	        
	            s.observers.push(observer);
	        }
	        s.initObservers = function () {
	            if (s.params.observeParents) {
	                var containerParents = s.container.parents();
	                for (var i = 0; i < containerParents.length; i++) {
	                    initObserver(containerParents[i]);
	                }
	            }
	        
	            // Observe container
	            initObserver(s.container[0], {childList: false});
	        
	            // Observe wrapper
	            initObserver(s.wrapper[0], {attributes: false});
	        };
	        s.disconnectObservers = function () {
	            for (var i = 0; i < s.observers.length; i++) {
	                s.observers[i].disconnect();
	            }
	            s.observers = [];
	        };
	        /*=========================
	          Loop
	          ===========================*/
	        // Create looped slides
	        s.createLoop = function () {
	            // Remove duplicated slides
	            s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
	        
	            var slides = s.wrapper.children('.' + s.params.slideClass);
	        
	            if(s.params.slidesPerView === 'auto' && !s.params.loopedSlides) s.params.loopedSlides = slides.length;
	        
	            s.loopedSlides = parseInt(s.params.loopedSlides || s.params.slidesPerView, 10);
	            s.loopedSlides = s.loopedSlides + s.params.loopAdditionalSlides;
	            if (s.loopedSlides > slides.length) {
	                s.loopedSlides = slides.length;
	            }
	        
	            var prependSlides = [], appendSlides = [], i;
	            slides.each(function (index, el) {
	                var slide = $(this);
	                if (index < s.loopedSlides) appendSlides.push(el);
	                if (index < slides.length && index >= slides.length - s.loopedSlides) prependSlides.push(el);
	                slide.attr('data-swiper-slide-index', index);
	            });
	            for (i = 0; i < appendSlides.length; i++) {
	                s.wrapper.append($(appendSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
	            }
	            for (i = prependSlides.length - 1; i >= 0; i--) {
	                s.wrapper.prepend($(prependSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
	            }
	        };
	        s.destroyLoop = function () {
	            s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
	            s.slides.removeAttr('data-swiper-slide-index');
	        };
	        s.reLoop = function (updatePosition) {
	            var oldIndex = s.activeIndex - s.loopedSlides;
	            s.destroyLoop();
	            s.createLoop();
	            s.updateSlidesSize();
	            if (updatePosition) {
	                s.slideTo(oldIndex + s.loopedSlides, 0, false);
	            }
	        
	        };
	        s.fixLoop = function () {
	            var newIndex;
	            //Fix For Negative Oversliding
	            if (s.activeIndex < s.loopedSlides) {
	                newIndex = s.slides.length - s.loopedSlides * 3 + s.activeIndex;
	                newIndex = newIndex + s.loopedSlides;
	                s.slideTo(newIndex, 0, false, true);
	            }
	            //Fix For Positive Oversliding
	            else if ((s.params.slidesPerView === 'auto' && s.activeIndex >= s.loopedSlides * 2) || (s.activeIndex > s.slides.length - s.params.slidesPerView * 2)) {
	                newIndex = -s.slides.length + s.activeIndex + s.loopedSlides;
	                newIndex = newIndex + s.loopedSlides;
	                s.slideTo(newIndex, 0, false, true);
	            }
	        };
	        /*=========================
	          Append/Prepend/Remove Slides
	          ===========================*/
	        s.appendSlide = function (slides) {
	            if (s.params.loop) {
	                s.destroyLoop();
	            }
	            if (typeof slides === 'object' && slides.length) {
	                for (var i = 0; i < slides.length; i++) {
	                    if (slides[i]) s.wrapper.append(slides[i]);
	                }
	            }
	            else {
	                s.wrapper.append(slides);
	            }
	            if (s.params.loop) {
	                s.createLoop();
	            }
	            if (!(s.params.observer && s.support.observer)) {
	                s.update(true);
	            }
	        };
	        s.prependSlide = function (slides) {
	            if (s.params.loop) {
	                s.destroyLoop();
	            }
	            var newActiveIndex = s.activeIndex + 1;
	            if (typeof slides === 'object' && slides.length) {
	                for (var i = 0; i < slides.length; i++) {
	                    if (slides[i]) s.wrapper.prepend(slides[i]);
	                }
	                newActiveIndex = s.activeIndex + slides.length;
	            }
	            else {
	                s.wrapper.prepend(slides);
	            }
	            if (s.params.loop) {
	                s.createLoop();
	            }
	            if (!(s.params.observer && s.support.observer)) {
	                s.update(true);
	            }
	            s.slideTo(newActiveIndex, 0, false);
	        };
	        s.removeSlide = function (slidesIndexes) {
	            if (s.params.loop) {
	                s.destroyLoop();
	                s.slides = s.wrapper.children('.' + s.params.slideClass);
	            }
	            var newActiveIndex = s.activeIndex,
	                indexToRemove;
	            if (typeof slidesIndexes === 'object' && slidesIndexes.length) {
	                for (var i = 0; i < slidesIndexes.length; i++) {
	                    indexToRemove = slidesIndexes[i];
	                    if (s.slides[indexToRemove]) s.slides.eq(indexToRemove).remove();
	                    if (indexToRemove < newActiveIndex) newActiveIndex--;
	                }
	                newActiveIndex = Math.max(newActiveIndex, 0);
	            }
	            else {
	                indexToRemove = slidesIndexes;
	                if (s.slides[indexToRemove]) s.slides.eq(indexToRemove).remove();
	                if (indexToRemove < newActiveIndex) newActiveIndex--;
	                newActiveIndex = Math.max(newActiveIndex, 0);
	            }
	        
	            if (s.params.loop) {
	                s.createLoop();
	            }
	        
	            if (!(s.params.observer && s.support.observer)) {
	                s.update(true);
	            }
	            if (s.params.loop) {
	                s.slideTo(newActiveIndex + s.loopedSlides, 0, false);
	            }
	            else {
	                s.slideTo(newActiveIndex, 0, false);
	            }
	        
	        };
	        s.removeAllSlides = function () {
	            var slidesIndexes = [];
	            for (var i = 0; i < s.slides.length; i++) {
	                slidesIndexes.push(i);
	            }
	            s.removeSlide(slidesIndexes);
	        };
	        
	
	        /*=========================
	          Effects
	          ===========================*/
	        s.effects = {
	            fade: {
	                setTranslate: function () {
	                    for (var i = 0; i < s.slides.length; i++) {
	                        var slide = s.slides.eq(i);
	                        var offset = slide[0].swiperSlideOffset;
	                        var tx = -offset;
	                        if (!s.params.virtualTranslate) tx = tx - s.translate;
	                        var ty = 0;
	                        if (!s.isHorizontal()) {
	                            ty = tx;
	                            tx = 0;
	                        }
	                        var slideOpacity = s.params.fade.crossFade ?
	                                Math.max(1 - Math.abs(slide[0].progress), 0) :
	                                1 + Math.min(Math.max(slide[0].progress, -1), 0);
	                        slide
	                            .css({
	                                opacity: slideOpacity
	                            })
	                            .transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px)');
	        
	                    }
	        
	                },
	                setTransition: function (duration) {
	                    s.slides.transition(duration);
	                    if (s.params.virtualTranslate && duration !== 0) {
	                        var eventTriggered = false;
	                        s.slides.transitionEnd(function () {
	                            if (eventTriggered) return;
	                            if (!s) return;
	                            eventTriggered = true;
	                            s.animating = false;
	                            var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];
	                            for (var i = 0; i < triggerEvents.length; i++) {
	                                s.wrapper.trigger(triggerEvents[i]);
	                            }
	                        });
	                    }
	                }
	            },
	            flip: {
	                setTranslate: function () {
	                    for (var i = 0; i < s.slides.length; i++) {
	                        var slide = s.slides.eq(i);
	                        var progress = slide[0].progress;
	                        if (s.params.flip.limitRotation) {
	                            progress = Math.max(Math.min(slide[0].progress, 1), -1);
	                        }
	                        var offset = slide[0].swiperSlideOffset;
	                        var rotate = -180 * progress,
	                            rotateY = rotate,
	                            rotateX = 0,
	                            tx = -offset,
	                            ty = 0;
	                        if (!s.isHorizontal()) {
	                            ty = tx;
	                            tx = 0;
	                            rotateX = -rotateY;
	                            rotateY = 0;
	                        }
	                        else if (s.rtl) {
	                            rotateY = -rotateY;
	                        }
	        
	                        slide[0].style.zIndex = -Math.abs(Math.round(progress)) + s.slides.length;
	        
	                        if (s.params.flip.slideShadows) {
	                            //Set shadows
	                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
	                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
	                            if (shadowBefore.length === 0) {
	                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
	                                slide.append(shadowBefore);
	                            }
	                            if (shadowAfter.length === 0) {
	                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
	                                slide.append(shadowAfter);
	                            }
	                            if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
	                            if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
	                        }
	        
	                        slide
	                            .transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)');
	                    }
	                },
	                setTransition: function (duration) {
	                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
	                    if (s.params.virtualTranslate && duration !== 0) {
	                        var eventTriggered = false;
	                        s.slides.eq(s.activeIndex).transitionEnd(function () {
	                            if (eventTriggered) return;
	                            if (!s) return;
	                            if (!$(this).hasClass(s.params.slideActiveClass)) return;
	                            eventTriggered = true;
	                            s.animating = false;
	                            var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];
	                            for (var i = 0; i < triggerEvents.length; i++) {
	                                s.wrapper.trigger(triggerEvents[i]);
	                            }
	                        });
	                    }
	                }
	            },
	            cube: {
	                setTranslate: function () {
	                    var wrapperRotate = 0, cubeShadow;
	                    if (s.params.cube.shadow) {
	                        if (s.isHorizontal()) {
	                            cubeShadow = s.wrapper.find('.swiper-cube-shadow');
	                            if (cubeShadow.length === 0) {
	                                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
	                                s.wrapper.append(cubeShadow);
	                            }
	                            cubeShadow.css({height: s.width + 'px'});
	                        }
	                        else {
	                            cubeShadow = s.container.find('.swiper-cube-shadow');
	                            if (cubeShadow.length === 0) {
	                                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
	                                s.container.append(cubeShadow);
	                            }
	                        }
	                    }
	                    for (var i = 0; i < s.slides.length; i++) {
	                        var slide = s.slides.eq(i);
	                        var slideAngle = i * 90;
	                        var round = Math.floor(slideAngle / 360);
	                        if (s.rtl) {
	                            slideAngle = -slideAngle;
	                            round = Math.floor(-slideAngle / 360);
	                        }
	                        var progress = Math.max(Math.min(slide[0].progress, 1), -1);
	                        var tx = 0, ty = 0, tz = 0;
	                        if (i % 4 === 0) {
	                            tx = - round * 4 * s.size;
	                            tz = 0;
	                        }
	                        else if ((i - 1) % 4 === 0) {
	                            tx = 0;
	                            tz = - round * 4 * s.size;
	                        }
	                        else if ((i - 2) % 4 === 0) {
	                            tx = s.size + round * 4 * s.size;
	                            tz = s.size;
	                        }
	                        else if ((i - 3) % 4 === 0) {
	                            tx = - s.size;
	                            tz = 3 * s.size + s.size * 4 * round;
	                        }
	                        if (s.rtl) {
	                            tx = -tx;
	                        }
	        
	                        if (!s.isHorizontal()) {
	                            ty = tx;
	                            tx = 0;
	                        }
	        
	                        var transform = 'rotateX(' + (s.isHorizontal() ? 0 : -slideAngle) + 'deg) rotateY(' + (s.isHorizontal() ? slideAngle : 0) + 'deg) translate3d(' + tx + 'px, ' + ty + 'px, ' + tz + 'px)';
	                        if (progress <= 1 && progress > -1) {
	                            wrapperRotate = i * 90 + progress * 90;
	                            if (s.rtl) wrapperRotate = -i * 90 - progress * 90;
	                        }
	                        slide.transform(transform);
	                        if (s.params.cube.slideShadows) {
	                            //Set shadows
	                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
	                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
	                            if (shadowBefore.length === 0) {
	                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
	                                slide.append(shadowBefore);
	                            }
	                            if (shadowAfter.length === 0) {
	                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
	                                slide.append(shadowAfter);
	                            }
	                            if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
	                            if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
	                        }
	                    }
	                    s.wrapper.css({
	                        '-webkit-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
	                        '-moz-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
	                        '-ms-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
	                        'transform-origin': '50% 50% -' + (s.size / 2) + 'px'
	                    });
	        
	                    if (s.params.cube.shadow) {
	                        if (s.isHorizontal()) {
	                            cubeShadow.transform('translate3d(0px, ' + (s.width / 2 + s.params.cube.shadowOffset) + 'px, ' + (-s.width / 2) + 'px) rotateX(90deg) rotateZ(0deg) scale(' + (s.params.cube.shadowScale) + ')');
	                        }
	                        else {
	                            var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
	                            var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
	                            var scale1 = s.params.cube.shadowScale,
	                                scale2 = s.params.cube.shadowScale / multiplier,
	                                offset = s.params.cube.shadowOffset;
	                            cubeShadow.transform('scale3d(' + scale1 + ', 1, ' + scale2 + ') translate3d(0px, ' + (s.height / 2 + offset) + 'px, ' + (-s.height / 2 / scale2) + 'px) rotateX(-90deg)');
	                        }
	                    }
	                    var zFactor = (s.isSafari || s.isUiWebView) ? (-s.size / 2) : 0;
	                    s.wrapper.transform('translate3d(0px,0,' + zFactor + 'px) rotateX(' + (s.isHorizontal() ? 0 : wrapperRotate) + 'deg) rotateY(' + (s.isHorizontal() ? -wrapperRotate : 0) + 'deg)');
	                },
	                setTransition: function (duration) {
	                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
	                    if (s.params.cube.shadow && !s.isHorizontal()) {
	                        s.container.find('.swiper-cube-shadow').transition(duration);
	                    }
	                }
	            },
	            coverflow: {
	                setTranslate: function () {
	                    var transform = s.translate;
	                    var center = s.isHorizontal() ? -transform + s.width / 2 : -transform + s.height / 2;
	                    var rotate = s.isHorizontal() ? s.params.coverflow.rotate: -s.params.coverflow.rotate;
	                    var translate = s.params.coverflow.depth;
	                    //Each slide offset from center
	                    for (var i = 0, length = s.slides.length; i < length; i++) {
	                        var slide = s.slides.eq(i);
	                        var slideSize = s.slidesSizesGrid[i];
	                        var slideOffset = slide[0].swiperSlideOffset;
	                        var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * s.params.coverflow.modifier;
	        
	                        var rotateY = s.isHorizontal() ? rotate * offsetMultiplier : 0;
	                        var rotateX = s.isHorizontal() ? 0 : rotate * offsetMultiplier;
	                        // var rotateZ = 0
	                        var translateZ = -translate * Math.abs(offsetMultiplier);
	        
	                        var translateY = s.isHorizontal() ? 0 : s.params.coverflow.stretch * (offsetMultiplier);
	                        var translateX = s.isHorizontal() ? s.params.coverflow.stretch * (offsetMultiplier) : 0;
	        
	                        //Fix for ultra small values
	                        if (Math.abs(translateX) < 0.001) translateX = 0;
	                        if (Math.abs(translateY) < 0.001) translateY = 0;
	                        if (Math.abs(translateZ) < 0.001) translateZ = 0;
	                        if (Math.abs(rotateY) < 0.001) rotateY = 0;
	                        if (Math.abs(rotateX) < 0.001) rotateX = 0;
	        
	                        var slideTransform = 'translate3d(' + translateX + 'px,' + translateY + 'px,' + translateZ + 'px)  rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
	        
	                        slide.transform(slideTransform);
	                        slide[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
	                        if (s.params.coverflow.slideShadows) {
	                            //Set shadows
	                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
	                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
	                            if (shadowBefore.length === 0) {
	                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
	                                slide.append(shadowBefore);
	                            }
	                            if (shadowAfter.length === 0) {
	                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
	                                slide.append(shadowAfter);
	                            }
	                            if (shadowBefore.length) shadowBefore[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
	                            if (shadowAfter.length) shadowAfter[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0;
	                        }
	                    }
	        
	                    //Set correct perspective for IE10
	                    if (s.browser.ie) {
	                        var ws = s.wrapper[0].style;
	                        ws.perspectiveOrigin = center + 'px 50%';
	                    }
	                },
	                setTransition: function (duration) {
	                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
	                }
	            }
	        };
	        
	
	        /*=========================
	          Images Lazy Loading
	          ===========================*/
	        s.lazy = {
	            initialImageLoaded: false,
	            loadImageInSlide: function (index, loadInDuplicate) {
	                if (typeof index === 'undefined') return;
	                if (typeof loadInDuplicate === 'undefined') loadInDuplicate = true;
	                if (s.slides.length === 0) return;
	        
	                var slide = s.slides.eq(index);
	                var img = slide.find('.' + s.params.lazyLoadingClass + ':not(.' + s.params.lazyStatusLoadedClass + '):not(.' + s.params.lazyStatusLoadingClass + ')');
	                if (slide.hasClass(s.params.lazyLoadingClass) && !slide.hasClass(s.params.lazyStatusLoadedClass) && !slide.hasClass(s.params.lazyStatusLoadingClass)) {
	                    img = img.add(slide[0]);
	                }
	                if (img.length === 0) return;
	        
	                img.each(function () {
	                    var _img = $(this);
	                    _img.addClass(s.params.lazyStatusLoadingClass);
	                    var background = _img.attr('data-background');
	                    var src = _img.attr('data-src'),
	                        srcset = _img.attr('data-srcset'),
	                        sizes = _img.attr('data-sizes');
	                    s.loadImage(_img[0], (src || background), srcset, sizes, false, function () {
	                        if (typeof s === 'undefined' || s === null || !s) return;
	                        if (background) {
	                            _img.css('background-image', 'url("' + background + '")');
	                            _img.removeAttr('data-background');
	                        }
	                        else {
	                            if (srcset) {
	                                _img.attr('srcset', srcset);
	                                _img.removeAttr('data-srcset');
	                            }
	                            if (sizes) {
	                                _img.attr('sizes', sizes);
	                                _img.removeAttr('data-sizes');
	                            }
	                            if (src) {
	                                _img.attr('src', src);
	                                _img.removeAttr('data-src');
	                            }
	        
	                        }
	        
	                        _img.addClass(s.params.lazyStatusLoadedClass).removeClass(s.params.lazyStatusLoadingClass);
	                        slide.find('.' + s.params.lazyPreloaderClass + ', .' + s.params.preloaderClass).remove();
	                        if (s.params.loop && loadInDuplicate) {
	                            var slideOriginalIndex = slide.attr('data-swiper-slide-index');
	                            if (slide.hasClass(s.params.slideDuplicateClass)) {
	                                var originalSlide = s.wrapper.children('[data-swiper-slide-index="' + slideOriginalIndex + '"]:not(.' + s.params.slideDuplicateClass + ')');
	                                s.lazy.loadImageInSlide(originalSlide.index(), false);
	                            }
	                            else {
	                                var duplicatedSlide = s.wrapper.children('.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + slideOriginalIndex + '"]');
	                                s.lazy.loadImageInSlide(duplicatedSlide.index(), false);
	                            }
	                        }
	                        s.emit('onLazyImageReady', s, slide[0], _img[0]);
	                    });
	        
	                    s.emit('onLazyImageLoad', s, slide[0], _img[0]);
	                });
	        
	            },
	            load: function () {
	                var i;
	                var slidesPerView = s.params.slidesPerView;
	                if (slidesPerView === 'auto') {
	                    slidesPerView = 0;
	                }
	                if (!s.lazy.initialImageLoaded) s.lazy.initialImageLoaded = true;
	                if (s.params.watchSlidesVisibility) {
	                    s.wrapper.children('.' + s.params.slideVisibleClass).each(function () {
	                        s.lazy.loadImageInSlide($(this).index());
	                    });
	                }
	                else {
	                    if (slidesPerView > 1) {
	                        for (i = s.activeIndex; i < s.activeIndex + slidesPerView ; i++) {
	                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
	                        }
	                    }
	                    else {
	                        s.lazy.loadImageInSlide(s.activeIndex);
	                    }
	                }
	                if (s.params.lazyLoadingInPrevNext) {
	                    if (slidesPerView > 1 || (s.params.lazyLoadingInPrevNextAmount && s.params.lazyLoadingInPrevNextAmount > 1)) {
	                        var amount = s.params.lazyLoadingInPrevNextAmount;
	                        var spv = slidesPerView;
	                        var maxIndex = Math.min(s.activeIndex + spv + Math.max(amount, spv), s.slides.length);
	                        var minIndex = Math.max(s.activeIndex - Math.max(spv, amount), 0);
	                        // Next Slides
	                        for (i = s.activeIndex + slidesPerView; i < maxIndex; i++) {
	                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
	                        }
	                        // Prev Slides
	                        for (i = minIndex; i < s.activeIndex ; i++) {
	                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
	                        }
	                    }
	                    else {
	                        var nextSlide = s.wrapper.children('.' + s.params.slideNextClass);
	                        if (nextSlide.length > 0) s.lazy.loadImageInSlide(nextSlide.index());
	        
	                        var prevSlide = s.wrapper.children('.' + s.params.slidePrevClass);
	                        if (prevSlide.length > 0) s.lazy.loadImageInSlide(prevSlide.index());
	                    }
	                }
	            },
	            onTransitionStart: function () {
	                if (s.params.lazyLoading) {
	                    if (s.params.lazyLoadingOnTransitionStart || (!s.params.lazyLoadingOnTransitionStart && !s.lazy.initialImageLoaded)) {
	                        s.lazy.load();
	                    }
	                }
	            },
	            onTransitionEnd: function () {
	                if (s.params.lazyLoading && !s.params.lazyLoadingOnTransitionStart) {
	                    s.lazy.load();
	                }
	            }
	        };
	        
	
	        /*=========================
	          Scrollbar
	          ===========================*/
	        s.scrollbar = {
	            isTouched: false,
	            setDragPosition: function (e) {
	                var sb = s.scrollbar;
	                var x = 0, y = 0;
	                var translate;
	                var pointerPosition = s.isHorizontal() ?
	                    ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX) :
	                    ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY) ;
	                var position = (pointerPosition) - sb.track.offset()[s.isHorizontal() ? 'left' : 'top'] - sb.dragSize / 2;
	                var positionMin = -s.minTranslate() * sb.moveDivider;
	                var positionMax = -s.maxTranslate() * sb.moveDivider;
	                if (position < positionMin) {
	                    position = positionMin;
	                }
	                else if (position > positionMax) {
	                    position = positionMax;
	                }
	                position = -position / sb.moveDivider;
	                s.updateProgress(position);
	                s.setWrapperTranslate(position, true);
	            },
	            dragStart: function (e) {
	                var sb = s.scrollbar;
	                sb.isTouched = true;
	                e.preventDefault();
	                e.stopPropagation();
	        
	                sb.setDragPosition(e);
	                clearTimeout(sb.dragTimeout);
	        
	                sb.track.transition(0);
	                if (s.params.scrollbarHide) {
	                    sb.track.css('opacity', 1);
	                }
	                s.wrapper.transition(100);
	                sb.drag.transition(100);
	                s.emit('onScrollbarDragStart', s);
	            },
	            dragMove: function (e) {
	                var sb = s.scrollbar;
	                if (!sb.isTouched) return;
	                if (e.preventDefault) e.preventDefault();
	                else e.returnValue = false;
	                sb.setDragPosition(e);
	                s.wrapper.transition(0);
	                sb.track.transition(0);
	                sb.drag.transition(0);
	                s.emit('onScrollbarDragMove', s);
	            },
	            dragEnd: function (e) {
	                var sb = s.scrollbar;
	                if (!sb.isTouched) return;
	                sb.isTouched = false;
	                if (s.params.scrollbarHide) {
	                    clearTimeout(sb.dragTimeout);
	                    sb.dragTimeout = setTimeout(function () {
	                        sb.track.css('opacity', 0);
	                        sb.track.transition(400);
	                    }, 1000);
	        
	                }
	                s.emit('onScrollbarDragEnd', s);
	                if (s.params.scrollbarSnapOnRelease) {
	                    s.slideReset();
	                }
	            },
	            draggableEvents: (function () {
	                if ((s.params.simulateTouch === false && !s.support.touch)) return s.touchEventsDesktop;
	                else return s.touchEvents;
	            })(),
	            enableDraggable: function () {
	                var sb = s.scrollbar;
	                var target = s.support.touch ? sb.track : document;
	                $(sb.track).on(sb.draggableEvents.start, sb.dragStart);
	                $(target).on(sb.draggableEvents.move, sb.dragMove);
	                $(target).on(sb.draggableEvents.end, sb.dragEnd);
	            },
	            disableDraggable: function () {
	                var sb = s.scrollbar;
	                var target = s.support.touch ? sb.track : document;
	                $(sb.track).off(sb.draggableEvents.start, sb.dragStart);
	                $(target).off(sb.draggableEvents.move, sb.dragMove);
	                $(target).off(sb.draggableEvents.end, sb.dragEnd);
	            },
	            set: function () {
	                if (!s.params.scrollbar) return;
	                var sb = s.scrollbar;
	                sb.track = $(s.params.scrollbar);
	                if (s.params.uniqueNavElements && typeof s.params.scrollbar === 'string' && sb.track.length > 1 && s.container.find(s.params.scrollbar).length === 1) {
	                    sb.track = s.container.find(s.params.scrollbar);
	                }
	                sb.drag = sb.track.find('.swiper-scrollbar-drag');
	                if (sb.drag.length === 0) {
	                    sb.drag = $('<div class="swiper-scrollbar-drag"></div>');
	                    sb.track.append(sb.drag);
	                }
	                sb.drag[0].style.width = '';
	                sb.drag[0].style.height = '';
	                sb.trackSize = s.isHorizontal() ? sb.track[0].offsetWidth : sb.track[0].offsetHeight;
	        
	                sb.divider = s.size / s.virtualSize;
	                sb.moveDivider = sb.divider * (sb.trackSize / s.size);
	                sb.dragSize = sb.trackSize * sb.divider;
	        
	                if (s.isHorizontal()) {
	                    sb.drag[0].style.width = sb.dragSize + 'px';
	                }
	                else {
	                    sb.drag[0].style.height = sb.dragSize + 'px';
	                }
	        
	                if (sb.divider >= 1) {
	                    sb.track[0].style.display = 'none';
	                }
	                else {
	                    sb.track[0].style.display = '';
	                }
	                if (s.params.scrollbarHide) {
	                    sb.track[0].style.opacity = 0;
	                }
	            },
	            setTranslate: function () {
	                if (!s.params.scrollbar) return;
	                var diff;
	                var sb = s.scrollbar;
	                var translate = s.translate || 0;
	                var newPos;
	        
	                var newSize = sb.dragSize;
	                newPos = (sb.trackSize - sb.dragSize) * s.progress;
	                if (s.rtl && s.isHorizontal()) {
	                    newPos = -newPos;
	                    if (newPos > 0) {
	                        newSize = sb.dragSize - newPos;
	                        newPos = 0;
	                    }
	                    else if (-newPos + sb.dragSize > sb.trackSize) {
	                        newSize = sb.trackSize + newPos;
	                    }
	                }
	                else {
	                    if (newPos < 0) {
	                        newSize = sb.dragSize + newPos;
	                        newPos = 0;
	                    }
	                    else if (newPos + sb.dragSize > sb.trackSize) {
	                        newSize = sb.trackSize - newPos;
	                    }
	                }
	                if (s.isHorizontal()) {
	                    if (s.support.transforms3d) {
	                        sb.drag.transform('translate3d(' + (newPos) + 'px, 0, 0)');
	                    }
	                    else {
	                        sb.drag.transform('translateX(' + (newPos) + 'px)');
	                    }
	                    sb.drag[0].style.width = newSize + 'px';
	                }
	                else {
	                    if (s.support.transforms3d) {
	                        sb.drag.transform('translate3d(0px, ' + (newPos) + 'px, 0)');
	                    }
	                    else {
	                        sb.drag.transform('translateY(' + (newPos) + 'px)');
	                    }
	                    sb.drag[0].style.height = newSize + 'px';
	                }
	                if (s.params.scrollbarHide) {
	                    clearTimeout(sb.timeout);
	                    sb.track[0].style.opacity = 1;
	                    sb.timeout = setTimeout(function () {
	                        sb.track[0].style.opacity = 0;
	                        sb.track.transition(400);
	                    }, 1000);
	                }
	            },
	            setTransition: function (duration) {
	                if (!s.params.scrollbar) return;
	                s.scrollbar.drag.transition(duration);
	            }
	        };
	        
	
	        /*=========================
	          Controller
	          ===========================*/
	        s.controller = {
	            LinearSpline: function (x, y) {
	                var binarySearch = (function() {
	                    var maxIndex, minIndex, guess;
	                    return function(array, val) {
	                        minIndex = -1;
	                        maxIndex = array.length;
	                        while (maxIndex - minIndex > 1)
	                            if (array[guess = maxIndex + minIndex >> 1] <= val) {
	                                minIndex = guess;
	                            } else {
	                                maxIndex = guess;
	                            }
	                        return maxIndex;
	                    };
	                })();
	                this.x = x;
	                this.y = y;
	                this.lastIndex = x.length - 1;
	                // Given an x value (x2), return the expected y2 value:
	                // (x1,y1) is the known point before given value,
	                // (x3,y3) is the known point after given value.
	                var i1, i3;
	                var l = this.x.length;
	        
	                this.interpolate = function (x2) {
	                    if (!x2) return 0;
	        
	                    // Get the indexes of x1 and x3 (the array indexes before and after given x2):
	                    i3 = binarySearch(this.x, x2);
	                    i1 = i3 - 1;
	        
	                    // We have our indexes i1 & i3, so we can calculate already:
	                    // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
	                    return ((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1]) + this.y[i1];
	                };
	            },
	            //xxx: for now i will just save one spline function to to
	            getInterpolateFunction: function(c){
	                if(!s.controller.spline) s.controller.spline = s.params.loop ?
	                    new s.controller.LinearSpline(s.slidesGrid, c.slidesGrid) :
	                    new s.controller.LinearSpline(s.snapGrid, c.snapGrid);
	            },
	            setTranslate: function (translate, byController) {
	               var controlled = s.params.control;
	               var multiplier, controlledTranslate;
	               function setControlledTranslate(c) {
	                    // this will create an Interpolate function based on the snapGrids
	                    // x is the Grid of the scrolled scroller and y will be the controlled scroller
	                    // it makes sense to create this only once and recall it for the interpolation
	                    // the function does a lot of value caching for performance
	                    translate = c.rtl && c.params.direction === 'horizontal' ? -s.translate : s.translate;
	                    if (s.params.controlBy === 'slide') {
	                        s.controller.getInterpolateFunction(c);
	                        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
	                        // but it did not work out
	                        controlledTranslate = -s.controller.spline.interpolate(-translate);
	                    }
	        
	                    if(!controlledTranslate || s.params.controlBy === 'container'){
	                        multiplier = (c.maxTranslate() - c.minTranslate()) / (s.maxTranslate() - s.minTranslate());
	                        controlledTranslate = (translate - s.minTranslate()) * multiplier + c.minTranslate();
	                    }
	        
	                    if (s.params.controlInverse) {
	                        controlledTranslate = c.maxTranslate() - controlledTranslate;
	                    }
	                    c.updateProgress(controlledTranslate);
	                    c.setWrapperTranslate(controlledTranslate, false, s);
	                    c.updateActiveIndex();
	               }
	               if (Array.isArray(controlled)) {
	                   for (var i = 0; i < controlled.length; i++) {
	                       if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	                           setControlledTranslate(controlled[i]);
	                       }
	                   }
	               }
	               else if (controlled instanceof Swiper && byController !== controlled) {
	        
	                   setControlledTranslate(controlled);
	               }
	            },
	            setTransition: function (duration, byController) {
	                var controlled = s.params.control;
	                var i;
	                function setControlledTransition(c) {
	                    c.setWrapperTransition(duration, s);
	                    if (duration !== 0) {
	                        c.onTransitionStart();
	                        c.wrapper.transitionEnd(function(){
	                            if (!controlled) return;
	                            if (c.params.loop && s.params.controlBy === 'slide') {
	                                c.fixLoop();
	                            }
	                            c.onTransitionEnd();
	        
	                        });
	                    }
	                }
	                if (Array.isArray(controlled)) {
	                    for (i = 0; i < controlled.length; i++) {
	                        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	                            setControlledTransition(controlled[i]);
	                        }
	                    }
	                }
	                else if (controlled instanceof Swiper && byController !== controlled) {
	                    setControlledTransition(controlled);
	                }
	            }
	        };
	        
	
	        /*=========================
	          Hash Navigation
	          ===========================*/
	        s.hashnav = {
	            onHashCange: function (e, a) {
	                var newHash = document.location.hash.replace('#', '');
	                var activeSlideHash = s.slides.eq(s.activeIndex).attr('data-hash');
	                if (newHash !== activeSlideHash) {
	                    s.slideTo(s.wrapper.children('.' + s.params.slideClass + '[data-hash="' + (newHash) + '"]').index());
	                }
	            },
	            attachEvents: function (detach) {
	                var action = detach ? 'off' : 'on';
	                $(window)[action]('hashchange', s.hashnav.onHashCange);
	            },
	            setHash: function () {
	                if (!s.hashnav.initialized || !s.params.hashnav) return;
	                if (s.params.replaceState && window.history && window.history.replaceState) {
	                    window.history.replaceState(null, null, ('#' + s.slides.eq(s.activeIndex).attr('data-hash') || ''));
	                } else {
	                    var slide = s.slides.eq(s.activeIndex);
	                    var hash = slide.attr('data-hash') || slide.attr('data-history');
	                    document.location.hash = hash || '';
	                }
	            },
	            init: function () {
	                if (!s.params.hashnav || s.params.history) return;
	                s.hashnav.initialized = true;
	                var hash = document.location.hash.replace('#', '');
	                if (hash) {
	                    var speed = 0;
	                    for (var i = 0, length = s.slides.length; i < length; i++) {
	                        var slide = s.slides.eq(i);
	                        var slideHash = slide.attr('data-hash') || slide.attr('data-history');
	                        if (slideHash === hash && !slide.hasClass(s.params.slideDuplicateClass)) {
	                            var index = slide.index();
	                            s.slideTo(index, speed, s.params.runCallbacksOnInit, true);
	                        }
	                    }
	                }
	                if (s.params.hashnavWatchState) s.hashnav.attachEvents();
	            },
	            destroy: function () {
	                if (s.params.hashnavWatchState) s.hashnav.attachEvents(true);
	            }
	        };
	        
	
	        /*=========================
	          History Api with fallback to Hashnav
	          ===========================*/
	        s.history = {
	            init: function () {
	                if (!s.params.history) return;
	                if (!window.history || !window.history.pushState) {
	                    s.params.history = false;
	                    s.params.hashnav = true;
	                    return;
	                }
	                s.history.initialized = true;
	                this.paths = this.getPathValues();
	                if (!this.paths.key && !this.paths.value) return;
	                this.scrollToSlide(0, this.paths.value, s.params.runCallbacksOnInit);
	                if (!s.params.replaceState) {
	                    window.addEventListener('popstate', this.setHistoryPopState);
	                }
	            },
	            setHistoryPopState: function() {
	                s.history.paths = s.history.getPathValues();
	                s.history.scrollToSlide(s.params.speed, s.history.paths.value, false);
	            },
	            getPathValues: function() {
	                var pathArray = window.location.pathname.slice(1).split('/');
	                var total = pathArray.length;
	                var key = pathArray[total - 2];
	                var value = pathArray[total - 1];
	                return { key: key, value: value };
	            },
	            setHistory: function (key, index) {
	                if (!s.history.initialized || !s.params.history) return;
	                var slide = s.slides.eq(index);
	                var value = this.slugify(slide.attr('data-history'));
	                if (!window.location.pathname.includes(key)) {
	                    value = key + '/' + value;
	                }
	                if (s.params.replaceState) {
	                    window.history.replaceState(null, null, value);
	                } else {
	                    window.history.pushState(null, null, value);
	                }
	            },
	            slugify: function(text) {
	                return text.toString().toLowerCase()
	                    .replace(/\s+/g, '-')
	                    .replace(/[^\w\-]+/g, '')
	                    .replace(/\-\-+/g, '-')
	                    .replace(/^-+/, '')
	                    .replace(/-+$/, '');
	            },
	            scrollToSlide: function(speed, value, runCallbacks) {
	                if (value) {
	                    for (var i = 0, length = s.slides.length; i < length; i++) {
	                        var slide = s.slides.eq(i);
	                        var slideHistory = this.slugify(slide.attr('data-history'));
	                        if (slideHistory === value && !slide.hasClass(s.params.slideDuplicateClass)) {
	                            var index = slide.index();
	                            s.slideTo(index, speed, runCallbacks);
	                        }
	                    }
	                } else {
	                    s.slideTo(0, speed, runCallbacks);
	                }
	            }
	        };
	        
	
	        /*=========================
	          Keyboard Control
	          ===========================*/
	        function handleKeyboard(e) {
	            if (e.originalEvent) e = e.originalEvent; //jquery fix
	            var kc = e.keyCode || e.charCode;
	            // Directions locks
	            if (!s.params.allowSwipeToNext && (s.isHorizontal() && kc === 39 || !s.isHorizontal() && kc === 40)) {
	                return false;
	            }
	            if (!s.params.allowSwipeToPrev && (s.isHorizontal() && kc === 37 || !s.isHorizontal() && kc === 38)) {
	                return false;
	            }
	            if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
	                return;
	            }
	            if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
	                return;
	            }
	            if (kc === 37 || kc === 39 || kc === 38 || kc === 40) {
	                var inView = false;
	                //Check that swiper should be inside of visible area of window
	                if (s.container.parents('.' + s.params.slideClass).length > 0 && s.container.parents('.' + s.params.slideActiveClass).length === 0) {
	                    return;
	                }
	                var windowScroll = {
	                    left: window.pageXOffset,
	                    top: window.pageYOffset
	                };
	                var windowWidth = window.innerWidth;
	                var windowHeight = window.innerHeight;
	                var swiperOffset = s.container.offset();
	                if (s.rtl) swiperOffset.left = swiperOffset.left - s.container[0].scrollLeft;
	                var swiperCoord = [
	                    [swiperOffset.left, swiperOffset.top],
	                    [swiperOffset.left + s.width, swiperOffset.top],
	                    [swiperOffset.left, swiperOffset.top + s.height],
	                    [swiperOffset.left + s.width, swiperOffset.top + s.height]
	                ];
	                for (var i = 0; i < swiperCoord.length; i++) {
	                    var point = swiperCoord[i];
	                    if (
	                        point[0] >= windowScroll.left && point[0] <= windowScroll.left + windowWidth &&
	                        point[1] >= windowScroll.top && point[1] <= windowScroll.top + windowHeight
	                    ) {
	                        inView = true;
	                    }
	        
	                }
	                if (!inView) return;
	            }
	            if (s.isHorizontal()) {
	                if (kc === 37 || kc === 39) {
	                    if (e.preventDefault) e.preventDefault();
	                    else e.returnValue = false;
	                }
	                if ((kc === 39 && !s.rtl) || (kc === 37 && s.rtl)) s.slideNext();
	                if ((kc === 37 && !s.rtl) || (kc === 39 && s.rtl)) s.slidePrev();
	            }
	            else {
	                if (kc === 38 || kc === 40) {
	                    if (e.preventDefault) e.preventDefault();
	                    else e.returnValue = false;
	                }
	                if (kc === 40) s.slideNext();
	                if (kc === 38) s.slidePrev();
	            }
	            s.emit('onKeyPress', s, kc);
	        }
	        s.disableKeyboardControl = function () {
	            s.params.keyboardControl = false;
	            $(document).off('keydown', handleKeyboard);
	        };
	        s.enableKeyboardControl = function () {
	            s.params.keyboardControl = true;
	            $(document).on('keydown', handleKeyboard);
	        };
	        
	
	        /*=========================
	          Mousewheel Control
	          ===========================*/
	        s.mousewheel = {
	            event: false,
	            lastScrollTime: (new window.Date()).getTime()
	        };
	        function isEventSupported() {
	            var eventName = 'onwheel';
	            var isSupported = eventName in document;
	        
	            if (!isSupported) {
	                var element = document.createElement('div');
	                element.setAttribute(eventName, 'return;');
	                isSupported = typeof element[eventName] === 'function';
	            }
	        
	            if (!isSupported &&
	                document.implementation &&
	                document.implementation.hasFeature &&
	                    // always returns true in newer browsers as per the standard.
	                    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	                document.implementation.hasFeature('', '') !== true ) {
	                // This is the only way to test support for the `wheel` event in IE9+.
	                isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	            }
	        
	            return isSupported;
	        }
	        /**
	         * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
	         * complicated, thus this doc is long and (hopefully) detailed enough to answer
	         * your questions.
	         *
	         * If you need to react to the mouse wheel in a predictable way, this code is
	         * like your bestest friend. * hugs *
	         *
	         * As of today, there are 4 DOM event types you can listen to:
	         *
	         *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
	         *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
	         *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
	         *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
	         *
	         * So what to do?  The is the best:
	         *
	         *   normalizeWheel.getEventType();
	         *
	         * In your event callback, use this code to get sane interpretation of the
	         * deltas.  This code will return an object with properties:
	         *
	         *   spinX   -- normalized spin speed (use for zoom) - x plane
	         *   spinY   -- " - y plane
	         *   pixelX  -- normalized distance (to pixels) - x plane
	         *   pixelY  -- " - y plane
	         *
	         * Wheel values are provided by the browser assuming you are using the wheel to
	         * scroll a web page by a number of lines or pixels (or pages).  Values can vary
	         * significantly on different platforms and browsers, forgetting that you can
	         * scroll at different speeds.  Some devices (like trackpads) emit more events
	         * at smaller increments with fine granularity, and some emit massive jumps with
	         * linear speed or acceleration.
	         *
	         * This code does its best to normalize the deltas for you:
	         *
	         *   - spin is trying to normalize how far the wheel was spun (or trackpad
	         *     dragged).  This is super useful for zoom support where you want to
	         *     throw away the chunky scroll steps on the PC and make those equal to
	         *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
	         *     resolve a single slow step on a wheel to 1.
	         *
	         *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
	         *     get the crazy differences between browsers, but at least it'll be in
	         *     pixels!
	         *
	         *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
	         *     should translate to positive value zooming IN, negative zooming OUT.
	         *     This matches the newer 'wheel' event.
	         *
	         * Why are there spinX, spinY (or pixels)?
	         *
	         *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
	         *     with a mouse.  It results in side-scrolling in the browser by default.
	         *
	         *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
	         *
	         *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
	         *     probably is by browsers in conjunction with fancy 3D controllers .. but
	         *     you know.
	         *
	         * Implementation info:
	         *
	         * Examples of 'wheel' event if you scroll slowly (down) by one step with an
	         * average mouse:
	         *
	         *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
	         *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
	         *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
	         *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
	         *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
	         *
	         * On the trackpad:
	         *
	         *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
	         *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
	         *
	         * On other/older browsers.. it's more complicated as there can be multiple and
	         * also missing delta values.
	         *
	         * The 'wheel' event is more standard:
	         *
	         * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
	         *
	         * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
	         * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
	         * backward compatibility with older events.  Those other values help us
	         * better normalize spin speed.  Example of what the browsers provide:
	         *
	         *                          | event.wheelDelta | event.detail
	         *        ------------------+------------------+--------------
	         *          Safari v5/OS X  |       -120       |       0
	         *          Safari v5/Win7  |       -120       |       0
	         *         Chrome v17/OS X  |       -120       |       0
	         *         Chrome v17/Win7  |       -120       |       0
	         *                IE9/Win7  |       -120       |   undefined
	         *         Firefox v4/OS X  |     undefined    |       1
	         *         Firefox v4/Win7  |     undefined    |       3
	         *
	         */
	        function normalizeWheel( /*object*/ event ) /*object*/ {
	            // Reasonable defaults
	            var PIXEL_STEP = 10;
	            var LINE_HEIGHT = 40;
	            var PAGE_HEIGHT = 800;
	        
	            var sX = 0, sY = 0,       // spinX, spinY
	                pX = 0, pY = 0;       // pixelX, pixelY
	        
	            // Legacy
	            if( 'detail' in event ) {
	                sY = event.detail;
	            }
	            if( 'wheelDelta' in event ) {
	                sY = -event.wheelDelta / 120;
	            }
	            if( 'wheelDeltaY' in event ) {
	                sY = -event.wheelDeltaY / 120;
	            }
	            if( 'wheelDeltaX' in event ) {
	                sX = -event.wheelDeltaX / 120;
	            }
	        
	            // side scrolling on FF with DOMMouseScroll
	            if( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
	                sX = sY;
	                sY = 0;
	            }
	        
	            pX = sX * PIXEL_STEP;
	            pY = sY * PIXEL_STEP;
	        
	            if( 'deltaY' in event ) {
	                pY = event.deltaY;
	            }
	            if( 'deltaX' in event ) {
	                pX = event.deltaX;
	            }
	        
	            if( (pX || pY) && event.deltaMode ) {
	                if( event.deltaMode === 1 ) {          // delta in LINE units
	                    pX *= LINE_HEIGHT;
	                    pY *= LINE_HEIGHT;
	                } else {                             // delta in PAGE units
	                    pX *= PAGE_HEIGHT;
	                    pY *= PAGE_HEIGHT;
	                }
	            }
	        
	            // Fall-back if spin cannot be determined
	            if( pX && !sX ) {
	                sX = (pX < 1) ? -1 : 1;
	            }
	            if( pY && !sY ) {
	                sY = (pY < 1) ? -1 : 1;
	            }
	        
	            return {
	                spinX: sX,
	                spinY: sY,
	                pixelX: pX,
	                pixelY: pY
	            };
	        }
	        if (s.params.mousewheelControl) {
	            /**
	             * The best combination if you prefer spinX + spinY normalization.  It favors
	             * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
	             * 'wheel' event, making spin speed determination impossible.
	             */
	            s.mousewheel.event = (navigator.userAgent.indexOf('firefox') > -1) ?
	                'DOMMouseScroll' :
	                isEventSupported() ?
	                    'wheel' : 'mousewheel';
	        }
	        function handleMousewheel(e) {
	            if (e.originalEvent) e = e.originalEvent; //jquery fix
	            var delta = 0;
	            var rtlFactor = s.rtl ? -1 : 1;
	        
	            var data = normalizeWheel( e );
	        
	            if (s.params.mousewheelForceToAxis) {
	                if (s.isHorizontal()) {
	                    if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = data.pixelX * rtlFactor;
	                    else return;
	                }
	                else {
	                    if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = data.pixelY;
	                    else return;
	                }
	            }
	            else {
	                delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? - data.pixelX * rtlFactor : - data.pixelY;
	            }
	        
	            if (delta === 0) return;
	        
	            if (s.params.mousewheelInvert) delta = -delta;
	        
	            if (!s.params.freeMode) {
	                if ((new window.Date()).getTime() - s.mousewheel.lastScrollTime > 60) {
	                    if (delta < 0) {
	                        if ((!s.isEnd || s.params.loop) && !s.animating) {
	                            s.slideNext();
	                            s.emit('onScroll', s, e);
	                        }
	                        else if (s.params.mousewheelReleaseOnEdges) return true;
	                    }
	                    else {
	                        if ((!s.isBeginning || s.params.loop) && !s.animating) {
	                            s.slidePrev();
	                            s.emit('onScroll', s, e);
	                        }
	                        else if (s.params.mousewheelReleaseOnEdges) return true;
	                    }
	                }
	                s.mousewheel.lastScrollTime = (new window.Date()).getTime();
	        
	            }
	            else {
	                //Freemode or scrollContainer:
	                var position = s.getWrapperTranslate() + delta * s.params.mousewheelSensitivity;
	                var wasBeginning = s.isBeginning,
	                    wasEnd = s.isEnd;
	        
	                if (position >= s.minTranslate()) position = s.minTranslate();
	                if (position <= s.maxTranslate()) position = s.maxTranslate();
	        
	                s.setWrapperTransition(0);
	                s.setWrapperTranslate(position);
	                s.updateProgress();
	                s.updateActiveIndex();
	        
	                if (!wasBeginning && s.isBeginning || !wasEnd && s.isEnd) {
	                    s.updateClasses();
	                }
	        
	                if (s.params.freeModeSticky) {
	                    clearTimeout(s.mousewheel.timeout);
	                    s.mousewheel.timeout = setTimeout(function () {
	                        s.slideReset();
	                    }, 300);
	                }
	                else {
	                    if (s.params.lazyLoading && s.lazy) {
	                        s.lazy.load();
	                    }
	                }
	                // Emit event
	                s.emit('onScroll', s, e);
	        
	                // Stop autoplay
	                if (s.params.autoplay && s.params.autoplayDisableOnInteraction) s.stopAutoplay();
	        
	                // Return page scroll on edge positions
	                if (position === 0 || position === s.maxTranslate()) return;
	            }
	        
	            if (e.preventDefault) e.preventDefault();
	            else e.returnValue = false;
	            return false;
	        }
	        s.disableMousewheelControl = function () {
	            if (!s.mousewheel.event) return false;
	            var target = s.container;
	            if (s.params.mousewheelEventsTarged !== 'container') {
	                target = $(s.params.mousewheelEventsTarged);
	            }
	            target.off(s.mousewheel.event, handleMousewheel);
	            s.params.mousewheelControl = false;
	            return true;
	        };
	        
	        s.enableMousewheelControl = function () {
	            if (!s.mousewheel.event) return false;
	            var target = s.container;
	            if (s.params.mousewheelEventsTarged !== 'container') {
	                target = $(s.params.mousewheelEventsTarged);
	            }
	            target.on(s.mousewheel.event, handleMousewheel);
	            s.params.mousewheelControl = true;
	            return true;
	        };
	        
	
	        /*=========================
	          Parallax
	          ===========================*/
	        function setParallaxTransform(el, progress) {
	            el = $(el);
	            var p, pX, pY;
	            var rtlFactor = s.rtl ? -1 : 1;
	        
	            p = el.attr('data-swiper-parallax') || '0';
	            pX = el.attr('data-swiper-parallax-x');
	            pY = el.attr('data-swiper-parallax-y');
	            if (pX || pY) {
	                pX = pX || '0';
	                pY = pY || '0';
	            }
	            else {
	                if (s.isHorizontal()) {
	                    pX = p;
	                    pY = '0';
	                }
	                else {
	                    pY = p;
	                    pX = '0';
	                }
	            }
	        
	            if ((pX).indexOf('%') >= 0) {
	                pX = parseInt(pX, 10) * progress * rtlFactor + '%';
	            }
	            else {
	                pX = pX * progress * rtlFactor + 'px' ;
	            }
	            if ((pY).indexOf('%') >= 0) {
	                pY = parseInt(pY, 10) * progress + '%';
	            }
	            else {
	                pY = pY * progress + 'px' ;
	            }
	        
	            el.transform('translate3d(' + pX + ', ' + pY + ',0px)');
	        }
	        s.parallax = {
	            setTranslate: function () {
	                s.container.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function(){
	                    setParallaxTransform(this, s.progress);
	        
	                });
	                s.slides.each(function () {
	                    var slide = $(this);
	                    slide.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function () {
	                        var progress = Math.min(Math.max(slide[0].progress, -1), 1);
	                        setParallaxTransform(this, progress);
	                    });
	                });
	            },
	            setTransition: function (duration) {
	                if (typeof duration === 'undefined') duration = s.params.speed;
	                s.container.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function(){
	                    var el = $(this);
	                    var parallaxDuration = parseInt(el.attr('data-swiper-parallax-duration'), 10) || duration;
	                    if (duration === 0) parallaxDuration = 0;
	                    el.transition(parallaxDuration);
	                });
	            }
	        };
	        
	
	        /*=========================
	          Zoom
	          ===========================*/
	        s.zoom = {
	            // "Global" Props
	            scale: 1,
	            currentScale: 1,
	            isScaling: false,
	            gesture: {
	                slide: undefined,
	                slideWidth: undefined,
	                slideHeight: undefined,
	                image: undefined,
	                imageWrap: undefined,
	                zoomMax: s.params.zoomMax
	            },
	            image: {
	                isTouched: undefined,
	                isMoved: undefined,
	                currentX: undefined,
	                currentY: undefined,
	                minX: undefined,
	                minY: undefined,
	                maxX: undefined,
	                maxY: undefined,
	                width: undefined,
	                height: undefined,
	                startX: undefined,
	                startY: undefined,
	                touchesStart: {},
	                touchesCurrent: {}
	            },
	            velocity: {
	                x: undefined,
	                y: undefined,
	                prevPositionX: undefined,
	                prevPositionY: undefined,
	                prevTime: undefined
	            },
	            // Calc Scale From Multi-touches
	            getDistanceBetweenTouches: function (e) {
	                if (e.targetTouches.length < 2) return 1;
	                var x1 = e.targetTouches[0].pageX,
	                    y1 = e.targetTouches[0].pageY,
	                    x2 = e.targetTouches[1].pageX,
	                    y2 = e.targetTouches[1].pageY;
	                var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
	                return distance;
	            },
	            // Events
	            onGestureStart: function (e) {
	                var z = s.zoom;
	                if (!s.support.gestures) {
	                    if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
	                        return;
	                    }
	                    z.gesture.scaleStart = z.getDistanceBetweenTouches(e);
	                }
	                if (!z.gesture.slide || !z.gesture.slide.length) {
	                    z.gesture.slide = $(this);
	                    if (z.gesture.slide.length === 0) z.gesture.slide = s.slides.eq(s.activeIndex);
	                    z.gesture.image = z.gesture.slide.find('img, svg, canvas');
	                    z.gesture.imageWrap = z.gesture.image.parent('.' + s.params.zoomContainerClass);
	                    z.gesture.zoomMax = z.gesture.imageWrap.attr('data-swiper-zoom') || s.params.zoomMax ;
	                    if (z.gesture.imageWrap.length === 0) {
	                        z.gesture.image = undefined;
	                        return;
	                    }
	                }
	                z.gesture.image.transition(0);
	                z.isScaling = true;
	            },
	            onGestureChange: function (e) {
	                var z = s.zoom;
	                if (!s.support.gestures) {
	                    if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
	                        return;
	                    }
	                    z.gesture.scaleMove = z.getDistanceBetweenTouches(e);
	                }
	                if (!z.gesture.image || z.gesture.image.length === 0) return;
	                if (s.support.gestures) {
	                    z.scale = e.scale * z.currentScale;
	                }
	                else {
	                    z.scale = (z.gesture.scaleMove / z.gesture.scaleStart) * z.currentScale;
	                }
	                if (z.scale > z.gesture.zoomMax) {
	                    z.scale = z.gesture.zoomMax - 1 + Math.pow((z.scale - z.gesture.zoomMax + 1), 0.5);
	                }
	                if (z.scale < s.params.zoomMin) {
	                    z.scale =  s.params.zoomMin + 1 - Math.pow((s.params.zoomMin - z.scale + 1), 0.5);
	                }
	                z.gesture.image.transform('translate3d(0,0,0) scale(' + z.scale + ')');
	            },
	            onGestureEnd: function (e) {
	                var z = s.zoom;
	                if (!s.support.gestures) {
	                    if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2) {
	                        return;
	                    }
	                }
	                if (!z.gesture.image || z.gesture.image.length === 0) return;
	                z.scale = Math.max(Math.min(z.scale, z.gesture.zoomMax), s.params.zoomMin);
	                z.gesture.image.transition(s.params.speed).transform('translate3d(0,0,0) scale(' + z.scale + ')');
	                z.currentScale = z.scale;
	                z.isScaling = false;
	                if (z.scale === 1) z.gesture.slide = undefined;
	            },
	            onTouchStart: function (s, e) {
	                var z = s.zoom;
	                if (!z.gesture.image || z.gesture.image.length === 0) return;
	                if (z.image.isTouched) return;
	                if (s.device.os === 'android') e.preventDefault();
	                z.image.isTouched = true;
	                z.image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	                z.image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	            },
	            onTouchMove: function (e) {
	                var z = s.zoom;
	                if (!z.gesture.image || z.gesture.image.length === 0) return;
	                s.allowClick = false;
	                if (!z.image.isTouched || !z.gesture.slide) return;
	        
	                if (!z.image.isMoved) {
	                    z.image.width = z.gesture.image[0].offsetWidth;
	                    z.image.height = z.gesture.image[0].offsetHeight;
	                    z.image.startX = s.getTranslate(z.gesture.imageWrap[0], 'x') || 0;
	                    z.image.startY = s.getTranslate(z.gesture.imageWrap[0], 'y') || 0;
	                    z.gesture.slideWidth = z.gesture.slide[0].offsetWidth;
	                    z.gesture.slideHeight = z.gesture.slide[0].offsetHeight;
	                    z.gesture.imageWrap.transition(0);
	                    if (s.rtl) z.image.startX = -z.image.startX;
	                    if (s.rtl) z.image.startY = -z.image.startY;
	                }
	                // Define if we need image drag
	                var scaledWidth = z.image.width * z.scale;
	                var scaledHeight = z.image.height * z.scale;
	        
	                if (scaledWidth < z.gesture.slideWidth && scaledHeight < z.gesture.slideHeight) return;
	        
	                z.image.minX = Math.min((z.gesture.slideWidth / 2 - scaledWidth / 2), 0);
	                z.image.maxX = -z.image.minX;
	                z.image.minY = Math.min((z.gesture.slideHeight / 2 - scaledHeight / 2), 0);
	                z.image.maxY = -z.image.minY;
	        
	                z.image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                z.image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	        
	                if (!z.image.isMoved && !z.isScaling) {
	                    if (s.isHorizontal() &&
	                        (Math.floor(z.image.minX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x < z.image.touchesStart.x) ||
	                        (Math.floor(z.image.maxX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x > z.image.touchesStart.x)
	                        ) {
	                        z.image.isTouched = false;
	                        return;
	                    }
	                    else if (!s.isHorizontal() &&
	                        (Math.floor(z.image.minY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y < z.image.touchesStart.y) ||
	                        (Math.floor(z.image.maxY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y > z.image.touchesStart.y)
	                        ) {
	                        z.image.isTouched = false;
	                        return;
	                    }
	                }
	                e.preventDefault();
	                e.stopPropagation();
	        
	                z.image.isMoved = true;
	                z.image.currentX = z.image.touchesCurrent.x - z.image.touchesStart.x + z.image.startX;
	                z.image.currentY = z.image.touchesCurrent.y - z.image.touchesStart.y + z.image.startY;
	        
	                if (z.image.currentX < z.image.minX) {
	                    z.image.currentX =  z.image.minX + 1 - Math.pow((z.image.minX - z.image.currentX + 1), 0.8);
	                }
	                if (z.image.currentX > z.image.maxX) {
	                    z.image.currentX = z.image.maxX - 1 + Math.pow((z.image.currentX - z.image.maxX + 1), 0.8);
	                }
	        
	                if (z.image.currentY < z.image.minY) {
	                    z.image.currentY =  z.image.minY + 1 - Math.pow((z.image.minY - z.image.currentY + 1), 0.8);
	                }
	                if (z.image.currentY > z.image.maxY) {
	                    z.image.currentY = z.image.maxY - 1 + Math.pow((z.image.currentY - z.image.maxY + 1), 0.8);
	                }
	        
	                //Velocity
	                if (!z.velocity.prevPositionX) z.velocity.prevPositionX = z.image.touchesCurrent.x;
	                if (!z.velocity.prevPositionY) z.velocity.prevPositionY = z.image.touchesCurrent.y;
	                if (!z.velocity.prevTime) z.velocity.prevTime = Date.now();
	                z.velocity.x = (z.image.touchesCurrent.x - z.velocity.prevPositionX) / (Date.now() - z.velocity.prevTime) / 2;
	                z.velocity.y = (z.image.touchesCurrent.y - z.velocity.prevPositionY) / (Date.now() - z.velocity.prevTime) / 2;
	                if (Math.abs(z.image.touchesCurrent.x - z.velocity.prevPositionX) < 2) z.velocity.x = 0;
	                if (Math.abs(z.image.touchesCurrent.y - z.velocity.prevPositionY) < 2) z.velocity.y = 0;
	                z.velocity.prevPositionX = z.image.touchesCurrent.x;
	                z.velocity.prevPositionY = z.image.touchesCurrent.y;
	                z.velocity.prevTime = Date.now();
	        
	                z.gesture.imageWrap.transform('translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
	            },
	            onTouchEnd: function (s, e) {
	                var z = s.zoom;
	                if (!z.gesture.image || z.gesture.image.length === 0) return;
	                if (!z.image.isTouched || !z.image.isMoved) {
	                    z.image.isTouched = false;
	                    z.image.isMoved = false;
	                    return;
	                }
	                z.image.isTouched = false;
	                z.image.isMoved = false;
	                var momentumDurationX = 300;
	                var momentumDurationY = 300;
	                var momentumDistanceX = z.velocity.x * momentumDurationX;
	                var newPositionX = z.image.currentX + momentumDistanceX;
	                var momentumDistanceY = z.velocity.y * momentumDurationY;
	                var newPositionY = z.image.currentY + momentumDistanceY;
	        
	                //Fix duration
	                if (z.velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - z.image.currentX) / z.velocity.x);
	                if (z.velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - z.image.currentY) / z.velocity.y);
	                var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
	        
	                z.image.currentX = newPositionX;
	                z.image.currentY = newPositionY;
	        
	                // Define if we need image drag
	                var scaledWidth = z.image.width * z.scale;
	                var scaledHeight = z.image.height * z.scale;
	                z.image.minX = Math.min((z.gesture.slideWidth / 2 - scaledWidth / 2), 0);
	                z.image.maxX = -z.image.minX;
	                z.image.minY = Math.min((z.gesture.slideHeight / 2 - scaledHeight / 2), 0);
	                z.image.maxY = -z.image.minY;
	                z.image.currentX = Math.max(Math.min(z.image.currentX, z.image.maxX), z.image.minX);
	                z.image.currentY = Math.max(Math.min(z.image.currentY, z.image.maxY), z.image.minY);
	        
	                z.gesture.imageWrap.transition(momentumDuration).transform('translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
	            },
	            onTransitionEnd: function (s) {
	                var z = s.zoom;
	                if (z.gesture.slide && s.previousIndex !== s.activeIndex) {
	                    z.gesture.image.transform('translate3d(0,0,0) scale(1)');
	                    z.gesture.imageWrap.transform('translate3d(0,0,0)');
	                    z.gesture.slide = z.gesture.image = z.gesture.imageWrap = undefined;
	                    z.scale = z.currentScale = 1;
	                }
	            },
	            // Toggle Zoom
	            toggleZoom: function (s, e) {
	                var z = s.zoom;
	                if (!z.gesture.slide) {
	                    z.gesture.slide = s.clickedSlide ? $(s.clickedSlide) : s.slides.eq(s.activeIndex);
	                    z.gesture.image = z.gesture.slide.find('img, svg, canvas');
	                    z.gesture.imageWrap = z.gesture.image.parent('.' + s.params.zoomContainerClass);
	                }
	                if (!z.gesture.image || z.gesture.image.length === 0) return;
	        
	                var touchX, touchY, offsetX, offsetY, diffX, diffY, translateX, translateY, imageWidth, imageHeight, scaledWidth, scaledHeight, translateMinX, translateMinY, translateMaxX, translateMaxY, slideWidth, slideHeight;
	        
	                if (typeof z.image.touchesStart.x === 'undefined' && e) {
	                    touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
	                    touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
	                }
	                else {
	                    touchX = z.image.touchesStart.x;
	                    touchY = z.image.touchesStart.y;
	                }
	        
	                if (z.scale && z.scale !== 1) {
	                    // Zoom Out
	                    z.scale = z.currentScale = 1;
	                    z.gesture.imageWrap.transition(300).transform('translate3d(0,0,0)');
	                    z.gesture.image.transition(300).transform('translate3d(0,0,0) scale(1)');
	                    z.gesture.slide = undefined;
	                }
	                else {
	                    // Zoom In
	                    z.scale = z.currentScale = z.gesture.imageWrap.attr('data-swiper-zoom') || s.params.zoomMax;
	                    if (e) {
	                        slideWidth = z.gesture.slide[0].offsetWidth;
	                        slideHeight = z.gesture.slide[0].offsetHeight;
	                        offsetX = z.gesture.slide.offset().left;
	                        offsetY = z.gesture.slide.offset().top;
	                        diffX = offsetX + slideWidth/2 - touchX;
	                        diffY = offsetY + slideHeight/2 - touchY;
	        
	                        imageWidth = z.gesture.image[0].offsetWidth;
	                        imageHeight = z.gesture.image[0].offsetHeight;
	                        scaledWidth = imageWidth * z.scale;
	                        scaledHeight = imageHeight * z.scale;
	        
	                        translateMinX = Math.min((slideWidth / 2 - scaledWidth / 2), 0);
	                        translateMinY = Math.min((slideHeight / 2 - scaledHeight / 2), 0);
	                        translateMaxX = -translateMinX;
	                        translateMaxY = -translateMinY;
	        
	                        translateX = diffX * z.scale;
	                        translateY = diffY * z.scale;
	        
	                        if (translateX < translateMinX) {
	                            translateX =  translateMinX;
	                        }
	                        if (translateX > translateMaxX) {
	                            translateX = translateMaxX;
	                        }
	        
	                        if (translateY < translateMinY) {
	                            translateY =  translateMinY;
	                        }
	                        if (translateY > translateMaxY) {
	                            translateY = translateMaxY;
	                        }
	                    }
	                    else {
	                        translateX = 0;
	                        translateY = 0;
	                    }
	                    z.gesture.imageWrap.transition(300).transform('translate3d(' + translateX + 'px, ' + translateY + 'px,0)');
	                    z.gesture.image.transition(300).transform('translate3d(0,0,0) scale(' + z.scale + ')');
	                }
	            },
	            // Attach/Detach Events
	            attachEvents: function (detach) {
	                var action = detach ? 'off' : 'on';
	        
	                if (s.params.zoom) {
	                    var target = s.slides;
	                    var passiveListener = s.touchEvents.start === 'touchstart' && s.support.passiveListener && s.params.passiveListeners ? {passive: true, capture: false} : false;
	                    // Scale image
	                    if (s.support.gestures) {
	                        s.slides[action]('gesturestart', s.zoom.onGestureStart, passiveListener);
	                        s.slides[action]('gesturechange', s.zoom.onGestureChange, passiveListener);
	                        s.slides[action]('gestureend', s.zoom.onGestureEnd, passiveListener);
	                    }
	                    else if (s.touchEvents.start === 'touchstart') {
	                        s.slides[action](s.touchEvents.start, s.zoom.onGestureStart, passiveListener);
	                        s.slides[action](s.touchEvents.move, s.zoom.onGestureChange, passiveListener);
	                        s.slides[action](s.touchEvents.end, s.zoom.onGestureEnd, passiveListener);
	                    }
	        
	                    // Move image
	                    s[action]('touchStart', s.zoom.onTouchStart);
	                    s.slides.each(function (index, slide){
	                        if ($(slide).find('.' + s.params.zoomContainerClass).length > 0) {
	                            $(slide)[action](s.touchEvents.move, s.zoom.onTouchMove);
	                        }
	                    });
	                    s[action]('touchEnd', s.zoom.onTouchEnd);
	        
	                    // Scale Out
	                    s[action]('transitionEnd', s.zoom.onTransitionEnd);
	                    if (s.params.zoomToggle) {
	                        s.on('doubleTap', s.zoom.toggleZoom);
	                    }
	                }
	            },
	            init: function () {
	                s.zoom.attachEvents();
	            },
	            destroy: function () {
	                s.zoom.attachEvents(true);
	            }
	        };
	        
	
	        /*=========================
	          Plugins API. Collect all and init all plugins
	          ===========================*/
	        s._plugins = [];
	        for (var plugin in s.plugins) {
	            var p = s.plugins[plugin](s, s.params[plugin]);
	            if (p) s._plugins.push(p);
	        }
	        // Method to call all plugins event/method
	        s.callPlugins = function (eventName) {
	            for (var i = 0; i < s._plugins.length; i++) {
	                if (eventName in s._plugins[i]) {
	                    s._plugins[i][eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	                }
	            }
	        };
	        
	
	        /*=========================
	          Events/Callbacks/Plugins Emitter
	          ===========================*/
	        function normalizeEventName (eventName) {
	            if (eventName.indexOf('on') !== 0) {
	                if (eventName[0] !== eventName[0].toUpperCase()) {
	                    eventName = 'on' + eventName[0].toUpperCase() + eventName.substring(1);
	                }
	                else {
	                    eventName = 'on' + eventName;
	                }
	            }
	            return eventName;
	        }
	        s.emitterEventListeners = {
	        
	        };
	        s.emit = function (eventName) {
	            // Trigger callbacks
	            if (s.params[eventName]) {
	                s.params[eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	            }
	            var i;
	            // Trigger events
	            if (s.emitterEventListeners[eventName]) {
	                for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
	                    s.emitterEventListeners[eventName][i](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	                }
	            }
	            // Trigger plugins
	            if (s.callPlugins) s.callPlugins(eventName, arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	        };
	        s.on = function (eventName, handler) {
	            eventName = normalizeEventName(eventName);
	            if (!s.emitterEventListeners[eventName]) s.emitterEventListeners[eventName] = [];
	            s.emitterEventListeners[eventName].push(handler);
	            return s;
	        };
	        s.off = function (eventName, handler) {
	            var i;
	            eventName = normalizeEventName(eventName);
	            if (typeof handler === 'undefined') {
	                // Remove all handlers for such event
	                s.emitterEventListeners[eventName] = [];
	                return s;
	            }
	            if (!s.emitterEventListeners[eventName] || s.emitterEventListeners[eventName].length === 0) return;
	            for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
	                if(s.emitterEventListeners[eventName][i] === handler) s.emitterEventListeners[eventName].splice(i, 1);
	            }
	            return s;
	        };
	        s.once = function (eventName, handler) {
	            eventName = normalizeEventName(eventName);
	            var _handler = function () {
	                handler(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
	                s.off(eventName, _handler);
	            };
	            s.on(eventName, _handler);
	            return s;
	        };
	        
	
	        // Accessibility tools
	        s.a11y = {
	            makeFocusable: function ($el) {
	                $el.attr('tabIndex', '0');
	                return $el;
	            },
	            addRole: function ($el, role) {
	                $el.attr('role', role);
	                return $el;
	            },
	        
	            addLabel: function ($el, label) {
	                $el.attr('aria-label', label);
	                return $el;
	            },
	        
	            disable: function ($el) {
	                $el.attr('aria-disabled', true);
	                return $el;
	            },
	        
	            enable: function ($el) {
	                $el.attr('aria-disabled', false);
	                return $el;
	            },
	        
	            onEnterKey: function (event) {
	                if (event.keyCode !== 13) return;
	                if ($(event.target).is(s.params.nextButton)) {
	                    s.onClickNext(event);
	                    if (s.isEnd) {
	                        s.a11y.notify(s.params.lastSlideMessage);
	                    }
	                    else {
	                        s.a11y.notify(s.params.nextSlideMessage);
	                    }
	                }
	                else if ($(event.target).is(s.params.prevButton)) {
	                    s.onClickPrev(event);
	                    if (s.isBeginning) {
	                        s.a11y.notify(s.params.firstSlideMessage);
	                    }
	                    else {
	                        s.a11y.notify(s.params.prevSlideMessage);
	                    }
	                }
	                if ($(event.target).is('.' + s.params.bulletClass)) {
	                    $(event.target)[0].click();
	                }
	            },
	        
	            liveRegion: $('<span class="' + s.params.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>'),
	        
	            notify: function (message) {
	                var notification = s.a11y.liveRegion;
	                if (notification.length === 0) return;
	                notification.html('');
	                notification.html(message);
	            },
	            init: function () {
	                // Setup accessibility
	                if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
	                    s.a11y.makeFocusable(s.nextButton);
	                    s.a11y.addRole(s.nextButton, 'button');
	                    s.a11y.addLabel(s.nextButton, s.params.nextSlideMessage);
	                }
	                if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
	                    s.a11y.makeFocusable(s.prevButton);
	                    s.a11y.addRole(s.prevButton, 'button');
	                    s.a11y.addLabel(s.prevButton, s.params.prevSlideMessage);
	                }
	        
	                $(s.container).append(s.a11y.liveRegion);
	            },
	            initPagination: function () {
	                if (s.params.pagination && s.params.paginationClickable && s.bullets && s.bullets.length) {
	                    s.bullets.each(function () {
	                        var bullet = $(this);
	                        s.a11y.makeFocusable(bullet);
	                        s.a11y.addRole(bullet, 'button');
	                        s.a11y.addLabel(bullet, s.params.paginationBulletMessage.replace(/{{index}}/, bullet.index() + 1));
	                    });
	                }
	            },
	            destroy: function () {
	                if (s.a11y.liveRegion && s.a11y.liveRegion.length > 0) s.a11y.liveRegion.remove();
	            }
	        };
	        
	
	        /*=========================
	          Init/Destroy
	          ===========================*/
	        s.init = function () {
	            if (s.params.loop) s.createLoop();
	            s.updateContainerSize();
	            s.updateSlidesSize();
	            s.updatePagination();
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.set();
	                if (s.params.scrollbarDraggable) {
	                    s.scrollbar.enableDraggable();
	                }
	            }
	            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
	                if (!s.params.loop) s.updateProgress();
	                s.effects[s.params.effect].setTranslate();
	            }
	            if (s.params.loop) {
	                s.slideTo(s.params.initialSlide + s.loopedSlides, 0, s.params.runCallbacksOnInit);
	            }
	            else {
	                s.slideTo(s.params.initialSlide, 0, s.params.runCallbacksOnInit);
	                if (s.params.initialSlide === 0) {
	                    if (s.parallax && s.params.parallax) s.parallax.setTranslate();
	                    if (s.lazy && s.params.lazyLoading) {
	                        s.lazy.load();
	                        s.lazy.initialImageLoaded = true;
	                    }
	                }
	            }
	            s.attachEvents();
	            if (s.params.observer && s.support.observer) {
	                s.initObservers();
	            }
	            if (s.params.preloadImages && !s.params.lazyLoading) {
	                s.preloadImages();
	            }
	            if (s.params.zoom && s.zoom) {
	                s.zoom.init();
	            }
	            if (s.params.autoplay) {
	                s.startAutoplay();
	            }
	            if (s.params.keyboardControl) {
	                if (s.enableKeyboardControl) s.enableKeyboardControl();
	            }
	            if (s.params.mousewheelControl) {
	                if (s.enableMousewheelControl) s.enableMousewheelControl();
	            }
	            // Deprecated hashnavReplaceState changed to replaceState for use in hashnav and history
	            if (s.params.hashnavReplaceState) {
	                s.params.replaceState = s.params.hashnavReplaceState;
	            }
	            if (s.params.history) {
	                if (s.history) s.history.init();
	            }
	            if (s.params.hashnav) {
	                if (s.hashnav) s.hashnav.init();
	            }
	            if (s.params.a11y && s.a11y) s.a11y.init();
	            s.emit('onInit', s);
	        };
	        
	        // Cleanup dynamic styles
	        s.cleanupStyles = function () {
	            // Container
	            s.container.removeClass(s.classNames.join(' ')).removeAttr('style');
	        
	            // Wrapper
	            s.wrapper.removeAttr('style');
	        
	            // Slides
	            if (s.slides && s.slides.length) {
	                s.slides
	                    .removeClass([
	                      s.params.slideVisibleClass,
	                      s.params.slideActiveClass,
	                      s.params.slideNextClass,
	                      s.params.slidePrevClass
	                    ].join(' '))
	                    .removeAttr('style')
	                    .removeAttr('data-swiper-column')
	                    .removeAttr('data-swiper-row');
	            }
	        
	            // Pagination/Bullets
	            if (s.paginationContainer && s.paginationContainer.length) {
	                s.paginationContainer.removeClass(s.params.paginationHiddenClass);
	            }
	            if (s.bullets && s.bullets.length) {
	                s.bullets.removeClass(s.params.bulletActiveClass);
	            }
	        
	            // Buttons
	            if (s.params.prevButton) $(s.params.prevButton).removeClass(s.params.buttonDisabledClass);
	            if (s.params.nextButton) $(s.params.nextButton).removeClass(s.params.buttonDisabledClass);
	        
	            // Scrollbar
	            if (s.params.scrollbar && s.scrollbar) {
	                if (s.scrollbar.track && s.scrollbar.track.length) s.scrollbar.track.removeAttr('style');
	                if (s.scrollbar.drag && s.scrollbar.drag.length) s.scrollbar.drag.removeAttr('style');
	            }
	        };
	        
	        // Destroy
	        s.destroy = function (deleteInstance, cleanupStyles) {
	            // Detach evebts
	            s.detachEvents();
	            // Stop autoplay
	            s.stopAutoplay();
	            // Disable draggable
	            if (s.params.scrollbar && s.scrollbar) {
	                if (s.params.scrollbarDraggable) {
	                    s.scrollbar.disableDraggable();
	                }
	            }
	            // Destroy loop
	            if (s.params.loop) {
	                s.destroyLoop();
	            }
	            // Cleanup styles
	            if (cleanupStyles) {
	                s.cleanupStyles();
	            }
	            // Disconnect observer
	            s.disconnectObservers();
	        
	            // Destroy zoom
	            if (s.params.zoom && s.zoom) {
	                s.zoom.destroy();
	            }
	            // Disable keyboard/mousewheel
	            if (s.params.keyboardControl) {
	                if (s.disableKeyboardControl) s.disableKeyboardControl();
	            }
	            if (s.params.mousewheelControl) {
	                if (s.disableMousewheelControl) s.disableMousewheelControl();
	            }
	            // Disable a11y
	            if (s.params.a11y && s.a11y) s.a11y.destroy();
	            // Delete history popstate
	            if (s.params.history && !s.params.replaceState) {
	                window.removeEventListener('popstate', s.history.setHistoryPopState);
	            }
	            if (s.params.hashnav && s.hashnav)  {
	                s.hashnav.destroy();
	            }
	            // Destroy callback
	            s.emit('onDestroy');
	            // Delete instance
	            if (deleteInstance !== false) s = null;
	        };
	        
	        s.init();
	        
	
	    
	        // Return swiper instance
	        return s;
	    };
	    
	
	    /*==================================================
	        Prototype
	    ====================================================*/
	    Swiper.prototype = {
	        isSafari: (function () {
	            var ua = window.navigator.userAgent.toLowerCase();
	            return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
	        })(),
	        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent),
	        isArray: function (arr) {
	            return Object.prototype.toString.apply(arr) === '[object Array]';
	        },
	        /*==================================================
	        Browser
	        ====================================================*/
	        browser: {
	            ie: window.navigator.pointerEnabled || window.navigator.msPointerEnabled,
	            ieTouch: (window.navigator.msPointerEnabled && window.navigator.msMaxTouchPoints > 1) || (window.navigator.pointerEnabled && window.navigator.maxTouchPoints > 1),
	            lteIE9: (function() {
	                // create temporary DIV
	                var div = document.createElement('div');
	                // add content to tmp DIV which is wrapped into the IE HTML conditional statement
	                div.innerHTML = '<!--[if lte IE 9]><i></i><![endif]-->';
	                // return true / false value based on what will browser render
	                return div.getElementsByTagName('i').length === 1;
	            })()
	        },
	        /*==================================================
	        Devices
	        ====================================================*/
	        device: (function () {
	            var ua = window.navigator.userAgent;
	            var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
	            var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	            var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	            var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	            return {
	                ios: ipad || iphone || ipod,
	                android: android
	            };
	        })(),
	        /*==================================================
	        Feature Detection
	        ====================================================*/
	        support: {
	            touch : (window.Modernizr && Modernizr.touch === true) || (function () {
	                return !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
	            })(),
	    
	            transforms3d : (window.Modernizr && Modernizr.csstransforms3d === true) || (function () {
	                var div = document.createElement('div').style;
	                return ('webkitPerspective' in div || 'MozPerspective' in div || 'OPerspective' in div || 'MsPerspective' in div || 'perspective' in div);
	            })(),
	    
	            flexbox: (function () {
	                var div = document.createElement('div').style;
	                var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
	                for (var i = 0; i < styles.length; i++) {
	                    if (styles[i] in div) return true;
	                }
	            })(),
	    
	            observer: (function () {
	                return ('MutationObserver' in window || 'WebkitMutationObserver' in window);
	            })(),
	    
	            passiveListener: (function () {
	                var supportsPassive = false;
	                try {
	                    var opts = Object.defineProperty({}, 'passive', {
	                        get: function() {
	                            supportsPassive = true;
	                        }
	                    });
	                    window.addEventListener('testPassiveListener', null, opts);
	                } catch (e) {}
	                return supportsPassive;
	            })(),
	    
	            gestures: (function () {
	                return 'ongesturestart' in window;
	            })()
	        },
	        /*==================================================
	        Plugins
	        ====================================================*/
	        plugins: {}
	    };
	    
	
	    /*===========================
	    Dom7 Library
	    ===========================*/
	    var Dom7 = (function () {
	        var Dom7 = function (arr) {
	            var _this = this, i = 0;
	            // Create array-like object
	            for (i = 0; i < arr.length; i++) {
	                _this[i] = arr[i];
	            }
	            _this.length = arr.length;
	            // Return collection with methods
	            return this;
	        };
	        var $ = function (selector, context) {
	            var arr = [], i = 0;
	            if (selector && !context) {
	                if (selector instanceof Dom7) {
	                    return selector;
	                }
	            }
	            if (selector) {
	                // String
	                if (typeof selector === 'string') {
	                    var els, tempParent, html = selector.trim();
	                    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
	                        var toCreate = 'div';
	                        if (html.indexOf('<li') === 0) toCreate = 'ul';
	                        if (html.indexOf('<tr') === 0) toCreate = 'tbody';
	                        if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
	                        if (html.indexOf('<tbody') === 0) toCreate = 'table';
	                        if (html.indexOf('<option') === 0) toCreate = 'select';
	                        tempParent = document.createElement(toCreate);
	                        tempParent.innerHTML = selector;
	                        for (i = 0; i < tempParent.childNodes.length; i++) {
	                            arr.push(tempParent.childNodes[i]);
	                        }
	                    }
	                    else {
	                        if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
	                            // Pure ID selector
	                            els = [document.getElementById(selector.split('#')[1])];
	                        }
	                        else {
	                            // Other selectors
	                            els = (context || document).querySelectorAll(selector);
	                        }
	                        for (i = 0; i < els.length; i++) {
	                            if (els[i]) arr.push(els[i]);
	                        }
	                    }
	                }
	                // Node/element
	                else if (selector.nodeType || selector === window || selector === document) {
	                    arr.push(selector);
	                }
	                //Array of elements or instance of Dom
	                else if (selector.length > 0 && selector[0].nodeType) {
	                    for (i = 0; i < selector.length; i++) {
	                        arr.push(selector[i]);
	                    }
	                }
	            }
	            return new Dom7(arr);
	        };
	        Dom7.prototype = {
	            // Classes and attriutes
	            addClass: function (className) {
	                if (typeof className === 'undefined') {
	                    return this;
	                }
	                var classes = className.split(' ');
	                for (var i = 0; i < classes.length; i++) {
	                    for (var j = 0; j < this.length; j++) {
	                        this[j].classList.add(classes[i]);
	                    }
	                }
	                return this;
	            },
	            removeClass: function (className) {
	                var classes = className.split(' ');
	                for (var i = 0; i < classes.length; i++) {
	                    for (var j = 0; j < this.length; j++) {
	                        this[j].classList.remove(classes[i]);
	                    }
	                }
	                return this;
	            },
	            hasClass: function (className) {
	                if (!this[0]) return false;
	                else return this[0].classList.contains(className);
	            },
	            toggleClass: function (className) {
	                var classes = className.split(' ');
	                for (var i = 0; i < classes.length; i++) {
	                    for (var j = 0; j < this.length; j++) {
	                        this[j].classList.toggle(classes[i]);
	                    }
	                }
	                return this;
	            },
	            attr: function (attrs, value) {
	                if (arguments.length === 1 && typeof attrs === 'string') {
	                    // Get attr
	                    if (this[0]) return this[0].getAttribute(attrs);
	                    else return undefined;
	                }
	                else {
	                    // Set attrs
	                    for (var i = 0; i < this.length; i++) {
	                        if (arguments.length === 2) {
	                            // String
	                            this[i].setAttribute(attrs, value);
	                        }
	                        else {
	                            // Object
	                            for (var attrName in attrs) {
	                                this[i][attrName] = attrs[attrName];
	                                this[i].setAttribute(attrName, attrs[attrName]);
	                            }
	                        }
	                    }
	                    return this;
	                }
	            },
	            removeAttr: function (attr) {
	                for (var i = 0; i < this.length; i++) {
	                    this[i].removeAttribute(attr);
	                }
	                return this;
	            },
	            data: function (key, value) {
	                if (typeof value === 'undefined') {
	                    // Get value
	                    if (this[0]) {
	                        var dataKey = this[0].getAttribute('data-' + key);
	                        if (dataKey) return dataKey;
	                        else if (this[0].dom7ElementDataStorage && (key in this[0].dom7ElementDataStorage)) return this[0].dom7ElementDataStorage[key];
	                        else return undefined;
	                    }
	                    else return undefined;
	                }
	                else {
	                    // Set value
	                    for (var i = 0; i < this.length; i++) {
	                        var el = this[i];
	                        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
	                        el.dom7ElementDataStorage[key] = value;
	                    }
	                    return this;
	                }
	            },
	            // Transforms
	            transform : function (transform) {
	                for (var i = 0; i < this.length; i++) {
	                    var elStyle = this[i].style;
	                    elStyle.webkitTransform = elStyle.MsTransform = elStyle.msTransform = elStyle.MozTransform = elStyle.OTransform = elStyle.transform = transform;
	                }
	                return this;
	            },
	            transition: function (duration) {
	                if (typeof duration !== 'string') {
	                    duration = duration + 'ms';
	                }
	                for (var i = 0; i < this.length; i++) {
	                    var elStyle = this[i].style;
	                    elStyle.webkitTransitionDuration = elStyle.MsTransitionDuration = elStyle.msTransitionDuration = elStyle.MozTransitionDuration = elStyle.OTransitionDuration = elStyle.transitionDuration = duration;
	                }
	                return this;
	            },
	            //Events
	            on: function (eventName, targetSelector, listener, capture) {
	                function handleLiveEvent(e) {
	                    var target = e.target;
	                    if ($(target).is(targetSelector)) listener.call(target, e);
	                    else {
	                        var parents = $(target).parents();
	                        for (var k = 0; k < parents.length; k++) {
	                            if ($(parents[k]).is(targetSelector)) listener.call(parents[k], e);
	                        }
	                    }
	                }
	                var events = eventName.split(' ');
	                var i, j;
	                for (i = 0; i < this.length; i++) {
	                    if (typeof targetSelector === 'function' || targetSelector === false) {
	                        // Usual events
	                        if (typeof targetSelector === 'function') {
	                            listener = arguments[1];
	                            capture = arguments[2] || false;
	                        }
	                        for (j = 0; j < events.length; j++) {
	                            this[i].addEventListener(events[j], listener, capture);
	                        }
	                    }
	                    else {
	                        //Live events
	                        for (j = 0; j < events.length; j++) {
	                            if (!this[i].dom7LiveListeners) this[i].dom7LiveListeners = [];
	                            this[i].dom7LiveListeners.push({listener: listener, liveListener: handleLiveEvent});
	                            this[i].addEventListener(events[j], handleLiveEvent, capture);
	                        }
	                    }
	                }
	    
	                return this;
	            },
	            off: function (eventName, targetSelector, listener, capture) {
	                var events = eventName.split(' ');
	                for (var i = 0; i < events.length; i++) {
	                    for (var j = 0; j < this.length; j++) {
	                        if (typeof targetSelector === 'function' || targetSelector === false) {
	                            // Usual events
	                            if (typeof targetSelector === 'function') {
	                                listener = arguments[1];
	                                capture = arguments[2] || false;
	                            }
	                            this[j].removeEventListener(events[i], listener, capture);
	                        }
	                        else {
	                            // Live event
	                            if (this[j].dom7LiveListeners) {
	                                for (var k = 0; k < this[j].dom7LiveListeners.length; k++) {
	                                    if (this[j].dom7LiveListeners[k].listener === listener) {
	                                        this[j].removeEventListener(events[i], this[j].dom7LiveListeners[k].liveListener, capture);
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	                return this;
	            },
	            once: function (eventName, targetSelector, listener, capture) {
	                var dom = this;
	                if (typeof targetSelector === 'function') {
	                    targetSelector = false;
	                    listener = arguments[1];
	                    capture = arguments[2];
	                }
	                function proxy(e) {
	                    listener(e);
	                    dom.off(eventName, targetSelector, proxy, capture);
	                }
	                dom.on(eventName, targetSelector, proxy, capture);
	            },
	            trigger: function (eventName, eventData) {
	                for (var i = 0; i < this.length; i++) {
	                    var evt;
	                    try {
	                        evt = new window.CustomEvent(eventName, {detail: eventData, bubbles: true, cancelable: true});
	                    }
	                    catch (e) {
	                        evt = document.createEvent('Event');
	                        evt.initEvent(eventName, true, true);
	                        evt.detail = eventData;
	                    }
	                    this[i].dispatchEvent(evt);
	                }
	                return this;
	            },
	            transitionEnd: function (callback) {
	                var events = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'],
	                    i, j, dom = this;
	                function fireCallBack(e) {
	                    /*jshint validthis:true */
	                    if (e.target !== this) return;
	                    callback.call(this, e);
	                    for (i = 0; i < events.length; i++) {
	                        dom.off(events[i], fireCallBack);
	                    }
	                }
	                if (callback) {
	                    for (i = 0; i < events.length; i++) {
	                        dom.on(events[i], fireCallBack);
	                    }
	                }
	                return this;
	            },
	            // Sizing/Styles
	            width: function () {
	                if (this[0] === window) {
	                    return window.innerWidth;
	                }
	                else {
	                    if (this.length > 0) {
	                        return parseFloat(this.css('width'));
	                    }
	                    else {
	                        return null;
	                    }
	                }
	            },
	            outerWidth: function (includeMargins) {
	                if (this.length > 0) {
	                    if (includeMargins)
	                        return this[0].offsetWidth + parseFloat(this.css('margin-right')) + parseFloat(this.css('margin-left'));
	                    else
	                        return this[0].offsetWidth;
	                }
	                else return null;
	            },
	            height: function () {
	                if (this[0] === window) {
	                    return window.innerHeight;
	                }
	                else {
	                    if (this.length > 0) {
	                        return parseFloat(this.css('height'));
	                    }
	                    else {
	                        return null;
	                    }
	                }
	            },
	            outerHeight: function (includeMargins) {
	                if (this.length > 0) {
	                    if (includeMargins)
	                        return this[0].offsetHeight + parseFloat(this.css('margin-top')) + parseFloat(this.css('margin-bottom'));
	                    else
	                        return this[0].offsetHeight;
	                }
	                else return null;
	            },
	            offset: function () {
	                if (this.length > 0) {
	                    var el = this[0];
	                    var box = el.getBoundingClientRect();
	                    var body = document.body;
	                    var clientTop  = el.clientTop  || body.clientTop  || 0;
	                    var clientLeft = el.clientLeft || body.clientLeft || 0;
	                    var scrollTop  = window.pageYOffset || el.scrollTop;
	                    var scrollLeft = window.pageXOffset || el.scrollLeft;
	                    return {
	                        top: box.top  + scrollTop  - clientTop,
	                        left: box.left + scrollLeft - clientLeft
	                    };
	                }
	                else {
	                    return null;
	                }
	            },
	            css: function (props, value) {
	                var i;
	                if (arguments.length === 1) {
	                    if (typeof props === 'string') {
	                        if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
	                    }
	                    else {
	                        for (i = 0; i < this.length; i++) {
	                            for (var prop in props) {
	                                this[i].style[prop] = props[prop];
	                            }
	                        }
	                        return this;
	                    }
	                }
	                if (arguments.length === 2 && typeof props === 'string') {
	                    for (i = 0; i < this.length; i++) {
	                        this[i].style[props] = value;
	                    }
	                    return this;
	                }
	                return this;
	            },
	    
	            //Dom manipulation
	            each: function (callback) {
	                for (var i = 0; i < this.length; i++) {
	                    callback.call(this[i], i, this[i]);
	                }
	                return this;
	            },
	            html: function (html) {
	                if (typeof html === 'undefined') {
	                    return this[0] ? this[0].innerHTML : undefined;
	                }
	                else {
	                    for (var i = 0; i < this.length; i++) {
	                        this[i].innerHTML = html;
	                    }
	                    return this;
	                }
	            },
	            text: function (text) {
	                if (typeof text === 'undefined') {
	                    if (this[0]) {
	                        return this[0].textContent.trim();
	                    }
	                    else return null;
	                }
	                else {
	                    for (var i = 0; i < this.length; i++) {
	                        this[i].textContent = text;
	                    }
	                    return this;
	                }
	            },
	            is: function (selector) {
	                if (!this[0]) return false;
	                var compareWith, i;
	                if (typeof selector === 'string') {
	                    var el = this[0];
	                    if (el === document) return selector === document;
	                    if (el === window) return selector === window;
	    
	                    if (el.matches) return el.matches(selector);
	                    else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
	                    else if (el.mozMatchesSelector) return el.mozMatchesSelector(selector);
	                    else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
	                    else {
	                        compareWith = $(selector);
	                        for (i = 0; i < compareWith.length; i++) {
	                            if (compareWith[i] === this[0]) return true;
	                        }
	                        return false;
	                    }
	                }
	                else if (selector === document) return this[0] === document;
	                else if (selector === window) return this[0] === window;
	                else {
	                    if (selector.nodeType || selector instanceof Dom7) {
	                        compareWith = selector.nodeType ? [selector] : selector;
	                        for (i = 0; i < compareWith.length; i++) {
	                            if (compareWith[i] === this[0]) return true;
	                        }
	                        return false;
	                    }
	                    return false;
	                }
	    
	            },
	            index: function () {
	                if (this[0]) {
	                    var child = this[0];
	                    var i = 0;
	                    while ((child = child.previousSibling) !== null) {
	                        if (child.nodeType === 1) i++;
	                    }
	                    return i;
	                }
	                else return undefined;
	            },
	            eq: function (index) {
	                if (typeof index === 'undefined') return this;
	                var length = this.length;
	                var returnIndex;
	                if (index > length - 1) {
	                    return new Dom7([]);
	                }
	                if (index < 0) {
	                    returnIndex = length + index;
	                    if (returnIndex < 0) return new Dom7([]);
	                    else return new Dom7([this[returnIndex]]);
	                }
	                return new Dom7([this[index]]);
	            },
	            append: function (newChild) {
	                var i, j;
	                for (i = 0; i < this.length; i++) {
	                    if (typeof newChild === 'string') {
	                        var tempDiv = document.createElement('div');
	                        tempDiv.innerHTML = newChild;
	                        while (tempDiv.firstChild) {
	                            this[i].appendChild(tempDiv.firstChild);
	                        }
	                    }
	                    else if (newChild instanceof Dom7) {
	                        for (j = 0; j < newChild.length; j++) {
	                            this[i].appendChild(newChild[j]);
	                        }
	                    }
	                    else {
	                        this[i].appendChild(newChild);
	                    }
	                }
	                return this;
	            },
	            prepend: function (newChild) {
	                var i, j;
	                for (i = 0; i < this.length; i++) {
	                    if (typeof newChild === 'string') {
	                        var tempDiv = document.createElement('div');
	                        tempDiv.innerHTML = newChild;
	                        for (j = tempDiv.childNodes.length - 1; j >= 0; j--) {
	                            this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
	                        }
	                        // this[i].insertAdjacentHTML('afterbegin', newChild);
	                    }
	                    else if (newChild instanceof Dom7) {
	                        for (j = 0; j < newChild.length; j++) {
	                            this[i].insertBefore(newChild[j], this[i].childNodes[0]);
	                        }
	                    }
	                    else {
	                        this[i].insertBefore(newChild, this[i].childNodes[0]);
	                    }
	                }
	                return this;
	            },
	            insertBefore: function (selector) {
	                var before = $(selector);
	                for (var i = 0; i < this.length; i++) {
	                    if (before.length === 1) {
	                        before[0].parentNode.insertBefore(this[i], before[0]);
	                    }
	                    else if (before.length > 1) {
	                        for (var j = 0; j < before.length; j++) {
	                            before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
	                        }
	                    }
	                }
	            },
	            insertAfter: function (selector) {
	                var after = $(selector);
	                for (var i = 0; i < this.length; i++) {
	                    if (after.length === 1) {
	                        after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
	                    }
	                    else if (after.length > 1) {
	                        for (var j = 0; j < after.length; j++) {
	                            after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
	                        }
	                    }
	                }
	            },
	            next: function (selector) {
	                if (this.length > 0) {
	                    if (selector) {
	                        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return new Dom7([this[0].nextElementSibling]);
	                        else return new Dom7([]);
	                    }
	                    else {
	                        if (this[0].nextElementSibling) return new Dom7([this[0].nextElementSibling]);
	                        else return new Dom7([]);
	                    }
	                }
	                else return new Dom7([]);
	            },
	            nextAll: function (selector) {
	                var nextEls = [];
	                var el = this[0];
	                if (!el) return new Dom7([]);
	                while (el.nextElementSibling) {
	                    var next = el.nextElementSibling;
	                    if (selector) {
	                        if($(next).is(selector)) nextEls.push(next);
	                    }
	                    else nextEls.push(next);
	                    el = next;
	                }
	                return new Dom7(nextEls);
	            },
	            prev: function (selector) {
	                if (this.length > 0) {
	                    if (selector) {
	                        if (this[0].previousElementSibling && $(this[0].previousElementSibling).is(selector)) return new Dom7([this[0].previousElementSibling]);
	                        else return new Dom7([]);
	                    }
	                    else {
	                        if (this[0].previousElementSibling) return new Dom7([this[0].previousElementSibling]);
	                        else return new Dom7([]);
	                    }
	                }
	                else return new Dom7([]);
	            },
	            prevAll: function (selector) {
	                var prevEls = [];
	                var el = this[0];
	                if (!el) return new Dom7([]);
	                while (el.previousElementSibling) {
	                    var prev = el.previousElementSibling;
	                    if (selector) {
	                        if($(prev).is(selector)) prevEls.push(prev);
	                    }
	                    else prevEls.push(prev);
	                    el = prev;
	                }
	                return new Dom7(prevEls);
	            },
	            parent: function (selector) {
	                var parents = [];
	                for (var i = 0; i < this.length; i++) {
	                    if (selector) {
	                        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
	                    }
	                    else {
	                        parents.push(this[i].parentNode);
	                    }
	                }
	                return $($.unique(parents));
	            },
	            parents: function (selector) {
	                var parents = [];
	                for (var i = 0; i < this.length; i++) {
	                    var parent = this[i].parentNode;
	                    while (parent) {
	                        if (selector) {
	                            if ($(parent).is(selector)) parents.push(parent);
	                        }
	                        else {
	                            parents.push(parent);
	                        }
	                        parent = parent.parentNode;
	                    }
	                }
	                return $($.unique(parents));
	            },
	            find : function (selector) {
	                var foundElements = [];
	                for (var i = 0; i < this.length; i++) {
	                    var found = this[i].querySelectorAll(selector);
	                    for (var j = 0; j < found.length; j++) {
	                        foundElements.push(found[j]);
	                    }
	                }
	                return new Dom7(foundElements);
	            },
	            children: function (selector) {
	                var children = [];
	                for (var i = 0; i < this.length; i++) {
	                    var childNodes = this[i].childNodes;
	    
	                    for (var j = 0; j < childNodes.length; j++) {
	                        if (!selector) {
	                            if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
	                        }
	                        else {
	                            if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) children.push(childNodes[j]);
	                        }
	                    }
	                }
	                return new Dom7($.unique(children));
	            },
	            remove: function () {
	                for (var i = 0; i < this.length; i++) {
	                    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
	                }
	                return this;
	            },
	            add: function () {
	                var dom = this;
	                var i, j;
	                for (i = 0; i < arguments.length; i++) {
	                    var toAdd = $(arguments[i]);
	                    for (j = 0; j < toAdd.length; j++) {
	                        dom[dom.length] = toAdd[j];
	                        dom.length++;
	                    }
	                }
	                return dom;
	            }
	        };
	        $.fn = Dom7.prototype;
	        $.unique = function (arr) {
	            var unique = [];
	            for (var i = 0; i < arr.length; i++) {
	                if (unique.indexOf(arr[i]) === -1) unique.push(arr[i]);
	            }
	            return unique;
	        };
	    
	        return $;
	    })();
	    
	
	    /*===========================
	     Get Dom libraries
	     ===========================*/
	    var swiperDomPlugins = ['jQuery', 'Zepto', 'Dom7'];
	    for (var i = 0; i < swiperDomPlugins.length; i++) {
	    	if (window[swiperDomPlugins[i]]) {
	    		addLibraryPlugin(window[swiperDomPlugins[i]]);
	    	}
	    }
	    // Required DOM Plugins
	    var domLib;
	    if (typeof Dom7 === 'undefined') {
	    	domLib = window.Dom7 || window.Zepto || window.jQuery;
	    }
	    else {
	    	domLib = Dom7;
	    }
	    
	
	    /*===========================
	    Add .swiper plugin from Dom libraries
	    ===========================*/
	    function addLibraryPlugin(lib) {
	        lib.fn.swiper = function (params) {
	            var firstInstance;
	            lib(this).each(function () {
	                var s = new Swiper(this, params);
	                if (!firstInstance) firstInstance = s;
	            });
	            return firstInstance;
	        };
	    }
	    
	    if (domLib) {
	        if (!('transitionEnd' in domLib.fn)) {
	            domLib.fn.transitionEnd = function (callback) {
	                var events = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'],
	                    i, j, dom = this;
	                function fireCallBack(e) {
	                    /*jshint validthis:true */
	                    if (e.target !== this) return;
	                    callback.call(this, e);
	                    for (i = 0; i < events.length; i++) {
	                        dom.off(events[i], fireCallBack);
	                    }
	                }
	                if (callback) {
	                    for (i = 0; i < events.length; i++) {
	                        dom.on(events[i], fireCallBack);
	                    }
	                }
	                return this;
	            };
	        }
	        if (!('transform' in domLib.fn)) {
	            domLib.fn.transform = function (transform) {
	                for (var i = 0; i < this.length; i++) {
	                    var elStyle = this[i].style;
	                    elStyle.webkitTransform = elStyle.MsTransform = elStyle.msTransform = elStyle.MozTransform = elStyle.OTransform = elStyle.transform = transform;
	                }
	                return this;
	            };
	        }
	        if (!('transition' in domLib.fn)) {
	            domLib.fn.transition = function (duration) {
	                if (typeof duration !== 'string') {
	                    duration = duration + 'ms';
	                }
	                for (var i = 0; i < this.length; i++) {
	                    var elStyle = this[i].style;
	                    elStyle.webkitTransitionDuration = elStyle.MsTransitionDuration = elStyle.msTransitionDuration = elStyle.MozTransitionDuration = elStyle.OTransitionDuration = elStyle.transitionDuration = duration;
	                }
	                return this;
	            };
	        }
	        if (!('outerWidth' in domLib.fn)) {
	            domLib.fn.outerWidth = function (includeMargins) {
	                if (this.length > 0) {
	                    if (includeMargins)
	                        return this[0].offsetWidth + parseFloat(this.css('margin-right')) + parseFloat(this.css('margin-left'));
	                    else
	                        return this[0].offsetWidth;
	                }
	                else return null;
	            };
	        }
	    }
	    
	
	    window.Swiper = Swiper;
	})();
	
	/*===========================
	Swiper AMD Export
	===========================*/
	if (true)
	{
	    module.exports = window.Swiper;
	}
	else if (typeof define === 'function' && define.amd) {
	    define([], function () {
	        'use strict';
	        return window.Swiper;
	    });
	}
	
	//# sourceMappingURL=maps/swiper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/main-1707216748545.js